{
  "contractName": "Survey",
  "abi": [
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_creator",
          "type": "address"
        },
        {
          "internalType": "string",
          "name": "_name",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "_description",
          "type": "string"
        },
        {
          "internalType": "uint256",
          "name": "_bonusAmount",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "string",
          "name": "s",
          "type": "string"
        }
      ],
      "name": "Log",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "enum SurveyInterface.Status",
          "name": "_status",
          "type": "uint8"
        }
      ],
      "name": "SurveyStatusChanged",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "answers",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "build",
      "outputs": [
        {
          "components": [
            {
              "internalType": "string",
              "name": "name",
              "type": "string"
            },
            {
              "internalType": "string",
              "name": "description",
              "type": "string"
            },
            {
              "internalType": "uint256",
              "name": "bonusAmount",
              "type": "uint256"
            }
          ],
          "internalType": "struct SurveyInterface.SurveyBasic",
          "name": "info",
          "type": "tuple"
        },
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "tokenAmount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "gasAmount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalGasSent",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalTokensSent",
              "type": "uint256"
            }
          ],
          "internalType": "struct SurveyInterface.LiquidityPool",
          "name": "pool",
          "type": "tuple"
        },
        {
          "internalType": "uint256",
          "name": "surveysTaken",
          "type": "uint256"
        },
        {
          "internalType": "enum SurveyInterface.Status",
          "name": "status",
          "type": "uint8"
        },
        {
          "internalType": "address",
          "name": "creator",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "questionCount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "questions",
      "outputs": [
        {
          "internalType": "enum SurveyInterface.QuestionType",
          "name": "questionType",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "worth",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "required",
          "type": "bool"
        },
        {
          "internalType": "string",
          "name": "title",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "description",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "enum SurveyInterface.Status",
          "name": "_status",
          "type": "uint8"
        }
      ],
      "name": "setSurveyStatus",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_gas",
          "type": "uint256"
        },
        {
          "internalType": "contract Token",
          "name": "_token",
          "type": "address"
        },
        {
          "internalType": "string[]",
          "name": "_answers",
          "type": "string[]"
        }
      ],
      "name": "submitSurvey",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "bonusAmount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "creator",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "status",
      "outputs": [
        {
          "internalType": "enum SurveyInterface.Status",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "info",
      "outputs": [
        {
          "components": [
            {
              "internalType": "string",
              "name": "name",
              "type": "string"
            },
            {
              "internalType": "string",
              "name": "description",
              "type": "string"
            },
            {
              "internalType": "uint256",
              "name": "bonusAmount",
              "type": "uint256"
            }
          ],
          "internalType": "struct SurveyInterface.SurveyBasic",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "pool",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "tokenAmount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "gasAmount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalGasSent",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalTokensSent",
              "type": "uint256"
            }
          ],
          "internalType": "struct SurveyInterface.LiquidityPool",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getBalance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getOverview",
      "outputs": [
        {
          "components": [
            {
              "internalType": "uint256",
              "name": "id",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "addr",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "worth",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "bonusAmount",
              "type": "uint256"
            },
            {
              "internalType": "string",
              "name": "name",
              "type": "string"
            },
            {
              "internalType": "string",
              "name": "description",
              "type": "string"
            },
            {
              "internalType": "enum SurveyInterface.Status",
              "name": "status",
              "type": "uint8"
            },
            {
              "internalType": "uint256",
              "name": "taken",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "gasLeft",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "tokensLeft",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "questionCount",
              "type": "uint256"
            }
          ],
          "internalType": "struct SurveyInterface.SurveyOverview",
          "name": "",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "worth",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getQuestions",
      "outputs": [
        {
          "components": [
            {
              "internalType": "enum SurveyInterface.QuestionType",
              "name": "questionType",
              "type": "uint8"
            },
            {
              "internalType": "uint256",
              "name": "worth",
              "type": "uint256"
            },
            {
              "internalType": "bool",
              "name": "required",
              "type": "bool"
            },
            {
              "internalType": "string",
              "name": "title",
              "type": "string"
            },
            {
              "internalType": "string",
              "name": "description",
              "type": "string"
            },
            {
              "internalType": "string[]",
              "name": "choices",
              "type": "string[]"
            }
          ],
          "internalType": "struct SurveyInterface.Question[]",
          "name": "",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "qid",
          "type": "uint256"
        }
      ],
      "name": "getAnswers",
      "outputs": [
        {
          "internalType": "string[]",
          "name": "",
          "type": "string[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "string",
          "name": "_name",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "_description",
          "type": "string"
        },
        {
          "internalType": "uint256",
          "name": "_bonusAmount",
          "type": "uint256"
        }
      ],
      "name": "updateSurvey",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "enum SurveyInterface.QuestionType",
          "name": "_qtypes",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "_worth",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "_required",
          "type": "bool"
        },
        {
          "internalType": "string",
          "name": "_title",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "_qdescription",
          "type": "string"
        },
        {
          "internalType": "string[]",
          "name": "_choices",
          "type": "string[]"
        }
      ],
      "name": "addQuestion",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_id",
          "type": "uint256"
        },
        {
          "internalType": "enum SurveyInterface.QuestionType",
          "name": "_qtypes",
          "type": "uint8"
        },
        {
          "internalType": "uint256",
          "name": "_worth",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "_required",
          "type": "bool"
        },
        {
          "internalType": "string",
          "name": "_title",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "_qdescription",
          "type": "string"
        },
        {
          "internalType": "string[]",
          "name": "_choices",
          "type": "string[]"
        }
      ],
      "name": "updateQuestion",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "contract Token",
          "name": "_token",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "depositToSurveyTokenPool",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "depositToSurveyGasPool",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "contract Token",
          "name": "_token",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "withdrawFromTokenPool",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "withdrawFromGasPool",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_addr",
          "type": "address"
        }
      ],
      "name": "didUserTakeSurvey",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "metadata": "{\"compiler\":{\"version\":\"0.8.7+commit.e28d00a7\"},\"language\":\"Solidity\",\"output\":{\"abi\":[{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_creator\",\"type\":\"address\"},{\"internalType\":\"string\",\"name\":\"_name\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"_description\",\"type\":\"string\"},{\"internalType\":\"uint256\",\"name\":\"_bonusAmount\",\"type\":\"uint256\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"string\",\"name\":\"s\",\"type\":\"string\"}],\"name\":\"Log\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"enum SurveyInterface.Status\",\"name\":\"_status\",\"type\":\"uint8\"}],\"name\":\"SurveyStatusChanged\",\"type\":\"event\"},{\"inputs\":[{\"internalType\":\"enum SurveyInterface.QuestionType\",\"name\":\"_qtypes\",\"type\":\"uint8\"},{\"internalType\":\"uint256\",\"name\":\"_worth\",\"type\":\"uint256\"},{\"internalType\":\"bool\",\"name\":\"_required\",\"type\":\"bool\"},{\"internalType\":\"string\",\"name\":\"_title\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"_qdescription\",\"type\":\"string\"},{\"internalType\":\"string[]\",\"name\":\"_choices\",\"type\":\"string[]\"}],\"name\":\"addQuestion\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"name\":\"answers\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"bonusAmount\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"build\",\"outputs\":[{\"components\":[{\"internalType\":\"string\",\"name\":\"name\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"description\",\"type\":\"string\"},{\"internalType\":\"uint256\",\"name\":\"bonusAmount\",\"type\":\"uint256\"}],\"internalType\":\"struct SurveyInterface.SurveyBasic\",\"name\":\"info\",\"type\":\"tuple\"},{\"components\":[{\"internalType\":\"uint256\",\"name\":\"tokenAmount\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"gasAmount\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"totalGasSent\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"totalTokensSent\",\"type\":\"uint256\"}],\"internalType\":\"struct SurveyInterface.LiquidityPool\",\"name\":\"pool\",\"type\":\"tuple\"},{\"internalType\":\"uint256\",\"name\":\"surveysTaken\",\"type\":\"uint256\"},{\"internalType\":\"enum SurveyInterface.Status\",\"name\":\"status\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"creator\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"creator\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"depositToSurveyGasPool\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"contract Token\",\"name\":\"_token\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_amount\",\"type\":\"uint256\"}],\"name\":\"depositToSurveyTokenPool\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_addr\",\"type\":\"address\"}],\"name\":\"didUserTakeSurvey\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"qid\",\"type\":\"uint256\"}],\"name\":\"getAnswers\",\"outputs\":[{\"internalType\":\"string[]\",\"name\":\"\",\"type\":\"string[]\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"getBalance\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"getOverview\",\"outputs\":[{\"components\":[{\"internalType\":\"uint256\",\"name\":\"id\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"addr\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"worth\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"bonusAmount\",\"type\":\"uint256\"},{\"internalType\":\"string\",\"name\":\"name\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"description\",\"type\":\"string\"},{\"internalType\":\"enum SurveyInterface.Status\",\"name\":\"status\",\"type\":\"uint8\"},{\"internalType\":\"uint256\",\"name\":\"taken\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"gasLeft\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"tokensLeft\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"questionCount\",\"type\":\"uint256\"}],\"internalType\":\"struct SurveyInterface.SurveyOverview\",\"name\":\"\",\"type\":\"tuple\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"getQuestions\",\"outputs\":[{\"components\":[{\"internalType\":\"enum SurveyInterface.QuestionType\",\"name\":\"questionType\",\"type\":\"uint8\"},{\"internalType\":\"uint256\",\"name\":\"worth\",\"type\":\"uint256\"},{\"internalType\":\"bool\",\"name\":\"required\",\"type\":\"bool\"},{\"internalType\":\"string\",\"name\":\"title\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"description\",\"type\":\"string\"},{\"internalType\":\"string[]\",\"name\":\"choices\",\"type\":\"string[]\"}],\"internalType\":\"struct SurveyInterface.Question[]\",\"name\":\"\",\"type\":\"tuple[]\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"info\",\"outputs\":[{\"components\":[{\"internalType\":\"string\",\"name\":\"name\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"description\",\"type\":\"string\"},{\"internalType\":\"uint256\",\"name\":\"bonusAmount\",\"type\":\"uint256\"}],\"internalType\":\"struct SurveyInterface.SurveyBasic\",\"name\":\"\",\"type\":\"tuple\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"name\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"pool\",\"outputs\":[{\"components\":[{\"internalType\":\"uint256\",\"name\":\"tokenAmount\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"gasAmount\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"totalGasSent\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"totalTokensSent\",\"type\":\"uint256\"}],\"internalType\":\"struct SurveyInterface.LiquidityPool\",\"name\":\"\",\"type\":\"tuple\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"questionCount\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"name\":\"questions\",\"outputs\":[{\"internalType\":\"enum SurveyInterface.QuestionType\",\"name\":\"questionType\",\"type\":\"uint8\"},{\"internalType\":\"uint256\",\"name\":\"worth\",\"type\":\"uint256\"},{\"internalType\":\"bool\",\"name\":\"required\",\"type\":\"bool\"},{\"internalType\":\"string\",\"name\":\"title\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"description\",\"type\":\"string\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"enum SurveyInterface.Status\",\"name\":\"_status\",\"type\":\"uint8\"}],\"name\":\"setSurveyStatus\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"status\",\"outputs\":[{\"internalType\":\"enum SurveyInterface.Status\",\"name\":\"\",\"type\":\"uint8\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_gas\",\"type\":\"uint256\"},{\"internalType\":\"contract Token\",\"name\":\"_token\",\"type\":\"address\"},{\"internalType\":\"string[]\",\"name\":\"_answers\",\"type\":\"string[]\"}],\"name\":\"submitSurvey\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_id\",\"type\":\"uint256\"},{\"internalType\":\"enum SurveyInterface.QuestionType\",\"name\":\"_qtypes\",\"type\":\"uint8\"},{\"internalType\":\"uint256\",\"name\":\"_worth\",\"type\":\"uint256\"},{\"internalType\":\"bool\",\"name\":\"_required\",\"type\":\"bool\"},{\"internalType\":\"string\",\"name\":\"_title\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"_qdescription\",\"type\":\"string\"},{\"internalType\":\"string[]\",\"name\":\"_choices\",\"type\":\"string[]\"}],\"name\":\"updateQuestion\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"string\",\"name\":\"_name\",\"type\":\"string\"},{\"internalType\":\"string\",\"name\":\"_description\",\"type\":\"string\"},{\"internalType\":\"uint256\",\"name\":\"_bonusAmount\",\"type\":\"uint256\"}],\"name\":\"updateSurvey\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_amount\",\"type\":\"uint256\"}],\"name\":\"withdrawFromGasPool\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"contract Token\",\"name\":\"_token\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_amount\",\"type\":\"uint256\"}],\"name\":\"withdrawFromTokenPool\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"worth\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"}],\"devdoc\":{\"kind\":\"dev\",\"methods\":{},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{},\"version\":1}},\"settings\":{\"compilationTarget\":{\"project:/contracts/Survey.sol\":\"Survey\"},\"evmVersion\":\"byzantium\",\"libraries\":{},\"metadata\":{\"bytecodeHash\":\"ipfs\"},\"optimizer\":{\"enabled\":true,\"runs\":50},\"remappings\":[]},\"sources\":{\"project:/contracts/Survey.sol\":{\"keccak256\":\"0xcb3815c87f1a9ef27e8e1c036e61a3ea20aa81d0bf2778b7d77d9399d4a0f16c\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://2dbce15db1594fbdcb3edcfcef763448ee6c3809ded5183a79a8ed4eea1ea225\",\"dweb:/ipfs/QmaY16YV8mQ4BTf3iMgoRT1fX8k8zPaCtuporCo4dJFQVX\"]},\"project:/contracts/SurveyInterface.sol\":{\"keccak256\":\"0xa706b2959a628f0e23d040fcf9e1452fbce5d4ecb2e11a846386a888f4b756f0\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://7c717b73e7ef64e95b43a533b93d129fc063eafe890931f818ebca10c3cda1fd\",\"dweb:/ipfs/QmeeFspBwG1ZTTPutjtHVkVNozHdG2NdAMnxrqovwGkLfB\"]},\"project:/contracts/Token.sol\":{\"keccak256\":\"0x36ab9bdd6138a5bbfd28e6256ee076e0af4130b420b3f2edf2089058cd1dd0d9\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://23a44b54c26c4283a60a708bda4cfeb1c7626cc9a678dcae85a0046affdbf610\",\"dweb:/ipfs/QmUqsW65JXH7VkmGijSUdQRhMSJt5GTRsqyBCw5XAzore6\"]}},\"version\":1}",
  "bytecode": "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",
  "deployedBytecode": "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",
  "immutableReferences": {},
  "generatedSources": [
    {
      "ast": {
        "nodeType": "YulBlock",
        "src": "0:2328:6",
        "statements": [
          {
            "nodeType": "YulBlock",
            "src": "6:3:6",
            "statements": []
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "78:821:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "127:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "136:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "139:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "129:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "129:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "129:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "106:6:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "114:4:6",
                                "type": "",
                                "value": "0x1f"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "102:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "102:17:6"
                          },
                          {
                            "name": "end",
                            "nodeType": "YulIdentifier",
                            "src": "121:3:6"
                          }
                        ],
                        "functionName": {
                          "name": "slt",
                          "nodeType": "YulIdentifier",
                          "src": "98:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "98:27:6"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "91:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "91:35:6"
                  },
                  "nodeType": "YulIf",
                  "src": "88:55:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "152:23:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "168:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "162:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "162:13:6"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "156:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "184:28:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "194:18:6",
                    "type": "",
                    "value": "0xffffffffffffffff"
                  },
                  "variables": [
                    {
                      "name": "_2",
                      "nodeType": "YulTypedName",
                      "src": "188:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "235:22:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x41",
                            "nodeType": "YulIdentifier",
                            "src": "237:16:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "237:18:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "237:18:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "227:2:6"
                      },
                      {
                        "name": "_2",
                        "nodeType": "YulIdentifier",
                        "src": "231:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "224:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "224:10:6"
                  },
                  "nodeType": "YulIf",
                  "src": "221:36:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "266:17:6",
                  "value": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "280:2:6",
                        "type": "",
                        "value": "31"
                      }
                    ],
                    "functionName": {
                      "name": "not",
                      "nodeType": "YulIdentifier",
                      "src": "276:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "276:7:6"
                  },
                  "variables": [
                    {
                      "name": "_3",
                      "nodeType": "YulTypedName",
                      "src": "270:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "292:23:6",
                  "value": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "312:2:6",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "306:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "306:9:6"
                  },
                  "variables": [
                    {
                      "name": "memPtr",
                      "nodeType": "YulTypedName",
                      "src": "296:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "324:71:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "memPtr",
                        "nodeType": "YulIdentifier",
                        "src": "346:6:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "arguments": [
                                      {
                                        "name": "_1",
                                        "nodeType": "YulIdentifier",
                                        "src": "370:2:6"
                                      },
                                      {
                                        "kind": "number",
                                        "nodeType": "YulLiteral",
                                        "src": "374:4:6",
                                        "type": "",
                                        "value": "0x1f"
                                      }
                                    ],
                                    "functionName": {
                                      "name": "add",
                                      "nodeType": "YulIdentifier",
                                      "src": "366:3:6"
                                    },
                                    "nodeType": "YulFunctionCall",
                                    "src": "366:13:6"
                                  },
                                  {
                                    "name": "_3",
                                    "nodeType": "YulIdentifier",
                                    "src": "381:2:6"
                                  }
                                ],
                                "functionName": {
                                  "name": "and",
                                  "nodeType": "YulIdentifier",
                                  "src": "362:3:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "362:22:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "386:2:6",
                                "type": "",
                                "value": "63"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "358:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "358:31:6"
                          },
                          {
                            "name": "_3",
                            "nodeType": "YulIdentifier",
                            "src": "391:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "354:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "354:40:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "342:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "342:53:6"
                  },
                  "variables": [
                    {
                      "name": "newFreePtr",
                      "nodeType": "YulTypedName",
                      "src": "328:10:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "454:22:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x41",
                            "nodeType": "YulIdentifier",
                            "src": "456:16:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "456:18:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "456:18:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "newFreePtr",
                            "nodeType": "YulIdentifier",
                            "src": "413:10:6"
                          },
                          {
                            "name": "_2",
                            "nodeType": "YulIdentifier",
                            "src": "425:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "gt",
                          "nodeType": "YulIdentifier",
                          "src": "410:2:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "410:18:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "newFreePtr",
                            "nodeType": "YulIdentifier",
                            "src": "433:10:6"
                          },
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "445:6:6"
                          }
                        ],
                        "functionName": {
                          "name": "lt",
                          "nodeType": "YulIdentifier",
                          "src": "430:2:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "430:22:6"
                      }
                    ],
                    "functionName": {
                      "name": "or",
                      "nodeType": "YulIdentifier",
                      "src": "407:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "407:46:6"
                  },
                  "nodeType": "YulIf",
                  "src": "404:72:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "492:2:6",
                        "type": "",
                        "value": "64"
                      },
                      {
                        "name": "newFreePtr",
                        "nodeType": "YulIdentifier",
                        "src": "496:10:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "485:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "485:22:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "485:22:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "memPtr",
                        "nodeType": "YulIdentifier",
                        "src": "523:6:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "531:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "516:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "516:18:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "516:18:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "543:14:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "553:4:6",
                    "type": "",
                    "value": "0x20"
                  },
                  "variables": [
                    {
                      "name": "_4",
                      "nodeType": "YulTypedName",
                      "src": "547:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "603:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "612:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "615:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "605:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "605:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "605:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "580:6:6"
                              },
                              {
                                "name": "_1",
                                "nodeType": "YulIdentifier",
                                "src": "588:2:6"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "576:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "576:15:6"
                          },
                          {
                            "name": "_4",
                            "nodeType": "YulIdentifier",
                            "src": "593:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "572:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "572:24:6"
                      },
                      {
                        "name": "end",
                        "nodeType": "YulIdentifier",
                        "src": "598:3:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "569:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "569:33:6"
                  },
                  "nodeType": "YulIf",
                  "src": "566:53:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "628:10:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "637:1:6",
                    "type": "",
                    "value": "0"
                  },
                  "variables": [
                    {
                      "name": "i",
                      "nodeType": "YulTypedName",
                      "src": "632:1:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "693:87:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "name": "memPtr",
                                      "nodeType": "YulIdentifier",
                                      "src": "722:6:6"
                                    },
                                    {
                                      "name": "i",
                                      "nodeType": "YulIdentifier",
                                      "src": "730:1:6"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "add",
                                    "nodeType": "YulIdentifier",
                                    "src": "718:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "718:14:6"
                                },
                                {
                                  "name": "_4",
                                  "nodeType": "YulIdentifier",
                                  "src": "734:2:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "714:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "714:23:6"
                            },
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "arguments": [
                                        {
                                          "name": "offset",
                                          "nodeType": "YulIdentifier",
                                          "src": "753:6:6"
                                        },
                                        {
                                          "name": "i",
                                          "nodeType": "YulIdentifier",
                                          "src": "761:1:6"
                                        }
                                      ],
                                      "functionName": {
                                        "name": "add",
                                        "nodeType": "YulIdentifier",
                                        "src": "749:3:6"
                                      },
                                      "nodeType": "YulFunctionCall",
                                      "src": "749:14:6"
                                    },
                                    {
                                      "name": "_4",
                                      "nodeType": "YulIdentifier",
                                      "src": "765:2:6"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "add",
                                    "nodeType": "YulIdentifier",
                                    "src": "745:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "745:23:6"
                                }
                              ],
                              "functionName": {
                                "name": "mload",
                                "nodeType": "YulIdentifier",
                                "src": "739:5:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "739:30:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "707:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "707:63:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "707:63:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "i",
                        "nodeType": "YulIdentifier",
                        "src": "658:1:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "661:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "lt",
                      "nodeType": "YulIdentifier",
                      "src": "655:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "655:9:6"
                  },
                  "nodeType": "YulForLoop",
                  "post": {
                    "nodeType": "YulBlock",
                    "src": "665:19:6",
                    "statements": [
                      {
                        "nodeType": "YulAssignment",
                        "src": "667:15:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "i",
                              "nodeType": "YulIdentifier",
                              "src": "676:1:6"
                            },
                            {
                              "name": "_4",
                              "nodeType": "YulIdentifier",
                              "src": "679:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "672:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "672:10:6"
                        },
                        "variableNames": [
                          {
                            "name": "i",
                            "nodeType": "YulIdentifier",
                            "src": "667:1:6"
                          }
                        ]
                      }
                    ]
                  },
                  "pre": {
                    "nodeType": "YulBlock",
                    "src": "651:3:6",
                    "statements": []
                  },
                  "src": "647:133:6"
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "810:59:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "name": "memPtr",
                                      "nodeType": "YulIdentifier",
                                      "src": "839:6:6"
                                    },
                                    {
                                      "name": "_1",
                                      "nodeType": "YulIdentifier",
                                      "src": "847:2:6"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "add",
                                    "nodeType": "YulIdentifier",
                                    "src": "835:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "835:15:6"
                                },
                                {
                                  "name": "_4",
                                  "nodeType": "YulIdentifier",
                                  "src": "852:2:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "831:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "831:24:6"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "857:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "824:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "824:35:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "824:35:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "i",
                        "nodeType": "YulIdentifier",
                        "src": "795:1:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "798:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "792:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "792:9:6"
                  },
                  "nodeType": "YulIf",
                  "src": "789:80:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "878:15:6",
                  "value": {
                    "name": "memPtr",
                    "nodeType": "YulIdentifier",
                    "src": "887:6:6"
                  },
                  "variableNames": [
                    {
                      "name": "array",
                      "nodeType": "YulIdentifier",
                      "src": "878:5:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_string_fromMemory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "offset",
                "nodeType": "YulTypedName",
                "src": "52:6:6",
                "type": ""
              },
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "60:3:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "array",
                "nodeType": "YulTypedName",
                "src": "68:5:6",
                "type": ""
              }
            ],
            "src": "14:885:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1056:639:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1103:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1112:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1115:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1105:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1105:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1105:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1077:7:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1086:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "1073:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1073:23:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1098:3:6",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "1069:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1069:33:6"
                  },
                  "nodeType": "YulIf",
                  "src": "1066:53:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1128:29:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "1147:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "1141:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1141:16:6"
                  },
                  "variables": [
                    {
                      "name": "value",
                      "nodeType": "YulTypedName",
                      "src": "1132:5:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1220:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1229:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1232:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1222:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1222:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1222:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "1179:5:6"
                          },
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "1190:5:6"
                              },
                              {
                                "arguments": [
                                  {
                                    "arguments": [
                                      {
                                        "kind": "number",
                                        "nodeType": "YulLiteral",
                                        "src": "1205:1:6",
                                        "type": "",
                                        "value": "2"
                                      },
                                      {
                                        "kind": "number",
                                        "nodeType": "YulLiteral",
                                        "src": "1208:3:6",
                                        "type": "",
                                        "value": "160"
                                      }
                                    ],
                                    "functionName": {
                                      "name": "exp",
                                      "nodeType": "YulIdentifier",
                                      "src": "1201:3:6"
                                    },
                                    "nodeType": "YulFunctionCall",
                                    "src": "1201:11:6"
                                  },
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "1214:1:6",
                                    "type": "",
                                    "value": "1"
                                  }
                                ],
                                "functionName": {
                                  "name": "sub",
                                  "nodeType": "YulIdentifier",
                                  "src": "1197:3:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "1197:19:6"
                              }
                            ],
                            "functionName": {
                              "name": "and",
                              "nodeType": "YulIdentifier",
                              "src": "1186:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1186:31:6"
                          }
                        ],
                        "functionName": {
                          "name": "eq",
                          "nodeType": "YulIdentifier",
                          "src": "1176:2:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1176:42:6"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "1169:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1169:50:6"
                  },
                  "nodeType": "YulIf",
                  "src": "1166:70:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1245:15:6",
                  "value": {
                    "name": "value",
                    "nodeType": "YulIdentifier",
                    "src": "1255:5:6"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "1245:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1269:39:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1293:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1304:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1289:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1289:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "1283:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1283:25:6"
                  },
                  "variables": [
                    {
                      "name": "offset",
                      "nodeType": "YulTypedName",
                      "src": "1273:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1317:28:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "1327:18:6",
                    "type": "",
                    "value": "0xffffffffffffffff"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "1321:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1372:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1381:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1384:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1374:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1374:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1374:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "1360:6:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "1368:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "1357:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1357:14:6"
                  },
                  "nodeType": "YulIf",
                  "src": "1354:34:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1397:71:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1440:9:6"
                          },
                          {
                            "name": "offset",
                            "nodeType": "YulIdentifier",
                            "src": "1451:6:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1436:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1436:22:6"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "1460:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string_fromMemory",
                      "nodeType": "YulIdentifier",
                      "src": "1407:28:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1407:61:6"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "1397:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1477:41:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1503:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1514:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1499:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1499:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "1493:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1493:25:6"
                  },
                  "variables": [
                    {
                      "name": "offset_1",
                      "nodeType": "YulTypedName",
                      "src": "1481:8:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1547:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1556:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1559:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1549:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1549:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1549:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset_1",
                        "nodeType": "YulIdentifier",
                        "src": "1533:8:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "1543:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "1530:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1530:16:6"
                  },
                  "nodeType": "YulIf",
                  "src": "1527:36:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1572:73:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1615:9:6"
                          },
                          {
                            "name": "offset_1",
                            "nodeType": "YulIdentifier",
                            "src": "1626:8:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1611:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1611:24:6"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "1637:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string_fromMemory",
                      "nodeType": "YulIdentifier",
                      "src": "1582:28:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1582:63:6"
                  },
                  "variableNames": [
                    {
                      "name": "value2",
                      "nodeType": "YulIdentifier",
                      "src": "1572:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1654:35:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1674:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1685:2:6",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1670:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1670:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "1664:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1664:25:6"
                  },
                  "variableNames": [
                    {
                      "name": "value3",
                      "nodeType": "YulIdentifier",
                      "src": "1654:6:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_addresst_string_memory_ptrt_string_memory_ptrt_uint256_fromMemory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "998:9:6",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "1009:7:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "1021:6:6",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "1029:6:6",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "1037:6:6",
                "type": ""
              },
              {
                "name": "value3",
                "nodeType": "YulTypedName",
                "src": "1045:6:6",
                "type": ""
              }
            ],
            "src": "904:791:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1755:382:6",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "1765:22:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "data",
                        "nodeType": "YulIdentifier",
                        "src": "1779:4:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1785:1:6",
                        "type": "",
                        "value": "2"
                      }
                    ],
                    "functionName": {
                      "name": "div",
                      "nodeType": "YulIdentifier",
                      "src": "1775:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1775:12:6"
                  },
                  "variableNames": [
                    {
                      "name": "length",
                      "nodeType": "YulIdentifier",
                      "src": "1765:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1796:38:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "data",
                        "nodeType": "YulIdentifier",
                        "src": "1826:4:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1832:1:6",
                        "type": "",
                        "value": "1"
                      }
                    ],
                    "functionName": {
                      "name": "and",
                      "nodeType": "YulIdentifier",
                      "src": "1822:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1822:12:6"
                  },
                  "variables": [
                    {
                      "name": "outOfPlaceEncoding",
                      "nodeType": "YulTypedName",
                      "src": "1800:18:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1873:31:6",
                    "statements": [
                      {
                        "nodeType": "YulAssignment",
                        "src": "1875:27:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "length",
                              "nodeType": "YulIdentifier",
                              "src": "1889:6:6"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1897:4:6",
                              "type": "",
                              "value": "0x7f"
                            }
                          ],
                          "functionName": {
                            "name": "and",
                            "nodeType": "YulIdentifier",
                            "src": "1885:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1885:17:6"
                        },
                        "variableNames": [
                          {
                            "name": "length",
                            "nodeType": "YulIdentifier",
                            "src": "1875:6:6"
                          }
                        ]
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "outOfPlaceEncoding",
                        "nodeType": "YulIdentifier",
                        "src": "1853:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "1846:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1846:26:6"
                  },
                  "nodeType": "YulIf",
                  "src": "1843:61:6"
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1963:168:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1984:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1987:77:6",
                              "type": "",
                              "value": "35408467139433450592217433187231851964531694900788300625387963629091585785856"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "1977:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1977:88:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1977:88:6"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2085:1:6",
                              "type": "",
                              "value": "4"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2088:4:6",
                              "type": "",
                              "value": "0x22"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "2078:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2078:15:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2078:15:6"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2113:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2116:4:6",
                              "type": "",
                              "value": "0x24"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "2106:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2106:15:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2106:15:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "outOfPlaceEncoding",
                        "nodeType": "YulIdentifier",
                        "src": "1919:18:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "length",
                            "nodeType": "YulIdentifier",
                            "src": "1942:6:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1950:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "lt",
                          "nodeType": "YulIdentifier",
                          "src": "1939:2:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1939:14:6"
                      }
                    ],
                    "functionName": {
                      "name": "eq",
                      "nodeType": "YulIdentifier",
                      "src": "1916:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1916:38:6"
                  },
                  "nodeType": "YulIf",
                  "src": "1913:218:6"
                }
              ]
            },
            "name": "extract_byte_array_length",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "data",
                "nodeType": "YulTypedName",
                "src": "1735:4:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "length",
                "nodeType": "YulTypedName",
                "src": "1744:6:6",
                "type": ""
              }
            ],
            "src": "1700:437:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2174:152:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2191:1:6",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2194:77:6",
                        "type": "",
                        "value": "35408467139433450592217433187231851964531694900788300625387963629091585785856"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "2184:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2184:88:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2184:88:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2288:1:6",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2291:4:6",
                        "type": "",
                        "value": "0x41"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "2281:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2281:15:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2281:15:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2312:1:6",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2315:4:6",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "2305:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2305:15:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2305:15:6"
                }
              ]
            },
            "name": "panic_error_0x41",
            "nodeType": "YulFunctionDefinition",
            "src": "2142:184:6"
          }
        ]
      },
      "contents": "{\n    { }\n    function abi_decode_string_fromMemory(offset, end) -> array\n    {\n        if iszero(slt(add(offset, 0x1f), end)) { revert(0, 0) }\n        let _1 := mload(offset)\n        let _2 := 0xffffffffffffffff\n        if gt(_1, _2) { panic_error_0x41() }\n        let _3 := not(31)\n        let memPtr := mload(64)\n        let newFreePtr := add(memPtr, and(add(and(add(_1, 0x1f), _3), 63), _3))\n        if or(gt(newFreePtr, _2), lt(newFreePtr, memPtr)) { panic_error_0x41() }\n        mstore(64, newFreePtr)\n        mstore(memPtr, _1)\n        let _4 := 0x20\n        if gt(add(add(offset, _1), _4), end) { revert(0, 0) }\n        let i := 0\n        for { } lt(i, _1) { i := add(i, _4) }\n        {\n            mstore(add(add(memPtr, i), _4), mload(add(add(offset, i), _4)))\n        }\n        if gt(i, _1)\n        {\n            mstore(add(add(memPtr, _1), _4), 0)\n        }\n        array := memPtr\n    }\n    function abi_decode_tuple_t_addresst_string_memory_ptrt_string_memory_ptrt_uint256_fromMemory(headStart, dataEnd) -> value0, value1, value2, value3\n    {\n        if slt(sub(dataEnd, headStart), 128) { revert(0, 0) }\n        let value := mload(headStart)\n        if iszero(eq(value, and(value, sub(exp(2, 160), 1)))) { revert(0, 0) }\n        value0 := value\n        let offset := mload(add(headStart, 32))\n        let _1 := 0xffffffffffffffff\n        if gt(offset, _1) { revert(0, 0) }\n        value1 := abi_decode_string_fromMemory(add(headStart, offset), dataEnd)\n        let offset_1 := mload(add(headStart, 64))\n        if gt(offset_1, _1) { revert(0, 0) }\n        value2 := abi_decode_string_fromMemory(add(headStart, offset_1), dataEnd)\n        value3 := mload(add(headStart, 96))\n    }\n    function extract_byte_array_length(data) -> length\n    {\n        length := div(data, 2)\n        let outOfPlaceEncoding := and(data, 1)\n        if iszero(outOfPlaceEncoding) { length := and(length, 0x7f) }\n        if eq(outOfPlaceEncoding, lt(length, 32))\n        {\n            mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\n            mstore(4, 0x22)\n            revert(0, 0x24)\n        }\n    }\n    function panic_error_0x41()\n    {\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\n        mstore(4, 0x41)\n        revert(0, 0x24)\n    }\n}",
      "id": 6,
      "language": "Yul",
      "name": "#utility.yul"
    }
  ],
  "deployedGeneratedSources": [
    {
      "ast": {
        "nodeType": "YulBlock",
        "src": "0:23609:6",
        "statements": [
          {
            "nodeType": "YulBlock",
            "src": "6:3:6",
            "statements": []
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "77:849:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "126:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "135:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "138:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "128:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "128:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "128:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "105:6:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "113:4:6",
                                "type": "",
                                "value": "0x1f"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "101:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "101:17:6"
                          },
                          {
                            "name": "end",
                            "nodeType": "YulIdentifier",
                            "src": "120:3:6"
                          }
                        ],
                        "functionName": {
                          "name": "slt",
                          "nodeType": "YulIdentifier",
                          "src": "97:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "97:27:6"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "90:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "90:35:6"
                  },
                  "nodeType": "YulIf",
                  "src": "87:55:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "151:30:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "174:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "161:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "161:20:6"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "155:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "190:14:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "200:4:6",
                    "type": "",
                    "value": "0x20"
                  },
                  "variables": [
                    {
                      "name": "_2",
                      "nodeType": "YulTypedName",
                      "src": "194:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "213:28:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "223:18:6",
                    "type": "",
                    "value": "0xffffffffffffffff"
                  },
                  "variables": [
                    {
                      "name": "_3",
                      "nodeType": "YulTypedName",
                      "src": "217:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "264:22:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x41",
                            "nodeType": "YulIdentifier",
                            "src": "266:16:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "266:18:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "266:18:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "256:2:6"
                      },
                      {
                        "name": "_3",
                        "nodeType": "YulIdentifier",
                        "src": "260:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "253:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "253:10:6"
                  },
                  "nodeType": "YulIf",
                  "src": "250:36:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "295:21:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "309:2:6"
                      },
                      {
                        "name": "_2",
                        "nodeType": "YulIdentifier",
                        "src": "313:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "mul",
                      "nodeType": "YulIdentifier",
                      "src": "305:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "305:11:6"
                  },
                  "variables": [
                    {
                      "name": "_4",
                      "nodeType": "YulTypedName",
                      "src": "299:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "325:39:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "_4",
                            "nodeType": "YulIdentifier",
                            "src": "356:2:6"
                          },
                          {
                            "name": "_2",
                            "nodeType": "YulIdentifier",
                            "src": "360:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "352:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "352:11:6"
                      }
                    ],
                    "functionName": {
                      "name": "allocate_memory",
                      "nodeType": "YulIdentifier",
                      "src": "336:15:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "336:28:6"
                  },
                  "variables": [
                    {
                      "name": "dst",
                      "nodeType": "YulTypedName",
                      "src": "329:3:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "373:16:6",
                  "value": {
                    "name": "dst",
                    "nodeType": "YulIdentifier",
                    "src": "386:3:6"
                  },
                  "variables": [
                    {
                      "name": "dst_1",
                      "nodeType": "YulTypedName",
                      "src": "377:5:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "dst",
                        "nodeType": "YulIdentifier",
                        "src": "405:3:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "410:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "398:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "398:15:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "398:15:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "422:19:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "dst",
                        "nodeType": "YulIdentifier",
                        "src": "433:3:6"
                      },
                      {
                        "name": "_2",
                        "nodeType": "YulIdentifier",
                        "src": "438:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "429:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "429:12:6"
                  },
                  "variableNames": [
                    {
                      "name": "dst",
                      "nodeType": "YulIdentifier",
                      "src": "422:3:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "450:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "465:6:6"
                      },
                      {
                        "name": "_2",
                        "nodeType": "YulIdentifier",
                        "src": "473:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "461:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "461:15:6"
                  },
                  "variables": [
                    {
                      "name": "src",
                      "nodeType": "YulTypedName",
                      "src": "454:3:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "522:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "531:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "534:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "524:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "524:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "524:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "499:6:6"
                              },
                              {
                                "name": "_4",
                                "nodeType": "YulIdentifier",
                                "src": "507:2:6"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "495:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "495:15:6"
                          },
                          {
                            "name": "_2",
                            "nodeType": "YulIdentifier",
                            "src": "512:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "491:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "491:24:6"
                      },
                      {
                        "name": "end",
                        "nodeType": "YulIdentifier",
                        "src": "517:3:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "488:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "488:33:6"
                  },
                  "nodeType": "YulIf",
                  "src": "485:53:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "547:10:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "556:1:6",
                    "type": "",
                    "value": "0"
                  },
                  "variables": [
                    {
                      "name": "i",
                      "nodeType": "YulTypedName",
                      "src": "551:1:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "566:12:6",
                  "value": {
                    "name": "i",
                    "nodeType": "YulIdentifier",
                    "src": "577:1:6"
                  },
                  "variables": [
                    {
                      "name": "i_1",
                      "nodeType": "YulTypedName",
                      "src": "570:3:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "638:259:6",
                    "statements": [
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "652:36:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "src",
                              "nodeType": "YulIdentifier",
                              "src": "684:3:6"
                            }
                          ],
                          "functionName": {
                            "name": "calldataload",
                            "nodeType": "YulIdentifier",
                            "src": "671:12:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "671:17:6"
                        },
                        "variables": [
                          {
                            "name": "innerOffset",
                            "nodeType": "YulTypedName",
                            "src": "656:11:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "body": {
                          "nodeType": "YulBlock",
                          "src": "724:16:6",
                          "statements": [
                            {
                              "expression": {
                                "arguments": [
                                  {
                                    "name": "i",
                                    "nodeType": "YulIdentifier",
                                    "src": "733:1:6"
                                  },
                                  {
                                    "name": "i",
                                    "nodeType": "YulIdentifier",
                                    "src": "736:1:6"
                                  }
                                ],
                                "functionName": {
                                  "name": "revert",
                                  "nodeType": "YulIdentifier",
                                  "src": "726:6:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "726:12:6"
                              },
                              "nodeType": "YulExpressionStatement",
                              "src": "726:12:6"
                            }
                          ]
                        },
                        "condition": {
                          "arguments": [
                            {
                              "name": "innerOffset",
                              "nodeType": "YulIdentifier",
                              "src": "707:11:6"
                            },
                            {
                              "name": "_3",
                              "nodeType": "YulIdentifier",
                              "src": "720:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "gt",
                            "nodeType": "YulIdentifier",
                            "src": "704:2:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "704:19:6"
                        },
                        "nodeType": "YulIf",
                        "src": "701:39:6"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "name": "dst",
                              "nodeType": "YulIdentifier",
                              "src": "760:3:6"
                            },
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "arguments": [
                                        {
                                          "name": "offset",
                                          "nodeType": "YulIdentifier",
                                          "src": "791:6:6"
                                        },
                                        {
                                          "name": "innerOffset",
                                          "nodeType": "YulIdentifier",
                                          "src": "799:11:6"
                                        }
                                      ],
                                      "functionName": {
                                        "name": "add",
                                        "nodeType": "YulIdentifier",
                                        "src": "787:3:6"
                                      },
                                      "nodeType": "YulFunctionCall",
                                      "src": "787:24:6"
                                    },
                                    {
                                      "name": "_2",
                                      "nodeType": "YulIdentifier",
                                      "src": "813:2:6"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "add",
                                    "nodeType": "YulIdentifier",
                                    "src": "783:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "783:33:6"
                                },
                                {
                                  "name": "end",
                                  "nodeType": "YulIdentifier",
                                  "src": "818:3:6"
                                }
                              ],
                              "functionName": {
                                "name": "abi_decode_string",
                                "nodeType": "YulIdentifier",
                                "src": "765:17:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "765:57:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "753:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "753:70:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "753:70:6"
                      },
                      {
                        "nodeType": "YulAssignment",
                        "src": "836:19:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "dst",
                              "nodeType": "YulIdentifier",
                              "src": "847:3:6"
                            },
                            {
                              "name": "_2",
                              "nodeType": "YulIdentifier",
                              "src": "852:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "843:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "843:12:6"
                        },
                        "variableNames": [
                          {
                            "name": "dst",
                            "nodeType": "YulIdentifier",
                            "src": "836:3:6"
                          }
                        ]
                      },
                      {
                        "nodeType": "YulAssignment",
                        "src": "868:19:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "src",
                              "nodeType": "YulIdentifier",
                              "src": "879:3:6"
                            },
                            {
                              "name": "_2",
                              "nodeType": "YulIdentifier",
                              "src": "884:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "875:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "875:12:6"
                        },
                        "variableNames": [
                          {
                            "name": "src",
                            "nodeType": "YulIdentifier",
                            "src": "868:3:6"
                          }
                        ]
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "i_1",
                        "nodeType": "YulIdentifier",
                        "src": "598:3:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "603:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "lt",
                      "nodeType": "YulIdentifier",
                      "src": "595:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "595:11:6"
                  },
                  "nodeType": "YulForLoop",
                  "post": {
                    "nodeType": "YulBlock",
                    "src": "607:22:6",
                    "statements": [
                      {
                        "nodeType": "YulAssignment",
                        "src": "609:18:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "i_1",
                              "nodeType": "YulIdentifier",
                              "src": "620:3:6"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "625:1:6",
                              "type": "",
                              "value": "1"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "616:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "616:11:6"
                        },
                        "variableNames": [
                          {
                            "name": "i_1",
                            "nodeType": "YulIdentifier",
                            "src": "609:3:6"
                          }
                        ]
                      }
                    ]
                  },
                  "pre": {
                    "nodeType": "YulBlock",
                    "src": "591:3:6",
                    "statements": []
                  },
                  "src": "587:310:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "906:14:6",
                  "value": {
                    "name": "dst_1",
                    "nodeType": "YulIdentifier",
                    "src": "915:5:6"
                  },
                  "variableNames": [
                    {
                      "name": "array",
                      "nodeType": "YulIdentifier",
                      "src": "906:5:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_array_string_dyn",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "offset",
                "nodeType": "YulTypedName",
                "src": "51:6:6",
                "type": ""
              },
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "59:3:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "array",
                "nodeType": "YulTypedName",
                "src": "67:5:6",
                "type": ""
              }
            ],
            "src": "14:912:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "984:478:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1033:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1042:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1045:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1035:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1035:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1035:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "1012:6:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "1020:4:6",
                                "type": "",
                                "value": "0x1f"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "1008:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1008:17:6"
                          },
                          {
                            "name": "end",
                            "nodeType": "YulIdentifier",
                            "src": "1027:3:6"
                          }
                        ],
                        "functionName": {
                          "name": "slt",
                          "nodeType": "YulIdentifier",
                          "src": "1004:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1004:27:6"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "997:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "997:35:6"
                  },
                  "nodeType": "YulIf",
                  "src": "994:55:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1058:30:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "1081:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "1068:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1068:20:6"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "1062:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1127:22:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x41",
                            "nodeType": "YulIdentifier",
                            "src": "1129:16:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1129:18:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1129:18:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "1103:2:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1107:18:6",
                        "type": "",
                        "value": "0xffffffffffffffff"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "1100:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1100:26:6"
                  },
                  "nodeType": "YulIf",
                  "src": "1097:52:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1158:70:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "name": "_1",
                                    "nodeType": "YulIdentifier",
                                    "src": "1201:2:6"
                                  },
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "1205:4:6",
                                    "type": "",
                                    "value": "0x1f"
                                  }
                                ],
                                "functionName": {
                                  "name": "add",
                                  "nodeType": "YulIdentifier",
                                  "src": "1197:3:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "1197:13:6"
                              },
                              {
                                "arguments": [
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "1216:2:6",
                                    "type": "",
                                    "value": "31"
                                  }
                                ],
                                "functionName": {
                                  "name": "not",
                                  "nodeType": "YulIdentifier",
                                  "src": "1212:3:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "1212:7:6"
                              }
                            ],
                            "functionName": {
                              "name": "and",
                              "nodeType": "YulIdentifier",
                              "src": "1193:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1193:27:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1222:4:6",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1189:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1189:38:6"
                      }
                    ],
                    "functionName": {
                      "name": "allocate_memory",
                      "nodeType": "YulIdentifier",
                      "src": "1173:15:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1173:55:6"
                  },
                  "variables": [
                    {
                      "name": "array_1",
                      "nodeType": "YulTypedName",
                      "src": "1162:7:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "array_1",
                        "nodeType": "YulIdentifier",
                        "src": "1244:7:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "1253:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "1237:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1237:19:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1237:19:6"
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1304:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1313:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1316:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1306:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1306:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1306:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "1279:6:6"
                              },
                              {
                                "name": "_1",
                                "nodeType": "YulIdentifier",
                                "src": "1287:2:6"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "1275:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1275:15:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1292:4:6",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1271:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1271:26:6"
                      },
                      {
                        "name": "end",
                        "nodeType": "YulIdentifier",
                        "src": "1299:3:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "1268:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1268:35:6"
                  },
                  "nodeType": "YulIf",
                  "src": "1265:55:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "array_1",
                            "nodeType": "YulIdentifier",
                            "src": "1346:7:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1355:4:6",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1342:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1342:18:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "offset",
                            "nodeType": "YulIdentifier",
                            "src": "1366:6:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1374:4:6",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1362:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1362:17:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "1381:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldatacopy",
                      "nodeType": "YulIdentifier",
                      "src": "1329:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1329:55:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1329:55:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "array_1",
                                "nodeType": "YulIdentifier",
                                "src": "1408:7:6"
                              },
                              {
                                "name": "_1",
                                "nodeType": "YulIdentifier",
                                "src": "1417:2:6"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "1404:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1404:16:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1422:4:6",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1400:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1400:27:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1429:1:6",
                        "type": "",
                        "value": "0"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "1393:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1393:38:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1393:38:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1440:16:6",
                  "value": {
                    "name": "array_1",
                    "nodeType": "YulIdentifier",
                    "src": "1449:7:6"
                  },
                  "variableNames": [
                    {
                      "name": "array",
                      "nodeType": "YulIdentifier",
                      "src": "1440:5:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_string",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "offset",
                "nodeType": "YulTypedName",
                "src": "958:6:6",
                "type": ""
              },
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "966:3:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "array",
                "nodeType": "YulTypedName",
                "src": "974:5:6",
                "type": ""
              }
            ],
            "src": "931:531:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1537:177:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1583:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1592:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1595:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1585:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1585:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1585:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1558:7:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1567:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "1554:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1554:23:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1579:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "1550:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1550:32:6"
                  },
                  "nodeType": "YulIf",
                  "src": "1547:52:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1608:36:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "1634:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "1621:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1621:23:6"
                  },
                  "variables": [
                    {
                      "name": "value",
                      "nodeType": "YulTypedName",
                      "src": "1612:5:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "1678:5:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_address",
                      "nodeType": "YulIdentifier",
                      "src": "1653:24:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1653:31:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1653:31:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1693:15:6",
                  "value": {
                    "name": "value",
                    "nodeType": "YulIdentifier",
                    "src": "1703:5:6"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "1693:6:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "1503:9:6",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "1514:7:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "1526:6:6",
                "type": ""
              }
            ],
            "src": "1467:247:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1797:167:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1843:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1852:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1855:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1845:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1845:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1845:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1818:7:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1827:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "1814:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1814:23:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1839:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "1810:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1810:32:6"
                  },
                  "nodeType": "YulIf",
                  "src": "1807:52:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "1868:29:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "1887:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "1881:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1881:16:6"
                  },
                  "variables": [
                    {
                      "name": "value",
                      "nodeType": "YulTypedName",
                      "src": "1872:5:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "1928:5:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_bool",
                      "nodeType": "YulIdentifier",
                      "src": "1906:21:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1906:28:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1906:28:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "1943:15:6",
                  "value": {
                    "name": "value",
                    "nodeType": "YulIdentifier",
                    "src": "1953:5:6"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "1943:6:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_bool_fromMemory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "1763:9:6",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "1774:7:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "1786:6:6",
                "type": ""
              }
            ],
            "src": "1719:245:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2070:228:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "2116:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2125:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2128:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "2118:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2118:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2118:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2091:7:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2100:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "2087:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2087:23:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2112:2:6",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "2083:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2083:32:6"
                  },
                  "nodeType": "YulIf",
                  "src": "2080:52:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "2141:36:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "2167:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "2154:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2154:23:6"
                  },
                  "variables": [
                    {
                      "name": "value",
                      "nodeType": "YulTypedName",
                      "src": "2145:5:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "2211:5:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_address",
                      "nodeType": "YulIdentifier",
                      "src": "2186:24:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2186:31:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2186:31:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2226:15:6",
                  "value": {
                    "name": "value",
                    "nodeType": "YulIdentifier",
                    "src": "2236:5:6"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "2226:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2250:42:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2277:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2288:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "2273:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2273:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "2260:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2260:32:6"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "2250:6:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_contract$_Token_$2124t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "2028:9:6",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "2039:7:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "2051:6:6",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "2059:6:6",
                "type": ""
              }
            ],
            "src": "1969:329:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2527:922:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "2574:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2583:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2586:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "2576:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2576:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2576:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2548:7:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2557:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "2544:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2544:23:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2569:3:6",
                        "type": "",
                        "value": "192"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "2540:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2540:33:6"
                  },
                  "nodeType": "YulIf",
                  "src": "2537:53:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "2599:36:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "2625:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "2612:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2612:23:6"
                  },
                  "variables": [
                    {
                      "name": "value",
                      "nodeType": "YulTypedName",
                      "src": "2603:5:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "2679:5:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_enum_QuestionType",
                      "nodeType": "YulIdentifier",
                      "src": "2644:34:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2644:41:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2644:41:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2694:15:6",
                  "value": {
                    "name": "value",
                    "nodeType": "YulIdentifier",
                    "src": "2704:5:6"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "2694:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2718:42:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2745:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2756:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "2741:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2741:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "2728:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2728:32:6"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "2718:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "2769:47:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2801:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2812:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "2797:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2797:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "2784:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2784:32:6"
                  },
                  "variables": [
                    {
                      "name": "value_1",
                      "nodeType": "YulTypedName",
                      "src": "2773:7:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value_1",
                        "nodeType": "YulIdentifier",
                        "src": "2847:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_bool",
                      "nodeType": "YulIdentifier",
                      "src": "2825:21:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2825:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2825:30:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "2864:17:6",
                  "value": {
                    "name": "value_1",
                    "nodeType": "YulIdentifier",
                    "src": "2874:7:6"
                  },
                  "variableNames": [
                    {
                      "name": "value2",
                      "nodeType": "YulIdentifier",
                      "src": "2864:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "2890:46:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2921:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2932:2:6",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "2917:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2917:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "2904:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2904:32:6"
                  },
                  "variables": [
                    {
                      "name": "offset",
                      "nodeType": "YulTypedName",
                      "src": "2894:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "2945:28:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "2955:18:6",
                    "type": "",
                    "value": "0xffffffffffffffff"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "2949:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "3000:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "3009:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "3012:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "3002:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "3002:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "3002:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "2988:6:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "2996:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "2985:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2985:14:6"
                  },
                  "nodeType": "YulIf",
                  "src": "2982:34:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "3025:60:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "3057:9:6"
                          },
                          {
                            "name": "offset",
                            "nodeType": "YulIdentifier",
                            "src": "3068:6:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "3053:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3053:22:6"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "3077:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string",
                      "nodeType": "YulIdentifier",
                      "src": "3035:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3035:50:6"
                  },
                  "variableNames": [
                    {
                      "name": "value3",
                      "nodeType": "YulIdentifier",
                      "src": "3025:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "3094:49:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "3127:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "3138:3:6",
                            "type": "",
                            "value": "128"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "3123:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3123:19:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "3110:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3110:33:6"
                  },
                  "variables": [
                    {
                      "name": "offset_1",
                      "nodeType": "YulTypedName",
                      "src": "3098:8:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "3172:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "3181:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "3184:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "3174:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "3174:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "3174:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset_1",
                        "nodeType": "YulIdentifier",
                        "src": "3158:8:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "3168:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "3155:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3155:16:6"
                  },
                  "nodeType": "YulIf",
                  "src": "3152:36:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "3197:62:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "3229:9:6"
                          },
                          {
                            "name": "offset_1",
                            "nodeType": "YulIdentifier",
                            "src": "3240:8:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "3225:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3225:24:6"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "3251:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string",
                      "nodeType": "YulIdentifier",
                      "src": "3207:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3207:52:6"
                  },
                  "variableNames": [
                    {
                      "name": "value4",
                      "nodeType": "YulIdentifier",
                      "src": "3197:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "3268:49:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "3301:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "3312:3:6",
                            "type": "",
                            "value": "160"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "3297:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3297:19:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "3284:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3284:33:6"
                  },
                  "variables": [
                    {
                      "name": "offset_2",
                      "nodeType": "YulTypedName",
                      "src": "3272:8:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "3346:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "3355:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "3358:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "3348:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "3348:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "3348:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset_2",
                        "nodeType": "YulIdentifier",
                        "src": "3332:8:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "3342:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "3329:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3329:16:6"
                  },
                  "nodeType": "YulIf",
                  "src": "3326:36:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "3371:72:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "3413:9:6"
                          },
                          {
                            "name": "offset_2",
                            "nodeType": "YulIdentifier",
                            "src": "3424:8:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "3409:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3409:24:6"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "3435:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_array_string_dyn",
                      "nodeType": "YulIdentifier",
                      "src": "3381:27:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3381:62:6"
                  },
                  "variableNames": [
                    {
                      "name": "value5",
                      "nodeType": "YulIdentifier",
                      "src": "3371:6:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_enum$_QuestionType_$2005t_uint256t_boolt_string_memory_ptrt_string_memory_ptrt_array$_t_string_memory_ptr_$dyn_memory_ptr",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "2453:9:6",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "2464:7:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "2476:6:6",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "2484:6:6",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "2492:6:6",
                "type": ""
              },
              {
                "name": "value3",
                "nodeType": "YulTypedName",
                "src": "2500:6:6",
                "type": ""
              },
              {
                "name": "value4",
                "nodeType": "YulTypedName",
                "src": "2508:6:6",
                "type": ""
              },
              {
                "name": "value5",
                "nodeType": "YulTypedName",
                "src": "2516:6:6",
                "type": ""
              }
            ],
            "src": "2303:1146:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3535:187:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "3581:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "3590:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "3593:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "3583:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "3583:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "3583:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "3556:7:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "3565:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "3552:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3552:23:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3577:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "3548:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3548:32:6"
                  },
                  "nodeType": "YulIf",
                  "src": "3545:52:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "3606:36:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "3632:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "3619:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3619:23:6"
                  },
                  "variables": [
                    {
                      "name": "value",
                      "nodeType": "YulTypedName",
                      "src": "3610:5:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "3686:5:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_enum_QuestionType",
                      "nodeType": "YulIdentifier",
                      "src": "3651:34:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3651:41:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3651:41:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "3701:15:6",
                  "value": {
                    "name": "value",
                    "nodeType": "YulIdentifier",
                    "src": "3711:5:6"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "3701:6:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_enum$_Status_$2001",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "3501:9:6",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "3512:7:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "3524:6:6",
                "type": ""
              }
            ],
            "src": "3454:268:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3851:487:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "3897:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "3906:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "3909:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "3899:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "3899:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "3899:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "3872:7:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "3881:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "3868:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3868:23:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3893:2:6",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "3864:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3864:32:6"
                  },
                  "nodeType": "YulIf",
                  "src": "3861:52:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "3922:37:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "3949:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "3936:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3936:23:6"
                  },
                  "variables": [
                    {
                      "name": "offset",
                      "nodeType": "YulTypedName",
                      "src": "3926:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "3968:28:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "3978:18:6",
                    "type": "",
                    "value": "0xffffffffffffffff"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "3972:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "4023:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4032:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4035:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "4025:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4025:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "4025:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "4011:6:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "4019:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "4008:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4008:14:6"
                  },
                  "nodeType": "YulIf",
                  "src": "4005:34:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "4048:60:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "4080:9:6"
                          },
                          {
                            "name": "offset",
                            "nodeType": "YulIdentifier",
                            "src": "4091:6:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "4076:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4076:22:6"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "4100:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string",
                      "nodeType": "YulIdentifier",
                      "src": "4058:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4058:50:6"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "4048:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "4117:48:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "4150:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "4161:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "4146:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4146:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "4133:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4133:32:6"
                  },
                  "variables": [
                    {
                      "name": "offset_1",
                      "nodeType": "YulTypedName",
                      "src": "4121:8:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "4194:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4203:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4206:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "4196:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4196:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "4196:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset_1",
                        "nodeType": "YulIdentifier",
                        "src": "4180:8:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "4190:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "4177:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4177:16:6"
                  },
                  "nodeType": "YulIf",
                  "src": "4174:36:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "4219:62:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "4251:9:6"
                          },
                          {
                            "name": "offset_1",
                            "nodeType": "YulIdentifier",
                            "src": "4262:8:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "4247:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4247:24:6"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "4273:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string",
                      "nodeType": "YulIdentifier",
                      "src": "4229:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4229:52:6"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "4219:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "4290:42:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "4317:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "4328:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "4313:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4313:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "4300:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4300:32:6"
                  },
                  "variableNames": [
                    {
                      "name": "value2",
                      "nodeType": "YulIdentifier",
                      "src": "4290:6:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_string_memory_ptrt_string_memory_ptrt_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "3801:9:6",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "3812:7:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "3824:6:6",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "3832:6:6",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "3840:6:6",
                "type": ""
              }
            ],
            "src": "3727:611:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "4413:110:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "4459:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4468:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4471:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "4461:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4461:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "4461:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "4434:7:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "4443:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "4430:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4430:23:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "4455:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "4426:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4426:32:6"
                  },
                  "nodeType": "YulIf",
                  "src": "4423:52:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "4484:33:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "4507:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "4494:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4494:23:6"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "4484:6:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "4379:9:6",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "4390:7:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "4402:6:6",
                "type": ""
              }
            ],
            "src": "4343:180:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "4609:103:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "4655:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4664:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4667:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "4657:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4657:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "4657:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "4630:7:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "4639:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "4626:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4626:23:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "4651:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "4622:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4622:32:6"
                  },
                  "nodeType": "YulIf",
                  "src": "4619:52:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "4680:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "4696:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "4690:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4690:16:6"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "4680:6:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_uint256_fromMemory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "4575:9:6",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "4586:7:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "4598:6:6",
                "type": ""
              }
            ],
            "src": "4528:184:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "4882:680:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "4928:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4937:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4940:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "4930:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4930:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "4930:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "4903:7:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "4912:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "4899:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4899:23:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "4924:2:6",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "4895:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4895:32:6"
                  },
                  "nodeType": "YulIf",
                  "src": "4892:52:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "4953:33:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "4976:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "4963:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4963:23:6"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "4953:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "4995:45:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5025:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "5036:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "5021:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5021:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "5008:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5008:32:6"
                  },
                  "variables": [
                    {
                      "name": "value",
                      "nodeType": "YulTypedName",
                      "src": "4999:5:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "5074:5:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_address",
                      "nodeType": "YulIdentifier",
                      "src": "5049:24:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5049:31:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "5049:31:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5089:15:6",
                  "value": {
                    "name": "value",
                    "nodeType": "YulIdentifier",
                    "src": "5099:5:6"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "5089:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "5113:46:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5144:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "5155:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "5140:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5140:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "5127:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5127:32:6"
                  },
                  "variables": [
                    {
                      "name": "offset",
                      "nodeType": "YulTypedName",
                      "src": "5117:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "5168:28:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "5178:18:6",
                    "type": "",
                    "value": "0xffffffffffffffff"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "5172:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "5223:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5232:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5235:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "5225:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "5225:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "5225:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "5211:6:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "5219:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "5208:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5208:14:6"
                  },
                  "nodeType": "YulIf",
                  "src": "5205:34:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "5248:32:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "5262:9:6"
                      },
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "5273:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "5258:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5258:22:6"
                  },
                  "variables": [
                    {
                      "name": "_2",
                      "nodeType": "YulTypedName",
                      "src": "5252:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "5328:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5337:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5340:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "5330:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "5330:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "5330:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "_2",
                                "nodeType": "YulIdentifier",
                                "src": "5307:2:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "5311:4:6",
                                "type": "",
                                "value": "0x1f"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "5303:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "5303:13:6"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "5318:7:6"
                          }
                        ],
                        "functionName": {
                          "name": "slt",
                          "nodeType": "YulIdentifier",
                          "src": "5299:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5299:27:6"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "5292:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5292:35:6"
                  },
                  "nodeType": "YulIf",
                  "src": "5289:55:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "5353:30:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "_2",
                        "nodeType": "YulIdentifier",
                        "src": "5380:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "5367:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5367:16:6"
                  },
                  "variables": [
                    {
                      "name": "length",
                      "nodeType": "YulTypedName",
                      "src": "5357:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "5410:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5419:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5422:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "5412:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "5412:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "5412:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "5398:6:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "5406:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "5395:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5395:14:6"
                  },
                  "nodeType": "YulIf",
                  "src": "5392:34:6"
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "5485:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5494:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5497:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "5487:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "5487:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "5487:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "_2",
                                "nodeType": "YulIdentifier",
                                "src": "5449:2:6"
                              },
                              {
                                "arguments": [
                                  {
                                    "name": "length",
                                    "nodeType": "YulIdentifier",
                                    "src": "5457:6:6"
                                  },
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "5465:2:6",
                                    "type": "",
                                    "value": "32"
                                  }
                                ],
                                "functionName": {
                                  "name": "mul",
                                  "nodeType": "YulIdentifier",
                                  "src": "5453:3:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "5453:15:6"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "5445:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "5445:24:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "5471:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "5441:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5441:33:6"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "5476:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "5438:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5438:46:6"
                  },
                  "nodeType": "YulIf",
                  "src": "5435:66:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5510:21:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "_2",
                        "nodeType": "YulIdentifier",
                        "src": "5524:2:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "5528:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "5520:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5520:11:6"
                  },
                  "variableNames": [
                    {
                      "name": "value2",
                      "nodeType": "YulIdentifier",
                      "src": "5510:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5540:16:6",
                  "value": {
                    "name": "length",
                    "nodeType": "YulIdentifier",
                    "src": "5550:6:6"
                  },
                  "variableNames": [
                    {
                      "name": "value3",
                      "nodeType": "YulIdentifier",
                      "src": "5540:6:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_uint256t_contract$_Token_$2124t_array$_t_string_calldata_ptr_$dyn_calldata_ptr",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "4824:9:6",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "4835:7:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "4847:6:6",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "4855:6:6",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "4863:6:6",
                "type": ""
              },
              {
                "name": "value3",
                "nodeType": "YulTypedName",
                "src": "4871:6:6",
                "type": ""
              }
            ],
            "src": "4717:845:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "5808:974:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "5855:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5864:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "5867:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "5857:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "5857:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "5857:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "5829:7:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5838:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "5825:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5825:23:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "5850:3:6",
                        "type": "",
                        "value": "224"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "5821:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5821:33:6"
                  },
                  "nodeType": "YulIf",
                  "src": "5818:53:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5880:33:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "5903:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "5890:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5890:23:6"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "5880:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "5922:45:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "5952:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "5963:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "5948:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "5948:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "5935:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5935:32:6"
                  },
                  "variables": [
                    {
                      "name": "value",
                      "nodeType": "YulTypedName",
                      "src": "5926:5:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "6011:5:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_enum_QuestionType",
                      "nodeType": "YulIdentifier",
                      "src": "5976:34:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5976:41:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "5976:41:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "6026:15:6",
                  "value": {
                    "name": "value",
                    "nodeType": "YulIdentifier",
                    "src": "6036:5:6"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "6026:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "6050:42:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "6077:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "6088:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "6073:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6073:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "6060:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6060:32:6"
                  },
                  "variableNames": [
                    {
                      "name": "value2",
                      "nodeType": "YulIdentifier",
                      "src": "6050:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "6101:47:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "6133:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "6144:2:6",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "6129:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6129:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "6116:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6116:32:6"
                  },
                  "variables": [
                    {
                      "name": "value_1",
                      "nodeType": "YulTypedName",
                      "src": "6105:7:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value_1",
                        "nodeType": "YulIdentifier",
                        "src": "6179:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_bool",
                      "nodeType": "YulIdentifier",
                      "src": "6157:21:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6157:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "6157:30:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "6196:17:6",
                  "value": {
                    "name": "value_1",
                    "nodeType": "YulIdentifier",
                    "src": "6206:7:6"
                  },
                  "variableNames": [
                    {
                      "name": "value3",
                      "nodeType": "YulIdentifier",
                      "src": "6196:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "6222:47:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "6253:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "6264:3:6",
                            "type": "",
                            "value": "128"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "6249:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6249:19:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "6236:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6236:33:6"
                  },
                  "variables": [
                    {
                      "name": "offset",
                      "nodeType": "YulTypedName",
                      "src": "6226:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "6278:28:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "6288:18:6",
                    "type": "",
                    "value": "0xffffffffffffffff"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "6282:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "6333:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6342:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6345:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "6335:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "6335:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "6335:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "6321:6:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "6329:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "6318:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6318:14:6"
                  },
                  "nodeType": "YulIf",
                  "src": "6315:34:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "6358:60:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "6390:9:6"
                          },
                          {
                            "name": "offset",
                            "nodeType": "YulIdentifier",
                            "src": "6401:6:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "6386:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6386:22:6"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "6410:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string",
                      "nodeType": "YulIdentifier",
                      "src": "6368:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6368:50:6"
                  },
                  "variableNames": [
                    {
                      "name": "value4",
                      "nodeType": "YulIdentifier",
                      "src": "6358:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "6427:49:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "6460:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "6471:3:6",
                            "type": "",
                            "value": "160"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "6456:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6456:19:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "6443:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6443:33:6"
                  },
                  "variables": [
                    {
                      "name": "offset_1",
                      "nodeType": "YulTypedName",
                      "src": "6431:8:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "6505:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6514:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6517:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "6507:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "6507:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "6507:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset_1",
                        "nodeType": "YulIdentifier",
                        "src": "6491:8:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "6501:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "6488:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6488:16:6"
                  },
                  "nodeType": "YulIf",
                  "src": "6485:36:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "6530:62:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "6562:9:6"
                          },
                          {
                            "name": "offset_1",
                            "nodeType": "YulIdentifier",
                            "src": "6573:8:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "6558:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6558:24:6"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "6584:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_string",
                      "nodeType": "YulIdentifier",
                      "src": "6540:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6540:52:6"
                  },
                  "variableNames": [
                    {
                      "name": "value5",
                      "nodeType": "YulIdentifier",
                      "src": "6530:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "6601:49:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "6634:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "6645:3:6",
                            "type": "",
                            "value": "192"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "6630:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6630:19:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "6617:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6617:33:6"
                  },
                  "variables": [
                    {
                      "name": "offset_2",
                      "nodeType": "YulTypedName",
                      "src": "6605:8:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "6679:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6688:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6691:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "6681:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "6681:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "6681:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "offset_2",
                        "nodeType": "YulIdentifier",
                        "src": "6665:8:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "6675:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "6662:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6662:16:6"
                  },
                  "nodeType": "YulIf",
                  "src": "6659:36:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "6704:72:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "6746:9:6"
                          },
                          {
                            "name": "offset_2",
                            "nodeType": "YulIdentifier",
                            "src": "6757:8:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "6742:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6742:24:6"
                      },
                      {
                        "name": "dataEnd",
                        "nodeType": "YulIdentifier",
                        "src": "6768:7:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_decode_array_string_dyn",
                      "nodeType": "YulIdentifier",
                      "src": "6714:27:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6714:62:6"
                  },
                  "variableNames": [
                    {
                      "name": "value6",
                      "nodeType": "YulIdentifier",
                      "src": "6704:6:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_uint256t_enum$_QuestionType_$2005t_uint256t_boolt_string_memory_ptrt_string_memory_ptrt_array$_t_string_memory_ptr_$dyn_memory_ptr",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "5726:9:6",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "5737:7:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "5749:6:6",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "5757:6:6",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "5765:6:6",
                "type": ""
              },
              {
                "name": "value3",
                "nodeType": "YulTypedName",
                "src": "5773:6:6",
                "type": ""
              },
              {
                "name": "value4",
                "nodeType": "YulTypedName",
                "src": "5781:6:6",
                "type": ""
              },
              {
                "name": "value5",
                "nodeType": "YulTypedName",
                "src": "5789:6:6",
                "type": ""
              },
              {
                "name": "value6",
                "nodeType": "YulTypedName",
                "src": "5797:6:6",
                "type": ""
              }
            ],
            "src": "5567:1215:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "6874:161:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "6920:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6929:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "6932:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "6922:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "6922:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "6922:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "6895:7:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "6904:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "6891:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6891:23:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "6916:2:6",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "6887:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6887:32:6"
                  },
                  "nodeType": "YulIf",
                  "src": "6884:52:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "6945:33:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "6968:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "6955:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6955:23:6"
                  },
                  "variableNames": [
                    {
                      "name": "value0",
                      "nodeType": "YulIdentifier",
                      "src": "6945:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "6987:42:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "7014:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7025:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7010:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7010:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "6997:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6997:32:6"
                  },
                  "variableNames": [
                    {
                      "name": "value1",
                      "nodeType": "YulIdentifier",
                      "src": "6987:6:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_uint256t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "6832:9:6",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "6843:7:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "6855:6:6",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "6863:6:6",
                "type": ""
              }
            ],
            "src": "6787:248:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "7084:83:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "7101:3:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "7110:5:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7117:42:6",
                            "type": "",
                            "value": "0xffffffffffffffffffffffffffffffffffffffff"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "7106:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7106:54:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7094:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7094:67:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7094:67:6"
                }
              ]
            },
            "name": "abi_encode_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "7068:5:6",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "7075:3:6",
                "type": ""
              }
            ],
            "src": "7040:127:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "7220:84:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "7265:5:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_assert_enum_QuestionType",
                      "nodeType": "YulIdentifier",
                      "src": "7230:34:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7230:41:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7230:41:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "7287:3:6"
                      },
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "7292:5:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7280:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7280:18:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7280:18:6"
                }
              ]
            },
            "name": "abi_encode_enum_Status",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "7204:5:6",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "7211:3:6",
                "type": ""
              }
            ],
            "src": "7172:132:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "7359:422:6",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "7369:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "7389:5:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "7383:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7383:12:6"
                  },
                  "variables": [
                    {
                      "name": "length",
                      "nodeType": "YulTypedName",
                      "src": "7373:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "7411:3:6"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "7416:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7404:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7404:19:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7404:19:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "7432:10:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "7441:1:6",
                    "type": "",
                    "value": "0"
                  },
                  "variables": [
                    {
                      "name": "i",
                      "nodeType": "YulTypedName",
                      "src": "7436:1:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "7503:110:6",
                    "statements": [
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "7517:14:6",
                        "value": {
                          "kind": "number",
                          "nodeType": "YulLiteral",
                          "src": "7527:4:6",
                          "type": "",
                          "value": "0x20"
                        },
                        "variables": [
                          {
                            "name": "_1",
                            "nodeType": "YulTypedName",
                            "src": "7521:2:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "name": "pos",
                                      "nodeType": "YulIdentifier",
                                      "src": "7559:3:6"
                                    },
                                    {
                                      "name": "i",
                                      "nodeType": "YulIdentifier",
                                      "src": "7564:1:6"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "add",
                                    "nodeType": "YulIdentifier",
                                    "src": "7555:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "7555:11:6"
                                },
                                {
                                  "name": "_1",
                                  "nodeType": "YulIdentifier",
                                  "src": "7568:2:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "7551:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "7551:20:6"
                            },
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "arguments": [
                                        {
                                          "name": "value",
                                          "nodeType": "YulIdentifier",
                                          "src": "7587:5:6"
                                        },
                                        {
                                          "name": "i",
                                          "nodeType": "YulIdentifier",
                                          "src": "7594:1:6"
                                        }
                                      ],
                                      "functionName": {
                                        "name": "add",
                                        "nodeType": "YulIdentifier",
                                        "src": "7583:3:6"
                                      },
                                      "nodeType": "YulFunctionCall",
                                      "src": "7583:13:6"
                                    },
                                    {
                                      "name": "_1",
                                      "nodeType": "YulIdentifier",
                                      "src": "7598:2:6"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "add",
                                    "nodeType": "YulIdentifier",
                                    "src": "7579:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "7579:22:6"
                                }
                              ],
                              "functionName": {
                                "name": "mload",
                                "nodeType": "YulIdentifier",
                                "src": "7573:5:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "7573:29:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "7544:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "7544:59:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "7544:59:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "i",
                        "nodeType": "YulIdentifier",
                        "src": "7462:1:6"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "7465:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "lt",
                      "nodeType": "YulIdentifier",
                      "src": "7459:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7459:13:6"
                  },
                  "nodeType": "YulForLoop",
                  "post": {
                    "nodeType": "YulBlock",
                    "src": "7473:21:6",
                    "statements": [
                      {
                        "nodeType": "YulAssignment",
                        "src": "7475:17:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "i",
                              "nodeType": "YulIdentifier",
                              "src": "7484:1:6"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "7487:4:6",
                              "type": "",
                              "value": "0x20"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "7480:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "7480:12:6"
                        },
                        "variableNames": [
                          {
                            "name": "i",
                            "nodeType": "YulIdentifier",
                            "src": "7475:1:6"
                          }
                        ]
                      }
                    ]
                  },
                  "pre": {
                    "nodeType": "YulBlock",
                    "src": "7455:3:6",
                    "statements": []
                  },
                  "src": "7451:162:6"
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "7647:62:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "name": "pos",
                                      "nodeType": "YulIdentifier",
                                      "src": "7676:3:6"
                                    },
                                    {
                                      "name": "length",
                                      "nodeType": "YulIdentifier",
                                      "src": "7681:6:6"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "add",
                                    "nodeType": "YulIdentifier",
                                    "src": "7672:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "7672:16:6"
                                },
                                {
                                  "kind": "number",
                                  "nodeType": "YulLiteral",
                                  "src": "7690:4:6",
                                  "type": "",
                                  "value": "0x20"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "7668:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "7668:27:6"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "7697:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "7661:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "7661:38:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "7661:38:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "i",
                        "nodeType": "YulIdentifier",
                        "src": "7628:1:6"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "7631:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "7625:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7625:13:6"
                  },
                  "nodeType": "YulIf",
                  "src": "7622:87:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "7718:57:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "7733:3:6"
                          },
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "name": "length",
                                    "nodeType": "YulIdentifier",
                                    "src": "7746:6:6"
                                  },
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "7754:2:6",
                                    "type": "",
                                    "value": "31"
                                  }
                                ],
                                "functionName": {
                                  "name": "add",
                                  "nodeType": "YulIdentifier",
                                  "src": "7742:3:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "7742:15:6"
                              },
                              {
                                "arguments": [
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "7763:2:6",
                                    "type": "",
                                    "value": "31"
                                  }
                                ],
                                "functionName": {
                                  "name": "not",
                                  "nodeType": "YulIdentifier",
                                  "src": "7759:3:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "7759:7:6"
                              }
                            ],
                            "functionName": {
                              "name": "and",
                              "nodeType": "YulIdentifier",
                              "src": "7738:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "7738:29:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7729:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7729:39:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "7770:4:6",
                        "type": "",
                        "value": "0x20"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "7725:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7725:50:6"
                  },
                  "variableNames": [
                    {
                      "name": "end",
                      "nodeType": "YulIdentifier",
                      "src": "7718:3:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_string",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "7336:5:6",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "7343:3:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "7351:3:6",
                "type": ""
              }
            ],
            "src": "7309:472:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "7843:209:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "7860:3:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "7871:5:6"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "7865:5:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7865:12:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7853:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7853:25:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7853:25:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "7898:3:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7903:4:6",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7894:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7894:14:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "7920:5:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "7927:4:6",
                                "type": "",
                                "value": "0x20"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "7916:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "7916:16:6"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "7910:5:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7910:23:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7887:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7887:47:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7887:47:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "7954:3:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7959:4:6",
                            "type": "",
                            "value": "0x40"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7950:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7950:14:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "7976:5:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "7983:4:6",
                                "type": "",
                                "value": "0x40"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "7972:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "7972:16:6"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "7966:5:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7966:23:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7943:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7943:47:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7943:47:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "8010:3:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8015:4:6",
                            "type": "",
                            "value": "0x60"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8006:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8006:14:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "8032:5:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "8039:4:6",
                                "type": "",
                                "value": "0x60"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "8028:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "8028:16:6"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "8022:5:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8022:23:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7999:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7999:47:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7999:47:6"
                }
              ]
            },
            "name": "abi_encode_struct_LiquidityPool",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "7827:5:6",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "7834:3:6",
                "type": ""
              }
            ],
            "src": "7786:266:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "8119:383:6",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "8129:32:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "8155:5:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "8149:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8149:12:6"
                  },
                  "variables": [
                    {
                      "name": "memberValue0",
                      "nodeType": "YulTypedName",
                      "src": "8133:12:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "8177:3:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8182:4:6",
                        "type": "",
                        "value": "0x60"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8170:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8170:17:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8170:17:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "8196:59:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "memberValue0",
                        "nodeType": "YulIdentifier",
                        "src": "8226:12:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "8244:3:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8249:4:6",
                            "type": "",
                            "value": "0x60"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8240:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8240:14:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_string",
                      "nodeType": "YulIdentifier",
                      "src": "8208:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8208:47:6"
                  },
                  "variables": [
                    {
                      "name": "tail",
                      "nodeType": "YulTypedName",
                      "src": "8200:4:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "8264:45:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "8296:5:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8303:4:6",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8292:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8292:16:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "8286:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8286:23:6"
                  },
                  "variables": [
                    {
                      "name": "memberValue0_1",
                      "nodeType": "YulTypedName",
                      "src": "8268:14:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "8329:3:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8334:4:6",
                            "type": "",
                            "value": "0x20"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8325:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8325:14:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "tail",
                            "nodeType": "YulIdentifier",
                            "src": "8345:4:6"
                          },
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "8351:3:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "8341:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8341:14:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8318:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8318:38:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8318:38:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "8365:53:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "memberValue0_1",
                        "nodeType": "YulIdentifier",
                        "src": "8397:14:6"
                      },
                      {
                        "name": "tail",
                        "nodeType": "YulIdentifier",
                        "src": "8413:4:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_string",
                      "nodeType": "YulIdentifier",
                      "src": "8379:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8379:39:6"
                  },
                  "variables": [
                    {
                      "name": "tail_1",
                      "nodeType": "YulTypedName",
                      "src": "8369:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "8438:3:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8443:4:6",
                            "type": "",
                            "value": "0x40"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8434:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8434:14:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "8460:5:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "8467:4:6",
                                "type": "",
                                "value": "0x40"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "8456:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "8456:16:6"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "8450:5:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8450:23:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8427:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8427:47:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8427:47:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "8483:13:6",
                  "value": {
                    "name": "tail_1",
                    "nodeType": "YulIdentifier",
                    "src": "8490:6:6"
                  },
                  "variableNames": [
                    {
                      "name": "end",
                      "nodeType": "YulIdentifier",
                      "src": "8483:3:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_struct_SurveyBasic",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "8096:5:6",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "8103:3:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "8111:3:6",
                "type": ""
              }
            ],
            "src": "8057:445:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "8608:125:6",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "8618:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "8630:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8641:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "8626:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8626:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "8618:4:6"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "8660:9:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "8675:6:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8683:42:6",
                            "type": "",
                            "value": "0xffffffffffffffffffffffffffffffffffffffff"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "8671:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8671:55:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8653:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8653:74:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8653:74:6"
                }
              ]
            },
            "name": "abi_encode_tuple_t_address__to_t_address__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "8577:9:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "8588:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "8599:4:6",
                "type": ""
              }
            ],
            "src": "8507:226:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "8895:241:6",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "8905:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "8917:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8928:2:6",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "8913:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8913:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "8905:4:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "8940:52:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "8950:42:6",
                    "type": "",
                    "value": "0xffffffffffffffffffffffffffffffffffffffff"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "8944:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "9008:9:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "9023:6:6"
                          },
                          {
                            "name": "_1",
                            "nodeType": "YulIdentifier",
                            "src": "9031:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "9019:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9019:15:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9001:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9001:34:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9001:34:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "9055:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "9066:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "9051:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9051:18:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value1",
                            "nodeType": "YulIdentifier",
                            "src": "9075:6:6"
                          },
                          {
                            "name": "_1",
                            "nodeType": "YulIdentifier",
                            "src": "9083:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "9071:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9071:15:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9044:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9044:43:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9044:43:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "9107:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "9118:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "9103:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9103:18:6"
                      },
                      {
                        "name": "value2",
                        "nodeType": "YulIdentifier",
                        "src": "9123:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9096:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9096:34:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9096:34:6"
                }
              ]
            },
            "name": "abi_encode_tuple_t_address_t_address_t_uint256__to_t_address_t_address_t_uint256__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "8848:9:6",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "8859:6:6",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "8867:6:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "8875:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "8886:4:6",
                "type": ""
              }
            ],
            "src": "8738:398:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "9270:168:6",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "9280:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "9292:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9303:2:6",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "9288:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9288:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "9280:4:6"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "9322:9:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "9337:6:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "9345:42:6",
                            "type": "",
                            "value": "0xffffffffffffffffffffffffffffffffffffffff"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "9333:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9333:55:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9315:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9315:74:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9315:74:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "9409:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "9420:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "9405:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9405:18:6"
                      },
                      {
                        "name": "value1",
                        "nodeType": "YulIdentifier",
                        "src": "9425:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9398:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9398:34:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9398:34:6"
                }
              ]
            },
            "name": "abi_encode_tuple_t_address_t_uint256__to_t_address_t_uint256__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "9231:9:6",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "9242:6:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "9250:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "9261:4:6",
                "type": ""
              }
            ],
            "src": "9141:297:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "9614:633:6",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "9624:12:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "9634:2:6",
                    "type": "",
                    "value": "32"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "9628:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "9645:32:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "9663:9:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "9674:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "9659:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9659:18:6"
                  },
                  "variables": [
                    {
                      "name": "tail_1",
                      "nodeType": "YulTypedName",
                      "src": "9649:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "9693:9:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "9704:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9686:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9686:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9686:21:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "9716:17:6",
                  "value": {
                    "name": "tail_1",
                    "nodeType": "YulIdentifier",
                    "src": "9727:6:6"
                  },
                  "variables": [
                    {
                      "name": "pos",
                      "nodeType": "YulTypedName",
                      "src": "9720:3:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "9742:27:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "9762:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "9756:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9756:13:6"
                  },
                  "variables": [
                    {
                      "name": "length",
                      "nodeType": "YulTypedName",
                      "src": "9746:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "tail_1",
                        "nodeType": "YulIdentifier",
                        "src": "9785:6:6"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "9793:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9778:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9778:22:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9778:22:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "9809:25:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "9820:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9831:2:6",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "9816:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9816:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "pos",
                      "nodeType": "YulIdentifier",
                      "src": "9809:3:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "9843:54:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "9865:9:6"
                          },
                          {
                            "arguments": [
                              {
                                "name": "length",
                                "nodeType": "YulIdentifier",
                                "src": "9880:6:6"
                              },
                              {
                                "name": "_1",
                                "nodeType": "YulIdentifier",
                                "src": "9888:2:6"
                              }
                            ],
                            "functionName": {
                              "name": "mul",
                              "nodeType": "YulIdentifier",
                              "src": "9876:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "9876:15:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "9861:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9861:31:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9894:2:6",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "9857:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9857:40:6"
                  },
                  "variables": [
                    {
                      "name": "tail_2",
                      "nodeType": "YulTypedName",
                      "src": "9847:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "9906:29:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "9924:6:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "9932:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "9920:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9920:15:6"
                  },
                  "variables": [
                    {
                      "name": "srcPtr",
                      "nodeType": "YulTypedName",
                      "src": "9910:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "9944:10:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "9953:1:6",
                    "type": "",
                    "value": "0"
                  },
                  "variables": [
                    {
                      "name": "i",
                      "nodeType": "YulTypedName",
                      "src": "9948:1:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "10012:206:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "name": "pos",
                              "nodeType": "YulIdentifier",
                              "src": "10033:3:6"
                            },
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "name": "tail_2",
                                      "nodeType": "YulIdentifier",
                                      "src": "10046:6:6"
                                    },
                                    {
                                      "name": "headStart",
                                      "nodeType": "YulIdentifier",
                                      "src": "10054:9:6"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "sub",
                                    "nodeType": "YulIdentifier",
                                    "src": "10042:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "10042:22:6"
                                },
                                {
                                  "arguments": [
                                    {
                                      "kind": "number",
                                      "nodeType": "YulLiteral",
                                      "src": "10070:2:6",
                                      "type": "",
                                      "value": "63"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "not",
                                    "nodeType": "YulIdentifier",
                                    "src": "10066:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "10066:7:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "10038:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "10038:36:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "10026:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "10026:49:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "10026:49:6"
                      },
                      {
                        "nodeType": "YulAssignment",
                        "src": "10088:50:6",
                        "value": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "name": "srcPtr",
                                  "nodeType": "YulIdentifier",
                                  "src": "10122:6:6"
                                }
                              ],
                              "functionName": {
                                "name": "mload",
                                "nodeType": "YulIdentifier",
                                "src": "10116:5:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "10116:13:6"
                            },
                            {
                              "name": "tail_2",
                              "nodeType": "YulIdentifier",
                              "src": "10131:6:6"
                            }
                          ],
                          "functionName": {
                            "name": "abi_encode_string",
                            "nodeType": "YulIdentifier",
                            "src": "10098:17:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "10098:40:6"
                        },
                        "variableNames": [
                          {
                            "name": "tail_2",
                            "nodeType": "YulIdentifier",
                            "src": "10088:6:6"
                          }
                        ]
                      },
                      {
                        "nodeType": "YulAssignment",
                        "src": "10151:25:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "srcPtr",
                              "nodeType": "YulIdentifier",
                              "src": "10165:6:6"
                            },
                            {
                              "name": "_1",
                              "nodeType": "YulIdentifier",
                              "src": "10173:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "10161:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "10161:15:6"
                        },
                        "variableNames": [
                          {
                            "name": "srcPtr",
                            "nodeType": "YulIdentifier",
                            "src": "10151:6:6"
                          }
                        ]
                      },
                      {
                        "nodeType": "YulAssignment",
                        "src": "10189:19:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "pos",
                              "nodeType": "YulIdentifier",
                              "src": "10200:3:6"
                            },
                            {
                              "name": "_1",
                              "nodeType": "YulIdentifier",
                              "src": "10205:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "10196:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "10196:12:6"
                        },
                        "variableNames": [
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "10189:3:6"
                          }
                        ]
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "i",
                        "nodeType": "YulIdentifier",
                        "src": "9974:1:6"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "9977:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "lt",
                      "nodeType": "YulIdentifier",
                      "src": "9971:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9971:13:6"
                  },
                  "nodeType": "YulForLoop",
                  "post": {
                    "nodeType": "YulBlock",
                    "src": "9985:18:6",
                    "statements": [
                      {
                        "nodeType": "YulAssignment",
                        "src": "9987:14:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "i",
                              "nodeType": "YulIdentifier",
                              "src": "9996:1:6"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "9999:1:6",
                              "type": "",
                              "value": "1"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "9992:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "9992:9:6"
                        },
                        "variableNames": [
                          {
                            "name": "i",
                            "nodeType": "YulIdentifier",
                            "src": "9987:1:6"
                          }
                        ]
                      }
                    ]
                  },
                  "pre": {
                    "nodeType": "YulBlock",
                    "src": "9967:3:6",
                    "statements": []
                  },
                  "src": "9963:255:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "10227:14:6",
                  "value": {
                    "name": "tail_2",
                    "nodeType": "YulIdentifier",
                    "src": "10235:6:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "10227:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_array$_t_string_memory_ptr_$dyn_memory_ptr__to_t_array$_t_string_memory_ptr_$dyn_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "9583:9:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "9594:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "9605:4:6",
                "type": ""
              }
            ],
            "src": "9443:804:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "10455:2095:6",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "10465:12:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "10475:2:6",
                    "type": "",
                    "value": "32"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "10469:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "10486:32:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "10504:9:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "10515:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "10500:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10500:18:6"
                  },
                  "variables": [
                    {
                      "name": "tail_1",
                      "nodeType": "YulTypedName",
                      "src": "10490:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "10534:9:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "10545:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10527:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10527:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10527:21:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "10557:17:6",
                  "value": {
                    "name": "tail_1",
                    "nodeType": "YulIdentifier",
                    "src": "10568:6:6"
                  },
                  "variables": [
                    {
                      "name": "pos",
                      "nodeType": "YulTypedName",
                      "src": "10561:3:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "10583:27:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "10603:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "10597:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10597:13:6"
                  },
                  "variables": [
                    {
                      "name": "length",
                      "nodeType": "YulTypedName",
                      "src": "10587:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "tail_1",
                        "nodeType": "YulIdentifier",
                        "src": "10626:6:6"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "10634:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10619:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10619:22:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10619:22:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "10650:12:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "10660:2:6",
                    "type": "",
                    "value": "64"
                  },
                  "variables": [
                    {
                      "name": "_2",
                      "nodeType": "YulTypedName",
                      "src": "10654:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "10671:25:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "10682:9:6"
                      },
                      {
                        "name": "_2",
                        "nodeType": "YulIdentifier",
                        "src": "10693:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "10678:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10678:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "pos",
                      "nodeType": "YulIdentifier",
                      "src": "10671:3:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "10705:54:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "10727:9:6"
                          },
                          {
                            "arguments": [
                              {
                                "name": "length",
                                "nodeType": "YulIdentifier",
                                "src": "10742:6:6"
                              },
                              {
                                "name": "_1",
                                "nodeType": "YulIdentifier",
                                "src": "10750:2:6"
                              }
                            ],
                            "functionName": {
                              "name": "mul",
                              "nodeType": "YulIdentifier",
                              "src": "10738:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "10738:15:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "10723:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "10723:31:6"
                      },
                      {
                        "name": "_2",
                        "nodeType": "YulIdentifier",
                        "src": "10756:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "10719:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10719:40:6"
                  },
                  "variables": [
                    {
                      "name": "tail_2",
                      "nodeType": "YulTypedName",
                      "src": "10709:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "10768:29:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "10786:6:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "10794:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "10782:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10782:15:6"
                  },
                  "variables": [
                    {
                      "name": "srcPtr",
                      "nodeType": "YulTypedName",
                      "src": "10772:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "10806:10:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "10815:1:6",
                    "type": "",
                    "value": "0"
                  },
                  "variables": [
                    {
                      "name": "i",
                      "nodeType": "YulTypedName",
                      "src": "10810:1:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "10825:12:6",
                  "value": {
                    "name": "i",
                    "nodeType": "YulIdentifier",
                    "src": "10836:1:6"
                  },
                  "variables": [
                    {
                      "name": "i_1",
                      "nodeType": "YulTypedName",
                      "src": "10829:3:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "10901:1620:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "name": "pos",
                              "nodeType": "YulIdentifier",
                              "src": "10922:3:6"
                            },
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "name": "tail_2",
                                      "nodeType": "YulIdentifier",
                                      "src": "10935:6:6"
                                    },
                                    {
                                      "name": "headStart",
                                      "nodeType": "YulIdentifier",
                                      "src": "10943:9:6"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "sub",
                                    "nodeType": "YulIdentifier",
                                    "src": "10931:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "10931:22:6"
                                },
                                {
                                  "arguments": [
                                    {
                                      "kind": "number",
                                      "nodeType": "YulLiteral",
                                      "src": "10959:2:6",
                                      "type": "",
                                      "value": "63"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "not",
                                    "nodeType": "YulIdentifier",
                                    "src": "10955:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "10955:7:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "10927:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "10927:36:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "10915:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "10915:49:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "10915:49:6"
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "10977:23:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "srcPtr",
                              "nodeType": "YulIdentifier",
                              "src": "10993:6:6"
                            }
                          ],
                          "functionName": {
                            "name": "mload",
                            "nodeType": "YulIdentifier",
                            "src": "10987:5:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "10987:13:6"
                        },
                        "variables": [
                          {
                            "name": "_3",
                            "nodeType": "YulTypedName",
                            "src": "10981:2:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11013:14:6",
                        "value": {
                          "kind": "number",
                          "nodeType": "YulLiteral",
                          "src": "11023:4:6",
                          "type": "",
                          "value": "0xc0"
                        },
                        "variables": [
                          {
                            "name": "_4",
                            "nodeType": "YulTypedName",
                            "src": "11017:2:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11040:19:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "_3",
                              "nodeType": "YulIdentifier",
                              "src": "11056:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "mload",
                            "nodeType": "YulIdentifier",
                            "src": "11050:5:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11050:9:6"
                        },
                        "variables": [
                          {
                            "name": "_5",
                            "nodeType": "YulTypedName",
                            "src": "11044:2:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "name": "_5",
                              "nodeType": "YulIdentifier",
                              "src": "11107:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "validator_assert_enum_QuestionType",
                            "nodeType": "YulIdentifier",
                            "src": "11072:34:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11072:38:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "11072:38:6"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "name": "tail_2",
                              "nodeType": "YulIdentifier",
                              "src": "11130:6:6"
                            },
                            {
                              "name": "_5",
                              "nodeType": "YulIdentifier",
                              "src": "11138:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "11123:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11123:18:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "11123:18:6"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "name": "tail_2",
                                  "nodeType": "YulIdentifier",
                                  "src": "11165:6:6"
                                },
                                {
                                  "name": "_1",
                                  "nodeType": "YulIdentifier",
                                  "src": "11173:2:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "11161:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11161:15:6"
                            },
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "name": "_3",
                                      "nodeType": "YulIdentifier",
                                      "src": "11188:2:6"
                                    },
                                    {
                                      "name": "_1",
                                      "nodeType": "YulIdentifier",
                                      "src": "11192:2:6"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "add",
                                    "nodeType": "YulIdentifier",
                                    "src": "11184:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "11184:11:6"
                                }
                              ],
                              "functionName": {
                                "name": "mload",
                                "nodeType": "YulIdentifier",
                                "src": "11178:5:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11178:18:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "11154:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11154:43:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "11154:43:6"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "name": "tail_2",
                                  "nodeType": "YulIdentifier",
                                  "src": "11221:6:6"
                                },
                                {
                                  "name": "_2",
                                  "nodeType": "YulIdentifier",
                                  "src": "11229:2:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "11217:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11217:15:6"
                            },
                            {
                              "arguments": [
                                {
                                  "arguments": [
                                    {
                                      "arguments": [
                                        {
                                          "arguments": [
                                            {
                                              "name": "_3",
                                              "nodeType": "YulIdentifier",
                                              "src": "11258:2:6"
                                            },
                                            {
                                              "name": "_2",
                                              "nodeType": "YulIdentifier",
                                              "src": "11262:2:6"
                                            }
                                          ],
                                          "functionName": {
                                            "name": "add",
                                            "nodeType": "YulIdentifier",
                                            "src": "11254:3:6"
                                          },
                                          "nodeType": "YulFunctionCall",
                                          "src": "11254:11:6"
                                        }
                                      ],
                                      "functionName": {
                                        "name": "mload",
                                        "nodeType": "YulIdentifier",
                                        "src": "11248:5:6"
                                      },
                                      "nodeType": "YulFunctionCall",
                                      "src": "11248:18:6"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "iszero",
                                    "nodeType": "YulIdentifier",
                                    "src": "11241:6:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "11241:26:6"
                                }
                              ],
                              "functionName": {
                                "name": "iszero",
                                "nodeType": "YulIdentifier",
                                "src": "11234:6:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11234:34:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "11210:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11210:59:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "11210:59:6"
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11282:14:6",
                        "value": {
                          "kind": "number",
                          "nodeType": "YulLiteral",
                          "src": "11292:4:6",
                          "type": "",
                          "value": "0x60"
                        },
                        "variables": [
                          {
                            "name": "_6",
                            "nodeType": "YulTypedName",
                            "src": "11286:2:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11309:38:6",
                        "value": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "name": "_3",
                                  "nodeType": "YulIdentifier",
                                  "src": "11339:2:6"
                                },
                                {
                                  "name": "_6",
                                  "nodeType": "YulIdentifier",
                                  "src": "11343:2:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "11335:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11335:11:6"
                            }
                          ],
                          "functionName": {
                            "name": "mload",
                            "nodeType": "YulIdentifier",
                            "src": "11329:5:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11329:18:6"
                        },
                        "variables": [
                          {
                            "name": "memberValue0",
                            "nodeType": "YulTypedName",
                            "src": "11313:12:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "name": "tail_2",
                                  "nodeType": "YulIdentifier",
                                  "src": "11371:6:6"
                                },
                                {
                                  "name": "_6",
                                  "nodeType": "YulIdentifier",
                                  "src": "11379:2:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "11367:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11367:15:6"
                            },
                            {
                              "name": "_4",
                              "nodeType": "YulIdentifier",
                              "src": "11384:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "11360:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11360:27:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "11360:27:6"
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11400:62:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "memberValue0",
                              "nodeType": "YulIdentifier",
                              "src": "11432:12:6"
                            },
                            {
                              "arguments": [
                                {
                                  "name": "tail_2",
                                  "nodeType": "YulIdentifier",
                                  "src": "11450:6:6"
                                },
                                {
                                  "name": "_4",
                                  "nodeType": "YulIdentifier",
                                  "src": "11458:2:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "11446:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11446:15:6"
                            }
                          ],
                          "functionName": {
                            "name": "abi_encode_string",
                            "nodeType": "YulIdentifier",
                            "src": "11414:17:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11414:48:6"
                        },
                        "variables": [
                          {
                            "name": "tail_3",
                            "nodeType": "YulTypedName",
                            "src": "11404:6:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11475:14:6",
                        "value": {
                          "kind": "number",
                          "nodeType": "YulLiteral",
                          "src": "11485:4:6",
                          "type": "",
                          "value": "0x80"
                        },
                        "variables": [
                          {
                            "name": "_7",
                            "nodeType": "YulTypedName",
                            "src": "11479:2:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11502:40:6",
                        "value": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "name": "_3",
                                  "nodeType": "YulIdentifier",
                                  "src": "11534:2:6"
                                },
                                {
                                  "name": "_7",
                                  "nodeType": "YulIdentifier",
                                  "src": "11538:2:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "11530:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11530:11:6"
                            }
                          ],
                          "functionName": {
                            "name": "mload",
                            "nodeType": "YulIdentifier",
                            "src": "11524:5:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11524:18:6"
                        },
                        "variables": [
                          {
                            "name": "memberValue0_1",
                            "nodeType": "YulTypedName",
                            "src": "11506:14:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "name": "tail_2",
                                  "nodeType": "YulIdentifier",
                                  "src": "11566:6:6"
                                },
                                {
                                  "name": "_7",
                                  "nodeType": "YulIdentifier",
                                  "src": "11574:2:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "11562:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11562:15:6"
                            },
                            {
                              "arguments": [
                                {
                                  "name": "tail_3",
                                  "nodeType": "YulIdentifier",
                                  "src": "11583:6:6"
                                },
                                {
                                  "name": "tail_2",
                                  "nodeType": "YulIdentifier",
                                  "src": "11591:6:6"
                                }
                              ],
                              "functionName": {
                                "name": "sub",
                                "nodeType": "YulIdentifier",
                                "src": "11579:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11579:19:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "11555:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11555:44:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "11555:44:6"
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11612:55:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "memberValue0_1",
                              "nodeType": "YulIdentifier",
                              "src": "11644:14:6"
                            },
                            {
                              "name": "tail_3",
                              "nodeType": "YulIdentifier",
                              "src": "11660:6:6"
                            }
                          ],
                          "functionName": {
                            "name": "abi_encode_string",
                            "nodeType": "YulIdentifier",
                            "src": "11626:17:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11626:41:6"
                        },
                        "variables": [
                          {
                            "name": "tail_4",
                            "nodeType": "YulTypedName",
                            "src": "11616:6:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11680:14:6",
                        "value": {
                          "kind": "number",
                          "nodeType": "YulLiteral",
                          "src": "11690:4:6",
                          "type": "",
                          "value": "0xa0"
                        },
                        "variables": [
                          {
                            "name": "_8",
                            "nodeType": "YulTypedName",
                            "src": "11684:2:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11707:40:6",
                        "value": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "name": "_3",
                                  "nodeType": "YulIdentifier",
                                  "src": "11739:2:6"
                                },
                                {
                                  "name": "_8",
                                  "nodeType": "YulIdentifier",
                                  "src": "11743:2:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "11735:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11735:11:6"
                            }
                          ],
                          "functionName": {
                            "name": "mload",
                            "nodeType": "YulIdentifier",
                            "src": "11729:5:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11729:18:6"
                        },
                        "variables": [
                          {
                            "name": "memberValue0_2",
                            "nodeType": "YulTypedName",
                            "src": "11711:14:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "name": "tail_2",
                                  "nodeType": "YulIdentifier",
                                  "src": "11771:6:6"
                                },
                                {
                                  "name": "_8",
                                  "nodeType": "YulIdentifier",
                                  "src": "11779:2:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "11767:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11767:15:6"
                            },
                            {
                              "arguments": [
                                {
                                  "name": "tail_4",
                                  "nodeType": "YulIdentifier",
                                  "src": "11788:6:6"
                                },
                                {
                                  "name": "tail_2",
                                  "nodeType": "YulIdentifier",
                                  "src": "11796:6:6"
                                }
                              ],
                              "functionName": {
                                "name": "sub",
                                "nodeType": "YulIdentifier",
                                "src": "11784:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11784:19:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "11760:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11760:44:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "11760:44:6"
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11817:19:6",
                        "value": {
                          "name": "tail_4",
                          "nodeType": "YulIdentifier",
                          "src": "11830:6:6"
                        },
                        "variables": [
                          {
                            "name": "pos_1",
                            "nodeType": "YulTypedName",
                            "src": "11821:5:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11849:37:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "memberValue0_2",
                              "nodeType": "YulIdentifier",
                              "src": "11871:14:6"
                            }
                          ],
                          "functionName": {
                            "name": "mload",
                            "nodeType": "YulIdentifier",
                            "src": "11865:5:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11865:21:6"
                        },
                        "variables": [
                          {
                            "name": "length_1",
                            "nodeType": "YulTypedName",
                            "src": "11853:8:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "name": "tail_4",
                              "nodeType": "YulIdentifier",
                              "src": "11906:6:6"
                            },
                            {
                              "name": "length_1",
                              "nodeType": "YulIdentifier",
                              "src": "11914:8:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "11899:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11899:24:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "11899:24:6"
                      },
                      {
                        "nodeType": "YulAssignment",
                        "src": "11936:24:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "tail_4",
                              "nodeType": "YulIdentifier",
                              "src": "11949:6:6"
                            },
                            {
                              "name": "_1",
                              "nodeType": "YulIdentifier",
                              "src": "11957:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "11945:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11945:15:6"
                        },
                        "variableNames": [
                          {
                            "name": "pos_1",
                            "nodeType": "YulIdentifier",
                            "src": "11936:5:6"
                          }
                        ]
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "11973:53:6",
                        "value": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "name": "tail_4",
                                  "nodeType": "YulIdentifier",
                                  "src": "11995:6:6"
                                },
                                {
                                  "arguments": [
                                    {
                                      "name": "length_1",
                                      "nodeType": "YulIdentifier",
                                      "src": "12007:8:6"
                                    },
                                    {
                                      "name": "_1",
                                      "nodeType": "YulIdentifier",
                                      "src": "12017:2:6"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "mul",
                                    "nodeType": "YulIdentifier",
                                    "src": "12003:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "12003:17:6"
                                }
                              ],
                              "functionName": {
                                "name": "add",
                                "nodeType": "YulIdentifier",
                                "src": "11991:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "11991:30:6"
                            },
                            {
                              "name": "_1",
                              "nodeType": "YulIdentifier",
                              "src": "12023:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "11987:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "11987:39:6"
                        },
                        "variables": [
                          {
                            "name": "tail_5",
                            "nodeType": "YulTypedName",
                            "src": "11977:6:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "12039:39:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "memberValue0_2",
                              "nodeType": "YulIdentifier",
                              "src": "12059:14:6"
                            },
                            {
                              "name": "_1",
                              "nodeType": "YulIdentifier",
                              "src": "12075:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "12055:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "12055:23:6"
                        },
                        "variables": [
                          {
                            "name": "srcPtr_1",
                            "nodeType": "YulTypedName",
                            "src": "12043:8:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "12091:12:6",
                        "value": {
                          "name": "i",
                          "nodeType": "YulIdentifier",
                          "src": "12102:1:6"
                        },
                        "variables": [
                          {
                            "name": "i_2",
                            "nodeType": "YulTypedName",
                            "src": "12095:3:6",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "body": {
                          "nodeType": "YulBlock",
                          "src": "12177:235:6",
                          "statements": [
                            {
                              "expression": {
                                "arguments": [
                                  {
                                    "name": "pos_1",
                                    "nodeType": "YulIdentifier",
                                    "src": "12202:5:6"
                                  },
                                  {
                                    "arguments": [
                                      {
                                        "arguments": [
                                          {
                                            "name": "tail_5",
                                            "nodeType": "YulIdentifier",
                                            "src": "12217:6:6"
                                          },
                                          {
                                            "name": "tail_4",
                                            "nodeType": "YulIdentifier",
                                            "src": "12225:6:6"
                                          }
                                        ],
                                        "functionName": {
                                          "name": "sub",
                                          "nodeType": "YulIdentifier",
                                          "src": "12213:3:6"
                                        },
                                        "nodeType": "YulFunctionCall",
                                        "src": "12213:19:6"
                                      },
                                      {
                                        "arguments": [
                                          {
                                            "kind": "number",
                                            "nodeType": "YulLiteral",
                                            "src": "12238:2:6",
                                            "type": "",
                                            "value": "31"
                                          }
                                        ],
                                        "functionName": {
                                          "name": "not",
                                          "nodeType": "YulIdentifier",
                                          "src": "12234:3:6"
                                        },
                                        "nodeType": "YulFunctionCall",
                                        "src": "12234:7:6"
                                      }
                                    ],
                                    "functionName": {
                                      "name": "add",
                                      "nodeType": "YulIdentifier",
                                      "src": "12209:3:6"
                                    },
                                    "nodeType": "YulFunctionCall",
                                    "src": "12209:33:6"
                                  }
                                ],
                                "functionName": {
                                  "name": "mstore",
                                  "nodeType": "YulIdentifier",
                                  "src": "12195:6:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "12195:48:6"
                              },
                              "nodeType": "YulExpressionStatement",
                              "src": "12195:48:6"
                            },
                            {
                              "nodeType": "YulAssignment",
                              "src": "12260:52:6",
                              "value": {
                                "arguments": [
                                  {
                                    "arguments": [
                                      {
                                        "name": "srcPtr_1",
                                        "nodeType": "YulIdentifier",
                                        "src": "12294:8:6"
                                      }
                                    ],
                                    "functionName": {
                                      "name": "mload",
                                      "nodeType": "YulIdentifier",
                                      "src": "12288:5:6"
                                    },
                                    "nodeType": "YulFunctionCall",
                                    "src": "12288:15:6"
                                  },
                                  {
                                    "name": "tail_5",
                                    "nodeType": "YulIdentifier",
                                    "src": "12305:6:6"
                                  }
                                ],
                                "functionName": {
                                  "name": "abi_encode_string",
                                  "nodeType": "YulIdentifier",
                                  "src": "12270:17:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "12270:42:6"
                              },
                              "variableNames": [
                                {
                                  "name": "tail_5",
                                  "nodeType": "YulIdentifier",
                                  "src": "12260:6:6"
                                }
                              ]
                            },
                            {
                              "nodeType": "YulAssignment",
                              "src": "12329:29:6",
                              "value": {
                                "arguments": [
                                  {
                                    "name": "srcPtr_1",
                                    "nodeType": "YulIdentifier",
                                    "src": "12345:8:6"
                                  },
                                  {
                                    "name": "_1",
                                    "nodeType": "YulIdentifier",
                                    "src": "12355:2:6"
                                  }
                                ],
                                "functionName": {
                                  "name": "add",
                                  "nodeType": "YulIdentifier",
                                  "src": "12341:3:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "12341:17:6"
                              },
                              "variableNames": [
                                {
                                  "name": "srcPtr_1",
                                  "nodeType": "YulIdentifier",
                                  "src": "12329:8:6"
                                }
                              ]
                            },
                            {
                              "nodeType": "YulAssignment",
                              "src": "12375:23:6",
                              "value": {
                                "arguments": [
                                  {
                                    "name": "pos_1",
                                    "nodeType": "YulIdentifier",
                                    "src": "12388:5:6"
                                  },
                                  {
                                    "name": "_1",
                                    "nodeType": "YulIdentifier",
                                    "src": "12395:2:6"
                                  }
                                ],
                                "functionName": {
                                  "name": "add",
                                  "nodeType": "YulIdentifier",
                                  "src": "12384:3:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "12384:14:6"
                              },
                              "variableNames": [
                                {
                                  "name": "pos_1",
                                  "nodeType": "YulIdentifier",
                                  "src": "12375:5:6"
                                }
                              ]
                            }
                          ]
                        },
                        "condition": {
                          "arguments": [
                            {
                              "name": "i_2",
                              "nodeType": "YulIdentifier",
                              "src": "12127:3:6"
                            },
                            {
                              "name": "length_1",
                              "nodeType": "YulIdentifier",
                              "src": "12132:8:6"
                            }
                          ],
                          "functionName": {
                            "name": "lt",
                            "nodeType": "YulIdentifier",
                            "src": "12124:2:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "12124:17:6"
                        },
                        "nodeType": "YulForLoop",
                        "post": {
                          "nodeType": "YulBlock",
                          "src": "12142:22:6",
                          "statements": [
                            {
                              "nodeType": "YulAssignment",
                              "src": "12144:18:6",
                              "value": {
                                "arguments": [
                                  {
                                    "name": "i_2",
                                    "nodeType": "YulIdentifier",
                                    "src": "12155:3:6"
                                  },
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "12160:1:6",
                                    "type": "",
                                    "value": "1"
                                  }
                                ],
                                "functionName": {
                                  "name": "add",
                                  "nodeType": "YulIdentifier",
                                  "src": "12151:3:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "12151:11:6"
                              },
                              "variableNames": [
                                {
                                  "name": "i_2",
                                  "nodeType": "YulIdentifier",
                                  "src": "12144:3:6"
                                }
                              ]
                            }
                          ]
                        },
                        "pre": {
                          "nodeType": "YulBlock",
                          "src": "12120:3:6",
                          "statements": []
                        },
                        "src": "12116:296:6"
                      },
                      {
                        "nodeType": "YulAssignment",
                        "src": "12425:16:6",
                        "value": {
                          "name": "tail_5",
                          "nodeType": "YulIdentifier",
                          "src": "12435:6:6"
                        },
                        "variableNames": [
                          {
                            "name": "tail_2",
                            "nodeType": "YulIdentifier",
                            "src": "12425:6:6"
                          }
                        ]
                      },
                      {
                        "nodeType": "YulAssignment",
                        "src": "12454:25:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "srcPtr",
                              "nodeType": "YulIdentifier",
                              "src": "12468:6:6"
                            },
                            {
                              "name": "_1",
                              "nodeType": "YulIdentifier",
                              "src": "12476:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "12464:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "12464:15:6"
                        },
                        "variableNames": [
                          {
                            "name": "srcPtr",
                            "nodeType": "YulIdentifier",
                            "src": "12454:6:6"
                          }
                        ]
                      },
                      {
                        "nodeType": "YulAssignment",
                        "src": "12492:19:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "pos",
                              "nodeType": "YulIdentifier",
                              "src": "12503:3:6"
                            },
                            {
                              "name": "_1",
                              "nodeType": "YulIdentifier",
                              "src": "12508:2:6"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "12499:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "12499:12:6"
                        },
                        "variableNames": [
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "12492:3:6"
                          }
                        ]
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "i_1",
                        "nodeType": "YulIdentifier",
                        "src": "10857:3:6"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "10862:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "lt",
                      "nodeType": "YulIdentifier",
                      "src": "10854:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10854:15:6"
                  },
                  "nodeType": "YulForLoop",
                  "post": {
                    "nodeType": "YulBlock",
                    "src": "10870:22:6",
                    "statements": [
                      {
                        "nodeType": "YulAssignment",
                        "src": "10872:18:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "i_1",
                              "nodeType": "YulIdentifier",
                              "src": "10883:3:6"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "10888:1:6",
                              "type": "",
                              "value": "1"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "10879:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "10879:11:6"
                        },
                        "variableNames": [
                          {
                            "name": "i_1",
                            "nodeType": "YulIdentifier",
                            "src": "10872:3:6"
                          }
                        ]
                      }
                    ]
                  },
                  "pre": {
                    "nodeType": "YulBlock",
                    "src": "10850:3:6",
                    "statements": []
                  },
                  "src": "10846:1675:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "12530:14:6",
                  "value": {
                    "name": "tail_2",
                    "nodeType": "YulIdentifier",
                    "src": "12538:6:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "12530:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr__to_t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "10424:9:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "10435:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "10446:4:6",
                "type": ""
              }
            ],
            "src": "10252:2298:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "12650:92:6",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "12660:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "12672:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "12683:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "12668:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12668:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "12660:4:6"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "12702:9:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value0",
                                "nodeType": "YulIdentifier",
                                "src": "12727:6:6"
                              }
                            ],
                            "functionName": {
                              "name": "iszero",
                              "nodeType": "YulIdentifier",
                              "src": "12720:6:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "12720:14:6"
                          }
                        ],
                        "functionName": {
                          "name": "iszero",
                          "nodeType": "YulIdentifier",
                          "src": "12713:6:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "12713:22:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "12695:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12695:41:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "12695:41:6"
                }
              ]
            },
            "name": "abi_encode_tuple_t_bool__to_t_bool__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "12619:9:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "12630:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "12641:4:6",
                "type": ""
              }
            ],
            "src": "12555:187:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13009:413:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "13054:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_assert_enum_QuestionType",
                      "nodeType": "YulIdentifier",
                      "src": "13019:34:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13019:42:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13019:42:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "13077:9:6"
                      },
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "13088:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13070:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13070:25:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13070:25:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "13115:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "13126:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13111:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13111:18:6"
                      },
                      {
                        "name": "value1",
                        "nodeType": "YulIdentifier",
                        "src": "13131:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13104:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13104:34:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13104:34:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "13158:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "13169:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13154:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13154:18:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value2",
                                "nodeType": "YulIdentifier",
                                "src": "13188:6:6"
                              }
                            ],
                            "functionName": {
                              "name": "iszero",
                              "nodeType": "YulIdentifier",
                              "src": "13181:6:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "13181:14:6"
                          }
                        ],
                        "functionName": {
                          "name": "iszero",
                          "nodeType": "YulIdentifier",
                          "src": "13174:6:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13174:22:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13147:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13147:50:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13147:50:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "13217:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "13228:2:6",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13213:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13213:18:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13233:3:6",
                        "type": "",
                        "value": "160"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13206:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13206:31:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13206:31:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "13246:60:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value3",
                        "nodeType": "YulIdentifier",
                        "src": "13278:6:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "13290:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "13301:3:6",
                            "type": "",
                            "value": "160"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13286:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13286:19:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_string",
                      "nodeType": "YulIdentifier",
                      "src": "13260:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13260:46:6"
                  },
                  "variables": [
                    {
                      "name": "tail_1",
                      "nodeType": "YulTypedName",
                      "src": "13250:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "13326:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "13337:3:6",
                            "type": "",
                            "value": "128"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13322:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13322:19:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "tail_1",
                            "nodeType": "YulIdentifier",
                            "src": "13347:6:6"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "13355:9:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "13343:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13343:22:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13315:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13315:51:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13315:51:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "13375:41:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value4",
                        "nodeType": "YulIdentifier",
                        "src": "13401:6:6"
                      },
                      {
                        "name": "tail_1",
                        "nodeType": "YulIdentifier",
                        "src": "13409:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_string",
                      "nodeType": "YulIdentifier",
                      "src": "13383:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13383:33:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "13375:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_enum$_QuestionType_$2005_t_uint256_t_bool_t_string_memory_ptr_t_string_memory_ptr__to_t_uint8_t_uint256_t_bool_t_string_memory_ptr_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "12946:9:6",
                "type": ""
              },
              {
                "name": "value4",
                "nodeType": "YulTypedName",
                "src": "12957:6:6",
                "type": ""
              },
              {
                "name": "value3",
                "nodeType": "YulTypedName",
                "src": "12965:6:6",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "12973:6:6",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "12981:6:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "12989:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "13000:4:6",
                "type": ""
              }
            ],
            "src": "12747:675:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13537:127:6",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "13547:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "13559:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13570:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "13555:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13555:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "13547:4:6"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "13617:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_assert_enum_QuestionType",
                      "nodeType": "YulIdentifier",
                      "src": "13582:34:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13582:42:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13582:42:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "13640:9:6"
                      },
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "13651:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13633:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13633:25:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13633:25:6"
                }
              ]
            },
            "name": "abi_encode_tuple_t_enum$_Status_$2001__to_t_uint8__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "13506:9:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "13517:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "13528:4:6",
                "type": ""
              }
            ],
            "src": "13427:237:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13790:99:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "13807:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13818:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13800:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13800:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13800:21:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "13830:53:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "13856:6:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "13868:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "13879:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13864:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13864:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_string",
                      "nodeType": "YulIdentifier",
                      "src": "13838:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13838:45:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "13830:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_string_memory_ptr__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "13759:9:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "13770:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "13781:4:6",
                "type": ""
              }
            ],
            "src": "13669:220:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "14068:239:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "14085:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14096:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14078:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14078:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14078:21:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14119:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14130:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14115:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14115:18:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14135:2:6",
                        "type": "",
                        "value": "49"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14108:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14108:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14108:30:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14158:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14169:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14154:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14154:18:6"
                      },
                      {
                        "hexValue": "4e6f7420656e6f7567682072657761726420746f20676976652c2063616e6365",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14174:34:6",
                        "type": "",
                        "value": "Not enough reward to give, cance"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14147:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14147:62:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14147:62:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14229:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14240:2:6",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14225:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14225:18:6"
                      },
                      {
                        "hexValue": "6c6c696e67207375626d697373696f6e2e",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14245:19:6",
                        "type": "",
                        "value": "lling submission."
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14218:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14218:47:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14218:47:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "14274:27:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "14286:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14297:3:6",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "14282:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14282:19:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "14274:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_011cc548aef422f49ec5b449d0fed3dafc46f94a16900943c531cd7c2a55cecb__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "14045:9:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "14059:4:6",
                "type": ""
              }
            ],
            "src": "13894:413:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "14486:182:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "14503:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14514:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14496:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14496:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14496:21:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14537:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14548:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14533:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14533:18:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14553:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14526:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14526:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14526:30:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14576:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14587:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14572:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14572:18:6"
                      },
                      {
                        "hexValue": "5265717569726564207175657374696f6e206e6f742066696c6c6564206f7574",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14592:34:6",
                        "type": "",
                        "value": "Required question not filled out"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14565:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14565:62:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14565:62:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "14636:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "14648:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14659:2:6",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "14644:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14644:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "14636:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_04037c1c73b6df0138c0effd84a095632c6f0e3142cefd7669cea1e916bce893__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "14463:9:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "14477:4:6",
                "type": ""
              }
            ],
            "src": "14312:356:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "14847:248:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "14864:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14875:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14857:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14857:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14857:21:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14898:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14909:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14894:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14894:18:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "14914:2:6",
                        "type": "",
                        "value": "58"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14887:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14887:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14887:30:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "14937:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14948:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14933:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14933:18:6"
                      },
                      {
                        "hexValue": "416e7377657220737472696e6720617272617920646f6573206e6f74206d6174",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14953:34:6",
                        "type": "",
                        "value": "Answer string array does not mat"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14926:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14926:62:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14926:62:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "15008:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "15019:2:6",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "15004:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "15004:18:6"
                      },
                      {
                        "hexValue": "636820746865206c656e677468206f66207175657374696f6e73",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "15024:28:6",
                        "type": "",
                        "value": "ch the length of questions"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14997:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14997:56:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14997:56:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "15062:27:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "15074:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "15085:3:6",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "15070:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15070:19:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "15062:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_0cea1408d7a63a11331c6748505bc80cd60b8480f58c4c2651963f54f0b97c32__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "14824:9:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "14838:4:6",
                "type": ""
              }
            ],
            "src": "14673:422:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "15274:181:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "15291:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "15302:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15284:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15284:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15284:21:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "15325:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "15336:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "15321:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "15321:18:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "15341:2:6",
                        "type": "",
                        "value": "31"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15314:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15314:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15314:30:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "15364:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "15375:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "15360:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "15360:18:6"
                      },
                      {
                        "hexValue": "537572766579206d75737420626520696e2065646974696e67207374616765",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "15380:33:6",
                        "type": "",
                        "value": "Survey must be in editing stage"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15353:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15353:61:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15353:61:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "15423:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "15435:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "15446:2:6",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "15431:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15431:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "15423:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "15251:9:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "15265:4:6",
                "type": ""
              }
            ],
            "src": "15100:355:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "15634:173:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "15651:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "15662:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15644:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15644:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15644:21:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "15685:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "15696:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "15681:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "15681:18:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "15701:2:6",
                        "type": "",
                        "value": "23"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15674:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15674:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15674:30:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "15724:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "15735:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "15720:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "15720:18:6"
                      },
                      {
                        "hexValue": "416c726561647920746f6f6b2074686520737572766579",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "15740:25:6",
                        "type": "",
                        "value": "Already took the survey"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15713:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15713:53:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15713:53:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "15775:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "15787:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "15798:2:6",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "15783:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15783:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "15775:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_6ea6531dad0de6919871ea7d20ff474e1ecd8be9b63504d49bb651d3d627d724__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "15611:9:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "15625:4:6",
                "type": ""
              }
            ],
            "src": "15460:347:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "15986:233:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "16003:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16014:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "15996:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "15996:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "15996:21:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16037:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16048:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16033:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16033:18:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16053:2:6",
                        "type": "",
                        "value": "43"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16026:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16026:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16026:30:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16076:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16087:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16072:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16072:18:6"
                      },
                      {
                        "hexValue": "4d757374206265207468652063726561746f7220746f20616363657373207468",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "16092:34:6",
                        "type": "",
                        "value": "Must be the creator to access th"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16065:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16065:62:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16065:62:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16147:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16158:2:6",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16143:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16143:18:6"
                      },
                      {
                        "hexValue": "69732066756e6374696f6e",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "16163:13:6",
                        "type": "",
                        "value": "is function"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16136:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16136:41:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16136:41:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "16186:27:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "16198:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16209:3:6",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "16194:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16194:19:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "16186:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_879c16fa9785c28093236dad4c926abbcc4ddd1e24d5a113771878e901c54b25__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "15963:9:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "15977:4:6",
                "type": ""
              }
            ],
            "src": "15812:407:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "16398:238:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "16415:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16426:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16408:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16408:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16408:21:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16449:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16460:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16445:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16445:18:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16465:2:6",
                        "type": "",
                        "value": "48"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16438:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16438:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16438:30:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16488:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16499:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16484:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16484:18:6"
                      },
                      {
                        "hexValue": "42616c616e63652068617320746f206265203e3d207468616e2074686520616d",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "16504:34:6",
                        "type": "",
                        "value": "Balance has to be >= than the am"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16477:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16477:62:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16477:62:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16559:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16570:2:6",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16555:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16555:18:6"
                      },
                      {
                        "hexValue": "6f756e7420746f207769746864726177",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "16575:18:6",
                        "type": "",
                        "value": "ount to withdraw"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16548:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16548:46:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16548:46:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "16603:27:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "16615:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16626:3:6",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "16611:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16611:19:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "16603:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_951ece5d5af66174f14cd35238da3522fbecff682f2440d776cb968d376dbcbf__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "16375:9:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "16389:4:6",
                "type": ""
              }
            ],
            "src": "16224:412:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "16815:168:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "16832:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16843:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16825:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16825:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16825:21:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16866:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16877:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16862:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16862:18:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16882:2:6",
                        "type": "",
                        "value": "18"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16855:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16855:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16855:30:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "16905:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "16916:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "16901:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "16901:18:6"
                      },
                      {
                        "hexValue": "537572766579206973206e6f74206f70656e",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "16921:20:6",
                        "type": "",
                        "value": "Survey is not open"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "16894:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16894:48:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "16894:48:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "16951:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "16963:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "16974:2:6",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "16959:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "16959:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "16951:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_f0fab26ac02ca5c681c22c19f8d96f059af3b7216c3818e8ee0f9360e4cf614b__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "16792:9:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "16806:4:6",
                "type": ""
              }
            ],
            "src": "16641:342:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "17162:180:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "17179:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "17190:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "17172:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17172:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17172:21:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "17213:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "17224:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "17209:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17209:18:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "17229:2:6",
                        "type": "",
                        "value": "30"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "17202:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17202:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17202:30:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "17252:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "17263:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "17248:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17248:18:6"
                      },
                      {
                        "hexValue": "43726561746f722063616e6e6f742074616b652074686520737572766579",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "17268:32:6",
                        "type": "",
                        "value": "Creator cannot take the survey"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "17241:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17241:60:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17241:60:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "17310:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "17322:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "17333:2:6",
                        "type": "",
                        "value": "96"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "17318:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17318:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "17310:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_f1c7bbfa2aef84eacd6e1bcb3c18e7590c1327e2ba069b2e3ddeb1a8f62ded03__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "17139:9:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "17153:4:6",
                "type": ""
              }
            ],
            "src": "16988:354:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "17521:224:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "17538:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "17549:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "17531:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17531:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17531:21:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "17572:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "17583:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "17568:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17568:18:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "17588:2:6",
                        "type": "",
                        "value": "34"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "17561:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17561:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17561:30:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "17611:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "17622:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "17607:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17607:18:6"
                      },
                      {
                        "hexValue": "616d6f756e742068617320746f2062652067726561746572207468616e207a65",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "17627:34:6",
                        "type": "",
                        "value": "amount has to be greater than ze"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "17600:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17600:62:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17600:62:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "17682:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "17693:2:6",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "17678:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "17678:18:6"
                      },
                      {
                        "hexValue": "726f",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "17698:4:6",
                        "type": "",
                        "value": "ro"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "17671:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17671:32:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17671:32:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "17712:27:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "17724:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "17735:3:6",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "17720:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17720:19:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "17712:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "17498:9:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "17512:4:6",
                "type": ""
              }
            ],
            "src": "17347:398:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "17913:102:6",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "17923:27:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "17935:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "17946:3:6",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "17931:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17931:19:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "17923:4:6"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "17991:6:6"
                      },
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "17999:9:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_struct_LiquidityPool",
                      "nodeType": "YulIdentifier",
                      "src": "17959:31:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "17959:50:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "17959:50:6"
                }
              ]
            },
            "name": "abi_encode_tuple_t_struct$_LiquidityPool_$2029_memory_ptr__to_t_struct$_LiquidityPool_$2029_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "17882:9:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "17893:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "17904:4:6",
                "type": ""
              }
            ],
            "src": "17750:265:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "18179:111:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "18196:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "18207:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "18189:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18189:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18189:21:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "18219:65:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "18257:6:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "18269:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "18280:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "18265:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "18265:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_struct_SurveyBasic",
                      "nodeType": "YulIdentifier",
                      "src": "18227:29:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18227:57:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "18219:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_struct$_SurveyBasic_$2036_memory_ptr__to_t_struct$_SurveyBasic_$2036_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "18148:9:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "18159:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "18170:4:6",
                "type": ""
              }
            ],
            "src": "18020:270:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "18637:433:6",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "18647:13:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "18657:3:6",
                    "type": "",
                    "value": "256"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "18651:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "18676:9:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "18687:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "18669:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18669:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18669:21:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "18699:65:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "18737:6:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "18749:9:6"
                          },
                          {
                            "name": "_1",
                            "nodeType": "YulIdentifier",
                            "src": "18760:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "18745:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "18745:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_struct_SurveyBasic",
                      "nodeType": "YulIdentifier",
                      "src": "18707:29:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18707:57:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "18699:4:6"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value1",
                        "nodeType": "YulIdentifier",
                        "src": "18805:6:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "18817:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "18828:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "18813:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "18813:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_struct_LiquidityPool",
                      "nodeType": "YulIdentifier",
                      "src": "18773:31:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18773:59:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18773:59:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "18852:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "18863:3:6",
                            "type": "",
                            "value": "160"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "18848:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "18848:19:6"
                      },
                      {
                        "name": "value2",
                        "nodeType": "YulIdentifier",
                        "src": "18869:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "18841:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18841:35:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18841:35:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value3",
                        "nodeType": "YulIdentifier",
                        "src": "18920:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "validator_assert_enum_QuestionType",
                      "nodeType": "YulIdentifier",
                      "src": "18885:34:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18885:42:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18885:42:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "18947:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "18958:3:6",
                            "type": "",
                            "value": "192"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "18943:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "18943:19:6"
                      },
                      {
                        "name": "value3",
                        "nodeType": "YulIdentifier",
                        "src": "18964:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "18936:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18936:35:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18936:35:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "18991:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19002:3:6",
                            "type": "",
                            "value": "224"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "18987:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "18987:19:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value4",
                            "nodeType": "YulIdentifier",
                            "src": "19012:6:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19020:42:6",
                            "type": "",
                            "value": "0xffffffffffffffffffffffffffffffffffffffff"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "19008:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19008:55:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "18980:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "18980:84:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "18980:84:6"
                }
              ]
            },
            "name": "abi_encode_tuple_t_struct$_SurveyBasic_$2036_memory_ptr_t_struct$_LiquidityPool_$2029_memory_ptr_t_uint256_t_enum$_Status_$2001_t_address__to_t_struct$_SurveyBasic_$2036_memory_ptr_t_struct$_LiquidityPool_$2029_memory_ptr_t_uint256_t_uint8_t_address__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "18574:9:6",
                "type": ""
              },
              {
                "name": "value4",
                "nodeType": "YulTypedName",
                "src": "18585:6:6",
                "type": ""
              },
              {
                "name": "value3",
                "nodeType": "YulTypedName",
                "src": "18593:6:6",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "18601:6:6",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "18609:6:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "18617:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "18628:4:6",
                "type": ""
              }
            ],
            "src": "18295:775:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "19240:1217:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "19257:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "19268:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "19250:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19250:21:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "19250:21:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "19291:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19302:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "19287:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19287:18:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "19313:6:6"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "19307:5:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19307:13:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "19280:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19280:41:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "19280:41:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "19330:42:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "19360:6:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19368:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "19356:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19356:15:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "19350:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19350:22:6"
                  },
                  "variables": [
                    {
                      "name": "memberValue0",
                      "nodeType": "YulTypedName",
                      "src": "19334:12:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "memberValue0",
                        "nodeType": "YulIdentifier",
                        "src": "19400:12:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "19418:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19429:2:6",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "19414:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19414:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_address",
                      "nodeType": "YulIdentifier",
                      "src": "19381:18:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19381:52:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "19381:52:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "19453:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19464:2:6",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "19449:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19449:18:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value0",
                                "nodeType": "YulIdentifier",
                                "src": "19479:6:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "19487:2:6",
                                "type": "",
                                "value": "64"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "19475:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "19475:15:6"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "19469:5:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19469:22:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "19442:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19442:50:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "19442:50:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "19512:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19523:3:6",
                            "type": "",
                            "value": "128"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "19508:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19508:19:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value0",
                                "nodeType": "YulIdentifier",
                                "src": "19539:6:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "19547:2:6",
                                "type": "",
                                "value": "96"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "19535:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "19535:15:6"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "19529:5:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19529:22:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "19501:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19501:51:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "19501:51:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "19561:45:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "19593:6:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19601:3:6",
                            "type": "",
                            "value": "128"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "19589:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19589:16:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "19583:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19583:23:6"
                  },
                  "variables": [
                    {
                      "name": "memberValue0_1",
                      "nodeType": "YulTypedName",
                      "src": "19565:14:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "19615:16:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "19625:6:6",
                    "type": "",
                    "value": "0x0160"
                  },
                  "variables": [
                    {
                      "name": "_1",
                      "nodeType": "YulTypedName",
                      "src": "19619:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "19651:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19662:3:6",
                            "type": "",
                            "value": "160"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "19647:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19647:19:6"
                      },
                      {
                        "name": "_1",
                        "nodeType": "YulIdentifier",
                        "src": "19668:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "19640:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19640:31:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "19640:31:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "19680:68:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "memberValue0_1",
                        "nodeType": "YulIdentifier",
                        "src": "19712:14:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "19732:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19743:3:6",
                            "type": "",
                            "value": "384"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "19728:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19728:19:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_string",
                      "nodeType": "YulIdentifier",
                      "src": "19694:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19694:54:6"
                  },
                  "variables": [
                    {
                      "name": "tail_1",
                      "nodeType": "YulTypedName",
                      "src": "19684:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "19757:45:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "19789:6:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19797:3:6",
                            "type": "",
                            "value": "160"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "19785:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19785:16:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "19779:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19779:23:6"
                  },
                  "variables": [
                    {
                      "name": "memberValue0_2",
                      "nodeType": "YulTypedName",
                      "src": "19761:14:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "19822:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19833:3:6",
                            "type": "",
                            "value": "192"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "19818:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19818:19:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "tail_1",
                                "nodeType": "YulIdentifier",
                                "src": "19847:6:6"
                              },
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "19855:9:6"
                              }
                            ],
                            "functionName": {
                              "name": "sub",
                              "nodeType": "YulIdentifier",
                              "src": "19843:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "19843:22:6"
                          },
                          {
                            "arguments": [
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "19871:2:6",
                                "type": "",
                                "value": "31"
                              }
                            ],
                            "functionName": {
                              "name": "not",
                              "nodeType": "YulIdentifier",
                              "src": "19867:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "19867:7:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "19839:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19839:36:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "19811:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19811:65:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "19811:65:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "19885:55:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "memberValue0_2",
                        "nodeType": "YulIdentifier",
                        "src": "19917:14:6"
                      },
                      {
                        "name": "tail_1",
                        "nodeType": "YulIdentifier",
                        "src": "19933:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_string",
                      "nodeType": "YulIdentifier",
                      "src": "19899:17:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19899:41:6"
                  },
                  "variables": [
                    {
                      "name": "tail_2",
                      "nodeType": "YulTypedName",
                      "src": "19889:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "19949:45:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "19981:6:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "19989:3:6",
                            "type": "",
                            "value": "192"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "19977:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "19977:16:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "19971:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "19971:23:6"
                  },
                  "variables": [
                    {
                      "name": "memberValue0_3",
                      "nodeType": "YulTypedName",
                      "src": "19953:14:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "memberValue0_3",
                        "nodeType": "YulIdentifier",
                        "src": "20026:14:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "20046:9:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "20057:3:6",
                            "type": "",
                            "value": "224"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "20042:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "20042:19:6"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_enum_Status",
                      "nodeType": "YulIdentifier",
                      "src": "20003:22:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20003:59:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "20003:59:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "20071:33:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "20091:6:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "20099:3:6",
                            "type": "",
                            "value": "224"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "20087:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "20087:16:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "20081:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20081:23:6"
                  },
                  "variables": [
                    {
                      "name": "_2",
                      "nodeType": "YulTypedName",
                      "src": "20075:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "20113:13:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "20123:3:6",
                    "type": "",
                    "value": "256"
                  },
                  "variables": [
                    {
                      "name": "_3",
                      "nodeType": "YulTypedName",
                      "src": "20117:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "20146:9:6"
                          },
                          {
                            "name": "_3",
                            "nodeType": "YulIdentifier",
                            "src": "20157:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "20142:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "20142:18:6"
                      },
                      {
                        "name": "_2",
                        "nodeType": "YulIdentifier",
                        "src": "20162:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "20135:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20135:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "20135:30:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "20174:32:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "20194:6:6"
                          },
                          {
                            "name": "_3",
                            "nodeType": "YulIdentifier",
                            "src": "20202:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "20190:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "20190:15:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "20184:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20184:22:6"
                  },
                  "variables": [
                    {
                      "name": "_4",
                      "nodeType": "YulTypedName",
                      "src": "20178:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "20215:13:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "20225:3:6",
                    "type": "",
                    "value": "288"
                  },
                  "variables": [
                    {
                      "name": "_5",
                      "nodeType": "YulTypedName",
                      "src": "20219:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "20248:9:6"
                          },
                          {
                            "name": "_5",
                            "nodeType": "YulIdentifier",
                            "src": "20259:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "20244:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "20244:18:6"
                      },
                      {
                        "name": "_4",
                        "nodeType": "YulIdentifier",
                        "src": "20264:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "20237:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20237:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "20237:30:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "20276:32:6",
                  "value": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value0",
                            "nodeType": "YulIdentifier",
                            "src": "20296:6:6"
                          },
                          {
                            "name": "_5",
                            "nodeType": "YulIdentifier",
                            "src": "20304:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "20292:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "20292:15:6"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "20286:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20286:22:6"
                  },
                  "variables": [
                    {
                      "name": "_6",
                      "nodeType": "YulTypedName",
                      "src": "20280:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "20317:13:6",
                  "value": {
                    "kind": "number",
                    "nodeType": "YulLiteral",
                    "src": "20327:3:6",
                    "type": "",
                    "value": "320"
                  },
                  "variables": [
                    {
                      "name": "_7",
                      "nodeType": "YulTypedName",
                      "src": "20321:2:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "20350:9:6"
                          },
                          {
                            "name": "_7",
                            "nodeType": "YulIdentifier",
                            "src": "20361:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "20346:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "20346:18:6"
                      },
                      {
                        "name": "_6",
                        "nodeType": "YulIdentifier",
                        "src": "20366:2:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "20339:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20339:30:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "20339:30:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "20389:9:6"
                          },
                          {
                            "name": "_1",
                            "nodeType": "YulIdentifier",
                            "src": "20400:2:6"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "20385:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "20385:18:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value0",
                                "nodeType": "YulIdentifier",
                                "src": "20415:6:6"
                              },
                              {
                                "name": "_7",
                                "nodeType": "YulIdentifier",
                                "src": "20423:2:6"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "20411:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "20411:15:6"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "20405:5:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "20405:22:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "20378:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20378:50:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "20378:50:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "20437:14:6",
                  "value": {
                    "name": "tail_2",
                    "nodeType": "YulIdentifier",
                    "src": "20445:6:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "20437:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_struct$_SurveyOverview_$2074_memory_ptr__to_t_struct$_SurveyOverview_$2074_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "19209:9:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "19220:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "19231:4:6",
                "type": ""
              }
            ],
            "src": "19075:1382:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "20563:76:6",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "20573:26:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "20585:9:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "20596:2:6",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "20581:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20581:18:6"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "20573:4:6"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "20615:9:6"
                      },
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "20626:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "20608:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20608:25:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "20608:25:6"
                }
              ]
            },
            "name": "abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "20532:9:6",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "20543:6:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "20554:4:6",
                "type": ""
              }
            ],
            "src": "20462:177:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "20739:427:6",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "20749:51:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "ptr_to_tail",
                        "nodeType": "YulIdentifier",
                        "src": "20788:11:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "20775:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20775:25:6"
                  },
                  "variables": [
                    {
                      "name": "rel_offset_of_tail",
                      "nodeType": "YulTypedName",
                      "src": "20753:18:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "20889:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "20898:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "20901:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "20891:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "20891:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "20891:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "rel_offset_of_tail",
                            "nodeType": "YulIdentifier",
                            "src": "20823:18:6"
                          },
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "arguments": [],
                                    "functionName": {
                                      "name": "calldatasize",
                                      "nodeType": "YulIdentifier",
                                      "src": "20851:12:6"
                                    },
                                    "nodeType": "YulFunctionCall",
                                    "src": "20851:14:6"
                                  },
                                  {
                                    "name": "base_ref",
                                    "nodeType": "YulIdentifier",
                                    "src": "20867:8:6"
                                  }
                                ],
                                "functionName": {
                                  "name": "sub",
                                  "nodeType": "YulIdentifier",
                                  "src": "20847:3:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "20847:29:6"
                              },
                              {
                                "arguments": [
                                  {
                                    "kind": "number",
                                    "nodeType": "YulLiteral",
                                    "src": "20882:2:6",
                                    "type": "",
                                    "value": "30"
                                  }
                                ],
                                "functionName": {
                                  "name": "not",
                                  "nodeType": "YulIdentifier",
                                  "src": "20878:3:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "20878:7:6"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "20843:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "20843:43:6"
                          }
                        ],
                        "functionName": {
                          "name": "slt",
                          "nodeType": "YulIdentifier",
                          "src": "20819:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "20819:68:6"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "20812:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20812:76:6"
                  },
                  "nodeType": "YulIf",
                  "src": "20809:96:6"
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "20914:47:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "base_ref",
                        "nodeType": "YulIdentifier",
                        "src": "20932:8:6"
                      },
                      {
                        "name": "rel_offset_of_tail",
                        "nodeType": "YulIdentifier",
                        "src": "20942:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "20928:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20928:33:6"
                  },
                  "variables": [
                    {
                      "name": "addr_1",
                      "nodeType": "YulTypedName",
                      "src": "20918:6:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "20970:30:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "addr_1",
                        "nodeType": "YulIdentifier",
                        "src": "20993:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "20980:12:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "20980:20:6"
                  },
                  "variableNames": [
                    {
                      "name": "length",
                      "nodeType": "YulIdentifier",
                      "src": "20970:6:6"
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "21043:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "21052:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "21055:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "21045:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "21045:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "21045:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "21015:6:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "21023:18:6",
                        "type": "",
                        "value": "0xffffffffffffffff"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "21012:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21012:30:6"
                  },
                  "nodeType": "YulIf",
                  "src": "21009:50:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "21068:25:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "addr_1",
                        "nodeType": "YulIdentifier",
                        "src": "21080:6:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "21088:4:6",
                        "type": "",
                        "value": "0x20"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "21076:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21076:17:6"
                  },
                  "variableNames": [
                    {
                      "name": "addr",
                      "nodeType": "YulIdentifier",
                      "src": "21068:4:6"
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "21144:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "21153:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "21156:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "21146:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "21146:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "21146:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "addr",
                        "nodeType": "YulIdentifier",
                        "src": "21109:4:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [],
                            "functionName": {
                              "name": "calldatasize",
                              "nodeType": "YulIdentifier",
                              "src": "21119:12:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "21119:14:6"
                          },
                          {
                            "name": "length",
                            "nodeType": "YulIdentifier",
                            "src": "21135:6:6"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "21115:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "21115:27:6"
                      }
                    ],
                    "functionName": {
                      "name": "sgt",
                      "nodeType": "YulIdentifier",
                      "src": "21105:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21105:38:6"
                  },
                  "nodeType": "YulIf",
                  "src": "21102:58:6"
                }
              ]
            },
            "name": "access_calldata_tail_t_string_calldata_ptr",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "base_ref",
                "nodeType": "YulTypedName",
                "src": "20696:8:6",
                "type": ""
              },
              {
                "name": "ptr_to_tail",
                "nodeType": "YulTypedName",
                "src": "20706:11:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "addr",
                "nodeType": "YulTypedName",
                "src": "20722:4:6",
                "type": ""
              },
              {
                "name": "length",
                "nodeType": "YulTypedName",
                "src": "20728:6:6",
                "type": ""
              }
            ],
            "src": "20644:522:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "21216:230:6",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "21226:19:6",
                  "value": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "21242:2:6",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "21236:5:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21236:9:6"
                  },
                  "variableNames": [
                    {
                      "name": "memPtr",
                      "nodeType": "YulIdentifier",
                      "src": "21226:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "21254:58:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "memPtr",
                        "nodeType": "YulIdentifier",
                        "src": "21276:6:6"
                      },
                      {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "size",
                                "nodeType": "YulIdentifier",
                                "src": "21292:4:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "21298:2:6",
                                "type": "",
                                "value": "31"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "21288:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "21288:13:6"
                          },
                          {
                            "arguments": [
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "21307:2:6",
                                "type": "",
                                "value": "31"
                              }
                            ],
                            "functionName": {
                              "name": "not",
                              "nodeType": "YulIdentifier",
                              "src": "21303:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "21303:7:6"
                          }
                        ],
                        "functionName": {
                          "name": "and",
                          "nodeType": "YulIdentifier",
                          "src": "21284:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "21284:27:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "21272:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21272:40:6"
                  },
                  "variables": [
                    {
                      "name": "newFreePtr",
                      "nodeType": "YulTypedName",
                      "src": "21258:10:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "21387:22:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x41",
                            "nodeType": "YulIdentifier",
                            "src": "21389:16:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "21389:18:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "21389:18:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "newFreePtr",
                            "nodeType": "YulIdentifier",
                            "src": "21330:10:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "21342:18:6",
                            "type": "",
                            "value": "0xffffffffffffffff"
                          }
                        ],
                        "functionName": {
                          "name": "gt",
                          "nodeType": "YulIdentifier",
                          "src": "21327:2:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "21327:34:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "newFreePtr",
                            "nodeType": "YulIdentifier",
                            "src": "21366:10:6"
                          },
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "21378:6:6"
                          }
                        ],
                        "functionName": {
                          "name": "lt",
                          "nodeType": "YulIdentifier",
                          "src": "21363:2:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "21363:22:6"
                      }
                    ],
                    "functionName": {
                      "name": "or",
                      "nodeType": "YulIdentifier",
                      "src": "21324:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21324:62:6"
                  },
                  "nodeType": "YulIf",
                  "src": "21321:88:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "21425:2:6",
                        "type": "",
                        "value": "64"
                      },
                      {
                        "name": "newFreePtr",
                        "nodeType": "YulIdentifier",
                        "src": "21429:10:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "21418:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21418:22:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "21418:22:6"
                }
              ]
            },
            "name": "allocate_memory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "size",
                "nodeType": "YulTypedName",
                "src": "21196:4:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "memPtr",
                "nodeType": "YulTypedName",
                "src": "21205:6:6",
                "type": ""
              }
            ],
            "src": "21171:275:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "21499:80:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "21526:22:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x11",
                            "nodeType": "YulIdentifier",
                            "src": "21528:16:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "21528:18:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "21528:18:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "21515:1:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "y",
                            "nodeType": "YulIdentifier",
                            "src": "21522:1:6"
                          }
                        ],
                        "functionName": {
                          "name": "not",
                          "nodeType": "YulIdentifier",
                          "src": "21518:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "21518:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "21512:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21512:13:6"
                  },
                  "nodeType": "YulIf",
                  "src": "21509:39:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "21557:16:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "21568:1:6"
                      },
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "21571:1:6"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "21564:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21564:9:6"
                  },
                  "variableNames": [
                    {
                      "name": "sum",
                      "nodeType": "YulIdentifier",
                      "src": "21557:3:6"
                    }
                  ]
                }
              ]
            },
            "name": "checked_add_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "x",
                "nodeType": "YulTypedName",
                "src": "21482:1:6",
                "type": ""
              },
              {
                "name": "y",
                "nodeType": "YulTypedName",
                "src": "21485:1:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "sum",
                "nodeType": "YulTypedName",
                "src": "21491:3:6",
                "type": ""
              }
            ],
            "src": "21451:128:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "21633:76:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "21655:22:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x11",
                            "nodeType": "YulIdentifier",
                            "src": "21657:16:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "21657:18:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "21657:18:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "21649:1:6"
                      },
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "21652:1:6"
                      }
                    ],
                    "functionName": {
                      "name": "lt",
                      "nodeType": "YulIdentifier",
                      "src": "21646:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21646:8:6"
                  },
                  "nodeType": "YulIf",
                  "src": "21643:34:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "21686:17:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "21698:1:6"
                      },
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "21701:1:6"
                      }
                    ],
                    "functionName": {
                      "name": "sub",
                      "nodeType": "YulIdentifier",
                      "src": "21694:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21694:9:6"
                  },
                  "variableNames": [
                    {
                      "name": "diff",
                      "nodeType": "YulIdentifier",
                      "src": "21686:4:6"
                    }
                  ]
                }
              ]
            },
            "name": "checked_sub_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "x",
                "nodeType": "YulTypedName",
                "src": "21615:1:6",
                "type": ""
              },
              {
                "name": "y",
                "nodeType": "YulTypedName",
                "src": "21618:1:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "diff",
                "nodeType": "YulTypedName",
                "src": "21624:4:6",
                "type": ""
              }
            ],
            "src": "21584:125:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "21769:333:6",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "21779:22:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "data",
                        "nodeType": "YulIdentifier",
                        "src": "21793:4:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "21799:1:6",
                        "type": "",
                        "value": "2"
                      }
                    ],
                    "functionName": {
                      "name": "div",
                      "nodeType": "YulIdentifier",
                      "src": "21789:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21789:12:6"
                  },
                  "variableNames": [
                    {
                      "name": "length",
                      "nodeType": "YulIdentifier",
                      "src": "21779:6:6"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "21810:38:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "data",
                        "nodeType": "YulIdentifier",
                        "src": "21840:4:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "21846:1:6",
                        "type": "",
                        "value": "1"
                      }
                    ],
                    "functionName": {
                      "name": "and",
                      "nodeType": "YulIdentifier",
                      "src": "21836:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21836:12:6"
                  },
                  "variables": [
                    {
                      "name": "outOfPlaceEncoding",
                      "nodeType": "YulTypedName",
                      "src": "21814:18:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "21887:31:6",
                    "statements": [
                      {
                        "nodeType": "YulAssignment",
                        "src": "21889:27:6",
                        "value": {
                          "arguments": [
                            {
                              "name": "length",
                              "nodeType": "YulIdentifier",
                              "src": "21903:6:6"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "21911:4:6",
                              "type": "",
                              "value": "0x7f"
                            }
                          ],
                          "functionName": {
                            "name": "and",
                            "nodeType": "YulIdentifier",
                            "src": "21899:3:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "21899:17:6"
                        },
                        "variableNames": [
                          {
                            "name": "length",
                            "nodeType": "YulIdentifier",
                            "src": "21889:6:6"
                          }
                        ]
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "outOfPlaceEncoding",
                        "nodeType": "YulIdentifier",
                        "src": "21867:18:6"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "21860:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21860:26:6"
                  },
                  "nodeType": "YulIf",
                  "src": "21857:61:6"
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "21977:119:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "21998:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "arguments": [
                                {
                                  "kind": "number",
                                  "nodeType": "YulLiteral",
                                  "src": "22005:10:6",
                                  "type": "",
                                  "value": "0x4e487b71"
                                },
                                {
                                  "arguments": [
                                    {
                                      "kind": "number",
                                      "nodeType": "YulLiteral",
                                      "src": "22021:1:6",
                                      "type": "",
                                      "value": "2"
                                    },
                                    {
                                      "kind": "number",
                                      "nodeType": "YulLiteral",
                                      "src": "22024:3:6",
                                      "type": "",
                                      "value": "224"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "exp",
                                    "nodeType": "YulIdentifier",
                                    "src": "22017:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "22017:11:6"
                                }
                              ],
                              "functionName": {
                                "name": "mul",
                                "nodeType": "YulIdentifier",
                                "src": "22001:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "22001:28:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "21991:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "21991:39:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "21991:39:6"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "22050:1:6",
                              "type": "",
                              "value": "4"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "22053:4:6",
                              "type": "",
                              "value": "0x22"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "22043:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "22043:15:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "22043:15:6"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "22078:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "22081:4:6",
                              "type": "",
                              "value": "0x24"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "22071:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "22071:15:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "22071:15:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "outOfPlaceEncoding",
                        "nodeType": "YulIdentifier",
                        "src": "21933:18:6"
                      },
                      {
                        "arguments": [
                          {
                            "name": "length",
                            "nodeType": "YulIdentifier",
                            "src": "21956:6:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "21964:2:6",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "lt",
                          "nodeType": "YulIdentifier",
                          "src": "21953:2:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "21953:14:6"
                      }
                    ],
                    "functionName": {
                      "name": "eq",
                      "nodeType": "YulIdentifier",
                      "src": "21930:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "21930:38:6"
                  },
                  "nodeType": "YulIf",
                  "src": "21927:169:6"
                }
              ]
            },
            "name": "extract_byte_array_length",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "data",
                "nodeType": "YulTypedName",
                "src": "21749:4:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "length",
                "nodeType": "YulTypedName",
                "src": "21758:6:6",
                "type": ""
              }
            ],
            "src": "21714:388:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "22154:88:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "22185:22:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x11",
                            "nodeType": "YulIdentifier",
                            "src": "22187:16:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "22187:18:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "22187:18:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "22170:5:6"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "22181:1:6",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "not",
                          "nodeType": "YulIdentifier",
                          "src": "22177:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "22177:6:6"
                      }
                    ],
                    "functionName": {
                      "name": "eq",
                      "nodeType": "YulIdentifier",
                      "src": "22167:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22167:17:6"
                  },
                  "nodeType": "YulIf",
                  "src": "22164:43:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "22216:20:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "22227:5:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22234:1:6",
                        "type": "",
                        "value": "1"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "22223:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22223:13:6"
                  },
                  "variableNames": [
                    {
                      "name": "ret",
                      "nodeType": "YulIdentifier",
                      "src": "22216:3:6"
                    }
                  ]
                }
              ]
            },
            "name": "increment_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "22136:5:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "ret",
                "nodeType": "YulTypedName",
                "src": "22146:3:6",
                "type": ""
              }
            ],
            "src": "22107:135:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "22292:130:6",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "22302:31:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "22321:5:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22328:4:6",
                        "type": "",
                        "value": "0xff"
                      }
                    ],
                    "functionName": {
                      "name": "and",
                      "nodeType": "YulIdentifier",
                      "src": "22317:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22317:16:6"
                  },
                  "variables": [
                    {
                      "name": "value_1",
                      "nodeType": "YulTypedName",
                      "src": "22306:7:6",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "22363:22:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x11",
                            "nodeType": "YulIdentifier",
                            "src": "22365:16:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "22365:18:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "22365:18:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "value_1",
                        "nodeType": "YulIdentifier",
                        "src": "22348:7:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22357:4:6",
                        "type": "",
                        "value": "0xff"
                      }
                    ],
                    "functionName": {
                      "name": "eq",
                      "nodeType": "YulIdentifier",
                      "src": "22345:2:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22345:17:6"
                  },
                  "nodeType": "YulIf",
                  "src": "22342:43:6"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "22394:22:6",
                  "value": {
                    "arguments": [
                      {
                        "name": "value_1",
                        "nodeType": "YulIdentifier",
                        "src": "22405:7:6"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22414:1:6",
                        "type": "",
                        "value": "1"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "22401:3:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22401:15:6"
                  },
                  "variableNames": [
                    {
                      "name": "ret",
                      "nodeType": "YulIdentifier",
                      "src": "22394:3:6"
                    }
                  ]
                }
              ]
            },
            "name": "increment_t_uint8",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "22274:5:6",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "ret",
                "nodeType": "YulTypedName",
                "src": "22284:3:6",
                "type": ""
              }
            ],
            "src": "22247:175:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "22459:103:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22476:1:6",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "22483:10:6",
                            "type": "",
                            "value": "0x4e487b71"
                          },
                          {
                            "arguments": [
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "22499:1:6",
                                "type": "",
                                "value": "2"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "22502:3:6",
                                "type": "",
                                "value": "224"
                              }
                            ],
                            "functionName": {
                              "name": "exp",
                              "nodeType": "YulIdentifier",
                              "src": "22495:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "22495:11:6"
                          }
                        ],
                        "functionName": {
                          "name": "mul",
                          "nodeType": "YulIdentifier",
                          "src": "22479:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "22479:28:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "22469:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22469:39:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "22469:39:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22524:1:6",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22527:4:6",
                        "type": "",
                        "value": "0x11"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "22517:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22517:15:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "22517:15:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22548:1:6",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22551:4:6",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "22541:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22541:15:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "22541:15:6"
                }
              ]
            },
            "name": "panic_error_0x11",
            "nodeType": "YulFunctionDefinition",
            "src": "22427:135:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "22599:103:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22616:1:6",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "22623:10:6",
                            "type": "",
                            "value": "0x4e487b71"
                          },
                          {
                            "arguments": [
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "22639:1:6",
                                "type": "",
                                "value": "2"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "22642:3:6",
                                "type": "",
                                "value": "224"
                              }
                            ],
                            "functionName": {
                              "name": "exp",
                              "nodeType": "YulIdentifier",
                              "src": "22635:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "22635:11:6"
                          }
                        ],
                        "functionName": {
                          "name": "mul",
                          "nodeType": "YulIdentifier",
                          "src": "22619:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "22619:28:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "22609:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22609:39:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "22609:39:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22664:1:6",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22667:4:6",
                        "type": "",
                        "value": "0x21"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "22657:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22657:15:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "22657:15:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22688:1:6",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22691:4:6",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "22681:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22681:15:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "22681:15:6"
                }
              ]
            },
            "name": "panic_error_0x21",
            "nodeType": "YulFunctionDefinition",
            "src": "22567:135:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "22739:103:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22756:1:6",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "22763:10:6",
                            "type": "",
                            "value": "0x4e487b71"
                          },
                          {
                            "arguments": [
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "22779:1:6",
                                "type": "",
                                "value": "2"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "22782:3:6",
                                "type": "",
                                "value": "224"
                              }
                            ],
                            "functionName": {
                              "name": "exp",
                              "nodeType": "YulIdentifier",
                              "src": "22775:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "22775:11:6"
                          }
                        ],
                        "functionName": {
                          "name": "mul",
                          "nodeType": "YulIdentifier",
                          "src": "22759:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "22759:28:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "22749:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22749:39:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "22749:39:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22804:1:6",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22807:4:6",
                        "type": "",
                        "value": "0x32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "22797:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22797:15:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "22797:15:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22828:1:6",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22831:4:6",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "22821:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22821:15:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "22821:15:6"
                }
              ]
            },
            "name": "panic_error_0x32",
            "nodeType": "YulFunctionDefinition",
            "src": "22707:135:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "22879:103:6",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22896:1:6",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "22903:10:6",
                            "type": "",
                            "value": "0x4e487b71"
                          },
                          {
                            "arguments": [
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "22919:1:6",
                                "type": "",
                                "value": "2"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "22922:3:6",
                                "type": "",
                                "value": "224"
                              }
                            ],
                            "functionName": {
                              "name": "exp",
                              "nodeType": "YulIdentifier",
                              "src": "22915:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "22915:11:6"
                          }
                        ],
                        "functionName": {
                          "name": "mul",
                          "nodeType": "YulIdentifier",
                          "src": "22899:3:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "22899:28:6"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "22889:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22889:39:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "22889:39:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22944:1:6",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22947:4:6",
                        "type": "",
                        "value": "0x41"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "22937:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22937:15:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "22937:15:6"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22968:1:6",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "22971:4:6",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "22961:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "22961:15:6"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "22961:15:6"
                }
              ]
            },
            "name": "panic_error_0x41",
            "nodeType": "YulFunctionDefinition",
            "src": "22847:135:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "23042:167:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "23084:119:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "23105:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "arguments": [
                                {
                                  "kind": "number",
                                  "nodeType": "YulLiteral",
                                  "src": "23112:10:6",
                                  "type": "",
                                  "value": "0x4e487b71"
                                },
                                {
                                  "arguments": [
                                    {
                                      "kind": "number",
                                      "nodeType": "YulLiteral",
                                      "src": "23128:1:6",
                                      "type": "",
                                      "value": "2"
                                    },
                                    {
                                      "kind": "number",
                                      "nodeType": "YulLiteral",
                                      "src": "23131:3:6",
                                      "type": "",
                                      "value": "224"
                                    }
                                  ],
                                  "functionName": {
                                    "name": "exp",
                                    "nodeType": "YulIdentifier",
                                    "src": "23124:3:6"
                                  },
                                  "nodeType": "YulFunctionCall",
                                  "src": "23124:11:6"
                                }
                              ],
                              "functionName": {
                                "name": "mul",
                                "nodeType": "YulIdentifier",
                                "src": "23108:3:6"
                              },
                              "nodeType": "YulFunctionCall",
                              "src": "23108:28:6"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "23098:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "23098:39:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "23098:39:6"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "23157:1:6",
                              "type": "",
                              "value": "4"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "23160:4:6",
                              "type": "",
                              "value": "0x21"
                            }
                          ],
                          "functionName": {
                            "name": "mstore",
                            "nodeType": "YulIdentifier",
                            "src": "23150:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "23150:15:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "23150:15:6"
                      },
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "23185:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "23188:4:6",
                              "type": "",
                              "value": "0x24"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "23178:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "23178:15:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "23178:15:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "23065:5:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "23072:1:6",
                            "type": "",
                            "value": "3"
                          }
                        ],
                        "functionName": {
                          "name": "lt",
                          "nodeType": "YulIdentifier",
                          "src": "23062:2:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "23062:12:6"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "23055:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "23055:20:6"
                  },
                  "nodeType": "YulIf",
                  "src": "23052:151:6"
                }
              ]
            },
            "name": "validator_assert_enum_QuestionType",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "23031:5:6",
                "type": ""
              }
            ],
            "src": "22987:222:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "23259:109:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "23346:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "23355:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "23358:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "23348:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "23348:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "23348:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "23282:5:6"
                          },
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "23293:5:6"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "23300:42:6",
                                "type": "",
                                "value": "0xffffffffffffffffffffffffffffffffffffffff"
                              }
                            ],
                            "functionName": {
                              "name": "and",
                              "nodeType": "YulIdentifier",
                              "src": "23289:3:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "23289:54:6"
                          }
                        ],
                        "functionName": {
                          "name": "eq",
                          "nodeType": "YulIdentifier",
                          "src": "23279:2:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "23279:65:6"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "23272:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "23272:73:6"
                  },
                  "nodeType": "YulIf",
                  "src": "23269:93:6"
                }
              ]
            },
            "name": "validator_revert_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "23248:5:6",
                "type": ""
              }
            ],
            "src": "23214:154:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "23415:76:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "23469:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "23478:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "23481:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "23471:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "23471:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "23471:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "23438:5:6"
                          },
                          {
                            "arguments": [
                              {
                                "arguments": [
                                  {
                                    "name": "value",
                                    "nodeType": "YulIdentifier",
                                    "src": "23459:5:6"
                                  }
                                ],
                                "functionName": {
                                  "name": "iszero",
                                  "nodeType": "YulIdentifier",
                                  "src": "23452:6:6"
                                },
                                "nodeType": "YulFunctionCall",
                                "src": "23452:13:6"
                              }
                            ],
                            "functionName": {
                              "name": "iszero",
                              "nodeType": "YulIdentifier",
                              "src": "23445:6:6"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "23445:21:6"
                          }
                        ],
                        "functionName": {
                          "name": "eq",
                          "nodeType": "YulIdentifier",
                          "src": "23435:2:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "23435:32:6"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "23428:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "23428:40:6"
                  },
                  "nodeType": "YulIf",
                  "src": "23425:60:6"
                }
              ]
            },
            "name": "validator_revert_bool",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "23404:5:6",
                "type": ""
              }
            ],
            "src": "23373:118:6"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "23551:56:6",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "23585:16:6",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "23594:1:6",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "23597:1:6",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "23587:6:6"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "23587:12:6"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "23587:12:6"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "23574:5:6"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "23581:1:6",
                            "type": "",
                            "value": "3"
                          }
                        ],
                        "functionName": {
                          "name": "lt",
                          "nodeType": "YulIdentifier",
                          "src": "23571:2:6"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "23571:12:6"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "23564:6:6"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "23564:20:6"
                  },
                  "nodeType": "YulIf",
                  "src": "23561:40:6"
                }
              ]
            },
            "name": "validator_revert_enum_QuestionType",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "23540:5:6",
                "type": ""
              }
            ],
            "src": "23496:111:6"
          }
        ]
      },
      "contents": "{\n    { }\n    function abi_decode_array_string_dyn(offset, end) -> array\n    {\n        if iszero(slt(add(offset, 0x1f), end)) { revert(0, 0) }\n        let _1 := calldataload(offset)\n        let _2 := 0x20\n        let _3 := 0xffffffffffffffff\n        if gt(_1, _3) { panic_error_0x41() }\n        let _4 := mul(_1, _2)\n        let dst := allocate_memory(add(_4, _2))\n        let dst_1 := dst\n        mstore(dst, _1)\n        dst := add(dst, _2)\n        let src := add(offset, _2)\n        if gt(add(add(offset, _4), _2), end) { revert(0, 0) }\n        let i := 0\n        let i_1 := i\n        for { } lt(i_1, _1) { i_1 := add(i_1, 1) }\n        {\n            let innerOffset := calldataload(src)\n            if gt(innerOffset, _3) { revert(i, i) }\n            mstore(dst, abi_decode_string(add(add(offset, innerOffset), _2), end))\n            dst := add(dst, _2)\n            src := add(src, _2)\n        }\n        array := dst_1\n    }\n    function abi_decode_string(offset, end) -> array\n    {\n        if iszero(slt(add(offset, 0x1f), end)) { revert(0, 0) }\n        let _1 := calldataload(offset)\n        if gt(_1, 0xffffffffffffffff) { panic_error_0x41() }\n        let array_1 := allocate_memory(add(and(add(_1, 0x1f), not(31)), 0x20))\n        mstore(array_1, _1)\n        if gt(add(add(offset, _1), 0x20), end) { revert(0, 0) }\n        calldatacopy(add(array_1, 0x20), add(offset, 0x20), _1)\n        mstore(add(add(array_1, _1), 0x20), 0)\n        array := array_1\n    }\n    function abi_decode_tuple_t_address(headStart, dataEnd) -> value0\n    {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n        let value := calldataload(headStart)\n        validator_revert_address(value)\n        value0 := value\n    }\n    function abi_decode_tuple_t_bool_fromMemory(headStart, dataEnd) -> value0\n    {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n        let value := mload(headStart)\n        validator_revert_bool(value)\n        value0 := value\n    }\n    function abi_decode_tuple_t_contract$_Token_$2124t_uint256(headStart, dataEnd) -> value0, value1\n    {\n        if slt(sub(dataEnd, headStart), 64) { revert(0, 0) }\n        let value := calldataload(headStart)\n        validator_revert_address(value)\n        value0 := value\n        value1 := calldataload(add(headStart, 32))\n    }\n    function abi_decode_tuple_t_enum$_QuestionType_$2005t_uint256t_boolt_string_memory_ptrt_string_memory_ptrt_array$_t_string_memory_ptr_$dyn_memory_ptr(headStart, dataEnd) -> value0, value1, value2, value3, value4, value5\n    {\n        if slt(sub(dataEnd, headStart), 192) { revert(0, 0) }\n        let value := calldataload(headStart)\n        validator_revert_enum_QuestionType(value)\n        value0 := value\n        value1 := calldataload(add(headStart, 32))\n        let value_1 := calldataload(add(headStart, 64))\n        validator_revert_bool(value_1)\n        value2 := value_1\n        let offset := calldataload(add(headStart, 96))\n        let _1 := 0xffffffffffffffff\n        if gt(offset, _1) { revert(0, 0) }\n        value3 := abi_decode_string(add(headStart, offset), dataEnd)\n        let offset_1 := calldataload(add(headStart, 128))\n        if gt(offset_1, _1) { revert(0, 0) }\n        value4 := abi_decode_string(add(headStart, offset_1), dataEnd)\n        let offset_2 := calldataload(add(headStart, 160))\n        if gt(offset_2, _1) { revert(0, 0) }\n        value5 := abi_decode_array_string_dyn(add(headStart, offset_2), dataEnd)\n    }\n    function abi_decode_tuple_t_enum$_Status_$2001(headStart, dataEnd) -> value0\n    {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n        let value := calldataload(headStart)\n        validator_revert_enum_QuestionType(value)\n        value0 := value\n    }\n    function abi_decode_tuple_t_string_memory_ptrt_string_memory_ptrt_uint256(headStart, dataEnd) -> value0, value1, value2\n    {\n        if slt(sub(dataEnd, headStart), 96) { revert(0, 0) }\n        let offset := calldataload(headStart)\n        let _1 := 0xffffffffffffffff\n        if gt(offset, _1) { revert(0, 0) }\n        value0 := abi_decode_string(add(headStart, offset), dataEnd)\n        let offset_1 := calldataload(add(headStart, 32))\n        if gt(offset_1, _1) { revert(0, 0) }\n        value1 := abi_decode_string(add(headStart, offset_1), dataEnd)\n        value2 := calldataload(add(headStart, 64))\n    }\n    function abi_decode_tuple_t_uint256(headStart, dataEnd) -> value0\n    {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n        value0 := calldataload(headStart)\n    }\n    function abi_decode_tuple_t_uint256_fromMemory(headStart, dataEnd) -> value0\n    {\n        if slt(sub(dataEnd, headStart), 32) { revert(0, 0) }\n        value0 := mload(headStart)\n    }\n    function abi_decode_tuple_t_uint256t_contract$_Token_$2124t_array$_t_string_calldata_ptr_$dyn_calldata_ptr(headStart, dataEnd) -> value0, value1, value2, value3\n    {\n        if slt(sub(dataEnd, headStart), 96) { revert(0, 0) }\n        value0 := calldataload(headStart)\n        let value := calldataload(add(headStart, 32))\n        validator_revert_address(value)\n        value1 := value\n        let offset := calldataload(add(headStart, 64))\n        let _1 := 0xffffffffffffffff\n        if gt(offset, _1) { revert(0, 0) }\n        let _2 := add(headStart, offset)\n        if iszero(slt(add(_2, 0x1f), dataEnd)) { revert(0, 0) }\n        let length := calldataload(_2)\n        if gt(length, _1) { revert(0, 0) }\n        if gt(add(add(_2, mul(length, 32)), 32), dataEnd) { revert(0, 0) }\n        value2 := add(_2, 32)\n        value3 := length\n    }\n    function abi_decode_tuple_t_uint256t_enum$_QuestionType_$2005t_uint256t_boolt_string_memory_ptrt_string_memory_ptrt_array$_t_string_memory_ptr_$dyn_memory_ptr(headStart, dataEnd) -> value0, value1, value2, value3, value4, value5, value6\n    {\n        if slt(sub(dataEnd, headStart), 224) { revert(0, 0) }\n        value0 := calldataload(headStart)\n        let value := calldataload(add(headStart, 32))\n        validator_revert_enum_QuestionType(value)\n        value1 := value\n        value2 := calldataload(add(headStart, 64))\n        let value_1 := calldataload(add(headStart, 96))\n        validator_revert_bool(value_1)\n        value3 := value_1\n        let offset := calldataload(add(headStart, 128))\n        let _1 := 0xffffffffffffffff\n        if gt(offset, _1) { revert(0, 0) }\n        value4 := abi_decode_string(add(headStart, offset), dataEnd)\n        let offset_1 := calldataload(add(headStart, 160))\n        if gt(offset_1, _1) { revert(0, 0) }\n        value5 := abi_decode_string(add(headStart, offset_1), dataEnd)\n        let offset_2 := calldataload(add(headStart, 192))\n        if gt(offset_2, _1) { revert(0, 0) }\n        value6 := abi_decode_array_string_dyn(add(headStart, offset_2), dataEnd)\n    }\n    function abi_decode_tuple_t_uint256t_uint256(headStart, dataEnd) -> value0, value1\n    {\n        if slt(sub(dataEnd, headStart), 64) { revert(0, 0) }\n        value0 := calldataload(headStart)\n        value1 := calldataload(add(headStart, 32))\n    }\n    function abi_encode_address(value, pos)\n    {\n        mstore(pos, and(value, 0xffffffffffffffffffffffffffffffffffffffff))\n    }\n    function abi_encode_enum_Status(value, pos)\n    {\n        validator_assert_enum_QuestionType(value)\n        mstore(pos, value)\n    }\n    function abi_encode_string(value, pos) -> end\n    {\n        let length := mload(value)\n        mstore(pos, length)\n        let i := 0\n        for { } lt(i, length) { i := add(i, 0x20) }\n        {\n            let _1 := 0x20\n            mstore(add(add(pos, i), _1), mload(add(add(value, i), _1)))\n        }\n        if gt(i, length)\n        {\n            mstore(add(add(pos, length), 0x20), 0)\n        }\n        end := add(add(pos, and(add(length, 31), not(31))), 0x20)\n    }\n    function abi_encode_struct_LiquidityPool(value, pos)\n    {\n        mstore(pos, mload(value))\n        mstore(add(pos, 0x20), mload(add(value, 0x20)))\n        mstore(add(pos, 0x40), mload(add(value, 0x40)))\n        mstore(add(pos, 0x60), mload(add(value, 0x60)))\n    }\n    function abi_encode_struct_SurveyBasic(value, pos) -> end\n    {\n        let memberValue0 := mload(value)\n        mstore(pos, 0x60)\n        let tail := abi_encode_string(memberValue0, add(pos, 0x60))\n        let memberValue0_1 := mload(add(value, 0x20))\n        mstore(add(pos, 0x20), sub(tail, pos))\n        let tail_1 := abi_encode_string(memberValue0_1, tail)\n        mstore(add(pos, 0x40), mload(add(value, 0x40)))\n        end := tail_1\n    }\n    function abi_encode_tuple_t_address__to_t_address__fromStack_reversed(headStart, value0) -> tail\n    {\n        tail := add(headStart, 32)\n        mstore(headStart, and(value0, 0xffffffffffffffffffffffffffffffffffffffff))\n    }\n    function abi_encode_tuple_t_address_t_address_t_uint256__to_t_address_t_address_t_uint256__fromStack_reversed(headStart, value2, value1, value0) -> tail\n    {\n        tail := add(headStart, 96)\n        let _1 := 0xffffffffffffffffffffffffffffffffffffffff\n        mstore(headStart, and(value0, _1))\n        mstore(add(headStart, 32), and(value1, _1))\n        mstore(add(headStart, 64), value2)\n    }\n    function abi_encode_tuple_t_address_t_uint256__to_t_address_t_uint256__fromStack_reversed(headStart, value1, value0) -> tail\n    {\n        tail := add(headStart, 64)\n        mstore(headStart, and(value0, 0xffffffffffffffffffffffffffffffffffffffff))\n        mstore(add(headStart, 32), value1)\n    }\n    function abi_encode_tuple_t_array$_t_string_memory_ptr_$dyn_memory_ptr__to_t_array$_t_string_memory_ptr_$dyn_memory_ptr__fromStack_reversed(headStart, value0) -> tail\n    {\n        let _1 := 32\n        let tail_1 := add(headStart, _1)\n        mstore(headStart, _1)\n        let pos := tail_1\n        let length := mload(value0)\n        mstore(tail_1, length)\n        pos := add(headStart, 64)\n        let tail_2 := add(add(headStart, mul(length, _1)), 64)\n        let srcPtr := add(value0, _1)\n        let i := 0\n        for { } lt(i, length) { i := add(i, 1) }\n        {\n            mstore(pos, add(sub(tail_2, headStart), not(63)))\n            tail_2 := abi_encode_string(mload(srcPtr), tail_2)\n            srcPtr := add(srcPtr, _1)\n            pos := add(pos, _1)\n        }\n        tail := tail_2\n    }\n    function abi_encode_tuple_t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr__to_t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr__fromStack_reversed(headStart, value0) -> tail\n    {\n        let _1 := 32\n        let tail_1 := add(headStart, _1)\n        mstore(headStart, _1)\n        let pos := tail_1\n        let length := mload(value0)\n        mstore(tail_1, length)\n        let _2 := 64\n        pos := add(headStart, _2)\n        let tail_2 := add(add(headStart, mul(length, _1)), _2)\n        let srcPtr := add(value0, _1)\n        let i := 0\n        let i_1 := i\n        for { } lt(i_1, length) { i_1 := add(i_1, 1) }\n        {\n            mstore(pos, add(sub(tail_2, headStart), not(63)))\n            let _3 := mload(srcPtr)\n            let _4 := 0xc0\n            let _5 := mload(_3)\n            validator_assert_enum_QuestionType(_5)\n            mstore(tail_2, _5)\n            mstore(add(tail_2, _1), mload(add(_3, _1)))\n            mstore(add(tail_2, _2), iszero(iszero(mload(add(_3, _2)))))\n            let _6 := 0x60\n            let memberValue0 := mload(add(_3, _6))\n            mstore(add(tail_2, _6), _4)\n            let tail_3 := abi_encode_string(memberValue0, add(tail_2, _4))\n            let _7 := 0x80\n            let memberValue0_1 := mload(add(_3, _7))\n            mstore(add(tail_2, _7), sub(tail_3, tail_2))\n            let tail_4 := abi_encode_string(memberValue0_1, tail_3)\n            let _8 := 0xa0\n            let memberValue0_2 := mload(add(_3, _8))\n            mstore(add(tail_2, _8), sub(tail_4, tail_2))\n            let pos_1 := tail_4\n            let length_1 := mload(memberValue0_2)\n            mstore(tail_4, length_1)\n            pos_1 := add(tail_4, _1)\n            let tail_5 := add(add(tail_4, mul(length_1, _1)), _1)\n            let srcPtr_1 := add(memberValue0_2, _1)\n            let i_2 := i\n            for { } lt(i_2, length_1) { i_2 := add(i_2, 1) }\n            {\n                mstore(pos_1, add(sub(tail_5, tail_4), not(31)))\n                tail_5 := abi_encode_string(mload(srcPtr_1), tail_5)\n                srcPtr_1 := add(srcPtr_1, _1)\n                pos_1 := add(pos_1, _1)\n            }\n            tail_2 := tail_5\n            srcPtr := add(srcPtr, _1)\n            pos := add(pos, _1)\n        }\n        tail := tail_2\n    }\n    function abi_encode_tuple_t_bool__to_t_bool__fromStack_reversed(headStart, value0) -> tail\n    {\n        tail := add(headStart, 32)\n        mstore(headStart, iszero(iszero(value0)))\n    }\n    function abi_encode_tuple_t_enum$_QuestionType_$2005_t_uint256_t_bool_t_string_memory_ptr_t_string_memory_ptr__to_t_uint8_t_uint256_t_bool_t_string_memory_ptr_t_string_memory_ptr__fromStack_reversed(headStart, value4, value3, value2, value1, value0) -> tail\n    {\n        validator_assert_enum_QuestionType(value0)\n        mstore(headStart, value0)\n        mstore(add(headStart, 32), value1)\n        mstore(add(headStart, 64), iszero(iszero(value2)))\n        mstore(add(headStart, 96), 160)\n        let tail_1 := abi_encode_string(value3, add(headStart, 160))\n        mstore(add(headStart, 128), sub(tail_1, headStart))\n        tail := abi_encode_string(value4, tail_1)\n    }\n    function abi_encode_tuple_t_enum$_Status_$2001__to_t_uint8__fromStack_reversed(headStart, value0) -> tail\n    {\n        tail := add(headStart, 32)\n        validator_assert_enum_QuestionType(value0)\n        mstore(headStart, value0)\n    }\n    function abi_encode_tuple_t_string_memory_ptr__to_t_string_memory_ptr__fromStack_reversed(headStart, value0) -> tail\n    {\n        mstore(headStart, 32)\n        tail := abi_encode_string(value0, add(headStart, 32))\n    }\n    function abi_encode_tuple_t_stringliteral_011cc548aef422f49ec5b449d0fed3dafc46f94a16900943c531cd7c2a55cecb__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 49)\n        mstore(add(headStart, 64), \"Not enough reward to give, cance\")\n        mstore(add(headStart, 96), \"lling submission.\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_stringliteral_04037c1c73b6df0138c0effd84a095632c6f0e3142cefd7669cea1e916bce893__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 32)\n        mstore(add(headStart, 64), \"Required question not filled out\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_stringliteral_0cea1408d7a63a11331c6748505bc80cd60b8480f58c4c2651963f54f0b97c32__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 58)\n        mstore(add(headStart, 64), \"Answer string array does not mat\")\n        mstore(add(headStart, 96), \"ch the length of questions\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 31)\n        mstore(add(headStart, 64), \"Survey must be in editing stage\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_stringliteral_6ea6531dad0de6919871ea7d20ff474e1ecd8be9b63504d49bb651d3d627d724__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 23)\n        mstore(add(headStart, 64), \"Already took the survey\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_stringliteral_879c16fa9785c28093236dad4c926abbcc4ddd1e24d5a113771878e901c54b25__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 43)\n        mstore(add(headStart, 64), \"Must be the creator to access th\")\n        mstore(add(headStart, 96), \"is function\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_stringliteral_951ece5d5af66174f14cd35238da3522fbecff682f2440d776cb968d376dbcbf__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 48)\n        mstore(add(headStart, 64), \"Balance has to be >= than the am\")\n        mstore(add(headStart, 96), \"ount to withdraw\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_stringliteral_f0fab26ac02ca5c681c22c19f8d96f059af3b7216c3818e8ee0f9360e4cf614b__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 18)\n        mstore(add(headStart, 64), \"Survey is not open\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_stringliteral_f1c7bbfa2aef84eacd6e1bcb3c18e7590c1327e2ba069b2e3ddeb1a8f62ded03__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 30)\n        mstore(add(headStart, 64), \"Creator cannot take the survey\")\n        tail := add(headStart, 96)\n    }\n    function abi_encode_tuple_t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef__to_t_string_memory_ptr__fromStack_reversed(headStart) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), 34)\n        mstore(add(headStart, 64), \"amount has to be greater than ze\")\n        mstore(add(headStart, 96), \"ro\")\n        tail := add(headStart, 128)\n    }\n    function abi_encode_tuple_t_struct$_LiquidityPool_$2029_memory_ptr__to_t_struct$_LiquidityPool_$2029_memory_ptr__fromStack_reversed(headStart, value0) -> tail\n    {\n        tail := add(headStart, 128)\n        abi_encode_struct_LiquidityPool(value0, headStart)\n    }\n    function abi_encode_tuple_t_struct$_SurveyBasic_$2036_memory_ptr__to_t_struct$_SurveyBasic_$2036_memory_ptr__fromStack_reversed(headStart, value0) -> tail\n    {\n        mstore(headStart, 32)\n        tail := abi_encode_struct_SurveyBasic(value0, add(headStart, 32))\n    }\n    function abi_encode_tuple_t_struct$_SurveyBasic_$2036_memory_ptr_t_struct$_LiquidityPool_$2029_memory_ptr_t_uint256_t_enum$_Status_$2001_t_address__to_t_struct$_SurveyBasic_$2036_memory_ptr_t_struct$_LiquidityPool_$2029_memory_ptr_t_uint256_t_uint8_t_address__fromStack_reversed(headStart, value4, value3, value2, value1, value0) -> tail\n    {\n        let _1 := 256\n        mstore(headStart, _1)\n        tail := abi_encode_struct_SurveyBasic(value0, add(headStart, _1))\n        abi_encode_struct_LiquidityPool(value1, add(headStart, 32))\n        mstore(add(headStart, 160), value2)\n        validator_assert_enum_QuestionType(value3)\n        mstore(add(headStart, 192), value3)\n        mstore(add(headStart, 224), and(value4, 0xffffffffffffffffffffffffffffffffffffffff))\n    }\n    function abi_encode_tuple_t_struct$_SurveyOverview_$2074_memory_ptr__to_t_struct$_SurveyOverview_$2074_memory_ptr__fromStack_reversed(headStart, value0) -> tail\n    {\n        mstore(headStart, 32)\n        mstore(add(headStart, 32), mload(value0))\n        let memberValue0 := mload(add(value0, 32))\n        abi_encode_address(memberValue0, add(headStart, 64))\n        mstore(add(headStart, 96), mload(add(value0, 64)))\n        mstore(add(headStart, 128), mload(add(value0, 96)))\n        let memberValue0_1 := mload(add(value0, 128))\n        let _1 := 0x0160\n        mstore(add(headStart, 160), _1)\n        let tail_1 := abi_encode_string(memberValue0_1, add(headStart, 384))\n        let memberValue0_2 := mload(add(value0, 160))\n        mstore(add(headStart, 192), add(sub(tail_1, headStart), not(31)))\n        let tail_2 := abi_encode_string(memberValue0_2, tail_1)\n        let memberValue0_3 := mload(add(value0, 192))\n        abi_encode_enum_Status(memberValue0_3, add(headStart, 224))\n        let _2 := mload(add(value0, 224))\n        let _3 := 256\n        mstore(add(headStart, _3), _2)\n        let _4 := mload(add(value0, _3))\n        let _5 := 288\n        mstore(add(headStart, _5), _4)\n        let _6 := mload(add(value0, _5))\n        let _7 := 320\n        mstore(add(headStart, _7), _6)\n        mstore(add(headStart, _1), mload(add(value0, _7)))\n        tail := tail_2\n    }\n    function abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed(headStart, value0) -> tail\n    {\n        tail := add(headStart, 32)\n        mstore(headStart, value0)\n    }\n    function access_calldata_tail_t_string_calldata_ptr(base_ref, ptr_to_tail) -> addr, length\n    {\n        let rel_offset_of_tail := calldataload(ptr_to_tail)\n        if iszero(slt(rel_offset_of_tail, add(sub(calldatasize(), base_ref), not(30)))) { revert(0, 0) }\n        let addr_1 := add(base_ref, rel_offset_of_tail)\n        length := calldataload(addr_1)\n        if gt(length, 0xffffffffffffffff) { revert(0, 0) }\n        addr := add(addr_1, 0x20)\n        if sgt(addr, sub(calldatasize(), length)) { revert(0, 0) }\n    }\n    function allocate_memory(size) -> memPtr\n    {\n        memPtr := mload(64)\n        let newFreePtr := add(memPtr, and(add(size, 31), not(31)))\n        if or(gt(newFreePtr, 0xffffffffffffffff), lt(newFreePtr, memPtr)) { panic_error_0x41() }\n        mstore(64, newFreePtr)\n    }\n    function checked_add_t_uint256(x, y) -> sum\n    {\n        if gt(x, not(y)) { panic_error_0x11() }\n        sum := add(x, y)\n    }\n    function checked_sub_t_uint256(x, y) -> diff\n    {\n        if lt(x, y) { panic_error_0x11() }\n        diff := sub(x, y)\n    }\n    function extract_byte_array_length(data) -> length\n    {\n        length := div(data, 2)\n        let outOfPlaceEncoding := and(data, 1)\n        if iszero(outOfPlaceEncoding) { length := and(length, 0x7f) }\n        if eq(outOfPlaceEncoding, lt(length, 32))\n        {\n            mstore(0, mul(0x4e487b71, exp(2, 224)))\n            mstore(4, 0x22)\n            revert(0, 0x24)\n        }\n    }\n    function increment_t_uint256(value) -> ret\n    {\n        if eq(value, not(0)) { panic_error_0x11() }\n        ret := add(value, 1)\n    }\n    function increment_t_uint8(value) -> ret\n    {\n        let value_1 := and(value, 0xff)\n        if eq(value_1, 0xff) { panic_error_0x11() }\n        ret := add(value_1, 1)\n    }\n    function panic_error_0x11()\n    {\n        mstore(0, mul(0x4e487b71, exp(2, 224)))\n        mstore(4, 0x11)\n        revert(0, 0x24)\n    }\n    function panic_error_0x21()\n    {\n        mstore(0, mul(0x4e487b71, exp(2, 224)))\n        mstore(4, 0x21)\n        revert(0, 0x24)\n    }\n    function panic_error_0x32()\n    {\n        mstore(0, mul(0x4e487b71, exp(2, 224)))\n        mstore(4, 0x32)\n        revert(0, 0x24)\n    }\n    function panic_error_0x41()\n    {\n        mstore(0, mul(0x4e487b71, exp(2, 224)))\n        mstore(4, 0x41)\n        revert(0, 0x24)\n    }\n    function validator_assert_enum_QuestionType(value)\n    {\n        if iszero(lt(value, 3))\n        {\n            mstore(0, mul(0x4e487b71, exp(2, 224)))\n            mstore(4, 0x21)\n            revert(0, 0x24)\n        }\n    }\n    function validator_revert_address(value)\n    {\n        if iszero(eq(value, and(value, 0xffffffffffffffffffffffffffffffffffffffff))) { revert(0, 0) }\n    }\n    function validator_revert_bool(value)\n    {\n        if iszero(eq(value, iszero(iszero(value)))) { revert(0, 0) }\n    }\n    function validator_revert_enum_QuestionType(value)\n    {\n        if iszero(lt(value, 3)) { revert(0, 0) }\n    }\n}",
      "id": 6,
      "language": "Yul",
      "name": "#utility.yul"
    }
  ],
  "sourceMap": "154:8653:3:-:0;;;385:1;357:29;;582:255;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;689:23;;;;:5;;:23;;;;;:::i;:::-;-1:-1:-1;719:37:3;;;;:22;;:37;;;;;:::i;:::-;-1:-1:-1;763:22:3;:37;-1:-1:-1;;807:13:3;:24;;-1:-1:-1;;;;;807:24:3;;;;;;-1:-1:-1;;807:24:3;;;;;;;;;154:8653;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;154:8653:3;;;-1:-1:-1;154:8653:3;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;14:885:6;68:5;121:3;114:4;106:6;102:17;98:27;88:55;;139:1;136;129:12;88:55;162:13;;-1:-1:-1;224:10:6;;;221:36;;;237:18;;:::i;:::-;312:2;306:9;280:2;366:13;;-1:-1:-1;;362:22:6;;;386:2;358:31;354:40;342:53;;;410:18;;;430:22;;;407:46;404:72;;;456:18;;:::i;:::-;496:10;492:2;485:22;531:2;523:6;516:18;553:4;543:14;;598:3;593:2;588;580:6;576:15;572:24;569:33;566:53;;;615:1;612;605:12;566:53;637:1;628:10;;647:133;661:2;658:1;655:9;647:133;;;749:14;;;745:23;;739:30;718:14;;;714:23;;707:63;672:10;;;;647:133;;;798:2;795:1;792:9;789:80;;;857:1;852:2;847;839:6;835:15;831:24;824:35;789:80;887:6;14:885;-1:-1:-1;;;;;;14:885:6:o;904:791::-;1021:6;1029;1037;1045;1098:3;1086:9;1077:7;1073:23;1069:33;1066:53;;;1115:1;1112;1105:12;1066:53;1141:16;;-1:-1:-1;;;;;1186:31:6;;1176:42;;1166:70;;1232:1;1229;1222:12;1166:70;1304:2;1289:18;;1283:25;1255:5;;-1:-1:-1;;1357:14:6;;;1354:34;;;1384:1;1381;1374:12;1354:34;1407:61;1460:7;1451:6;1440:9;1436:22;1407:61;:::i;:::-;1397:71;;1514:2;1503:9;1499:18;1493:25;1477:41;;1543:2;1533:8;1530:16;1527:36;;;1559:1;1556;1549:12;1527:36;;1582:63;1637:7;1626:8;1615:9;1611:24;1582:63;:::i;:::-;1685:2;1670:18;;;;1664:25;904:791;;;;-1:-1:-1;;;;904:791:6:o;1700:437::-;1785:1;1775:12;;1832:1;1822:12;;;1843:61;;1897:4;1889:6;1885:17;1875:27;;1843:61;1950:2;1942:6;1939:14;1919:18;1916:38;1913:218;;;-1:-1:-1;;;;;1984:1:6;1977:88;2088:4;2085:1;2078:15;2116:4;2113:1;2106:15;1913:218;;1700:437;;;:::o;2142:184::-;-1:-1:-1;;;;;2191:1:6;2184:88;2291:4;2288:1;2281:15;2315:4;2312:1;2305:15;2142:184;154:8653:3;;;;;;",
  "deployedSourceMap": "154:8653:3:-:0;;;;;;;;-1:-1:-1;;;154:8653:3;;;;;-1:-1:-1;154:8653:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4170:84;;;;;;;;;;-1:-1:-1;4235:13:3;;4170:84;;4235:13;;;;-1:-1:-1;;;;;4235:13:3;8653:74:6;;8641:2;8626:18;4170:84:3;;;;;;;;3857:89;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;4607:92::-;;;;;;;;;;-1:-1:-1;4680:4:3;4672:21;4607:92;;;20608:25:6;;;20596:2;20581:18;4607:92:3;20462:177:6;7920:341:3;;;;;;;;;;-1:-1:-1;7920:341:3;;;;;:::i;:::-;;:::i;:::-;;357:29;;;;;;;;;;;;;;;;4442:91;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;5649:144::-;;;;;;;;;;-1:-1:-1;5649:144:3;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;6162:335::-;;;;;;;;;;-1:-1:-1;6162:335:3;;;;;:::i;:::-;;:::i;4260:81::-;;;;;;;;;;-1:-1:-1;4323:12:3;;;;4260:81;;;;;;:::i;4705:476::-;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;393:41::-;;;;;;;;;;-1:-1:-1;393:41:3;;;;;:::i;:::-;;:::i;7740:174::-;;;:::i;310:42::-;;;;;;;;;;-1:-1:-1;310:42:3;;;;;:::i;:::-;;:::i;:::-;;;;;;;;;;;:::i;4347:89::-;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;7481:253::-;;;;;;;;;;-1:-1:-1;7481:253:3;;;;;:::i;:::-;;:::i;6503:515::-;;;;;;;;;;-1:-1:-1;6503:515:3;;;;;:::i;:::-;;:::i;7024:451::-;;;;;;;;;;-1:-1:-1;7024:451:3;;;;;:::i;:::-;;:::i;8623:181::-;;;;;;;;;;-1:-1:-1;8623:181:3;;;;;:::i;:::-;;:::i;:::-;;;12720:14:6;;12713:22;12695:41;;12683:2;12668:18;8623:181:3;12555:187:6;491:24:3;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;:::i;8267:350::-;;;;;;;;;;-1:-1:-1;8267:350:3;;;;;:::i;:::-;;:::i;5392:251::-;;;;;;;;;;;;;:::i;:::-;;;;;;;:::i;4070:94::-;;;;;;;;;;-1:-1:-1;4136:22:3;;4070:94;;5187:199;;;;;;;;;;;;;:::i;1193:2545::-;;;;;;;;;;-1:-1:-1;1193:2545:3;;;;;:::i;:::-;;:::i;1066:95::-;;;;;;;;;;-1:-1:-1;1066:95:3;;;;;:::i;:::-;;:::i;3857:89::-;3925:5;3918:22;;3896:13;;3925:5;3918:22;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3857:89;:::o;7920:341::-;971:13;;;;;-1:-1:-1;;;;;971:13:3;988:9;971:26;963:82;;;;-1:-1:-1;;;;;963:82:3;;;;;;;:::i;:::-;;;;;;;;;8023:1:::1;8013:7;:11;8005:58;;;::::0;-1:-1:-1;;;;;8005:58:3;;::::1;::::0;::::1;;;:::i;:::-;8078:31;::::0;-1:-1:-1;;;;;8078:31:3;;8103:4:::1;8078:31;::::0;::::1;8653:74:6::0;8113:7:3;;-1:-1:-1;;;;;8078:16:3;::::1;::::0;-1:-1:-1;;8626:18:6;;8078:31:3::1;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:42;;8070:103;;;::::0;-1:-1:-1;;;;;8070:103:3;;::::1;::::0;::::1;;;:::i;:::-;8180:35;::::0;-1:-1:-1;;;;;8180:35:3;;8196:9:::1;8180:35;::::0;::::1;9315:74:6::0;9405:18;;;9398:34;;;-1:-1:-1;;;;;8180:15:3;::::1;::::0;-1:-1:-1;;9288:18:6;;8180:35:3::1;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;-1:-1:-1::0;8222:10:3;:33;;8248:7;;8222:10;:22:::1;::::0;:33:::1;::::0;8248:7;;8222:33:::1;:::i;:::-;::::0;;;-1:-1:-1;;;;7920:341:3:o;4442:91::-;4481:20;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4481:20:3;-1:-1:-1;4510:17:3;;;;;;;;4517:10;4510:17;;;;;;;;;;;;;;;;;;;;;;;;;4442:91::o;5649:144::-;971:13;;5712:15;;971:13;;;-1:-1:-1;;;;;971:13:3;988:9;971:26;963:82;;;;-1:-1:-1;;;;;963:82:3;;;;;;;:::i;:::-;5736:19:::1;5758:12:::0;;;:7:::1;:12;::::0;;;;;;;5736:34;;;;;;::::1;::::0;;;;;;;;;;;;5758:12;;5736:34;:19;;:34;::::1;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1::0;5736:34:3;;5649:144;-1:-1:-1;;;;;;5649:144:3:o;6162:335::-;971:13;;;;;-1:-1:-1;;;;;971:13:3;988:9;971:26;963:82;;;;-1:-1:-1;;;;;963:82:3;;;;;;;:::i;:::-;6320:17:::1;6304:12:::0;;::::1;;:33;::::0;::::1;;;;;;:::i;:::-;;6296:77;;;::::0;-1:-1:-1;;;;;6296:77:3;;::::1;::::0;::::1;;;:::i;:::-;6380:23:::0;;::::1;::::0;:5:::1;::::0;:23:::1;::::0;::::1;::::0;::::1;:::i;:::-;-1:-1:-1::0;6410:37:3;;::::1;::::0;:22;;:37:::1;::::0;::::1;::::0;::::1;:::i;:::-;-1:-1:-1::0;6454:22:3;:37;-1:-1:-1;;6162:335:3:o;4705:476::-;4751:21;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4751:21:3;4788:387;;;;;;;;-1:-1:-1;4788:387:3;;4840:4;4788:387;;;;;;;4861:7;:5;:7::i;:::-;4788:387;;4890:22;;4788:387;;;;4890:5;4788:387;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4964:5;:10;;:22;;4788:387;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;4788:387:3;;;-1:-1:-1;;5003:12:3;;4788:387;;;;;5003:12;;4788:387;;;;;;;;:::i;:::-;;;5031:18;;4788:387;;;;5067:20;;4788:387;;;;5031:18;5108:22;4788:387;;;;5067:20;5154:13;4788:387;;;;;4781:394;4705:476;-1:-1:-1;4705:476:3:o;393:41::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;7740:174::-;971:13;;;;;-1:-1:-1;;;;;971:13:3;988:9;971:26;963:82;;;;-1:-1:-1;;;;;963:82:3;;;;;;;:::i;:::-;7828:1:::1;7816:9;:13;7808:60;;;::::0;-1:-1:-1;;;;;7808:60:3;;::::1;::::0;::::1;;;:::i;:::-;7875:20:::0;:33;;7899:9:::1;::::0;7875:20;::::1;::::0;:33:::1;::::0;7899:9;;7875:33:::1;:::i;:::-;::::0;;;-1:-1:-1;;7740:174:3:o;310:42::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;4347:89::-;4386:18;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;4386:18:3;4413:17;;;;;;;;;4420:5;4413:17;;;;4420:5;;4413:17;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4347:89;:::o;7481:253::-;971:13;;;;;-1:-1:-1;;;;;971:13:3;988:9;971:26;963:82;;;;-1:-1:-1;;;;;963:82:3;;;;;;;:::i;:::-;7587:1:::1;7577:7;:11;7569:58;;;::::0;-1:-1:-1;;;;;7569:58:3;;::::1;::::0;::::1;;;:::i;:::-;7634:54;::::0;-1:-1:-1;;;;;7634:54:3;;7654:9:::1;7634:54;::::0;::::1;9001:34:6::0;7673:4:3::1;9051:18:6::0;;;9044:43;9103:18;;;9096:34;;;-1:-1:-1;;;;;7634:19:3;::::1;::::0;::::1;::::0;8913:18:6;;7634:54:3::1;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;-1:-1:-1::0;7695:10:3;:33;;7721:7;;7695:10;:22:::1;::::0;:33:::1;::::0;7721:7;;7695:33:::1;:::i;6503:515::-:0;971:13;;6714:4;;971:13;;;-1:-1:-1;;;;;971:13:3;988:9;971:26;963:82;;;;-1:-1:-1;;;;;963:82:3;;;;;;;:::i;:::-;6751:17:::1;6735:12:::0;;::::1;;:33;::::0;::::1;;;;;;:::i;:::-;;6727:77;;;::::0;-1:-1:-1;;;;;6727:77:3;;::::1;::::0;::::1;;;:::i;:::-;6811:146;6834:13;;6856:7;6872:6;6887:9;6905:6;6920:13;6942:8;6811:14;:146::i;:::-;6964:13;:15:::0;;;:13:::1;:15;::::0;::::1;:::i;:::-;;;;;;7011:1;6995:13:::0;::::1;:17;;;;:::i;:::-;6988:24:::0;6503:515;-1:-1:-1;;;;;;;6503:515:3:o;7024:451::-;971:13;;;;;-1:-1:-1;;;;;971:13:3;988:9;971:26;963:82;;;;-1:-1:-1;;;;;963:82:3;;;;;;;:::i;:::-;7274:17:::1;7258:12:::0;;::::1;;:33;::::0;::::1;;;;;;:::i;:::-;;7250:77;;;::::0;-1:-1:-1;;;;;7250:77:3;;::::1;::::0;::::1;;;:::i;:::-;7351:118;;;;;;;;7368:7;7351:118;;;;;;;;:::i;:::-;::::0;;::::1;::::0;;::::1;::::0;;;;::::1;;::::0;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;7334:14:3;;;;;;;;:135;;;;:14;;-1:-1:-1;;7334:135:3::1;::::0;;::::1;::::0;::::1;;;;;;:::i;:::-;;;::::0;;-1:-1:-1;7334:135:3::1;::::0;;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;;-1:-1:-1;;7334:135:3::1;::::0;::::1;;::::0;;;::::1;::::0;;::::1;::::0;::::1;::::0;;;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;::::1;:::i;:::-;-1:-1:-1::0;7334:135:3::1;::::0;::::1;::::0;;;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;;::::1;::::0;::::1;:::i;:::-;-1:-1:-1::0;7334:135:3::1;::::0;::::1;::::0;;;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;;::::1;::::0;::::1;:::i;:::-;-1:-1:-1::0;;;;;;;;;;7024:451:3:o;8623:181::-;-1:-1:-1;;;;;8712:18:3;;8686:4;8712:18;;;:11;:18;;;;;;8741:9;;8737:43;;-1:-1:-1;8768:4:3;;8623:181;-1:-1:-1;;8623:181:3:o;8737:43::-;-1:-1:-1;8793:5:3;;8623:181;-1:-1:-1;;8623:181:3:o;491:24::-;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;491:24:3;;;-1:-1:-1;;491:24:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;491:24:3;;:::o;8267:350::-;971:13;;;;;-1:-1:-1;;;;;971:13:3;988:9;971:26;963:82;;;;-1:-1:-1;;;;;963:82:3;;;;;;;:::i;:::-;8354:1:::1;8344:7;:11;8336:58;;;::::0;-1:-1:-1;;;;;8336:58:3;;::::1;::::0;::::1;;;:::i;:::-;8417:4;8409:21;:32:::0;-1:-1:-1;8409:32:3::1;8401:93;;;::::0;-1:-1:-1;;;;;8401:93:3;;::::1;::::0;::::1;;;:::i;:::-;8550:23;::::0;8533:9:::1;::::0;;;8550:23;::::1;;;::::0;8565:7;;8501:21:::1;8550:23:::0;8501:21;8550:23;8565:7;8533:9;8550:23;::::1;;;;;;;;;;;;;::::0;::::1;;;;;-1:-1:-1::0;8580:20:3;:31;;8604:7;;8580:20;::::1;::::0;:31:::1;::::0;8604:7;;8580:31:::1;:::i;5392:251::-:0;5439:17;5465:19;5502:13;;5487:29;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5487:29:3;;;;;;;;;;;;;;;;;5465:51;;5528:13;5523:100;5555:13;;5547:5;:21;5523:100;;;5599:9;:16;;;;;;;;;;;;5588:27;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:1;5590:5;5588:8;;;;;;;;:::i;:::-;;;;;;:27;;;;5570:7;;;;;:::i;:::-;;;;5523:100;;;-1:-1:-1;5636:1:3;5392:251;-1:-1:-1;5392:251:3:o;5187:199::-;5225:4;;;5255:111;5276:13;;5272:1;:17;5255:111;;;5305:17;5325:12;;;;;;;;;;;5305:32;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;5305:32:3;;-1:-1:-1;;5351:7:3;;;;5305:32;;-1:-1:-1;5346:12:3;;;;:::i;:::-;;;5296:70;5291:3;;;;;:::i;:::-;;;;5255:111;;1193:2545;1346:13;;1306:4;;1327:32;;1319:103;;;;-1:-1:-1;;;;;1319:103:3;;14875:2:6;1319:103:3;;;14857:21:6;14914:2;14894:18;;;14887:30;14953:34;14933:18;;;14926:62;15024:28;15004:18;;;14997:56;15070:19;;1319:103:3;14673:422:6;1319:103:3;1490:28;1508:9;1490:17;:28::i;:::-;1489:29;1481:65;;;;-1:-1:-1;;;;;1481:65:3;;15662:2:6;1481:65:3;;;15644:21:6;15701:2;15681:18;;;15674:30;15740:25;15720:18;;;15713:53;15783:18;;1481:65:3;15460:347:6;1481:65:3;1623:13;;;;;-1:-1:-1;;;;;1623:13:3;1640:9;1623:26;;1615:69;;;;-1:-1:-1;;;;;1615:69:3;;17190:2:6;1615:69:3;;;17172:21:6;17229:2;17209:18;;;17202:30;17268:32;17248:18;;;17241:60;17318:18;;1615:69:3;16988:354:6;1615:69:3;1749:11;1733:12;;;;:27;;;;;;;;:::i;:::-;;1725:58;;;;-1:-1:-1;;;;;1725:58:3;;16843:2:6;1725:58:3;;;16825:21:6;16882:2;16862:18;;;16855:30;16921:20;16901:18;;;16894:48;16959:18;;1725:58:3;16641:342:6;1725:58:3;1838:11;1860:12;1888:6;1883:303;1904:13;;1900:1;:17;1883:303;;;1933:17;1953:12;;;;;;;;;;;1933:32;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1974:15;1992:8;;2001:1;1992:11;;;;;;;:::i;:::-;;;;;;;;;;;;:::i;:::-;1974:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;2016:15:3;;1974:29;;-1:-1:-1;;2016:19:3;;;-1:-1:-1;2012:167:3;;2058:7;;;;2048:17;;;;:::i;:::-;;-1:-1:-1;2076:8:3;;;;:::i;:::-;;;;2012:167;;;2104:1;:10;;;2100:79;;;2127:42;;-1:-1:-1;;;;;2127:42:3;;14514:2:6;2127:42:3;;;14496:21:6;;;14533:18;;;14526:30;14592:34;14572:18;;;14565:62;14644:18;;2127:42:3;14312:356:6;2100:79:3;1924:262;;1919:3;;;;;:::i;:::-;;;;1883:303;;;;2206:13;;2196:6;:23;;;2192:78;;;2240:22;;2230:32;;;;:::i;:::-;;;2192:78;2365:10;:22;2355:32;;;2347:94;;;;-1:-1:-1;;;;;2347:94:3;;14096:2:6;2347:94:3;;;14078:21:6;14135:2;14115:18;;;14108:30;14174:34;14154:18;;;14147:62;14245:19;14225:18;;;14218:47;14282:19;;2347:94:3;13894:413:6;2347:94:3;2475:18;;:22;;2496:1;2475:22;:::i;:::-;2462:9;2450:22;;;;:11;:22;;;;;:47;;;;2593:161;2609:19;;;2593:161;;;2644:15;2662:8;;2671:1;2662:11;;;;;;;:::i;:::-;;;;;;;;;;;;:::i;:::-;2644:29;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;2686:15:3;;2644:29;;-1:-1:-1;;2686:19:3;;;-1:-1:-1;2682:65:3;;2718:10;;;;:7;:10;;;;;;;:18;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;2682:65;-1:-1:-1;2630:3:3;;;;:::i;:::-;;;;2593:161;;;-1:-1:-1;2836:34:3;;-1:-1:-1;;;;;2836:34:3;;2852:9;2836:34;;;9315:74:6;9405:18;;;9398:34;;;-1:-1:-1;;;;;2836:15:3;;;-1:-1:-1;;9288:18:6;;2836:34:3;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;-1:-1:-1;2877:10:3;:32;;2903:6;;2877:10;:22;;:32;;2903:6;;2877:32;:::i;:::-;;;;-1:-1:-1;;2916:26:3;:36;;2946:6;;2916:26;;;:36;;2946:6;;2916:36;:::i;:::-;;;;-1:-1:-1;;3008:20:3;;:24;3004:394;;3055:20;;3043:9;;3055:27;;3078:4;;3055:27;:::i;:::-;3043:39;-1:-1:-1;3103:4:3;3120:9;3116:63;;-1:-1:-1;3149:20:3;;3116:63;3199:4;3191:21;:29;-1:-1:-1;3187:204:3;;3283:17;;3262:9;;;;3283:17;;;;;3295:4;;3233:18;3283:17;3233:18;3283:17;3295:4;3262:9;3283:17;;;;;;;;;;;;;;;;;;;;-1:-1:-1;3311:20:3;:28;;3335:4;;3311:20;;;:28;;3335:4;;3311:28;:::i;:::-;;;;-1:-1:-1;;3350:23:3;:31;;3377:4;;3350:23;;;:31;;3377:4;;3350:31;:::i;:::-;;;;-1:-1:-1;;;3187:204:3;3034:364;;3004:394;3437:18;:20;;;:18;:20;;;:::i;:::-;;;;;;3610:7;:5;:7::i;:::-;3585:10;:22;:32;3581:132;;;3628:12;:30;;-1:-1:-1;;3628:30:3;3643:15;3628:30;;;;;;3672:33;;;;;;;:::i;:::-;;;;;;;;3581:132;-1:-1:-1;3726:6:3;1193:2545;-1:-1:-1;;;;;1193:2545:3:o;1066:95::-;971:13;;;;;-1:-1:-1;;;;;971:13:3;988:9;971:26;963:82;;;;-1:-1:-1;;;;;963:82:3;;;;;;;:::i;:::-;1133:12;:22;;1148:7;;1133:12;-1:-1:-1;;1133:22:3::1;::::0;1148:7;1133:22:::1;::::0;::::1;;;;;;:::i;:::-;;;;;;1066:95:::0;:::o;-1:-1:-1:-;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;:::i;:::-;;:::o;14:912:6:-;67:5;120:3;113:4;105:6;101:17;97:27;87:55;;138:1;135;128:12;87:55;174:6;161:20;200:4;223:18;260:2;256;253:10;250:36;;;266:18;;:::i;:::-;313:2;309;305:11;336:28;360:2;356;352:11;336:28;:::i;:::-;398:15;;;429:12;;;;461:15;;;495;;;491:24;;488:33;-1:-1:-1;485:53:6;;;534:1;531;524:12;485:53;556:1;547:10;;577:1;587:310;603:2;598:3;595:11;587:310;;;684:3;671:17;720:2;707:11;704:19;701:39;;;736:1;733;726:12;701:39;765:57;818:3;813:2;799:11;791:6;787:24;783:33;765:57;:::i;:::-;753:70;;-1:-1:-1;843:12:6;;;;875;;;;625:1;616:11;587:310;;;-1:-1:-1;915:5:6;;14:912;-1:-1:-1;;;;;;;;;14:912:6:o;931:531::-;974:5;1027:3;1020:4;1012:6;1008:17;1004:27;994:55;;1045:1;1042;1035:12;994:55;1081:6;1068:20;1107:18;1103:2;1100:26;1097:52;;;1129:18;;:::i;:::-;1173:55;1222:4;-1:-1:-1;;1216:2:6;1197:13;;1193:27;1189:38;1173:55;:::i;:::-;1253:2;1244:7;1237:19;1299:3;1292:4;1287:2;1279:6;1275:15;1271:26;1268:35;1265:55;;;1316:1;1313;1306:12;1265:55;1381:2;1374:4;1366:6;1362:17;1355:4;1346:7;1342:18;1329:55;1429:1;1404:16;;;1422:4;1400:27;1393:38;;;;1408:7;931:531;-1:-1:-1;;;931:531:6:o;1467:247::-;1526:6;1579:2;1567:9;1558:7;1554:23;1550:32;1547:52;;;1595:1;1592;1585:12;1547:52;1634:9;1621:23;1653:31;1678:5;1653:31;:::i;:::-;1703:5;1467:247;-1:-1:-1;;;1467:247:6:o;1719:245::-;1786:6;1839:2;1827:9;1818:7;1814:23;1810:32;1807:52;;;1855:1;1852;1845:12;1807:52;1887:9;1881:16;1906:28;1928:5;1906:28;:::i;1969:329::-;2051:6;2059;2112:2;2100:9;2091:7;2087:23;2083:32;2080:52;;;2128:1;2125;2118:12;2080:52;2167:9;2154:23;2186:31;2211:5;2186:31;:::i;:::-;2236:5;2288:2;2273:18;;;;2260:32;;-1:-1:-1;;;1969:329:6:o;2303:1146::-;2476:6;2484;2492;2500;2508;2516;2569:3;2557:9;2548:7;2544:23;2540:33;2537:53;;;2586:1;2583;2576:12;2537:53;2625:9;2612:23;2644:41;2679:5;2644:41;:::i;:::-;2704:5;-1:-1:-1;2756:2:6;2741:18;;2728:32;;-1:-1:-1;2812:2:6;2797:18;;2784:32;2825:30;2784:32;2825:30;:::i;:::-;2874:7;-1:-1:-1;2932:2:6;2917:18;;2904:32;2955:18;2985:14;;;2982:34;;;3012:1;3009;3002:12;2982:34;3035:50;3077:7;3068:6;3057:9;3053:22;3035:50;:::i;:::-;3025:60;;3138:3;3127:9;3123:19;3110:33;3094:49;;3168:2;3158:8;3155:16;3152:36;;;3184:1;3181;3174:12;3152:36;3207:52;3251:7;3240:8;3229:9;3225:24;3207:52;:::i;:::-;3197:62;;3312:3;3301:9;3297:19;3284:33;3268:49;;3342:2;3332:8;3329:16;3326:36;;;3358:1;3355;3348:12;3326:36;;3381:62;3435:7;3424:8;3413:9;3409:24;3381:62;:::i;:::-;3371:72;;;2303:1146;;;;;;;;:::o;3454:268::-;3524:6;3577:2;3565:9;3556:7;3552:23;3548:32;3545:52;;;3593:1;3590;3583:12;3545:52;3632:9;3619:23;3651:41;3686:5;3651:41;:::i;3727:611::-;3824:6;3832;3840;3893:2;3881:9;3872:7;3868:23;3864:32;3861:52;;;3909:1;3906;3899:12;3861:52;3949:9;3936:23;3978:18;4019:2;4011:6;4008:14;4005:34;;;4035:1;4032;4025:12;4005:34;4058:50;4100:7;4091:6;4080:9;4076:22;4058:50;:::i;:::-;4048:60;;4161:2;4150:9;4146:18;4133:32;4117:48;;4190:2;4180:8;4177:16;4174:36;;;4206:1;4203;4196:12;4174:36;;4229:52;4273:7;4262:8;4251:9;4247:24;4229:52;:::i;:::-;4219:62;;;4328:2;4317:9;4313:18;4300:32;4290:42;;3727:611;;;;;:::o;4343:180::-;4402:6;4455:2;4443:9;4434:7;4430:23;4426:32;4423:52;;;4471:1;4468;4461:12;4423:52;-1:-1:-1;4494:23:6;;4343:180;-1:-1:-1;4343:180:6:o;4528:184::-;4598:6;4651:2;4639:9;4630:7;4626:23;4622:32;4619:52;;;4667:1;4664;4657:12;4619:52;-1:-1:-1;4690:16:6;;4528:184;-1:-1:-1;4528:184:6:o;4717:845::-;4847:6;4855;4863;4871;4924:2;4912:9;4903:7;4899:23;4895:32;4892:52;;;4940:1;4937;4930:12;4892:52;4976:9;4963:23;4953:33;;5036:2;5025:9;5021:18;5008:32;5049:31;5074:5;5049:31;:::i;:::-;5099:5;-1:-1:-1;5155:2:6;5140:18;;5127:32;5178:18;5208:14;;;5205:34;;;5235:1;5232;5225:12;5205:34;5273:6;5262:9;5258:22;5248:32;;5318:7;5311:4;5307:2;5303:13;5299:27;5289:55;;5340:1;5337;5330:12;5289:55;5380:2;5367:16;5406:2;5398:6;5395:14;5392:34;;;5422:1;5419;5412:12;5392:34;5476:7;5471:2;5465;5457:6;5453:15;5449:2;5445:24;5441:33;5438:46;5435:66;;;5497:1;5494;5487:12;5435:66;4717:845;;;;-1:-1:-1;;5528:2:6;5520:11;;-1:-1:-1;;;4717:845:6:o;5567:1215::-;5749:6;5757;5765;5773;5781;5789;5797;5850:3;5838:9;5829:7;5825:23;5821:33;5818:53;;;5867:1;5864;5857:12;5818:53;5903:9;5890:23;5880:33;;5963:2;5952:9;5948:18;5935:32;5976:41;6011:5;5976:41;:::i;:::-;6036:5;-1:-1:-1;6088:2:6;6073:18;;6060:32;;-1:-1:-1;6144:2:6;6129:18;;6116:32;6157:30;6116:32;6157:30;:::i;:::-;6206:7;-1:-1:-1;6264:3:6;6249:19;;6236:33;6288:18;6318:14;;;6315:34;;;6345:1;6342;6335:12;6315:34;6368:50;6410:7;6401:6;6390:9;6386:22;6368:50;:::i;:::-;6358:60;;6471:3;6460:9;6456:19;6443:33;6427:49;;6501:2;6491:8;6488:16;6485:36;;;6517:1;6514;6507:12;6485:36;6540:52;6584:7;6573:8;6562:9;6558:24;6540:52;:::i;:::-;6530:62;;6645:3;6634:9;6630:19;6617:33;6601:49;;6675:2;6665:8;6662:16;6659:36;;;6691:1;6688;6681:12;6659:36;;6714:62;6768:7;6757:8;6746:9;6742:24;6714:62;:::i;:::-;6704:72;;;5567:1215;;;;;;;;;;:::o;6787:248::-;6855:6;6863;6916:2;6904:9;6895:7;6891:23;6887:32;6884:52;;;6932:1;6929;6922:12;6884:52;-1:-1:-1;;6955:23:6;;;7025:2;7010:18;;;6997:32;;-1:-1:-1;6787:248:6:o;7172:132::-;7230:41;7265:5;7230:41;:::i;:::-;7280:18;;7172:132::o;7309:472::-;7351:3;7389:5;7383:12;7416:6;7411:3;7404:19;7441:1;7451:162;7465:6;7462:1;7459:13;7451:162;;;7527:4;7583:13;;;7579:22;;7573:29;7555:11;;;7551:20;;7544:59;7480:12;7451:162;;;7631:6;7628:1;7625:13;7622:87;;;7697:1;7690:4;7681:6;7676:3;7672:16;7668:27;7661:38;7622:87;-1:-1:-1;7763:2:6;7742:15;-1:-1:-1;;7738:29:6;7729:39;;;;7770:4;7725:50;;7309:472;-1:-1:-1;;7309:472:6:o;7786:266::-;7871:5;7865:12;7860:3;7853:25;7927:4;7920:5;7916:16;7910:23;7903:4;7898:3;7894:14;7887:47;7983:4;7976:5;7972:16;7966:23;7959:4;7954:3;7950:14;7943:47;8039:4;8032:5;8028:16;8022:23;8015:4;8010:3;8006:14;7999:47;;;7786:266::o;8057:445::-;8111:3;8155:5;8149:12;8182:4;8177:3;8170:17;8208:47;8249:4;8244:3;8240:14;8226:12;8208:47;:::i;:::-;8196:59;;8303:4;8296:5;8292:16;8286:23;8351:3;8345:4;8341:14;8334:4;8329:3;8325:14;8318:38;8379:39;8413:4;8397:14;8379:39;:::i;:::-;8365:53;;;8467:4;8460:5;8456:16;8450:23;8443:4;8438:3;8434:14;8427:47;8490:6;8483:13;;;8057:445;;;;:::o;9443:804::-;9605:4;9634:2;9674;9663:9;9659:18;9704:2;9693:9;9686:21;9727:6;9762;9756:13;9793:6;9785;9778:22;9831:2;9820:9;9816:18;9809:25;;9894:2;9888;9880:6;9876:15;9865:9;9861:31;9857:40;9843:54;;9932:2;9924:6;9920:15;9953:1;9963:255;9977:6;9974:1;9971:13;9963:255;;;10070:2;10066:7;10054:9;10046:6;10042:22;10038:36;10033:3;10026:49;10098:40;10131:6;10122;10116:13;10098:40;:::i;:::-;10088:50;-1:-1:-1;10196:12:6;;;;10161:15;;;;9999:1;9992:9;9963:255;;;-1:-1:-1;10235:6:6;;9443:804;-1:-1:-1;;;;;;;9443:804:6:o;10252:2298::-;10475:2;10527:21;;;10597:13;;10500:18;;;10619:22;;;10446:4;;10475:2;10660;;10678:18;;;;10738:15;;;10723:31;;10719:40;;10782:15;;;10446:4;;10846:1675;10862:6;10857:3;10854:15;10846:1675;;;10959:2;10955:7;10943:9;10935:6;10931:22;10927:36;10922:3;10915:49;10993:6;10987:13;11023:4;11056:2;11050:9;11072:38;11107:2;11072:38;:::i;:::-;11123:18;;11184:11;;;11178:18;11161:15;;;11154:43;11254:11;;;11248:18;11241:26;11234:34;11217:15;;;11210:59;11292:4;11335:11;;;11329:18;11367:15;;;11360:27;;;11414:48;11446:15;;;11329:18;11414:48;:::i;:::-;11400:62;;;;11485:4;11538:2;11534;11530:11;11524:18;11591:6;11583;11579:19;11574:2;11566:6;11562:15;11555:44;11626:41;11660:6;11644:14;11626:41;:::i;:::-;11690:4;11735:11;;;11729:18;11784:19;;;11767:15;;;11760:44;;;;11865:21;;11899:24;;;12055:23;;;;11612:55;;-1:-1:-1;11945:15:6;;;;-1:-1:-1;11865:21:6;-1:-1:-1;12003:17:6;;;11991:30;;11987:39;;12102:1;12116:296;12132:8;12127:3;12124:17;12116:296;;;12238:2;12234:7;12225:6;12217;12213:19;12209:33;12202:5;12195:48;12270:42;12305:6;12294:8;12288:15;12270:42;:::i;:::-;12341:17;;;;12384:14;;;;12260:52;-1:-1:-1;12160:1:6;12151:11;12116:296;;;-1:-1:-1;12499:12:6;;;;12435:6;-1:-1:-1;;;12464:15:6;;;;-1:-1:-1;;10888:1:6;10879:11;10846:1675;;;-1:-1:-1;12538:6:6;;10252:2298;-1:-1:-1;;;;;;;;;10252:2298:6:o;12747:675::-;13019:42;13054:6;13019:42;:::i;:::-;13088:6;13077:9;13070:25;13131:6;13126:2;13115:9;13111:18;13104:34;13188:6;13181:14;13174:22;13169:2;13158:9;13154:18;13147:50;13233:3;13228:2;13217:9;13213:18;13206:31;13000:4;13260:46;13301:3;13290:9;13286:19;13278:6;13260:46;:::i;:::-;13355:9;13347:6;13343:22;13337:3;13326:9;13322:19;13315:51;13383:33;13409:6;13401;13383:33;:::i;:::-;13375:41;12747:675;-1:-1:-1;;;;;;;;12747:675:6:o;13427:237::-;13570:2;13555:18;;13582:42;13617:6;13582:42;:::i;:::-;13633:25;;;13427:237;:::o;13669:220::-;13818:2;13807:9;13800:21;13781:4;13838:45;13879:2;13868:9;13864:18;13856:6;13838:45;:::i;15100:355::-;15302:2;15284:21;;;15341:2;15321:18;;;15314:30;15380:33;15375:2;15360:18;;15353:61;15446:2;15431:18;;15100:355::o;15812:407::-;16014:2;15996:21;;;16053:2;16033:18;;;16026:30;16092:34;16087:2;16072:18;;16065:62;16163:13;16158:2;16143:18;;16136:41;16209:3;16194:19;;15812:407::o;16224:412::-;16426:2;16408:21;;;16465:2;16445:18;;;16438:30;16504:34;16499:2;16484:18;;16477:62;16575:18;16570:2;16555:18;;16548:46;16626:3;16611:19;;16224:412::o;17347:398::-;17549:2;17531:21;;;17588:2;17568:18;;;17561:30;17627:34;17622:2;17607:18;;17600:62;-1:-1:-1;;;;;17693:2:6;17678:18;;17671:32;17735:3;17720:19;;17347:398::o;17750:265::-;17946:3;17931:19;;17959:50;17935:9;17991:6;17959:50;:::i;:::-;17750:265;;;;:::o;18020:270::-;18207:2;18196:9;18189:21;18170:4;18227:57;18280:2;18269:9;18265:18;18257:6;18227:57;:::i;18295:775::-;18628:4;18657:3;18687:2;18676:9;18669:21;18707:57;18760:2;18749:9;18745:18;18737:6;18707:57;:::i;:::-;18699:65;;;18773:59;18828:2;18817:9;18813:18;18805:6;18773:59;:::i;:::-;18869:6;18863:3;18852:9;18848:19;18841:35;18885:42;18920:6;18885:42;:::i;:::-;18958:3;18943:19;;18936:35;;;;-1:-1:-1;;;;;19008:55:6;;;;19002:3;18987:19;;;18980:84;18295:775;;-1:-1:-1;;;18295:775:6:o;19075:1382::-;19268:2;19250:21;;;19307:13;;19287:18;;;19280:41;19356:15;;19350:22;-1:-1:-1;;;;;7106:54:6;;19429:2;19414:18;;7094:67;-1:-1:-1;;19381:52:6;19487:2;19479:6;19475:15;19469:22;19464:2;19453:9;19449:18;19442:50;19547:2;19539:6;19535:15;19529:22;19523:3;19512:9;19508:19;19501:51;19601:3;19593:6;19589:16;19583:23;19625:6;19668:2;19662:3;19651:9;19647:19;19640:31;19694:54;19743:3;19732:9;19728:19;19712:14;19694:54;:::i;:::-;19680:68;;19797:3;19789:6;19785:16;19779:23;19871:2;19867:7;19855:9;19847:6;19843:22;19839:36;19833:3;19822:9;19818:19;19811:65;19899:41;19933:6;19917:14;19899:41;:::i;:::-;19885:55;;;19989:3;19981:6;19977:16;19971:23;20003:59;20057:3;20046:9;20042:19;20026:14;20003:59;:::i;:::-;-1:-1:-1;20099:3:6;20087:16;;20081:23;20123:3;20142:18;;;20135:30;;;;20190:15;;20184:22;20225:3;20244:18;;;20237:30;;;;20292:15;;20286:22;20327:3;20346:18;;;20339:30;;;;20411:15;;;20405:22;20385:18;;;;20378:50;;;;20445:6;19075:1382;-1:-1:-1;19075:1382:6:o;20644:522::-;20722:4;20728:6;20788:11;20775:25;20882:2;20878:7;20867:8;20851:14;20847:29;20843:43;20823:18;20819:68;20809:96;;20901:1;20898;20891:12;20809:96;20928:33;;20980:20;;;-1:-1:-1;21023:18:6;21012:30;;21009:50;;;21055:1;21052;21045:12;21009:50;21088:4;21076:17;;-1:-1:-1;21119:14:6;21115:27;;;21105:38;;21102:58;;;21156:1;21153;21146:12;21102:58;20644:522;;;;;:::o;21171:275::-;21242:2;21236:9;-1:-1:-1;;21307:2:6;21288:13;;21284:27;21272:40;;21363:22;;;21342:18;21327:34;;21324:62;21321:88;;;21389:18;;:::i;:::-;21425:2;21418:22;21171:275;;-1:-1:-1;21171:275:6:o;21451:128::-;21491:3;21522:1;21518:6;21515:1;21512:13;21509:39;;;21528:18;;:::i;:::-;-1:-1:-1;21564:9:6;;21451:128::o;21584:125::-;21624:4;21652:1;21649;21646:8;21643:34;;;21657:18;;:::i;:::-;-1:-1:-1;21694:9:6;;21584:125::o;21714:388::-;21799:1;21789:12;;21846:1;21836:12;;;21857:61;;21911:4;21903:6;21899:17;21889:27;;21857:61;21964:2;21956:6;21953:14;21933:18;21930:38;21927:169;;;-1:-1:-1;;;;;21998:1:6;21991:39;;;22053:4;22050:1;22043:15;22081:4;;22071:15;22107:135;22146:3;-1:-1:-1;;22167:17:6;;22164:43;;;22187:18;;:::i;:::-;-1:-1:-1;22234:1:6;22223:13;;22107:135::o;22247:175::-;22284:3;22328:4;22321:5;22317:16;22357:4;22348:7;22345:17;22342:43;;;22365:18;;:::i;:::-;22414:1;22401:15;;22247:175;-1:-1:-1;;22247:175:6:o;22427:135::-;-1:-1:-1;;;;;22476:1:6;22469:39;;;22527:4;22524:1;22517:15;22551:4;;22541:15;22567:135;-1:-1:-1;;;;;22616:1:6;22609:39;;;22667:4;22664:1;22657:15;22691:4;;22681:15;22707:135;-1:-1:-1;;;;;22756:1:6;22749:39;;;22807:4;22804:1;22797:15;22831:4;;22821:15;22847:135;-1:-1:-1;;;;;22896:1:6;22889:39;;;22947:4;22944:1;22937:15;22971:4;;22961:15;22987:222;23072:1;23065:5;23062:12;23052:151;;-1:-1:-1;;;;;23105:1:6;23098:39;;;23160:4;23157:1;23150:15;23188:4;;23178:15;23214:154;-1:-1:-1;;;;;23289:54:6;;23279:65;;23269:93;;23358:1;23355;23348:12;23373:118;23459:5;23452:13;23445:21;23438:5;23435:32;23425:60;;23481:1;23478;23471:12;23496:111;23581:1;23574:5;23571:12;23561:40;;23597:1;23594;23587:12",
  "source": "// SPDX-License-Identifier: MIT\r\npragma experimental ABIEncoderV2;\r\npragma solidity >=0.6.0;\r\n\r\nimport \"./SurveyInterface.sol\";\r\nimport \"./Token.sol\";\r\n\r\ncontract Survey is SurveyInterface {\r\n\r\n  //multichoice would store index, rating would be a number, and text is text\r\n  // Question[] public questions;\r\n  mapping(uint => Question) public questions;\r\n  uint public questionCount = 0;\r\n\r\n  mapping (uint => string[]) public answers;\r\n  mapping (address => uint) private userAnswers;\r\n\r\n  SurveyBuild public build;\r\n\r\n  event SurveyStatusChanged(\r\n    Status _status\r\n  );\r\n  \r\n  constructor(address _creator, string memory _name, string memory _description, uint _bonusAmount) {\r\n\r\n    build.info.name = _name;\r\n    build.info.description = _description;\r\n    build.info.bonusAmount = _bonusAmount;\r\n    build.creator = _creator;\r\n  }\r\n\r\n  modifier isCreator {\r\n    // require(build.creator == msg.sender);\r\n    //if either one is the creator continue on\r\n    require(build.creator == tx.origin, \"Must be the creator to access this function\"); \r\n    _;\r\n  }\r\n\r\n  function setSurveyStatus(Status _status) external isCreator {\r\n    build.status = _status;\r\n  }\r\n\r\n  event Log(string s);\r\n\r\n  function submitSurvey(\r\n    uint _gas,\r\n    Token _token,\r\n    string[] calldata _answers\r\n  ) external returns (uint) {\r\n    require(_answers.length == questionCount, \"Answer string array does not match the length of questions\");\r\n    //make sure we haven't done this survey before\r\n    require(!didUserTakeSurvey(tx.origin), \"Already took the survey\");\r\n\r\n    //make sure the creator didn't submit their own survey\r\n    require(build.creator != tx.origin, \"Creator cannot take the survey\");\r\n    //make sure it is still open\r\n    require(build.status == Status.OPEN, \"Survey is not open\");\r\n    //this calulates how much rewards they get\r\n    uint reward = 0;\r\n    uint8 filled = 0;\r\n    for (uint i = 0; i < questionCount; i++) {\r\n      Question memory q = questions[i];\r\n      string memory a = _answers[i];\r\n      if (bytes(a).length > 0) {\r\n        reward += q.worth;\r\n        filled++;\r\n      } else if (q.required) {\r\n        revert(\"Required question not filled out\");\r\n      }\r\n    }\r\n    if (filled == questionCount) {\r\n      reward += build.info.bonusAmount;\r\n    }\r\n    //liquidity pool must have enough funds to continue this function\r\n    require(reward <= build.pool.tokenAmount, \"Not enough reward to give, cancelling submission.\");\r\n\r\n    userAnswers[tx.origin] = build.surveysTaken + 1; //tells you which id you are in the string[] of questions\r\n    //push answers to mapping\r\n    for(uint i = 0; i < _answers.length; i++) {\r\n      string memory a = _answers[i];\r\n      if (bytes(a).length > 0) {\r\n        answers[i].push(a); \r\n      }\r\n    }\r\n\r\n    //this takes the money from the liquidity pool and sends them tokens\r\n    _token.transfer(tx.origin, reward);\r\n    build.pool.tokenAmount -= reward;\r\n    build.pool.totalTokensSent += reward;\r\n\r\n    //try to send them back the gas money\r\n    if (build.pool.gasAmount > 0) {\r\n      uint diff = build.pool.gasAmount - _gas;\r\n      uint send = _gas;\r\n      if (diff <= 0) {\r\n        send = build.pool.gasAmount;\r\n      }\r\n      if (address(this).balance >= send) {\r\n        address payable pa = payable(tx.origin);\r\n        pa.transfer(send);\r\n        build.pool.gasAmount -= send;\r\n        build.pool.totalGasSent += send;\r\n      }\r\n    }\r\n\r\n    //increment taken surveys\r\n    build.surveysTaken++;\r\n\r\n    //this checks to see if the survey needs to close\r\n    //to check this we see if they can fund another survey\r\n    if (build.pool.tokenAmount < worth()) {\r\n      build.status = Status.FINISHED;\r\n      emit SurveyStatusChanged(build.status);\r\n    }\r\n    return reward;\r\n  }\r\n\r\n  //find a way to eliminate these functions\r\n  ////////////////////////////////////////////////////////////////\r\n  function name() view external returns (string memory) {\r\n    return build.info.name;\r\n  }\r\n\r\n  // function description() view external returns (string memory) {\r\n  //   return build.info.description;\r\n  // }\r\n\r\n  function bonusAmount() view external returns (uint) {\r\n    return build.info.bonusAmount;\r\n  }\r\n\r\n  function creator() view external returns (address) {\r\n    return build.creator;\r\n  }\r\n\r\n  function status() view external returns (Status) {\r\n    return build.status;\r\n  }\r\n\r\n  function info() view external returns (SurveyBasic memory) {\r\n    return build.info;\r\n  }\r\n\r\n  function pool() view external returns (LiquidityPool memory) {\r\n    return build.pool;\r\n  }\r\n  ////////////////////////////////////////////////////////////////\r\n\r\n  function getBalance() view external returns (uint) {\r\n    return address(this).balance;\r\n  }\r\n\r\n  function getOverview() view external returns (SurveyOverview memory) {\r\n    return SurveyOverview({\r\n      id: 0,\r\n      addr: address(this),\r\n      worth: worth(),\r\n      bonusAmount: build.info.bonusAmount,\r\n      name: build.info.name,\r\n      description: build.info.description,\r\n      status: build.status,\r\n      taken: build.surveysTaken,\r\n      gasLeft: build.pool.gasAmount,\r\n      tokensLeft: build.pool.tokenAmount,\r\n      questionCount: questionCount\r\n    });\r\n  }\r\n\r\n  function worth() view public returns (uint) {\r\n    uint w = 0;\r\n    for (uint i = 0; i < questionCount; i++) {\r\n      Question memory q = questions[i];\r\n      w += q.worth;\r\n    }\r\n    return w;\r\n  }\r\n\r\n  function getQuestions() external view returns (Question[] memory) {\r\n    Question[] memory q = new Question[](questionCount);\r\n    for (uint256 index = 0; index < questionCount; index++) {\r\n      q[index] = questions[index];\r\n    }\r\n    return q;\r\n  }\r\n\r\n  function getAnswers(uint qid) external view isCreator returns (string[] memory) {\r\n    string[] memory ret = answers[qid];\r\n    return ret;\r\n  }\r\n\r\n  // function getUserAnswers() external view returns (string[] memory) {\r\n  //   uint index = userAnswers[tx.origin] - 1;\r\n  //   require(index >= 0, \"No answers found\");\r\n  //   string[] memory ret = new string[](questionCount);\r\n  //   for (uint256 i = 0; i < questionCount; i++) {\r\n  //     ret[i] = answers[i][index];\r\n  //   }\r\n  //   return ret;\r\n  // }\r\n\r\n  function updateSurvey(\r\n    string memory _name,\r\n    string memory _description,\r\n    uint _bonusAmount\r\n  ) public isCreator {\r\n    require(build.status == Status.NOT_OPENED, \"Survey must be in editing stage\");\r\n    build.info.name = _name;\r\n    build.info.description = _description;\r\n    build.info.bonusAmount = _bonusAmount;\r\n  }\r\n\r\n  function addQuestion(\r\n    QuestionType _qtypes,\r\n    uint _worth,\r\n    bool _required,\r\n    string memory _title,\r\n    string memory _qdescription,\r\n    string[] memory _choices\r\n  ) public  isCreator returns (uint) {\r\n    require(build.status == Status.NOT_OPENED, \"Survey must be in editing stage\");\r\n    updateQuestion(\r\n      questionCount,\r\n      _qtypes,\r\n      _worth,\r\n      _required,\r\n      _title,\r\n      _qdescription,\r\n      _choices\r\n    );\r\n    questionCount++;\r\n\r\n    return questionCount - 1;\r\n  }\r\n\r\n  function updateQuestion(\r\n    uint _id,\r\n    QuestionType _qtypes,\r\n    uint _worth,\r\n    bool _required,\r\n    string memory _title,\r\n    string memory _qdescription,\r\n    string[] memory _choices\r\n  ) public isCreator {\r\n    require(build.status == Status.NOT_OPENED, \"Survey must be in editing stage\");\r\n    questions[_id] = Question(\r\n      _qtypes,\r\n      _worth,\r\n      _required,\r\n      _title,\r\n      _qdescription,\r\n      _choices\r\n    );\r\n  }\r\n\r\n  function depositToSurveyTokenPool(Token _token, uint _amount) external isCreator {\r\n    require(_amount > 0, \"amount has to be greater than zero\");\r\n    _token.transferFrom(tx.origin, address(this), _amount);\r\n    build.pool.tokenAmount += _amount;\r\n  }\r\n\r\n  function depositToSurveyGasPool() external payable isCreator {\r\n    require(msg.value > 0, \"amount has to be greater than zero\");\r\n    build.pool.gasAmount += msg.value;\r\n  }\r\n\r\n  function withdrawFromTokenPool(Token _token, uint _amount) external isCreator {\r\n    require(_amount > 0, \"amount has to be greater than zero\");\r\n    require(_token.balanceOf(address(this)) >= _amount, \"Balance has to be >= than the amount to withdraw\");\r\n    _token.transfer(tx.origin, _amount);\r\n    build.pool.tokenAmount -= _amount;\r\n  }\r\n\r\n  function withdrawFromGasPool(uint _amount) external isCreator {\r\n    require(_amount > 0, \"amount has to be greater than zero\");\r\n    require(address(this).balance >= _amount, \"Balance has to be >= than the amount to withdraw\");\r\n    address payable _addr = payable(tx.origin);\r\n    _addr.transfer(_amount);\r\n    build.pool.gasAmount -= _amount;\r\n  }\r\n\r\n  function didUserTakeSurvey(address _addr) view public returns (bool) {\r\n    uint index = userAnswers[_addr];\r\n    if (index > 0) {\r\n      return true;\r\n    }\r\n    return false;\r\n  }\r\n}\r\n",
  "sourcePath": "C:\\Users\\surge\\Desktop\\dapp-projects\\survana\\contracts\\Survey.sol",
  "ast": {
    "absolutePath": "project:/contracts/Survey.sol",
    "exportedSymbols": {
      "Survey": [
        1994
      ],
      "SurveyInterface": [
        2075
      ],
      "Token": [
        2124
      ]
    },
    "id": 1995,
    "license": "MIT",
    "nodeType": "SourceUnit",
    "nodes": [
      {
        "id": 1073,
        "literals": [
          "experimental",
          "ABIEncoderV2"
        ],
        "nodeType": "PragmaDirective",
        "src": "33:33:3"
      },
      {
        "id": 1074,
        "literals": [
          "solidity",
          ">=",
          "0.6",
          ".0"
        ],
        "nodeType": "PragmaDirective",
        "src": "68:24:3"
      },
      {
        "absolutePath": "project:/contracts/SurveyInterface.sol",
        "file": "./SurveyInterface.sol",
        "id": 1075,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 1995,
        "sourceUnit": 2076,
        "src": "96:31:3",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "project:/contracts/Token.sol",
        "file": "./Token.sol",
        "id": 1076,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 1995,
        "sourceUnit": 2125,
        "src": "129:21:3",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "abstract": false,
        "baseContracts": [
          {
            "baseName": {
              "id": 1077,
              "name": "SurveyInterface",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 2075,
              "src": "173:15:3"
            },
            "id": 1078,
            "nodeType": "InheritanceSpecifier",
            "src": "173:15:3"
          }
        ],
        "contractDependencies": [],
        "contractKind": "contract",
        "fullyImplemented": true,
        "id": 1994,
        "linearizedBaseContracts": [
          1994,
          2075
        ],
        "name": "Survey",
        "nameLocation": "163:6:3",
        "nodeType": "ContractDefinition",
        "nodes": [
          {
            "constant": false,
            "functionSelector": "31b1b978",
            "id": 1083,
            "mutability": "mutable",
            "name": "questions",
            "nameLocation": "343:9:3",
            "nodeType": "VariableDeclaration",
            "scope": 1994,
            "src": "310:42:3",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_uint256_$_t_struct$_Question_$2020_storage_$",
              "typeString": "mapping(uint256 => struct SurveyInterface.Question)"
            },
            "typeName": {
              "id": 1082,
              "keyType": {
                "id": 1079,
                "name": "uint",
                "nodeType": "ElementaryTypeName",
                "src": "318:4:3",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "nodeType": "Mapping",
              "src": "310:25:3",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_uint256_$_t_struct$_Question_$2020_storage_$",
                "typeString": "mapping(uint256 => struct SurveyInterface.Question)"
              },
              "valueType": {
                "id": 1081,
                "nodeType": "UserDefinedTypeName",
                "pathNode": {
                  "id": 1080,
                  "name": "Question",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 2020,
                  "src": "326:8:3"
                },
                "referencedDeclaration": 2020,
                "src": "326:8:3",
                "typeDescriptions": {
                  "typeIdentifier": "t_struct$_Question_$2020_storage_ptr",
                  "typeString": "struct SurveyInterface.Question"
                }
              }
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "1468aa2c",
            "id": 1086,
            "mutability": "mutable",
            "name": "questionCount",
            "nameLocation": "369:13:3",
            "nodeType": "VariableDeclaration",
            "scope": 1994,
            "src": "357:29:3",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 1084,
              "name": "uint",
              "nodeType": "ElementaryTypeName",
              "src": "357:4:3",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": {
              "hexValue": "30",
              "id": 1085,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "385:1:3",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_0_by_1",
                "typeString": "int_const 0"
              },
              "value": "0"
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "2401519c",
            "id": 1091,
            "mutability": "mutable",
            "name": "answers",
            "nameLocation": "427:7:3",
            "nodeType": "VariableDeclaration",
            "scope": 1994,
            "src": "393:41:3",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_uint256_$_t_array$_t_string_storage_$dyn_storage_$",
              "typeString": "mapping(uint256 => string[])"
            },
            "typeName": {
              "id": 1090,
              "keyType": {
                "id": 1087,
                "name": "uint",
                "nodeType": "ElementaryTypeName",
                "src": "402:4:3",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "nodeType": "Mapping",
              "src": "393:26:3",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_uint256_$_t_array$_t_string_storage_$dyn_storage_$",
                "typeString": "mapping(uint256 => string[])"
              },
              "valueType": {
                "baseType": {
                  "id": 1088,
                  "name": "string",
                  "nodeType": "ElementaryTypeName",
                  "src": "410:6:3",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_storage_ptr",
                    "typeString": "string"
                  }
                },
                "id": 1089,
                "nodeType": "ArrayTypeName",
                "src": "410:8:3",
                "typeDescriptions": {
                  "typeIdentifier": "t_array$_t_string_storage_$dyn_storage_ptr",
                  "typeString": "string[]"
                }
              }
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "id": 1095,
            "mutability": "mutable",
            "name": "userAnswers",
            "nameLocation": "473:11:3",
            "nodeType": "VariableDeclaration",
            "scope": 1994,
            "src": "439:45:3",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
              "typeString": "mapping(address => uint256)"
            },
            "typeName": {
              "id": 1094,
              "keyType": {
                "id": 1092,
                "name": "address",
                "nodeType": "ElementaryTypeName",
                "src": "448:7:3",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              },
              "nodeType": "Mapping",
              "src": "439:25:3",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
                "typeString": "mapping(address => uint256)"
              },
              "valueType": {
                "id": 1093,
                "name": "uint",
                "nodeType": "ElementaryTypeName",
                "src": "459:4:3",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              }
            },
            "visibility": "private"
          },
          {
            "constant": false,
            "functionSelector": "8e1a55fc",
            "id": 1098,
            "mutability": "mutable",
            "name": "build",
            "nameLocation": "510:5:3",
            "nodeType": "VariableDeclaration",
            "scope": 1994,
            "src": "491:24:3",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
              "typeString": "struct SurveyInterface.SurveyBuild"
            },
            "typeName": {
              "id": 1097,
              "nodeType": "UserDefinedTypeName",
              "pathNode": {
                "id": 1096,
                "name": "SurveyBuild",
                "nodeType": "IdentifierPath",
                "referencedDeclaration": 2050,
                "src": "491:11:3"
              },
              "referencedDeclaration": 2050,
              "src": "491:11:3",
              "typeDescriptions": {
                "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage_ptr",
                "typeString": "struct SurveyInterface.SurveyBuild"
              }
            },
            "visibility": "public"
          },
          {
            "anonymous": false,
            "id": 1103,
            "name": "SurveyStatusChanged",
            "nameLocation": "528:19:3",
            "nodeType": "EventDefinition",
            "parameters": {
              "id": 1102,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1101,
                  "indexed": false,
                  "mutability": "mutable",
                  "name": "_status",
                  "nameLocation": "561:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1103,
                  "src": "554:14:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_enum$_Status_$2001",
                    "typeString": "enum SurveyInterface.Status"
                  },
                  "typeName": {
                    "id": 1100,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1099,
                      "name": "Status",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2001,
                      "src": "554:6:3"
                    },
                    "referencedDeclaration": 2001,
                    "src": "554:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_Status_$2001",
                      "typeString": "enum SurveyInterface.Status"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "547:26:3"
            },
            "src": "522:52:3"
          },
          {
            "body": {
              "id": 1144,
              "nodeType": "Block",
              "src": "680:157:3",
              "statements": [
                {
                  "expression": {
                    "id": 1120,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1114,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "689:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1117,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "info",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2039,
                        "src": "689:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                          "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                        }
                      },
                      "id": 1118,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "name",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2031,
                      "src": "689:15:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage",
                        "typeString": "string storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1119,
                      "name": "_name",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1107,
                      "src": "707:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_memory_ptr",
                        "typeString": "string memory"
                      }
                    },
                    "src": "689:23:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "id": 1121,
                  "nodeType": "ExpressionStatement",
                  "src": "689:23:3"
                },
                {
                  "expression": {
                    "id": 1128,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1122,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "719:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1125,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "info",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2039,
                        "src": "719:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                          "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                        }
                      },
                      "id": 1126,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "description",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2033,
                      "src": "719:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage",
                        "typeString": "string storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1127,
                      "name": "_description",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1109,
                      "src": "744:12:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_memory_ptr",
                        "typeString": "string memory"
                      }
                    },
                    "src": "719:37:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "id": 1129,
                  "nodeType": "ExpressionStatement",
                  "src": "719:37:3"
                },
                {
                  "expression": {
                    "id": 1136,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1130,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "763:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1133,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "info",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2039,
                        "src": "763:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                          "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                        }
                      },
                      "id": 1134,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "bonusAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2035,
                      "src": "763:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1135,
                      "name": "_bonusAmount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1111,
                      "src": "788:12:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "763:37:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1137,
                  "nodeType": "ExpressionStatement",
                  "src": "763:37:3"
                },
                {
                  "expression": {
                    "id": 1142,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "id": 1138,
                        "name": "build",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1098,
                        "src": "807:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                          "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                        }
                      },
                      "id": 1140,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "creator",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2049,
                      "src": "807:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1141,
                      "name": "_creator",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1105,
                      "src": "823:8:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "src": "807:24:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "id": 1143,
                  "nodeType": "ExpressionStatement",
                  "src": "807:24:3"
                }
              ]
            },
            "id": 1145,
            "implemented": true,
            "kind": "constructor",
            "modifiers": [],
            "name": "",
            "nameLocation": "-1:-1:-1",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1112,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1105,
                  "mutability": "mutable",
                  "name": "_creator",
                  "nameLocation": "602:8:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1145,
                  "src": "594:16:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 1104,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "594:7:3",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1107,
                  "mutability": "mutable",
                  "name": "_name",
                  "nameLocation": "626:5:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1145,
                  "src": "612:19:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1106,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "612:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1109,
                  "mutability": "mutable",
                  "name": "_description",
                  "nameLocation": "647:12:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1145,
                  "src": "633:26:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1108,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "633:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1111,
                  "mutability": "mutable",
                  "name": "_bonusAmount",
                  "nameLocation": "666:12:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1145,
                  "src": "661:17:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1110,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "661:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "593:86:3"
            },
            "returnParameters": {
              "id": 1113,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "680:0:3"
            },
            "scope": 1994,
            "src": "582:255:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 1157,
              "nodeType": "Block",
              "src": "862:198:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        "id": 1152,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1148,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "971:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1149,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "creator",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2049,
                          "src": "971:13:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "expression": {
                            "id": 1150,
                            "name": "tx",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967270,
                            "src": "988:2:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_magic_transaction",
                              "typeString": "tx"
                            }
                          },
                          "id": 1151,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "origin",
                          "nodeType": "MemberAccess",
                          "src": "988:9:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "src": "971:26:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4d757374206265207468652063726561746f7220746f2061636365737320746869732066756e6374696f6e",
                        "id": 1153,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "999:45:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_879c16fa9785c28093236dad4c926abbcc4ddd1e24d5a113771878e901c54b25",
                          "typeString": "literal_string \"Must be the creator to access this function\""
                        },
                        "value": "Must be the creator to access this function"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_879c16fa9785c28093236dad4c926abbcc4ddd1e24d5a113771878e901c54b25",
                          "typeString": "literal_string \"Must be the creator to access this function\""
                        }
                      ],
                      "id": 1147,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "963:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1154,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "963:82:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1155,
                  "nodeType": "ExpressionStatement",
                  "src": "963:82:3"
                },
                {
                  "id": 1156,
                  "nodeType": "PlaceholderStatement",
                  "src": "1053:1:3"
                }
              ]
            },
            "id": 1158,
            "name": "isCreator",
            "nameLocation": "852:9:3",
            "nodeType": "ModifierDefinition",
            "parameters": {
              "id": 1146,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "862:0:3"
            },
            "src": "843:217:3",
            "virtual": false,
            "visibility": "internal"
          },
          {
            "body": {
              "id": 1172,
              "nodeType": "Block",
              "src": "1126:35:3",
              "statements": [
                {
                  "expression": {
                    "id": 1170,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "id": 1166,
                        "name": "build",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1098,
                        "src": "1133:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                          "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                        }
                      },
                      "id": 1168,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "status",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2047,
                      "src": "1133:12:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_enum$_Status_$2001",
                        "typeString": "enum SurveyInterface.Status"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1169,
                      "name": "_status",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1161,
                      "src": "1148:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_enum$_Status_$2001",
                        "typeString": "enum SurveyInterface.Status"
                      }
                    },
                    "src": "1133:22:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_Status_$2001",
                      "typeString": "enum SurveyInterface.Status"
                    }
                  },
                  "id": 1171,
                  "nodeType": "ExpressionStatement",
                  "src": "1133:22:3"
                }
              ]
            },
            "functionSelector": "f93bbb87",
            "id": 1173,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1164,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1163,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "1116:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "1116:9:3"
              }
            ],
            "name": "setSurveyStatus",
            "nameLocation": "1075:15:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1162,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1161,
                  "mutability": "mutable",
                  "name": "_status",
                  "nameLocation": "1098:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1173,
                  "src": "1091:14:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_enum$_Status_$2001",
                    "typeString": "enum SurveyInterface.Status"
                  },
                  "typeName": {
                    "id": 1160,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1159,
                      "name": "Status",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2001,
                      "src": "1091:6:3"
                    },
                    "referencedDeclaration": 2001,
                    "src": "1091:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_Status_$2001",
                      "typeString": "enum SurveyInterface.Status"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1090:16:3"
            },
            "returnParameters": {
              "id": 1165,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "1126:0:3"
            },
            "scope": 1994,
            "src": "1066:95:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "external"
          },
          {
            "anonymous": false,
            "id": 1177,
            "name": "Log",
            "nameLocation": "1173:3:3",
            "nodeType": "EventDefinition",
            "parameters": {
              "id": 1176,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1175,
                  "indexed": false,
                  "mutability": "mutable",
                  "name": "s",
                  "nameLocation": "1184:1:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1177,
                  "src": "1177:8:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1174,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "1177:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1176:10:3"
            },
            "src": "1167:20:3"
          },
          {
            "body": {
              "id": 1468,
              "nodeType": "Block",
              "src": "1312:2426:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1194,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1191,
                            "name": "_answers",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1185,
                            "src": "1327:8:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_array$_t_string_calldata_ptr_$dyn_calldata_ptr",
                              "typeString": "string calldata[] calldata"
                            }
                          },
                          "id": 1192,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "length",
                          "nodeType": "MemberAccess",
                          "src": "1327:15:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "id": 1193,
                          "name": "questionCount",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1086,
                          "src": "1346:13:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "src": "1327:32:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "416e7377657220737472696e6720617272617920646f6573206e6f74206d6174636820746865206c656e677468206f66207175657374696f6e73",
                        "id": 1195,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "1361:60:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_0cea1408d7a63a11331c6748505bc80cd60b8480f58c4c2651963f54f0b97c32",
                          "typeString": "literal_string \"Answer string array does not match the length of questions\""
                        },
                        "value": "Answer string array does not match the length of questions"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_0cea1408d7a63a11331c6748505bc80cd60b8480f58c4c2651963f54f0b97c32",
                          "typeString": "literal_string \"Answer string array does not match the length of questions\""
                        }
                      ],
                      "id": 1190,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "1319:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1196,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1319:103:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1197,
                  "nodeType": "ExpressionStatement",
                  "src": "1319:103:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 1203,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "nodeType": "UnaryOperation",
                        "operator": "!",
                        "prefix": true,
                        "src": "1489:29:3",
                        "subExpression": {
                          "arguments": [
                            {
                              "expression": {
                                "id": 1200,
                                "name": "tx",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 4294967270,
                                "src": "1508:2:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_magic_transaction",
                                  "typeString": "tx"
                                }
                              },
                              "id": 1201,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": false,
                              "lValueRequested": false,
                              "memberName": "origin",
                              "nodeType": "MemberAccess",
                              "src": "1508:9:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            ],
                            "id": 1199,
                            "name": "didUserTakeSurvey",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1993,
                            "src": "1490:17:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_view$_t_address_$returns$_t_bool_$",
                              "typeString": "function (address) view returns (bool)"
                            }
                          },
                          "id": 1202,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "1490:28:3",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "416c726561647920746f6f6b2074686520737572766579",
                        "id": 1204,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "1520:25:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_6ea6531dad0de6919871ea7d20ff474e1ecd8be9b63504d49bb651d3d627d724",
                          "typeString": "literal_string \"Already took the survey\""
                        },
                        "value": "Already took the survey"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_6ea6531dad0de6919871ea7d20ff474e1ecd8be9b63504d49bb651d3d627d724",
                          "typeString": "literal_string \"Already took the survey\""
                        }
                      ],
                      "id": 1198,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "1481:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1205,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1481:65:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1206,
                  "nodeType": "ExpressionStatement",
                  "src": "1481:65:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        "id": 1212,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1208,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "1623:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1209,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "creator",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2049,
                          "src": "1623:13:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "!=",
                        "rightExpression": {
                          "expression": {
                            "id": 1210,
                            "name": "tx",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967270,
                            "src": "1640:2:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_magic_transaction",
                              "typeString": "tx"
                            }
                          },
                          "id": 1211,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "origin",
                          "nodeType": "MemberAccess",
                          "src": "1640:9:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "src": "1623:26:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "43726561746f722063616e6e6f742074616b652074686520737572766579",
                        "id": 1213,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "1651:32:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_f1c7bbfa2aef84eacd6e1bcb3c18e7590c1327e2ba069b2e3ddeb1a8f62ded03",
                          "typeString": "literal_string \"Creator cannot take the survey\""
                        },
                        "value": "Creator cannot take the survey"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_f1c7bbfa2aef84eacd6e1bcb3c18e7590c1327e2ba069b2e3ddeb1a8f62ded03",
                          "typeString": "literal_string \"Creator cannot take the survey\""
                        }
                      ],
                      "id": 1207,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "1615:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1214,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1615:69:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1215,
                  "nodeType": "ExpressionStatement",
                  "src": "1615:69:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_enum$_Status_$2001",
                          "typeString": "enum SurveyInterface.Status"
                        },
                        "id": 1221,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1217,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "1733:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1218,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "status",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2047,
                          "src": "1733:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "expression": {
                            "id": 1219,
                            "name": "Status",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2001,
                            "src": "1749:6:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_enum$_Status_$2001_$",
                              "typeString": "type(enum SurveyInterface.Status)"
                            }
                          },
                          "id": 1220,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "memberName": "OPEN",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 1999,
                          "src": "1749:11:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "src": "1733:27:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "537572766579206973206e6f74206f70656e",
                        "id": 1222,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "1762:20:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_f0fab26ac02ca5c681c22c19f8d96f059af3b7216c3818e8ee0f9360e4cf614b",
                          "typeString": "literal_string \"Survey is not open\""
                        },
                        "value": "Survey is not open"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_f0fab26ac02ca5c681c22c19f8d96f059af3b7216c3818e8ee0f9360e4cf614b",
                          "typeString": "literal_string \"Survey is not open\""
                        }
                      ],
                      "id": 1216,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "1725:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1223,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1725:58:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1224,
                  "nodeType": "ExpressionStatement",
                  "src": "1725:58:3"
                },
                {
                  "assignments": [
                    1226
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1226,
                      "mutability": "mutable",
                      "name": "reward",
                      "nameLocation": "1843:6:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1468,
                      "src": "1838:11:3",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 1225,
                        "name": "uint",
                        "nodeType": "ElementaryTypeName",
                        "src": "1838:4:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1228,
                  "initialValue": {
                    "hexValue": "30",
                    "id": 1227,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "number",
                    "lValueRequested": false,
                    "nodeType": "Literal",
                    "src": "1852:1:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_rational_0_by_1",
                      "typeString": "int_const 0"
                    },
                    "value": "0"
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1838:15:3"
                },
                {
                  "assignments": [
                    1230
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1230,
                      "mutability": "mutable",
                      "name": "filled",
                      "nameLocation": "1866:6:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1468,
                      "src": "1860:12:3",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint8",
                        "typeString": "uint8"
                      },
                      "typeName": {
                        "id": 1229,
                        "name": "uint8",
                        "nodeType": "ElementaryTypeName",
                        "src": "1860:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint8",
                          "typeString": "uint8"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1232,
                  "initialValue": {
                    "hexValue": "30",
                    "id": 1231,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "number",
                    "lValueRequested": false,
                    "nodeType": "Literal",
                    "src": "1875:1:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_rational_0_by_1",
                      "typeString": "int_const 0"
                    },
                    "value": "0"
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1860:16:3"
                },
                {
                  "body": {
                    "id": 1281,
                    "nodeType": "Block",
                    "src": "1924:262:3",
                    "statements": [
                      {
                        "assignments": [
                          1245
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 1245,
                            "mutability": "mutable",
                            "name": "q",
                            "nameLocation": "1949:1:3",
                            "nodeType": "VariableDeclaration",
                            "scope": 1281,
                            "src": "1933:17:3",
                            "stateVariable": false,
                            "storageLocation": "memory",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                              "typeString": "struct SurveyInterface.Question"
                            },
                            "typeName": {
                              "id": 1244,
                              "nodeType": "UserDefinedTypeName",
                              "pathNode": {
                                "id": 1243,
                                "name": "Question",
                                "nodeType": "IdentifierPath",
                                "referencedDeclaration": 2020,
                                "src": "1933:8:3"
                              },
                              "referencedDeclaration": 2020,
                              "src": "1933:8:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_Question_$2020_storage_ptr",
                                "typeString": "struct SurveyInterface.Question"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 1249,
                        "initialValue": {
                          "baseExpression": {
                            "id": 1246,
                            "name": "questions",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1083,
                            "src": "1953:9:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_mapping$_t_uint256_$_t_struct$_Question_$2020_storage_$",
                              "typeString": "mapping(uint256 => struct SurveyInterface.Question storage ref)"
                            }
                          },
                          "id": 1248,
                          "indexExpression": {
                            "id": 1247,
                            "name": "i",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1234,
                            "src": "1963:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "nodeType": "IndexAccess",
                          "src": "1953:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Question_$2020_storage",
                            "typeString": "struct SurveyInterface.Question storage ref"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "1933:32:3"
                      },
                      {
                        "assignments": [
                          1251
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 1251,
                            "mutability": "mutable",
                            "name": "a",
                            "nameLocation": "1988:1:3",
                            "nodeType": "VariableDeclaration",
                            "scope": 1281,
                            "src": "1974:15:3",
                            "stateVariable": false,
                            "storageLocation": "memory",
                            "typeDescriptions": {
                              "typeIdentifier": "t_string_memory_ptr",
                              "typeString": "string"
                            },
                            "typeName": {
                              "id": 1250,
                              "name": "string",
                              "nodeType": "ElementaryTypeName",
                              "src": "1974:6:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_string_storage_ptr",
                                "typeString": "string"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 1255,
                        "initialValue": {
                          "baseExpression": {
                            "id": 1252,
                            "name": "_answers",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1185,
                            "src": "1992:8:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_array$_t_string_calldata_ptr_$dyn_calldata_ptr",
                              "typeString": "string calldata[] calldata"
                            }
                          },
                          "id": 1254,
                          "indexExpression": {
                            "id": 1253,
                            "name": "i",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1234,
                            "src": "2001:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "nodeType": "IndexAccess",
                          "src": "1992:11:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_string_calldata_ptr",
                            "typeString": "string calldata"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "1974:29:3"
                      },
                      {
                        "condition": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 1262,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "expression": {
                              "arguments": [
                                {
                                  "id": 1258,
                                  "name": "a",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1251,
                                  "src": "2022:1:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_string_memory_ptr",
                                    "typeString": "string memory"
                                  }
                                }
                              ],
                              "expression": {
                                "argumentTypes": [
                                  {
                                    "typeIdentifier": "t_string_memory_ptr",
                                    "typeString": "string memory"
                                  }
                                ],
                                "id": 1257,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": true,
                                "lValueRequested": false,
                                "nodeType": "ElementaryTypeNameExpression",
                                "src": "2016:5:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
                                  "typeString": "type(bytes storage pointer)"
                                },
                                "typeName": {
                                  "id": 1256,
                                  "name": "bytes",
                                  "nodeType": "ElementaryTypeName",
                                  "src": "2016:5:3",
                                  "typeDescriptions": {}
                                }
                              },
                              "id": 1259,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": false,
                              "kind": "typeConversion",
                              "lValueRequested": false,
                              "names": [],
                              "nodeType": "FunctionCall",
                              "src": "2016:8:3",
                              "tryCall": false,
                              "typeDescriptions": {
                                "typeIdentifier": "t_bytes_memory_ptr",
                                "typeString": "bytes memory"
                              }
                            },
                            "id": 1260,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "length",
                            "nodeType": "MemberAccess",
                            "src": "2016:15:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": ">",
                          "rightExpression": {
                            "hexValue": "30",
                            "id": 1261,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "kind": "number",
                            "lValueRequested": false,
                            "nodeType": "Literal",
                            "src": "2034:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_rational_0_by_1",
                              "typeString": "int_const 0"
                            },
                            "value": "0"
                          },
                          "src": "2016:19:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "falseBody": {
                          "condition": {
                            "expression": {
                              "id": 1272,
                              "name": "q",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1245,
                              "src": "2104:1:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                                "typeString": "struct SurveyInterface.Question memory"
                              }
                            },
                            "id": 1273,
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "required",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2012,
                            "src": "2104:10:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            }
                          },
                          "id": 1279,
                          "nodeType": "IfStatement",
                          "src": "2100:79:3",
                          "trueBody": {
                            "id": 1278,
                            "nodeType": "Block",
                            "src": "2116:63:3",
                            "statements": [
                              {
                                "expression": {
                                  "arguments": [
                                    {
                                      "hexValue": "5265717569726564207175657374696f6e206e6f742066696c6c6564206f7574",
                                      "id": 1275,
                                      "isConstant": false,
                                      "isLValue": false,
                                      "isPure": true,
                                      "kind": "string",
                                      "lValueRequested": false,
                                      "nodeType": "Literal",
                                      "src": "2134:34:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_stringliteral_04037c1c73b6df0138c0effd84a095632c6f0e3142cefd7669cea1e916bce893",
                                        "typeString": "literal_string \"Required question not filled out\""
                                      },
                                      "value": "Required question not filled out"
                                    }
                                  ],
                                  "expression": {
                                    "argumentTypes": [
                                      {
                                        "typeIdentifier": "t_stringliteral_04037c1c73b6df0138c0effd84a095632c6f0e3142cefd7669cea1e916bce893",
                                        "typeString": "literal_string \"Required question not filled out\""
                                      }
                                    ],
                                    "id": 1274,
                                    "name": "revert",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [
                                      4294967277,
                                      4294967277
                                    ],
                                    "referencedDeclaration": 4294967277,
                                    "src": "2127:6:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_function_revert_pure$_t_string_memory_ptr_$returns$__$",
                                      "typeString": "function (string memory) pure"
                                    }
                                  },
                                  "id": 1276,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "kind": "functionCall",
                                  "lValueRequested": false,
                                  "names": [],
                                  "nodeType": "FunctionCall",
                                  "src": "2127:42:3",
                                  "tryCall": false,
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_tuple$__$",
                                    "typeString": "tuple()"
                                  }
                                },
                                "id": 1277,
                                "nodeType": "ExpressionStatement",
                                "src": "2127:42:3"
                              }
                            ]
                          }
                        },
                        "id": 1280,
                        "nodeType": "IfStatement",
                        "src": "2012:167:3",
                        "trueBody": {
                          "id": 1271,
                          "nodeType": "Block",
                          "src": "2037:57:3",
                          "statements": [
                            {
                              "expression": {
                                "id": 1266,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "lValueRequested": false,
                                "leftHandSide": {
                                  "id": 1263,
                                  "name": "reward",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1226,
                                  "src": "2048:6:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "nodeType": "Assignment",
                                "operator": "+=",
                                "rightHandSide": {
                                  "expression": {
                                    "id": 1264,
                                    "name": "q",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 1245,
                                    "src": "2058:1:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                                      "typeString": "struct SurveyInterface.Question memory"
                                    }
                                  },
                                  "id": 1265,
                                  "isConstant": false,
                                  "isLValue": true,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "worth",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 2010,
                                  "src": "2058:7:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "src": "2048:17:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              "id": 1267,
                              "nodeType": "ExpressionStatement",
                              "src": "2048:17:3"
                            },
                            {
                              "expression": {
                                "id": 1269,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "lValueRequested": false,
                                "nodeType": "UnaryOperation",
                                "operator": "++",
                                "prefix": false,
                                "src": "2076:8:3",
                                "subExpression": {
                                  "id": 1268,
                                  "name": "filled",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1230,
                                  "src": "2076:6:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint8",
                                    "typeString": "uint8"
                                  }
                                },
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint8",
                                  "typeString": "uint8"
                                }
                              },
                              "id": 1270,
                              "nodeType": "ExpressionStatement",
                              "src": "2076:8:3"
                            }
                          ]
                        }
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1239,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1237,
                      "name": "i",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1234,
                      "src": "1900:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "id": 1238,
                      "name": "questionCount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1086,
                      "src": "1904:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1900:17:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1282,
                  "initializationExpression": {
                    "assignments": [
                      1234
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 1234,
                        "mutability": "mutable",
                        "name": "i",
                        "nameLocation": "1893:1:3",
                        "nodeType": "VariableDeclaration",
                        "scope": 1282,
                        "src": "1888:6:3",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 1233,
                          "name": "uint",
                          "nodeType": "ElementaryTypeName",
                          "src": "1888:4:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 1236,
                    "initialValue": {
                      "hexValue": "30",
                      "id": 1235,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "1897:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "nodeType": "VariableDeclarationStatement",
                    "src": "1888:10:3"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 1241,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "1919:3:3",
                      "subExpression": {
                        "id": 1240,
                        "name": "i",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1234,
                        "src": "1919:1:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 1242,
                    "nodeType": "ExpressionStatement",
                    "src": "1919:3:3"
                  },
                  "nodeType": "ForStatement",
                  "src": "1883:303:3"
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1285,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1283,
                      "name": "filled",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1230,
                      "src": "2196:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint8",
                        "typeString": "uint8"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 1284,
                      "name": "questionCount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1086,
                      "src": "2206:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2196:23:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1293,
                  "nodeType": "IfStatement",
                  "src": "2192:78:3",
                  "trueBody": {
                    "id": 1292,
                    "nodeType": "Block",
                    "src": "2221:49:3",
                    "statements": [
                      {
                        "expression": {
                          "id": 1290,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "id": 1286,
                            "name": "reward",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1226,
                            "src": "2230:6:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "+=",
                          "rightHandSide": {
                            "expression": {
                              "expression": {
                                "id": 1287,
                                "name": "build",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 1098,
                                "src": "2240:5:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                  "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                                }
                              },
                              "id": 1288,
                              "isConstant": false,
                              "isLValue": true,
                              "isPure": false,
                              "lValueRequested": false,
                              "memberName": "info",
                              "nodeType": "MemberAccess",
                              "referencedDeclaration": 2039,
                              "src": "2240:10:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                                "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                              }
                            },
                            "id": 1289,
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "bonusAmount",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2035,
                            "src": "2240:22:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "src": "2230:32:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "id": 1291,
                        "nodeType": "ExpressionStatement",
                        "src": "2230:32:3"
                      }
                    ]
                  }
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1299,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "id": 1295,
                          "name": "reward",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1226,
                          "src": "2355:6:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "<=",
                        "rightExpression": {
                          "expression": {
                            "expression": {
                              "id": 1296,
                              "name": "build",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1098,
                              "src": "2365:5:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                              }
                            },
                            "id": 1297,
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "pool",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2042,
                            "src": "2365:10:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                              "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                            }
                          },
                          "id": 1298,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "tokenAmount",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2022,
                          "src": "2365:22:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "src": "2355:32:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4e6f7420656e6f7567682072657761726420746f20676976652c2063616e63656c6c696e67207375626d697373696f6e2e",
                        "id": 1300,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2389:51:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_011cc548aef422f49ec5b449d0fed3dafc46f94a16900943c531cd7c2a55cecb",
                          "typeString": "literal_string \"Not enough reward to give, cancelling submission.\""
                        },
                        "value": "Not enough reward to give, cancelling submission."
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_011cc548aef422f49ec5b449d0fed3dafc46f94a16900943c531cd7c2a55cecb",
                          "typeString": "literal_string \"Not enough reward to give, cancelling submission.\""
                        }
                      ],
                      "id": 1294,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "2347:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1301,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2347:94:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1302,
                  "nodeType": "ExpressionStatement",
                  "src": "2347:94:3"
                },
                {
                  "expression": {
                    "id": 1311,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "baseExpression": {
                        "id": 1303,
                        "name": "userAnswers",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1095,
                        "src": "2450:11:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
                          "typeString": "mapping(address => uint256)"
                        }
                      },
                      "id": 1306,
                      "indexExpression": {
                        "expression": {
                          "id": 1304,
                          "name": "tx",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967270,
                          "src": "2462:2:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_transaction",
                            "typeString": "tx"
                          }
                        },
                        "id": 1305,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "origin",
                        "nodeType": "MemberAccess",
                        "src": "2462:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "nodeType": "IndexAccess",
                      "src": "2450:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "commonType": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "id": 1310,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "leftExpression": {
                        "expression": {
                          "id": 1307,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "2475:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1308,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "surveysTaken",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2044,
                        "src": "2475:18:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "nodeType": "BinaryOperation",
                      "operator": "+",
                      "rightExpression": {
                        "hexValue": "31",
                        "id": 1309,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "number",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2496:1:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_rational_1_by_1",
                          "typeString": "int_const 1"
                        },
                        "value": "1"
                      },
                      "src": "2475:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2450:47:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1312,
                  "nodeType": "ExpressionStatement",
                  "src": "2450:47:3"
                },
                {
                  "body": {
                    "id": 1346,
                    "nodeType": "Block",
                    "src": "2635:119:3",
                    "statements": [
                      {
                        "assignments": [
                          1325
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 1325,
                            "mutability": "mutable",
                            "name": "a",
                            "nameLocation": "2658:1:3",
                            "nodeType": "VariableDeclaration",
                            "scope": 1346,
                            "src": "2644:15:3",
                            "stateVariable": false,
                            "storageLocation": "memory",
                            "typeDescriptions": {
                              "typeIdentifier": "t_string_memory_ptr",
                              "typeString": "string"
                            },
                            "typeName": {
                              "id": 1324,
                              "name": "string",
                              "nodeType": "ElementaryTypeName",
                              "src": "2644:6:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_string_storage_ptr",
                                "typeString": "string"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 1329,
                        "initialValue": {
                          "baseExpression": {
                            "id": 1326,
                            "name": "_answers",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1185,
                            "src": "2662:8:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_array$_t_string_calldata_ptr_$dyn_calldata_ptr",
                              "typeString": "string calldata[] calldata"
                            }
                          },
                          "id": 1328,
                          "indexExpression": {
                            "id": 1327,
                            "name": "i",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1314,
                            "src": "2671:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "nodeType": "IndexAccess",
                          "src": "2662:11:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_string_calldata_ptr",
                            "typeString": "string calldata"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "2644:29:3"
                      },
                      {
                        "condition": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 1336,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "expression": {
                              "arguments": [
                                {
                                  "id": 1332,
                                  "name": "a",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1325,
                                  "src": "2692:1:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_string_memory_ptr",
                                    "typeString": "string memory"
                                  }
                                }
                              ],
                              "expression": {
                                "argumentTypes": [
                                  {
                                    "typeIdentifier": "t_string_memory_ptr",
                                    "typeString": "string memory"
                                  }
                                ],
                                "id": 1331,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": true,
                                "lValueRequested": false,
                                "nodeType": "ElementaryTypeNameExpression",
                                "src": "2686:5:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
                                  "typeString": "type(bytes storage pointer)"
                                },
                                "typeName": {
                                  "id": 1330,
                                  "name": "bytes",
                                  "nodeType": "ElementaryTypeName",
                                  "src": "2686:5:3",
                                  "typeDescriptions": {}
                                }
                              },
                              "id": 1333,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": false,
                              "kind": "typeConversion",
                              "lValueRequested": false,
                              "names": [],
                              "nodeType": "FunctionCall",
                              "src": "2686:8:3",
                              "tryCall": false,
                              "typeDescriptions": {
                                "typeIdentifier": "t_bytes_memory_ptr",
                                "typeString": "bytes memory"
                              }
                            },
                            "id": 1334,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "length",
                            "nodeType": "MemberAccess",
                            "src": "2686:15:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": ">",
                          "rightExpression": {
                            "hexValue": "30",
                            "id": 1335,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "kind": "number",
                            "lValueRequested": false,
                            "nodeType": "Literal",
                            "src": "2704:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_rational_0_by_1",
                              "typeString": "int_const 0"
                            },
                            "value": "0"
                          },
                          "src": "2686:19:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "id": 1345,
                        "nodeType": "IfStatement",
                        "src": "2682:65:3",
                        "trueBody": {
                          "id": 1344,
                          "nodeType": "Block",
                          "src": "2707:40:3",
                          "statements": [
                            {
                              "expression": {
                                "arguments": [
                                  {
                                    "id": 1341,
                                    "name": "a",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 1325,
                                    "src": "2734:1:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_string_memory_ptr",
                                      "typeString": "string memory"
                                    }
                                  }
                                ],
                                "expression": {
                                  "argumentTypes": [
                                    {
                                      "typeIdentifier": "t_string_memory_ptr",
                                      "typeString": "string memory"
                                    }
                                  ],
                                  "expression": {
                                    "baseExpression": {
                                      "id": 1337,
                                      "name": "answers",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 1091,
                                      "src": "2718:7:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_mapping$_t_uint256_$_t_array$_t_string_storage_$dyn_storage_$",
                                        "typeString": "mapping(uint256 => string storage ref[] storage ref)"
                                      }
                                    },
                                    "id": 1339,
                                    "indexExpression": {
                                      "id": 1338,
                                      "name": "i",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 1314,
                                      "src": "2726:1:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_uint256",
                                        "typeString": "uint256"
                                      }
                                    },
                                    "isConstant": false,
                                    "isLValue": true,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "nodeType": "IndexAccess",
                                    "src": "2718:10:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_array$_t_string_storage_$dyn_storage",
                                      "typeString": "string storage ref[] storage ref"
                                    }
                                  },
                                  "id": 1340,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "push",
                                  "nodeType": "MemberAccess",
                                  "src": "2718:15:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_arraypush_nonpayable$_t_array$_t_string_storage_$dyn_storage_ptr_$_t_string_storage_$returns$__$bound_to$_t_array$_t_string_storage_$dyn_storage_ptr_$",
                                    "typeString": "function (string storage ref[] storage pointer,string storage ref)"
                                  }
                                },
                                "id": 1342,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "2718:18:3",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_tuple$__$",
                                  "typeString": "tuple()"
                                }
                              },
                              "id": 1343,
                              "nodeType": "ExpressionStatement",
                              "src": "2718:18:3"
                            }
                          ]
                        }
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1320,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1317,
                      "name": "i",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1314,
                      "src": "2609:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "expression": {
                        "id": 1318,
                        "name": "_answers",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1185,
                        "src": "2613:8:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_string_calldata_ptr_$dyn_calldata_ptr",
                          "typeString": "string calldata[] calldata"
                        }
                      },
                      "id": 1319,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "length",
                      "nodeType": "MemberAccess",
                      "src": "2613:15:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2609:19:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1347,
                  "initializationExpression": {
                    "assignments": [
                      1314
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 1314,
                        "mutability": "mutable",
                        "name": "i",
                        "nameLocation": "2602:1:3",
                        "nodeType": "VariableDeclaration",
                        "scope": 1347,
                        "src": "2597:6:3",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 1313,
                          "name": "uint",
                          "nodeType": "ElementaryTypeName",
                          "src": "2597:4:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 1316,
                    "initialValue": {
                      "hexValue": "30",
                      "id": 1315,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "2606:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "nodeType": "VariableDeclarationStatement",
                    "src": "2597:10:3"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 1322,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "2630:3:3",
                      "subExpression": {
                        "id": 1321,
                        "name": "i",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1314,
                        "src": "2630:1:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 1323,
                    "nodeType": "ExpressionStatement",
                    "src": "2630:3:3"
                  },
                  "nodeType": "ForStatement",
                  "src": "2593:161:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "expression": {
                          "id": 1351,
                          "name": "tx",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967270,
                          "src": "2852:2:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_transaction",
                            "typeString": "tx"
                          }
                        },
                        "id": 1352,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "origin",
                        "nodeType": "MemberAccess",
                        "src": "2852:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 1353,
                        "name": "reward",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1226,
                        "src": "2863:6:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "expression": {
                        "id": 1348,
                        "name": "_token",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1182,
                        "src": "2836:6:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_Token_$2124",
                          "typeString": "contract Token"
                        }
                      },
                      "id": 1350,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "transfer",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2103,
                      "src": "2836:15:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
                        "typeString": "function (address,uint256) external returns (bool)"
                      }
                    },
                    "id": 1354,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2836:34:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1355,
                  "nodeType": "ExpressionStatement",
                  "src": "2836:34:3"
                },
                {
                  "expression": {
                    "id": 1362,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1356,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "2877:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1359,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "2877:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1360,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "tokenAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2022,
                      "src": "2877:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "-=",
                    "rightHandSide": {
                      "id": 1361,
                      "name": "reward",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1226,
                      "src": "2903:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2877:32:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1363,
                  "nodeType": "ExpressionStatement",
                  "src": "2877:32:3"
                },
                {
                  "expression": {
                    "id": 1370,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1364,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "2916:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1367,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "2916:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1368,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "totalTokensSent",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2028,
                      "src": "2916:26:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "+=",
                    "rightHandSide": {
                      "id": 1369,
                      "name": "reward",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1226,
                      "src": "2946:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2916:36:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1371,
                  "nodeType": "ExpressionStatement",
                  "src": "2916:36:3"
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1376,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "expression": {
                        "expression": {
                          "id": 1372,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "3008:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1373,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "3008:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1374,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "gasAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2024,
                      "src": "3008:20:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": ">",
                    "rightExpression": {
                      "hexValue": "30",
                      "id": 1375,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "3031:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "src": "3008:24:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1440,
                  "nodeType": "IfStatement",
                  "src": "3004:394:3",
                  "trueBody": {
                    "id": 1439,
                    "nodeType": "Block",
                    "src": "3034:364:3",
                    "statements": [
                      {
                        "assignments": [
                          1378
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 1378,
                            "mutability": "mutable",
                            "name": "diff",
                            "nameLocation": "3048:4:3",
                            "nodeType": "VariableDeclaration",
                            "scope": 1439,
                            "src": "3043:9:3",
                            "stateVariable": false,
                            "storageLocation": "default",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            },
                            "typeName": {
                              "id": 1377,
                              "name": "uint",
                              "nodeType": "ElementaryTypeName",
                              "src": "3043:4:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 1384,
                        "initialValue": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 1383,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "expression": {
                              "expression": {
                                "id": 1379,
                                "name": "build",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 1098,
                                "src": "3055:5:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                  "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                                }
                              },
                              "id": 1380,
                              "isConstant": false,
                              "isLValue": true,
                              "isPure": false,
                              "lValueRequested": false,
                              "memberName": "pool",
                              "nodeType": "MemberAccess",
                              "referencedDeclaration": 2042,
                              "src": "3055:10:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                                "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                              }
                            },
                            "id": 1381,
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "gasAmount",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2024,
                            "src": "3055:20:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": "-",
                          "rightExpression": {
                            "id": 1382,
                            "name": "_gas",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1179,
                            "src": "3078:4:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "src": "3055:27:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "3043:39:3"
                      },
                      {
                        "assignments": [
                          1386
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 1386,
                            "mutability": "mutable",
                            "name": "send",
                            "nameLocation": "3096:4:3",
                            "nodeType": "VariableDeclaration",
                            "scope": 1439,
                            "src": "3091:9:3",
                            "stateVariable": false,
                            "storageLocation": "default",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            },
                            "typeName": {
                              "id": 1385,
                              "name": "uint",
                              "nodeType": "ElementaryTypeName",
                              "src": "3091:4:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 1388,
                        "initialValue": {
                          "id": 1387,
                          "name": "_gas",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1179,
                          "src": "3103:4:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "3091:16:3"
                      },
                      {
                        "condition": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 1391,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "id": 1389,
                            "name": "diff",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1378,
                            "src": "3120:4:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": "<=",
                          "rightExpression": {
                            "hexValue": "30",
                            "id": 1390,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "kind": "number",
                            "lValueRequested": false,
                            "nodeType": "Literal",
                            "src": "3128:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_rational_0_by_1",
                              "typeString": "int_const 0"
                            },
                            "value": "0"
                          },
                          "src": "3120:9:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "id": 1399,
                        "nodeType": "IfStatement",
                        "src": "3116:63:3",
                        "trueBody": {
                          "id": 1398,
                          "nodeType": "Block",
                          "src": "3131:48:3",
                          "statements": [
                            {
                              "expression": {
                                "id": 1396,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "lValueRequested": false,
                                "leftHandSide": {
                                  "id": 1392,
                                  "name": "send",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1386,
                                  "src": "3142:4:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "nodeType": "Assignment",
                                "operator": "=",
                                "rightHandSide": {
                                  "expression": {
                                    "expression": {
                                      "id": 1393,
                                      "name": "build",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 1098,
                                      "src": "3149:5:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                                      }
                                    },
                                    "id": 1394,
                                    "isConstant": false,
                                    "isLValue": true,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "memberName": "pool",
                                    "nodeType": "MemberAccess",
                                    "referencedDeclaration": 2042,
                                    "src": "3149:10:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                                      "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                                    }
                                  },
                                  "id": 1395,
                                  "isConstant": false,
                                  "isLValue": true,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "gasAmount",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 2024,
                                  "src": "3149:20:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "src": "3142:27:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              "id": 1397,
                              "nodeType": "ExpressionStatement",
                              "src": "3142:27:3"
                            }
                          ]
                        }
                      },
                      {
                        "condition": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 1406,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "expression": {
                              "arguments": [
                                {
                                  "id": 1402,
                                  "name": "this",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 4294967268,
                                  "src": "3199:4:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_contract$_Survey_$1994",
                                    "typeString": "contract Survey"
                                  }
                                }
                              ],
                              "expression": {
                                "argumentTypes": [
                                  {
                                    "typeIdentifier": "t_contract$_Survey_$1994",
                                    "typeString": "contract Survey"
                                  }
                                ],
                                "id": 1401,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": true,
                                "lValueRequested": false,
                                "nodeType": "ElementaryTypeNameExpression",
                                "src": "3191:7:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_type$_t_address_$",
                                  "typeString": "type(address)"
                                },
                                "typeName": {
                                  "id": 1400,
                                  "name": "address",
                                  "nodeType": "ElementaryTypeName",
                                  "src": "3191:7:3",
                                  "typeDescriptions": {}
                                }
                              },
                              "id": 1403,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": false,
                              "kind": "typeConversion",
                              "lValueRequested": false,
                              "names": [],
                              "nodeType": "FunctionCall",
                              "src": "3191:13:3",
                              "tryCall": false,
                              "typeDescriptions": {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            },
                            "id": 1404,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "balance",
                            "nodeType": "MemberAccess",
                            "src": "3191:21:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": ">=",
                          "rightExpression": {
                            "id": 1405,
                            "name": "send",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1386,
                            "src": "3216:4:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "src": "3191:29:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "id": 1438,
                        "nodeType": "IfStatement",
                        "src": "3187:204:3",
                        "trueBody": {
                          "id": 1437,
                          "nodeType": "Block",
                          "src": "3222:169:3",
                          "statements": [
                            {
                              "assignments": [
                                1408
                              ],
                              "declarations": [
                                {
                                  "constant": false,
                                  "id": 1408,
                                  "mutability": "mutable",
                                  "name": "pa",
                                  "nameLocation": "3249:2:3",
                                  "nodeType": "VariableDeclaration",
                                  "scope": 1437,
                                  "src": "3233:18:3",
                                  "stateVariable": false,
                                  "storageLocation": "default",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_address_payable",
                                    "typeString": "address payable"
                                  },
                                  "typeName": {
                                    "id": 1407,
                                    "name": "address",
                                    "nodeType": "ElementaryTypeName",
                                    "src": "3233:15:3",
                                    "stateMutability": "payable",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_address_payable",
                                      "typeString": "address payable"
                                    }
                                  },
                                  "visibility": "internal"
                                }
                              ],
                              "id": 1414,
                              "initialValue": {
                                "arguments": [
                                  {
                                    "expression": {
                                      "id": 1411,
                                      "name": "tx",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 4294967270,
                                      "src": "3262:2:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_magic_transaction",
                                        "typeString": "tx"
                                      }
                                    },
                                    "id": 1412,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "memberName": "origin",
                                    "nodeType": "MemberAccess",
                                    "src": "3262:9:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_address",
                                      "typeString": "address"
                                    }
                                  }
                                ],
                                "expression": {
                                  "argumentTypes": [
                                    {
                                      "typeIdentifier": "t_address",
                                      "typeString": "address"
                                    }
                                  ],
                                  "id": 1410,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": true,
                                  "lValueRequested": false,
                                  "nodeType": "ElementaryTypeNameExpression",
                                  "src": "3254:8:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_type$_t_address_payable_$",
                                    "typeString": "type(address payable)"
                                  },
                                  "typeName": {
                                    "id": 1409,
                                    "name": "address",
                                    "nodeType": "ElementaryTypeName",
                                    "src": "3254:8:3",
                                    "stateMutability": "payable",
                                    "typeDescriptions": {}
                                  }
                                },
                                "id": 1413,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "typeConversion",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "3254:18:3",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_address_payable",
                                  "typeString": "address payable"
                                }
                              },
                              "nodeType": "VariableDeclarationStatement",
                              "src": "3233:39:3"
                            },
                            {
                              "expression": {
                                "arguments": [
                                  {
                                    "id": 1418,
                                    "name": "send",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 1386,
                                    "src": "3295:4:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_uint256",
                                      "typeString": "uint256"
                                    }
                                  }
                                ],
                                "expression": {
                                  "argumentTypes": [
                                    {
                                      "typeIdentifier": "t_uint256",
                                      "typeString": "uint256"
                                    }
                                  ],
                                  "expression": {
                                    "id": 1415,
                                    "name": "pa",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 1408,
                                    "src": "3283:2:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_address_payable",
                                      "typeString": "address payable"
                                    }
                                  },
                                  "id": 1417,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "transfer",
                                  "nodeType": "MemberAccess",
                                  "src": "3283:11:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
                                    "typeString": "function (uint256)"
                                  }
                                },
                                "id": 1419,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "3283:17:3",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_tuple$__$",
                                  "typeString": "tuple()"
                                }
                              },
                              "id": 1420,
                              "nodeType": "ExpressionStatement",
                              "src": "3283:17:3"
                            },
                            {
                              "expression": {
                                "id": 1427,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "lValueRequested": false,
                                "leftHandSide": {
                                  "expression": {
                                    "expression": {
                                      "id": 1421,
                                      "name": "build",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 1098,
                                      "src": "3311:5:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                                      }
                                    },
                                    "id": 1424,
                                    "isConstant": false,
                                    "isLValue": true,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "memberName": "pool",
                                    "nodeType": "MemberAccess",
                                    "referencedDeclaration": 2042,
                                    "src": "3311:10:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                                      "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                                    }
                                  },
                                  "id": 1425,
                                  "isConstant": false,
                                  "isLValue": true,
                                  "isPure": false,
                                  "lValueRequested": true,
                                  "memberName": "gasAmount",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 2024,
                                  "src": "3311:20:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "nodeType": "Assignment",
                                "operator": "-=",
                                "rightHandSide": {
                                  "id": 1426,
                                  "name": "send",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1386,
                                  "src": "3335:4:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "src": "3311:28:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              "id": 1428,
                              "nodeType": "ExpressionStatement",
                              "src": "3311:28:3"
                            },
                            {
                              "expression": {
                                "id": 1435,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "lValueRequested": false,
                                "leftHandSide": {
                                  "expression": {
                                    "expression": {
                                      "id": 1429,
                                      "name": "build",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 1098,
                                      "src": "3350:5:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                                      }
                                    },
                                    "id": 1432,
                                    "isConstant": false,
                                    "isLValue": true,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "memberName": "pool",
                                    "nodeType": "MemberAccess",
                                    "referencedDeclaration": 2042,
                                    "src": "3350:10:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                                      "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                                    }
                                  },
                                  "id": 1433,
                                  "isConstant": false,
                                  "isLValue": true,
                                  "isPure": false,
                                  "lValueRequested": true,
                                  "memberName": "totalGasSent",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 2026,
                                  "src": "3350:23:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "nodeType": "Assignment",
                                "operator": "+=",
                                "rightHandSide": {
                                  "id": 1434,
                                  "name": "send",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1386,
                                  "src": "3377:4:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "src": "3350:31:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              "id": 1436,
                              "nodeType": "ExpressionStatement",
                              "src": "3350:31:3"
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  "expression": {
                    "id": 1444,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "nodeType": "UnaryOperation",
                    "operator": "++",
                    "prefix": false,
                    "src": "3437:20:3",
                    "subExpression": {
                      "expression": {
                        "id": 1441,
                        "name": "build",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1098,
                        "src": "3437:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                          "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                        }
                      },
                      "id": 1443,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "surveysTaken",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2044,
                      "src": "3437:18:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1445,
                  "nodeType": "ExpressionStatement",
                  "src": "3437:20:3"
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1451,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "expression": {
                        "expression": {
                          "id": 1446,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "3585:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1447,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "3585:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1448,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "tokenAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2022,
                      "src": "3585:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "arguments": [],
                      "expression": {
                        "argumentTypes": [],
                        "id": 1449,
                        "name": "worth",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1613,
                        "src": "3610:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_internal_view$__$returns$_t_uint256_$",
                          "typeString": "function () view returns (uint256)"
                        }
                      },
                      "id": 1450,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "3610:7:3",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "3585:32:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1465,
                  "nodeType": "IfStatement",
                  "src": "3581:132:3",
                  "trueBody": {
                    "id": 1464,
                    "nodeType": "Block",
                    "src": "3619:94:3",
                    "statements": [
                      {
                        "expression": {
                          "id": 1457,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "expression": {
                              "id": 1452,
                              "name": "build",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1098,
                              "src": "3628:5:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                              }
                            },
                            "id": 1454,
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": true,
                            "memberName": "status",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2047,
                            "src": "3628:12:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_enum$_Status_$2001",
                              "typeString": "enum SurveyInterface.Status"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "=",
                          "rightHandSide": {
                            "expression": {
                              "id": 1455,
                              "name": "Status",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2001,
                              "src": "3643:6:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_type$_t_enum$_Status_$2001_$",
                                "typeString": "type(enum SurveyInterface.Status)"
                              }
                            },
                            "id": 1456,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "lValueRequested": false,
                            "memberName": "FINISHED",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2000,
                            "src": "3643:15:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_enum$_Status_$2001",
                              "typeString": "enum SurveyInterface.Status"
                            }
                          },
                          "src": "3628:30:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "id": 1458,
                        "nodeType": "ExpressionStatement",
                        "src": "3628:30:3"
                      },
                      {
                        "eventCall": {
                          "arguments": [
                            {
                              "expression": {
                                "id": 1460,
                                "name": "build",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 1098,
                                "src": "3692:5:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                  "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                                }
                              },
                              "id": 1461,
                              "isConstant": false,
                              "isLValue": true,
                              "isPure": false,
                              "lValueRequested": false,
                              "memberName": "status",
                              "nodeType": "MemberAccess",
                              "referencedDeclaration": 2047,
                              "src": "3692:12:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_enum$_Status_$2001",
                                "typeString": "enum SurveyInterface.Status"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_enum$_Status_$2001",
                                "typeString": "enum SurveyInterface.Status"
                              }
                            ],
                            "id": 1459,
                            "name": "SurveyStatusChanged",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1103,
                            "src": "3672:19:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_event_nonpayable$_t_enum$_Status_$2001_$returns$__$",
                              "typeString": "function (enum SurveyInterface.Status)"
                            }
                          },
                          "id": 1462,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "3672:33:3",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_tuple$__$",
                            "typeString": "tuple()"
                          }
                        },
                        "id": 1463,
                        "nodeType": "EmitStatement",
                        "src": "3667:38:3"
                      }
                    ]
                  }
                },
                {
                  "expression": {
                    "id": 1466,
                    "name": "reward",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1226,
                    "src": "3726:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 1189,
                  "id": 1467,
                  "nodeType": "Return",
                  "src": "3719:13:3"
                }
              ]
            },
            "functionSelector": "d6da669e",
            "id": 1469,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "submitSurvey",
            "nameLocation": "1202:12:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1186,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1179,
                  "mutability": "mutable",
                  "name": "_gas",
                  "nameLocation": "1226:4:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1469,
                  "src": "1221:9:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1178,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "1221:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1182,
                  "mutability": "mutable",
                  "name": "_token",
                  "nameLocation": "1243:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1469,
                  "src": "1237:12:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_contract$_Token_$2124",
                    "typeString": "contract Token"
                  },
                  "typeName": {
                    "id": 1181,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1180,
                      "name": "Token",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2124,
                      "src": "1237:5:3"
                    },
                    "referencedDeclaration": 2124,
                    "src": "1237:5:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_Token_$2124",
                      "typeString": "contract Token"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1185,
                  "mutability": "mutable",
                  "name": "_answers",
                  "nameLocation": "1274:8:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1469,
                  "src": "1256:26:3",
                  "stateVariable": false,
                  "storageLocation": "calldata",
                  "typeDescriptions": {
                    "typeIdentifier": "t_array$_t_string_calldata_ptr_$dyn_calldata_ptr",
                    "typeString": "string[]"
                  },
                  "typeName": {
                    "baseType": {
                      "id": 1183,
                      "name": "string",
                      "nodeType": "ElementaryTypeName",
                      "src": "1256:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage_ptr",
                        "typeString": "string"
                      }
                    },
                    "id": 1184,
                    "nodeType": "ArrayTypeName",
                    "src": "1256:8:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_string_storage_$dyn_storage_ptr",
                      "typeString": "string[]"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1214:73:3"
            },
            "returnParameters": {
              "id": 1189,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1188,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1469,
                  "src": "1306:4:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1187,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "1306:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1305:6:3"
            },
            "scope": 1994,
            "src": "1193:2545:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1478,
              "nodeType": "Block",
              "src": "3911:35:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "expression": {
                        "id": 1474,
                        "name": "build",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1098,
                        "src": "3925:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                          "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                        }
                      },
                      "id": 1475,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "info",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2039,
                      "src": "3925:10:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                        "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                      }
                    },
                    "id": 1476,
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "name",
                    "nodeType": "MemberAccess",
                    "referencedDeclaration": 2031,
                    "src": "3925:15:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "functionReturnParameters": 1473,
                  "id": 1477,
                  "nodeType": "Return",
                  "src": "3918:22:3"
                }
              ]
            },
            "functionSelector": "06fdde03",
            "id": 1479,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "name",
            "nameLocation": "3866:4:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1470,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "3870:2:3"
            },
            "returnParameters": {
              "id": 1473,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1472,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1479,
                  "src": "3896:13:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1471,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "3896:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3895:15:3"
            },
            "scope": 1994,
            "src": "3857:89:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1488,
              "nodeType": "Block",
              "src": "4122:42:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "expression": {
                        "id": 1484,
                        "name": "build",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1098,
                        "src": "4136:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                          "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                        }
                      },
                      "id": 1485,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "info",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2039,
                      "src": "4136:10:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                        "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                      }
                    },
                    "id": 1486,
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "bonusAmount",
                    "nodeType": "MemberAccess",
                    "referencedDeclaration": 2035,
                    "src": "4136:22:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 1483,
                  "id": 1487,
                  "nodeType": "Return",
                  "src": "4129:29:3"
                }
              ]
            },
            "functionSelector": "abadaf9a",
            "id": 1489,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "bonusAmount",
            "nameLocation": "4079:11:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1480,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4090:2:3"
            },
            "returnParameters": {
              "id": 1483,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1482,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1489,
                  "src": "4116:4:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1481,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "4116:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4115:6:3"
            },
            "scope": 1994,
            "src": "4070:94:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1497,
              "nodeType": "Block",
              "src": "4221:33:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "id": 1494,
                      "name": "build",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1098,
                      "src": "4235:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                      }
                    },
                    "id": 1495,
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "creator",
                    "nodeType": "MemberAccess",
                    "referencedDeclaration": 2049,
                    "src": "4235:13:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "functionReturnParameters": 1493,
                  "id": 1496,
                  "nodeType": "Return",
                  "src": "4228:20:3"
                }
              ]
            },
            "functionSelector": "02d05d3f",
            "id": 1498,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "creator",
            "nameLocation": "4179:7:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1490,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4186:2:3"
            },
            "returnParameters": {
              "id": 1493,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1492,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1498,
                  "src": "4212:7:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 1491,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "4212:7:3",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4211:9:3"
            },
            "scope": 1994,
            "src": "4170:84:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1507,
              "nodeType": "Block",
              "src": "4309:32:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "id": 1504,
                      "name": "build",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1098,
                      "src": "4323:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                      }
                    },
                    "id": 1505,
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "status",
                    "nodeType": "MemberAccess",
                    "referencedDeclaration": 2047,
                    "src": "4323:12:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_Status_$2001",
                      "typeString": "enum SurveyInterface.Status"
                    }
                  },
                  "functionReturnParameters": 1503,
                  "id": 1506,
                  "nodeType": "Return",
                  "src": "4316:19:3"
                }
              ]
            },
            "functionSelector": "200d2ed2",
            "id": 1508,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "status",
            "nameLocation": "4269:6:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1499,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4275:2:3"
            },
            "returnParameters": {
              "id": 1503,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1502,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1508,
                  "src": "4301:6:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_enum$_Status_$2001",
                    "typeString": "enum SurveyInterface.Status"
                  },
                  "typeName": {
                    "id": 1501,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1500,
                      "name": "Status",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2001,
                      "src": "4301:6:3"
                    },
                    "referencedDeclaration": 2001,
                    "src": "4301:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_Status_$2001",
                      "typeString": "enum SurveyInterface.Status"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4300:8:3"
            },
            "scope": 1994,
            "src": "4260:81:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1517,
              "nodeType": "Block",
              "src": "4406:30:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "id": 1514,
                      "name": "build",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1098,
                      "src": "4420:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                      }
                    },
                    "id": 1515,
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "info",
                    "nodeType": "MemberAccess",
                    "referencedDeclaration": 2039,
                    "src": "4420:10:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                      "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                    }
                  },
                  "functionReturnParameters": 1513,
                  "id": 1516,
                  "nodeType": "Return",
                  "src": "4413:17:3"
                }
              ]
            },
            "functionSelector": "370158ea",
            "id": 1518,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "info",
            "nameLocation": "4356:4:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1509,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4360:2:3"
            },
            "returnParameters": {
              "id": 1513,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1512,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1518,
                  "src": "4386:18:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_SurveyBasic_$2036_memory_ptr",
                    "typeString": "struct SurveyInterface.SurveyBasic"
                  },
                  "typeName": {
                    "id": 1511,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1510,
                      "name": "SurveyBasic",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2036,
                      "src": "4386:11:3"
                    },
                    "referencedDeclaration": 2036,
                    "src": "4386:11:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage_ptr",
                      "typeString": "struct SurveyInterface.SurveyBasic"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4385:20:3"
            },
            "scope": 1994,
            "src": "4347:89:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1527,
              "nodeType": "Block",
              "src": "4503:30:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "id": 1524,
                      "name": "build",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1098,
                      "src": "4517:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                      }
                    },
                    "id": 1525,
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "pool",
                    "nodeType": "MemberAccess",
                    "referencedDeclaration": 2042,
                    "src": "4517:10:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                      "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                    }
                  },
                  "functionReturnParameters": 1523,
                  "id": 1526,
                  "nodeType": "Return",
                  "src": "4510:17:3"
                }
              ]
            },
            "functionSelector": "16f0115b",
            "id": 1528,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "pool",
            "nameLocation": "4451:4:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1519,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4455:2:3"
            },
            "returnParameters": {
              "id": 1523,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1522,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1528,
                  "src": "4481:20:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_LiquidityPool_$2029_memory_ptr",
                    "typeString": "struct SurveyInterface.LiquidityPool"
                  },
                  "typeName": {
                    "id": 1521,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1520,
                      "name": "LiquidityPool",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2029,
                      "src": "4481:13:3"
                    },
                    "referencedDeclaration": 2029,
                    "src": "4481:13:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage_ptr",
                      "typeString": "struct SurveyInterface.LiquidityPool"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4480:22:3"
            },
            "scope": 1994,
            "src": "4442:91:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1539,
              "nodeType": "Block",
              "src": "4658:41:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "arguments": [
                        {
                          "id": 1535,
                          "name": "this",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967268,
                          "src": "4680:4:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_contract$_Survey_$1994",
                            "typeString": "contract Survey"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_contract$_Survey_$1994",
                            "typeString": "contract Survey"
                          }
                        ],
                        "id": 1534,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "nodeType": "ElementaryTypeNameExpression",
                        "src": "4672:7:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_address_$",
                          "typeString": "type(address)"
                        },
                        "typeName": {
                          "id": 1533,
                          "name": "address",
                          "nodeType": "ElementaryTypeName",
                          "src": "4672:7:3",
                          "typeDescriptions": {}
                        }
                      },
                      "id": 1536,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "typeConversion",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "4672:13:3",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "id": 1537,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "balance",
                    "nodeType": "MemberAccess",
                    "src": "4672:21:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 1532,
                  "id": 1538,
                  "nodeType": "Return",
                  "src": "4665:28:3"
                }
              ]
            },
            "functionSelector": "12065fe0",
            "id": 1540,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "getBalance",
            "nameLocation": "4616:10:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1529,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4626:2:3"
            },
            "returnParameters": {
              "id": 1532,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1531,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1540,
                  "src": "4652:4:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1530,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "4652:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4651:6:3"
            },
            "scope": 1994,
            "src": "4607:92:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1576,
              "nodeType": "Block",
              "src": "4774:407:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "hexValue": "30",
                        "id": 1547,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "number",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "4816:1:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_rational_0_by_1",
                          "typeString": "int_const 0"
                        },
                        "value": "0"
                      },
                      {
                        "arguments": [
                          {
                            "id": 1550,
                            "name": "this",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967268,
                            "src": "4840:4:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_contract$_Survey_$1994",
                              "typeString": "contract Survey"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_contract$_Survey_$1994",
                              "typeString": "contract Survey"
                            }
                          ],
                          "id": 1549,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "nodeType": "ElementaryTypeNameExpression",
                          "src": "4832:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_type$_t_address_$",
                            "typeString": "type(address)"
                          },
                          "typeName": {
                            "id": 1548,
                            "name": "address",
                            "nodeType": "ElementaryTypeName",
                            "src": "4832:7:3",
                            "typeDescriptions": {}
                          }
                        },
                        "id": 1551,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "typeConversion",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "4832:13:3",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "arguments": [],
                        "expression": {
                          "argumentTypes": [],
                          "id": 1552,
                          "name": "worth",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1613,
                          "src": "4861:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_function_internal_view$__$returns$_t_uint256_$",
                            "typeString": "function () view returns (uint256)"
                          }
                        },
                        "id": 1553,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "functionCall",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "4861:7:3",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "expression": {
                          "expression": {
                            "id": 1554,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "4890:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1555,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "info",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2039,
                          "src": "4890:10:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                            "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                          }
                        },
                        "id": 1556,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "bonusAmount",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2035,
                        "src": "4890:22:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "expression": {
                          "expression": {
                            "id": 1557,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "4927:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1558,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "info",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2039,
                          "src": "4927:10:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                            "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                          }
                        },
                        "id": 1559,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "name",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2031,
                        "src": "4927:15:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_storage",
                          "typeString": "string storage ref"
                        }
                      },
                      {
                        "expression": {
                          "expression": {
                            "id": 1560,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "4964:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1561,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "info",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2039,
                          "src": "4964:10:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                            "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                          }
                        },
                        "id": 1562,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "description",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2033,
                        "src": "4964:22:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_storage",
                          "typeString": "string storage ref"
                        }
                      },
                      {
                        "expression": {
                          "id": 1563,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "5003:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1564,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "status",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2047,
                        "src": "5003:12:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_enum$_Status_$2001",
                          "typeString": "enum SurveyInterface.Status"
                        }
                      },
                      {
                        "expression": {
                          "id": 1565,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "5031:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1566,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "surveysTaken",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2044,
                        "src": "5031:18:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "expression": {
                          "expression": {
                            "id": 1567,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "5067:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1568,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "pool",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2042,
                          "src": "5067:10:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                            "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                          }
                        },
                        "id": 1569,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "gasAmount",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2024,
                        "src": "5067:20:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "expression": {
                          "expression": {
                            "id": 1570,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "5108:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1571,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "pool",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2042,
                          "src": "5108:10:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                            "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                          }
                        },
                        "id": 1572,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "tokenAmount",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2022,
                        "src": "5108:22:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "id": 1573,
                        "name": "questionCount",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1086,
                        "src": "5154:13:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_rational_0_by_1",
                          "typeString": "int_const 0"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_string_storage",
                          "typeString": "string storage ref"
                        },
                        {
                          "typeIdentifier": "t_string_storage",
                          "typeString": "string storage ref"
                        },
                        {
                          "typeIdentifier": "t_enum$_Status_$2001",
                          "typeString": "enum SurveyInterface.Status"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "id": 1546,
                      "name": "SurveyOverview",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2074,
                      "src": "4788:14:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_type$_t_struct$_SurveyOverview_$2074_storage_ptr_$",
                        "typeString": "type(struct SurveyInterface.SurveyOverview storage pointer)"
                      }
                    },
                    "id": 1574,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "structConstructorCall",
                    "lValueRequested": false,
                    "names": [
                      "id",
                      "addr",
                      "worth",
                      "bonusAmount",
                      "name",
                      "description",
                      "status",
                      "taken",
                      "gasLeft",
                      "tokensLeft",
                      "questionCount"
                    ],
                    "nodeType": "FunctionCall",
                    "src": "4788:387:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_SurveyOverview_$2074_memory_ptr",
                      "typeString": "struct SurveyInterface.SurveyOverview memory"
                    }
                  },
                  "functionReturnParameters": 1545,
                  "id": 1575,
                  "nodeType": "Return",
                  "src": "4781:394:3"
                }
              ]
            },
            "functionSelector": "20443e8d",
            "id": 1577,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "getOverview",
            "nameLocation": "4714:11:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1541,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4725:2:3"
            },
            "returnParameters": {
              "id": 1545,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1544,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1577,
                  "src": "4751:21:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_SurveyOverview_$2074_memory_ptr",
                    "typeString": "struct SurveyInterface.SurveyOverview"
                  },
                  "typeName": {
                    "id": 1543,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1542,
                      "name": "SurveyOverview",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2074,
                      "src": "4751:14:3"
                    },
                    "referencedDeclaration": 2074,
                    "src": "4751:14:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_SurveyOverview_$2074_storage_ptr",
                      "typeString": "struct SurveyInterface.SurveyOverview"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4750:23:3"
            },
            "scope": 1994,
            "src": "4705:476:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1612,
              "nodeType": "Block",
              "src": "5231:155:3",
              "statements": [
                {
                  "assignments": [
                    1583
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1583,
                      "mutability": "mutable",
                      "name": "w",
                      "nameLocation": "5243:1:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1612,
                      "src": "5238:6:3",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 1582,
                        "name": "uint",
                        "nodeType": "ElementaryTypeName",
                        "src": "5238:4:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1585,
                  "initialValue": {
                    "hexValue": "30",
                    "id": 1584,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "number",
                    "lValueRequested": false,
                    "nodeType": "Literal",
                    "src": "5247:1:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_rational_0_by_1",
                      "typeString": "int_const 0"
                    },
                    "value": "0"
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "5238:10:3"
                },
                {
                  "body": {
                    "id": 1608,
                    "nodeType": "Block",
                    "src": "5296:70:3",
                    "statements": [
                      {
                        "assignments": [
                          1598
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 1598,
                            "mutability": "mutable",
                            "name": "q",
                            "nameLocation": "5321:1:3",
                            "nodeType": "VariableDeclaration",
                            "scope": 1608,
                            "src": "5305:17:3",
                            "stateVariable": false,
                            "storageLocation": "memory",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                              "typeString": "struct SurveyInterface.Question"
                            },
                            "typeName": {
                              "id": 1597,
                              "nodeType": "UserDefinedTypeName",
                              "pathNode": {
                                "id": 1596,
                                "name": "Question",
                                "nodeType": "IdentifierPath",
                                "referencedDeclaration": 2020,
                                "src": "5305:8:3"
                              },
                              "referencedDeclaration": 2020,
                              "src": "5305:8:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_Question_$2020_storage_ptr",
                                "typeString": "struct SurveyInterface.Question"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 1602,
                        "initialValue": {
                          "baseExpression": {
                            "id": 1599,
                            "name": "questions",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1083,
                            "src": "5325:9:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_mapping$_t_uint256_$_t_struct$_Question_$2020_storage_$",
                              "typeString": "mapping(uint256 => struct SurveyInterface.Question storage ref)"
                            }
                          },
                          "id": 1601,
                          "indexExpression": {
                            "id": 1600,
                            "name": "i",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1587,
                            "src": "5335:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "nodeType": "IndexAccess",
                          "src": "5325:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Question_$2020_storage",
                            "typeString": "struct SurveyInterface.Question storage ref"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "5305:32:3"
                      },
                      {
                        "expression": {
                          "id": 1606,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "id": 1603,
                            "name": "w",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1583,
                            "src": "5346:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "+=",
                          "rightHandSide": {
                            "expression": {
                              "id": 1604,
                              "name": "q",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1598,
                              "src": "5351:1:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                                "typeString": "struct SurveyInterface.Question memory"
                              }
                            },
                            "id": 1605,
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "worth",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2010,
                            "src": "5351:7:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "src": "5346:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "id": 1607,
                        "nodeType": "ExpressionStatement",
                        "src": "5346:12:3"
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1592,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1590,
                      "name": "i",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1587,
                      "src": "5272:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "id": 1591,
                      "name": "questionCount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1086,
                      "src": "5276:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "5272:17:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1609,
                  "initializationExpression": {
                    "assignments": [
                      1587
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 1587,
                        "mutability": "mutable",
                        "name": "i",
                        "nameLocation": "5265:1:3",
                        "nodeType": "VariableDeclaration",
                        "scope": 1609,
                        "src": "5260:6:3",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 1586,
                          "name": "uint",
                          "nodeType": "ElementaryTypeName",
                          "src": "5260:4:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 1589,
                    "initialValue": {
                      "hexValue": "30",
                      "id": 1588,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "5269:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "nodeType": "VariableDeclarationStatement",
                    "src": "5260:10:3"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 1594,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "5291:3:3",
                      "subExpression": {
                        "id": 1593,
                        "name": "i",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1587,
                        "src": "5291:1:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 1595,
                    "nodeType": "ExpressionStatement",
                    "src": "5291:3:3"
                  },
                  "nodeType": "ForStatement",
                  "src": "5255:111:3"
                },
                {
                  "expression": {
                    "id": 1610,
                    "name": "w",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1583,
                    "src": "5379:1:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 1581,
                  "id": 1611,
                  "nodeType": "Return",
                  "src": "5372:8:3"
                }
              ]
            },
            "functionSelector": "ad11c131",
            "id": 1613,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "worth",
            "nameLocation": "5196:5:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1578,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "5201:2:3"
            },
            "returnParameters": {
              "id": 1581,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1580,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1613,
                  "src": "5225:4:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1579,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "5225:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5224:6:3"
            },
            "scope": 1994,
            "src": "5187:199:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 1654,
              "nodeType": "Block",
              "src": "5458:185:3",
              "statements": [
                {
                  "assignments": [
                    1624
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1624,
                      "mutability": "mutable",
                      "name": "q",
                      "nameLocation": "5483:1:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1654,
                      "src": "5465:19:3",
                      "stateVariable": false,
                      "storageLocation": "memory",
                      "typeDescriptions": {
                        "typeIdentifier": "t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr",
                        "typeString": "struct SurveyInterface.Question[]"
                      },
                      "typeName": {
                        "baseType": {
                          "id": 1622,
                          "nodeType": "UserDefinedTypeName",
                          "pathNode": {
                            "id": 1621,
                            "name": "Question",
                            "nodeType": "IdentifierPath",
                            "referencedDeclaration": 2020,
                            "src": "5465:8:3"
                          },
                          "referencedDeclaration": 2020,
                          "src": "5465:8:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Question_$2020_storage_ptr",
                            "typeString": "struct SurveyInterface.Question"
                          }
                        },
                        "id": 1623,
                        "nodeType": "ArrayTypeName",
                        "src": "5465:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_struct$_Question_$2020_storage_$dyn_storage_ptr",
                          "typeString": "struct SurveyInterface.Question[]"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1631,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 1629,
                        "name": "questionCount",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1086,
                        "src": "5502:13:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "id": 1628,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "lValueRequested": false,
                      "nodeType": "NewExpression",
                      "src": "5487:14:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr_$",
                        "typeString": "function (uint256) pure returns (struct SurveyInterface.Question memory[] memory)"
                      },
                      "typeName": {
                        "baseType": {
                          "id": 1626,
                          "nodeType": "UserDefinedTypeName",
                          "pathNode": {
                            "id": 1625,
                            "name": "Question",
                            "nodeType": "IdentifierPath",
                            "referencedDeclaration": 2020,
                            "src": "5491:8:3"
                          },
                          "referencedDeclaration": 2020,
                          "src": "5491:8:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Question_$2020_storage_ptr",
                            "typeString": "struct SurveyInterface.Question"
                          }
                        },
                        "id": 1627,
                        "nodeType": "ArrayTypeName",
                        "src": "5491:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_struct$_Question_$2020_storage_$dyn_storage_ptr",
                          "typeString": "struct SurveyInterface.Question[]"
                        }
                      }
                    },
                    "id": 1630,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5487:29:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr",
                      "typeString": "struct SurveyInterface.Question memory[] memory"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "5465:51:3"
                },
                {
                  "body": {
                    "id": 1650,
                    "nodeType": "Block",
                    "src": "5579:44:3",
                    "statements": [
                      {
                        "expression": {
                          "id": 1648,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "baseExpression": {
                              "id": 1642,
                              "name": "q",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1624,
                              "src": "5588:1:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr",
                                "typeString": "struct SurveyInterface.Question memory[] memory"
                              }
                            },
                            "id": 1644,
                            "indexExpression": {
                              "id": 1643,
                              "name": "index",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1633,
                              "src": "5590:5:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": true,
                            "nodeType": "IndexAccess",
                            "src": "5588:8:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                              "typeString": "struct SurveyInterface.Question memory"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "=",
                          "rightHandSide": {
                            "baseExpression": {
                              "id": 1645,
                              "name": "questions",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1083,
                              "src": "5599:9:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_mapping$_t_uint256_$_t_struct$_Question_$2020_storage_$",
                                "typeString": "mapping(uint256 => struct SurveyInterface.Question storage ref)"
                              }
                            },
                            "id": 1647,
                            "indexExpression": {
                              "id": 1646,
                              "name": "index",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1633,
                              "src": "5609:5:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "nodeType": "IndexAccess",
                            "src": "5599:16:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_Question_$2020_storage",
                              "typeString": "struct SurveyInterface.Question storage ref"
                            }
                          },
                          "src": "5588:27:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                            "typeString": "struct SurveyInterface.Question memory"
                          }
                        },
                        "id": 1649,
                        "nodeType": "ExpressionStatement",
                        "src": "5588:27:3"
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1638,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1636,
                      "name": "index",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1633,
                      "src": "5547:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "id": 1637,
                      "name": "questionCount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1086,
                      "src": "5555:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "5547:21:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1651,
                  "initializationExpression": {
                    "assignments": [
                      1633
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 1633,
                        "mutability": "mutable",
                        "name": "index",
                        "nameLocation": "5536:5:3",
                        "nodeType": "VariableDeclaration",
                        "scope": 1651,
                        "src": "5528:13:3",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 1632,
                          "name": "uint256",
                          "nodeType": "ElementaryTypeName",
                          "src": "5528:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 1635,
                    "initialValue": {
                      "hexValue": "30",
                      "id": 1634,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "5544:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "nodeType": "VariableDeclarationStatement",
                    "src": "5528:17:3"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 1640,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "5570:7:3",
                      "subExpression": {
                        "id": 1639,
                        "name": "index",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1633,
                        "src": "5570:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 1641,
                    "nodeType": "ExpressionStatement",
                    "src": "5570:7:3"
                  },
                  "nodeType": "ForStatement",
                  "src": "5523:100:3"
                },
                {
                  "expression": {
                    "id": 1652,
                    "name": "q",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1624,
                    "src": "5636:1:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr",
                      "typeString": "struct SurveyInterface.Question memory[] memory"
                    }
                  },
                  "functionReturnParameters": 1619,
                  "id": 1653,
                  "nodeType": "Return",
                  "src": "5629:8:3"
                }
              ]
            },
            "functionSelector": "97221ab7",
            "id": 1655,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "getQuestions",
            "nameLocation": "5401:12:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1614,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "5413:2:3"
            },
            "returnParameters": {
              "id": 1619,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1618,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1655,
                  "src": "5439:17:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr",
                    "typeString": "struct SurveyInterface.Question[]"
                  },
                  "typeName": {
                    "baseType": {
                      "id": 1616,
                      "nodeType": "UserDefinedTypeName",
                      "pathNode": {
                        "id": 1615,
                        "name": "Question",
                        "nodeType": "IdentifierPath",
                        "referencedDeclaration": 2020,
                        "src": "5439:8:3"
                      },
                      "referencedDeclaration": 2020,
                      "src": "5439:8:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_Question_$2020_storage_ptr",
                        "typeString": "struct SurveyInterface.Question"
                      }
                    },
                    "id": 1617,
                    "nodeType": "ArrayTypeName",
                    "src": "5439:10:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_struct$_Question_$2020_storage_$dyn_storage_ptr",
                      "typeString": "struct SurveyInterface.Question[]"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5438:19:3"
            },
            "scope": 1994,
            "src": "5392:251:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1676,
              "nodeType": "Block",
              "src": "5729:64:3",
              "statements": [
                {
                  "assignments": [
                    1669
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1669,
                      "mutability": "mutable",
                      "name": "ret",
                      "nameLocation": "5752:3:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1676,
                      "src": "5736:19:3",
                      "stateVariable": false,
                      "storageLocation": "memory",
                      "typeDescriptions": {
                        "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                        "typeString": "string[]"
                      },
                      "typeName": {
                        "baseType": {
                          "id": 1667,
                          "name": "string",
                          "nodeType": "ElementaryTypeName",
                          "src": "5736:6:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_string_storage_ptr",
                            "typeString": "string"
                          }
                        },
                        "id": 1668,
                        "nodeType": "ArrayTypeName",
                        "src": "5736:8:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_string_storage_$dyn_storage_ptr",
                          "typeString": "string[]"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1673,
                  "initialValue": {
                    "baseExpression": {
                      "id": 1670,
                      "name": "answers",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1091,
                      "src": "5758:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_mapping$_t_uint256_$_t_array$_t_string_storage_$dyn_storage_$",
                        "typeString": "mapping(uint256 => string storage ref[] storage ref)"
                      }
                    },
                    "id": 1672,
                    "indexExpression": {
                      "id": 1671,
                      "name": "qid",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1657,
                      "src": "5766:3:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "nodeType": "IndexAccess",
                    "src": "5758:12:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_string_storage_$dyn_storage",
                      "typeString": "string storage ref[] storage ref"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "5736:34:3"
                },
                {
                  "expression": {
                    "id": 1674,
                    "name": "ret",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1669,
                    "src": "5784:3:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                      "typeString": "string memory[] memory"
                    }
                  },
                  "functionReturnParameters": 1664,
                  "id": 1675,
                  "nodeType": "Return",
                  "src": "5777:10:3"
                }
              ]
            },
            "functionSelector": "1e59e02a",
            "id": 1677,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1660,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1659,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "5693:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "5693:9:3"
              }
            ],
            "name": "getAnswers",
            "nameLocation": "5658:10:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1658,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1657,
                  "mutability": "mutable",
                  "name": "qid",
                  "nameLocation": "5674:3:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1677,
                  "src": "5669:8:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1656,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "5669:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5668:10:3"
            },
            "returnParameters": {
              "id": 1664,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1663,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1677,
                  "src": "5712:15:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                    "typeString": "string[]"
                  },
                  "typeName": {
                    "baseType": {
                      "id": 1661,
                      "name": "string",
                      "nodeType": "ElementaryTypeName",
                      "src": "5712:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage_ptr",
                        "typeString": "string"
                      }
                    },
                    "id": 1662,
                    "nodeType": "ArrayTypeName",
                    "src": "5712:8:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_string_storage_$dyn_storage_ptr",
                      "typeString": "string[]"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5711:17:3"
            },
            "scope": 1994,
            "src": "5649:144:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1721,
              "nodeType": "Block",
              "src": "6289:208:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_enum$_Status_$2001",
                          "typeString": "enum SurveyInterface.Status"
                        },
                        "id": 1693,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1689,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "6304:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1690,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "status",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2047,
                          "src": "6304:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "expression": {
                            "id": 1691,
                            "name": "Status",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2001,
                            "src": "6320:6:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_enum$_Status_$2001_$",
                              "typeString": "type(enum SurveyInterface.Status)"
                            }
                          },
                          "id": 1692,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "memberName": "NOT_OPENED",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 1998,
                          "src": "6320:17:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "src": "6304:33:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "537572766579206d75737420626520696e2065646974696e67207374616765",
                        "id": 1694,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "6339:33:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3",
                          "typeString": "literal_string \"Survey must be in editing stage\""
                        },
                        "value": "Survey must be in editing stage"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3",
                          "typeString": "literal_string \"Survey must be in editing stage\""
                        }
                      ],
                      "id": 1688,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "6296:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1695,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6296:77:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1696,
                  "nodeType": "ExpressionStatement",
                  "src": "6296:77:3"
                },
                {
                  "expression": {
                    "id": 1703,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1697,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "6380:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1700,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "info",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2039,
                        "src": "6380:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                          "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                        }
                      },
                      "id": 1701,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "name",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2031,
                      "src": "6380:15:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage",
                        "typeString": "string storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1702,
                      "name": "_name",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1679,
                      "src": "6398:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_memory_ptr",
                        "typeString": "string memory"
                      }
                    },
                    "src": "6380:23:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "id": 1704,
                  "nodeType": "ExpressionStatement",
                  "src": "6380:23:3"
                },
                {
                  "expression": {
                    "id": 1711,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1705,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "6410:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1708,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "info",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2039,
                        "src": "6410:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                          "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                        }
                      },
                      "id": 1709,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "description",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2033,
                      "src": "6410:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage",
                        "typeString": "string storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1710,
                      "name": "_description",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1681,
                      "src": "6435:12:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_memory_ptr",
                        "typeString": "string memory"
                      }
                    },
                    "src": "6410:37:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "id": 1712,
                  "nodeType": "ExpressionStatement",
                  "src": "6410:37:3"
                },
                {
                  "expression": {
                    "id": 1719,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1713,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "6454:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1716,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "info",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2039,
                        "src": "6454:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                          "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                        }
                      },
                      "id": 1717,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "bonusAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2035,
                      "src": "6454:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1718,
                      "name": "_bonusAmount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1683,
                      "src": "6479:12:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "6454:37:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1720,
                  "nodeType": "ExpressionStatement",
                  "src": "6454:37:3"
                }
              ]
            },
            "functionSelector": "1eea56a3",
            "id": 1722,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1686,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1685,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "6279:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "6279:9:3"
              }
            ],
            "name": "updateSurvey",
            "nameLocation": "6171:12:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1684,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1679,
                  "mutability": "mutable",
                  "name": "_name",
                  "nameLocation": "6204:5:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1722,
                  "src": "6190:19:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1678,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "6190:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1681,
                  "mutability": "mutable",
                  "name": "_description",
                  "nameLocation": "6230:12:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1722,
                  "src": "6216:26:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1680,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "6216:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1683,
                  "mutability": "mutable",
                  "name": "_bonusAmount",
                  "nameLocation": "6254:12:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1722,
                  "src": "6249:17:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1682,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "6249:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6183:88:3"
            },
            "returnParameters": {
              "id": 1687,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "6289:0:3"
            },
            "scope": 1994,
            "src": "6162:335:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 1769,
              "nodeType": "Block",
              "src": "6720:298:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_enum$_Status_$2001",
                          "typeString": "enum SurveyInterface.Status"
                        },
                        "id": 1748,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1744,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "6735:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1745,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "status",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2047,
                          "src": "6735:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "expression": {
                            "id": 1746,
                            "name": "Status",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2001,
                            "src": "6751:6:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_enum$_Status_$2001_$",
                              "typeString": "type(enum SurveyInterface.Status)"
                            }
                          },
                          "id": 1747,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "memberName": "NOT_OPENED",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 1998,
                          "src": "6751:17:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "src": "6735:33:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "537572766579206d75737420626520696e2065646974696e67207374616765",
                        "id": 1749,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "6770:33:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3",
                          "typeString": "literal_string \"Survey must be in editing stage\""
                        },
                        "value": "Survey must be in editing stage"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3",
                          "typeString": "literal_string \"Survey must be in editing stage\""
                        }
                      ],
                      "id": 1743,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "6727:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1750,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6727:77:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1751,
                  "nodeType": "ExpressionStatement",
                  "src": "6727:77:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 1753,
                        "name": "questionCount",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1086,
                        "src": "6834:13:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "id": 1754,
                        "name": "_qtypes",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1725,
                        "src": "6856:7:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_enum$_QuestionType_$2005",
                          "typeString": "enum SurveyInterface.QuestionType"
                        }
                      },
                      {
                        "id": 1755,
                        "name": "_worth",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1727,
                        "src": "6872:6:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "id": 1756,
                        "name": "_required",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1729,
                        "src": "6887:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "id": 1757,
                        "name": "_title",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1731,
                        "src": "6905:6:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      },
                      {
                        "id": 1758,
                        "name": "_qdescription",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1733,
                        "src": "6920:13:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      },
                      {
                        "id": 1759,
                        "name": "_choices",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1736,
                        "src": "6942:8:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                          "typeString": "string memory[] memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_enum$_QuestionType_$2005",
                          "typeString": "enum SurveyInterface.QuestionType"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        },
                        {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        },
                        {
                          "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                          "typeString": "string memory[] memory"
                        }
                      ],
                      "id": 1752,
                      "name": "updateQuestion",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1814,
                      "src": "6811:14:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$_t_enum$_QuestionType_$2005_$_t_uint256_$_t_bool_$_t_string_memory_ptr_$_t_string_memory_ptr_$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$returns$__$",
                        "typeString": "function (uint256,enum SurveyInterface.QuestionType,uint256,bool,string memory,string memory,string memory[] memory)"
                      }
                    },
                    "id": 1760,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6811:146:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1761,
                  "nodeType": "ExpressionStatement",
                  "src": "6811:146:3"
                },
                {
                  "expression": {
                    "id": 1763,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "nodeType": "UnaryOperation",
                    "operator": "++",
                    "prefix": false,
                    "src": "6964:15:3",
                    "subExpression": {
                      "id": 1762,
                      "name": "questionCount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1086,
                      "src": "6964:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1764,
                  "nodeType": "ExpressionStatement",
                  "src": "6964:15:3"
                },
                {
                  "expression": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1767,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1765,
                      "name": "questionCount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1086,
                      "src": "6995:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "-",
                    "rightExpression": {
                      "hexValue": "31",
                      "id": 1766,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "7011:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_1_by_1",
                        "typeString": "int_const 1"
                      },
                      "value": "1"
                    },
                    "src": "6995:17:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 1742,
                  "id": 1768,
                  "nodeType": "Return",
                  "src": "6988:24:3"
                }
              ]
            },
            "functionSelector": "482ff513",
            "id": 1770,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1739,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1738,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "6695:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "6695:9:3"
              }
            ],
            "name": "addQuestion",
            "nameLocation": "6512:11:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1737,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1725,
                  "mutability": "mutable",
                  "name": "_qtypes",
                  "nameLocation": "6543:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6530:20:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_enum$_QuestionType_$2005",
                    "typeString": "enum SurveyInterface.QuestionType"
                  },
                  "typeName": {
                    "id": 1724,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1723,
                      "name": "QuestionType",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2005,
                      "src": "6530:12:3"
                    },
                    "referencedDeclaration": 2005,
                    "src": "6530:12:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_QuestionType_$2005",
                      "typeString": "enum SurveyInterface.QuestionType"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1727,
                  "mutability": "mutable",
                  "name": "_worth",
                  "nameLocation": "6562:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6557:11:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1726,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "6557:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1729,
                  "mutability": "mutable",
                  "name": "_required",
                  "nameLocation": "6580:9:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6575:14:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bool",
                    "typeString": "bool"
                  },
                  "typeName": {
                    "id": 1728,
                    "name": "bool",
                    "nodeType": "ElementaryTypeName",
                    "src": "6575:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1731,
                  "mutability": "mutable",
                  "name": "_title",
                  "nameLocation": "6610:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6596:20:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1730,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "6596:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1733,
                  "mutability": "mutable",
                  "name": "_qdescription",
                  "nameLocation": "6637:13:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6623:27:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1732,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "6623:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1736,
                  "mutability": "mutable",
                  "name": "_choices",
                  "nameLocation": "6673:8:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6657:24:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                    "typeString": "string[]"
                  },
                  "typeName": {
                    "baseType": {
                      "id": 1734,
                      "name": "string",
                      "nodeType": "ElementaryTypeName",
                      "src": "6657:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage_ptr",
                        "typeString": "string"
                      }
                    },
                    "id": 1735,
                    "nodeType": "ArrayTypeName",
                    "src": "6657:8:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_string_storage_$dyn_storage_ptr",
                      "typeString": "string[]"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6523:163:3"
            },
            "returnParameters": {
              "id": 1742,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1741,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6714:4:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1740,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "6714:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6713:6:3"
            },
            "scope": 1994,
            "src": "6503:515:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 1813,
              "nodeType": "Block",
              "src": "7243:232:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_enum$_Status_$2001",
                          "typeString": "enum SurveyInterface.Status"
                        },
                        "id": 1796,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1792,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "7258:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1793,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "status",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2047,
                          "src": "7258:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "expression": {
                            "id": 1794,
                            "name": "Status",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2001,
                            "src": "7274:6:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_enum$_Status_$2001_$",
                              "typeString": "type(enum SurveyInterface.Status)"
                            }
                          },
                          "id": 1795,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "memberName": "NOT_OPENED",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 1998,
                          "src": "7274:17:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "src": "7258:33:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "537572766579206d75737420626520696e2065646974696e67207374616765",
                        "id": 1797,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "7293:33:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3",
                          "typeString": "literal_string \"Survey must be in editing stage\""
                        },
                        "value": "Survey must be in editing stage"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3",
                          "typeString": "literal_string \"Survey must be in editing stage\""
                        }
                      ],
                      "id": 1791,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "7250:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1798,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "7250:77:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1799,
                  "nodeType": "ExpressionStatement",
                  "src": "7250:77:3"
                },
                {
                  "expression": {
                    "id": 1811,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "baseExpression": {
                        "id": 1800,
                        "name": "questions",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1083,
                        "src": "7334:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_mapping$_t_uint256_$_t_struct$_Question_$2020_storage_$",
                          "typeString": "mapping(uint256 => struct SurveyInterface.Question storage ref)"
                        }
                      },
                      "id": 1802,
                      "indexExpression": {
                        "id": 1801,
                        "name": "_id",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1772,
                        "src": "7344:3:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "nodeType": "IndexAccess",
                      "src": "7334:14:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_Question_$2020_storage",
                        "typeString": "struct SurveyInterface.Question storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "arguments": [
                        {
                          "id": 1804,
                          "name": "_qtypes",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1775,
                          "src": "7368:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_QuestionType_$2005",
                            "typeString": "enum SurveyInterface.QuestionType"
                          }
                        },
                        {
                          "id": 1805,
                          "name": "_worth",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1777,
                          "src": "7384:6:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        {
                          "id": 1806,
                          "name": "_required",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1779,
                          "src": "7399:9:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        {
                          "id": 1807,
                          "name": "_title",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1781,
                          "src": "7417:6:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_string_memory_ptr",
                            "typeString": "string memory"
                          }
                        },
                        {
                          "id": 1808,
                          "name": "_qdescription",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1783,
                          "src": "7432:13:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_string_memory_ptr",
                            "typeString": "string memory"
                          }
                        },
                        {
                          "id": 1809,
                          "name": "_choices",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1786,
                          "src": "7454:8:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                            "typeString": "string memory[] memory"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_enum$_QuestionType_$2005",
                            "typeString": "enum SurveyInterface.QuestionType"
                          },
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          },
                          {
                            "typeIdentifier": "t_string_memory_ptr",
                            "typeString": "string memory"
                          },
                          {
                            "typeIdentifier": "t_string_memory_ptr",
                            "typeString": "string memory"
                          },
                          {
                            "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                            "typeString": "string memory[] memory"
                          }
                        ],
                        "id": 1803,
                        "name": "Question",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2020,
                        "src": "7351:8:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_struct$_Question_$2020_storage_ptr_$",
                          "typeString": "type(struct SurveyInterface.Question storage pointer)"
                        }
                      },
                      "id": 1810,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "structConstructorCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "7351:118:3",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                        "typeString": "struct SurveyInterface.Question memory"
                      }
                    },
                    "src": "7334:135:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_Question_$2020_storage",
                      "typeString": "struct SurveyInterface.Question storage ref"
                    }
                  },
                  "id": 1812,
                  "nodeType": "ExpressionStatement",
                  "src": "7334:135:3"
                }
              ]
            },
            "functionSelector": "4a4cd405",
            "id": 1814,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1789,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1788,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "7233:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "7233:9:3"
              }
            ],
            "name": "updateQuestion",
            "nameLocation": "7033:14:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1787,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1772,
                  "mutability": "mutable",
                  "name": "_id",
                  "nameLocation": "7059:3:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7054:8:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1771,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "7054:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1775,
                  "mutability": "mutable",
                  "name": "_qtypes",
                  "nameLocation": "7082:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7069:20:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_enum$_QuestionType_$2005",
                    "typeString": "enum SurveyInterface.QuestionType"
                  },
                  "typeName": {
                    "id": 1774,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1773,
                      "name": "QuestionType",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2005,
                      "src": "7069:12:3"
                    },
                    "referencedDeclaration": 2005,
                    "src": "7069:12:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_QuestionType_$2005",
                      "typeString": "enum SurveyInterface.QuestionType"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1777,
                  "mutability": "mutable",
                  "name": "_worth",
                  "nameLocation": "7101:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7096:11:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1776,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "7096:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1779,
                  "mutability": "mutable",
                  "name": "_required",
                  "nameLocation": "7119:9:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7114:14:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bool",
                    "typeString": "bool"
                  },
                  "typeName": {
                    "id": 1778,
                    "name": "bool",
                    "nodeType": "ElementaryTypeName",
                    "src": "7114:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1781,
                  "mutability": "mutable",
                  "name": "_title",
                  "nameLocation": "7149:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7135:20:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1780,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "7135:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1783,
                  "mutability": "mutable",
                  "name": "_qdescription",
                  "nameLocation": "7176:13:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7162:27:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1782,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "7162:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1786,
                  "mutability": "mutable",
                  "name": "_choices",
                  "nameLocation": "7212:8:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7196:24:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                    "typeString": "string[]"
                  },
                  "typeName": {
                    "baseType": {
                      "id": 1784,
                      "name": "string",
                      "nodeType": "ElementaryTypeName",
                      "src": "7196:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage_ptr",
                        "typeString": "string"
                      }
                    },
                    "id": 1785,
                    "nodeType": "ArrayTypeName",
                    "src": "7196:8:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_string_storage_$dyn_storage_ptr",
                      "typeString": "string[]"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "7047:178:3"
            },
            "returnParameters": {
              "id": 1790,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "7243:0:3"
            },
            "scope": 1994,
            "src": "7024:451:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 1851,
              "nodeType": "Block",
              "src": "7562:172:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1827,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "id": 1825,
                          "name": "_amount",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1819,
                          "src": "7577:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">",
                        "rightExpression": {
                          "hexValue": "30",
                          "id": 1826,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "number",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "7587:1:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_rational_0_by_1",
                            "typeString": "int_const 0"
                          },
                          "value": "0"
                        },
                        "src": "7577:11:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "616d6f756e742068617320746f2062652067726561746572207468616e207a65726f",
                        "id": 1828,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "7590:36:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        },
                        "value": "amount has to be greater than zero"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        }
                      ],
                      "id": 1824,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "7569:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1829,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "7569:58:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1830,
                  "nodeType": "ExpressionStatement",
                  "src": "7569:58:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "expression": {
                          "id": 1834,
                          "name": "tx",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967270,
                          "src": "7654:2:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_transaction",
                            "typeString": "tx"
                          }
                        },
                        "id": 1835,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "origin",
                        "nodeType": "MemberAccess",
                        "src": "7654:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "arguments": [
                          {
                            "id": 1838,
                            "name": "this",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967268,
                            "src": "7673:4:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_contract$_Survey_$1994",
                              "typeString": "contract Survey"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_contract$_Survey_$1994",
                              "typeString": "contract Survey"
                            }
                          ],
                          "id": 1837,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "nodeType": "ElementaryTypeNameExpression",
                          "src": "7665:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_type$_t_address_$",
                            "typeString": "type(address)"
                          },
                          "typeName": {
                            "id": 1836,
                            "name": "address",
                            "nodeType": "ElementaryTypeName",
                            "src": "7665:7:3",
                            "typeDescriptions": {}
                          }
                        },
                        "id": 1839,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "typeConversion",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "7665:13:3",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 1840,
                        "name": "_amount",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1819,
                        "src": "7680:7:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "expression": {
                        "id": 1831,
                        "name": "_token",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1817,
                        "src": "7634:6:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_Token_$2124",
                          "typeString": "contract Token"
                        }
                      },
                      "id": 1833,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "transferFrom",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2114,
                      "src": "7634:19:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_bool_$",
                        "typeString": "function (address,address,uint256) external returns (bool)"
                      }
                    },
                    "id": 1841,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "7634:54:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1842,
                  "nodeType": "ExpressionStatement",
                  "src": "7634:54:3"
                },
                {
                  "expression": {
                    "id": 1849,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1843,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "7695:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1846,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "7695:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1847,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "tokenAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2022,
                      "src": "7695:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "+=",
                    "rightHandSide": {
                      "id": 1848,
                      "name": "_amount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1819,
                      "src": "7721:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "7695:33:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1850,
                  "nodeType": "ExpressionStatement",
                  "src": "7695:33:3"
                }
              ]
            },
            "functionSelector": "38745a1c",
            "id": 1852,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1822,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1821,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "7552:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "7552:9:3"
              }
            ],
            "name": "depositToSurveyTokenPool",
            "nameLocation": "7490:24:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1820,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1817,
                  "mutability": "mutable",
                  "name": "_token",
                  "nameLocation": "7521:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1852,
                  "src": "7515:12:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_contract$_Token_$2124",
                    "typeString": "contract Token"
                  },
                  "typeName": {
                    "id": 1816,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1815,
                      "name": "Token",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2124,
                      "src": "7515:5:3"
                    },
                    "referencedDeclaration": 2124,
                    "src": "7515:5:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_Token_$2124",
                      "typeString": "contract Token"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1819,
                  "mutability": "mutable",
                  "name": "_amount",
                  "nameLocation": "7534:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1852,
                  "src": "7529:12:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1818,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "7529:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "7514:28:3"
            },
            "returnParameters": {
              "id": 1823,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "7562:0:3"
            },
            "scope": 1994,
            "src": "7481:253:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1874,
              "nodeType": "Block",
              "src": "7801:113:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1861,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1858,
                            "name": "msg",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967281,
                            "src": "7816:3:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_magic_message",
                              "typeString": "msg"
                            }
                          },
                          "id": 1859,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "value",
                          "nodeType": "MemberAccess",
                          "src": "7816:9:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">",
                        "rightExpression": {
                          "hexValue": "30",
                          "id": 1860,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "number",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "7828:1:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_rational_0_by_1",
                            "typeString": "int_const 0"
                          },
                          "value": "0"
                        },
                        "src": "7816:13:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "616d6f756e742068617320746f2062652067726561746572207468616e207a65726f",
                        "id": 1862,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "7831:36:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        },
                        "value": "amount has to be greater than zero"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        }
                      ],
                      "id": 1857,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "7808:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1863,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "7808:60:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1864,
                  "nodeType": "ExpressionStatement",
                  "src": "7808:60:3"
                },
                {
                  "expression": {
                    "id": 1872,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1865,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "7875:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1868,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "7875:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1869,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "gasAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2024,
                      "src": "7875:20:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "+=",
                    "rightHandSide": {
                      "expression": {
                        "id": 1870,
                        "name": "msg",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 4294967281,
                        "src": "7899:3:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_magic_message",
                          "typeString": "msg"
                        }
                      },
                      "id": 1871,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "value",
                      "nodeType": "MemberAccess",
                      "src": "7899:9:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "7875:33:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1873,
                  "nodeType": "ExpressionStatement",
                  "src": "7875:33:3"
                }
              ]
            },
            "functionSelector": "31767ffd",
            "id": 1875,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1855,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1854,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "7791:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "7791:9:3"
              }
            ],
            "name": "depositToSurveyGasPool",
            "nameLocation": "7749:22:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1853,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "7771:2:3"
            },
            "returnParameters": {
              "id": 1856,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "7801:0:3"
            },
            "scope": 1994,
            "src": "7740:174:3",
            "stateMutability": "payable",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1921,
              "nodeType": "Block",
              "src": "7998:263:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1888,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "id": 1886,
                          "name": "_amount",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1880,
                          "src": "8013:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">",
                        "rightExpression": {
                          "hexValue": "30",
                          "id": 1887,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "number",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "8023:1:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_rational_0_by_1",
                            "typeString": "int_const 0"
                          },
                          "value": "0"
                        },
                        "src": "8013:11:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "616d6f756e742068617320746f2062652067726561746572207468616e207a65726f",
                        "id": 1889,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "8026:36:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        },
                        "value": "amount has to be greater than zero"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        }
                      ],
                      "id": 1885,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "8005:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1890,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8005:58:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1891,
                  "nodeType": "ExpressionStatement",
                  "src": "8005:58:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1901,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "id": 1897,
                                  "name": "this",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 4294967268,
                                  "src": "8103:4:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_contract$_Survey_$1994",
                                    "typeString": "contract Survey"
                                  }
                                }
                              ],
                              "expression": {
                                "argumentTypes": [
                                  {
                                    "typeIdentifier": "t_contract$_Survey_$1994",
                                    "typeString": "contract Survey"
                                  }
                                ],
                                "id": 1896,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": true,
                                "lValueRequested": false,
                                "nodeType": "ElementaryTypeNameExpression",
                                "src": "8095:7:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_type$_t_address_$",
                                  "typeString": "type(address)"
                                },
                                "typeName": {
                                  "id": 1895,
                                  "name": "address",
                                  "nodeType": "ElementaryTypeName",
                                  "src": "8095:7:3",
                                  "typeDescriptions": {}
                                }
                              },
                              "id": 1898,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": false,
                              "kind": "typeConversion",
                              "lValueRequested": false,
                              "names": [],
                              "nodeType": "FunctionCall",
                              "src": "8095:13:3",
                              "tryCall": false,
                              "typeDescriptions": {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            ],
                            "expression": {
                              "id": 1893,
                              "name": "_token",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1878,
                              "src": "8078:6:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_contract$_Token_$2124",
                                "typeString": "contract Token"
                              }
                            },
                            "id": 1894,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "balanceOf",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2085,
                            "src": "8078:16:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_external_view$_t_address_$returns$_t_uint256_$",
                              "typeString": "function (address) view external returns (uint256)"
                            }
                          },
                          "id": 1899,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "8078:31:3",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">=",
                        "rightExpression": {
                          "id": 1900,
                          "name": "_amount",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1880,
                          "src": "8113:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "src": "8078:42:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "42616c616e63652068617320746f206265203e3d207468616e2074686520616d6f756e7420746f207769746864726177",
                        "id": 1902,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "8122:50:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_951ece5d5af66174f14cd35238da3522fbecff682f2440d776cb968d376dbcbf",
                          "typeString": "literal_string \"Balance has to be >= than the amount to withdraw\""
                        },
                        "value": "Balance has to be >= than the amount to withdraw"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_951ece5d5af66174f14cd35238da3522fbecff682f2440d776cb968d376dbcbf",
                          "typeString": "literal_string \"Balance has to be >= than the amount to withdraw\""
                        }
                      ],
                      "id": 1892,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "8070:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1903,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8070:103:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1904,
                  "nodeType": "ExpressionStatement",
                  "src": "8070:103:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "expression": {
                          "id": 1908,
                          "name": "tx",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967270,
                          "src": "8196:2:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_transaction",
                            "typeString": "tx"
                          }
                        },
                        "id": 1909,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "origin",
                        "nodeType": "MemberAccess",
                        "src": "8196:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 1910,
                        "name": "_amount",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1880,
                        "src": "8207:7:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "expression": {
                        "id": 1905,
                        "name": "_token",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1878,
                        "src": "8180:6:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_Token_$2124",
                          "typeString": "contract Token"
                        }
                      },
                      "id": 1907,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "transfer",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2103,
                      "src": "8180:15:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
                        "typeString": "function (address,uint256) external returns (bool)"
                      }
                    },
                    "id": 1911,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8180:35:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1912,
                  "nodeType": "ExpressionStatement",
                  "src": "8180:35:3"
                },
                {
                  "expression": {
                    "id": 1919,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1913,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "8222:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1916,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "8222:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1917,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "tokenAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2022,
                      "src": "8222:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "-=",
                    "rightHandSide": {
                      "id": 1918,
                      "name": "_amount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1880,
                      "src": "8248:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "8222:33:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1920,
                  "nodeType": "ExpressionStatement",
                  "src": "8222:33:3"
                }
              ]
            },
            "functionSelector": "1275b3bb",
            "id": 1922,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1883,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1882,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "7988:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "7988:9:3"
              }
            ],
            "name": "withdrawFromTokenPool",
            "nameLocation": "7929:21:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1881,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1878,
                  "mutability": "mutable",
                  "name": "_token",
                  "nameLocation": "7957:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1922,
                  "src": "7951:12:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_contract$_Token_$2124",
                    "typeString": "contract Token"
                  },
                  "typeName": {
                    "id": 1877,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1876,
                      "name": "Token",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2124,
                      "src": "7951:5:3"
                    },
                    "referencedDeclaration": 2124,
                    "src": "7951:5:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_Token_$2124",
                      "typeString": "contract Token"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1880,
                  "mutability": "mutable",
                  "name": "_amount",
                  "nameLocation": "7970:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1922,
                  "src": "7965:12:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1879,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "7965:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "7950:28:3"
            },
            "returnParameters": {
              "id": 1884,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "7998:0:3"
            },
            "scope": 1994,
            "src": "7920:341:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1969,
              "nodeType": "Block",
              "src": "8329:288:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1932,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "id": 1930,
                          "name": "_amount",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1924,
                          "src": "8344:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">",
                        "rightExpression": {
                          "hexValue": "30",
                          "id": 1931,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "number",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "8354:1:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_rational_0_by_1",
                            "typeString": "int_const 0"
                          },
                          "value": "0"
                        },
                        "src": "8344:11:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "616d6f756e742068617320746f2062652067726561746572207468616e207a65726f",
                        "id": 1933,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "8357:36:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        },
                        "value": "amount has to be greater than zero"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        }
                      ],
                      "id": 1929,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "8336:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1934,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8336:58:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1935,
                  "nodeType": "ExpressionStatement",
                  "src": "8336:58:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1943,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "arguments": [
                              {
                                "id": 1939,
                                "name": "this",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 4294967268,
                                "src": "8417:4:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_contract$_Survey_$1994",
                                  "typeString": "contract Survey"
                                }
                              }
                            ],
                            "expression": {
                              "argumentTypes": [
                                {
                                  "typeIdentifier": "t_contract$_Survey_$1994",
                                  "typeString": "contract Survey"
                                }
                              ],
                              "id": 1938,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": true,
                              "lValueRequested": false,
                              "nodeType": "ElementaryTypeNameExpression",
                              "src": "8409:7:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_type$_t_address_$",
                                "typeString": "type(address)"
                              },
                              "typeName": {
                                "id": 1937,
                                "name": "address",
                                "nodeType": "ElementaryTypeName",
                                "src": "8409:7:3",
                                "typeDescriptions": {}
                              }
                            },
                            "id": 1940,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "kind": "typeConversion",
                            "lValueRequested": false,
                            "names": [],
                            "nodeType": "FunctionCall",
                            "src": "8409:13:3",
                            "tryCall": false,
                            "typeDescriptions": {
                              "typeIdentifier": "t_address",
                              "typeString": "address"
                            }
                          },
                          "id": 1941,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "balance",
                          "nodeType": "MemberAccess",
                          "src": "8409:21:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">=",
                        "rightExpression": {
                          "id": 1942,
                          "name": "_amount",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1924,
                          "src": "8434:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "src": "8409:32:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "42616c616e63652068617320746f206265203e3d207468616e2074686520616d6f756e7420746f207769746864726177",
                        "id": 1944,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "8443:50:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_951ece5d5af66174f14cd35238da3522fbecff682f2440d776cb968d376dbcbf",
                          "typeString": "literal_string \"Balance has to be >= than the amount to withdraw\""
                        },
                        "value": "Balance has to be >= than the amount to withdraw"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_951ece5d5af66174f14cd35238da3522fbecff682f2440d776cb968d376dbcbf",
                          "typeString": "literal_string \"Balance has to be >= than the amount to withdraw\""
                        }
                      ],
                      "id": 1936,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "8401:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1945,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8401:93:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1946,
                  "nodeType": "ExpressionStatement",
                  "src": "8401:93:3"
                },
                {
                  "assignments": [
                    1948
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1948,
                      "mutability": "mutable",
                      "name": "_addr",
                      "nameLocation": "8517:5:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1969,
                      "src": "8501:21:3",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address_payable",
                        "typeString": "address payable"
                      },
                      "typeName": {
                        "id": 1947,
                        "name": "address",
                        "nodeType": "ElementaryTypeName",
                        "src": "8501:15:3",
                        "stateMutability": "payable",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address_payable",
                          "typeString": "address payable"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1954,
                  "initialValue": {
                    "arguments": [
                      {
                        "expression": {
                          "id": 1951,
                          "name": "tx",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967270,
                          "src": "8533:2:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_transaction",
                            "typeString": "tx"
                          }
                        },
                        "id": 1952,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "origin",
                        "nodeType": "MemberAccess",
                        "src": "8533:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 1950,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "lValueRequested": false,
                      "nodeType": "ElementaryTypeNameExpression",
                      "src": "8525:8:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_type$_t_address_payable_$",
                        "typeString": "type(address payable)"
                      },
                      "typeName": {
                        "id": 1949,
                        "name": "address",
                        "nodeType": "ElementaryTypeName",
                        "src": "8525:8:3",
                        "stateMutability": "payable",
                        "typeDescriptions": {}
                      }
                    },
                    "id": 1953,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "typeConversion",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8525:18:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_address_payable",
                      "typeString": "address payable"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "8501:42:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 1958,
                        "name": "_amount",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1924,
                        "src": "8565:7:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "expression": {
                        "id": 1955,
                        "name": "_addr",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1948,
                        "src": "8550:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address_payable",
                          "typeString": "address payable"
                        }
                      },
                      "id": 1957,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "transfer",
                      "nodeType": "MemberAccess",
                      "src": "8550:14:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
                        "typeString": "function (uint256)"
                      }
                    },
                    "id": 1959,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8550:23:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1960,
                  "nodeType": "ExpressionStatement",
                  "src": "8550:23:3"
                },
                {
                  "expression": {
                    "id": 1967,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1961,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "8580:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1964,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "8580:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1965,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "gasAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2024,
                      "src": "8580:20:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "-=",
                    "rightHandSide": {
                      "id": 1966,
                      "name": "_amount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1924,
                      "src": "8604:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "8580:31:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1968,
                  "nodeType": "ExpressionStatement",
                  "src": "8580:31:3"
                }
              ]
            },
            "functionSelector": "8e6b582f",
            "id": 1970,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1927,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1926,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "8319:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "8319:9:3"
              }
            ],
            "name": "withdrawFromGasPool",
            "nameLocation": "8276:19:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1925,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1924,
                  "mutability": "mutable",
                  "name": "_amount",
                  "nameLocation": "8301:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1970,
                  "src": "8296:12:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1923,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "8296:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "8295:14:3"
            },
            "returnParameters": {
              "id": 1928,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "8329:0:3"
            },
            "scope": 1994,
            "src": "8267:350:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1992,
              "nodeType": "Block",
              "src": "8692:112:3",
              "statements": [
                {
                  "assignments": [
                    1978
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1978,
                      "mutability": "mutable",
                      "name": "index",
                      "nameLocation": "8704:5:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1992,
                      "src": "8699:10:3",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 1977,
                        "name": "uint",
                        "nodeType": "ElementaryTypeName",
                        "src": "8699:4:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1982,
                  "initialValue": {
                    "baseExpression": {
                      "id": 1979,
                      "name": "userAnswers",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1095,
                      "src": "8712:11:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
                        "typeString": "mapping(address => uint256)"
                      }
                    },
                    "id": 1981,
                    "indexExpression": {
                      "id": 1980,
                      "name": "_addr",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1972,
                      "src": "8724:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "nodeType": "IndexAccess",
                    "src": "8712:18:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "8699:31:3"
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1985,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1983,
                      "name": "index",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1978,
                      "src": "8741:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": ">",
                    "rightExpression": {
                      "hexValue": "30",
                      "id": 1984,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "8749:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "src": "8741:9:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1989,
                  "nodeType": "IfStatement",
                  "src": "8737:43:3",
                  "trueBody": {
                    "id": 1988,
                    "nodeType": "Block",
                    "src": "8752:28:3",
                    "statements": [
                      {
                        "expression": {
                          "hexValue": "74727565",
                          "id": 1986,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "bool",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "8768:4:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          },
                          "value": "true"
                        },
                        "functionReturnParameters": 1976,
                        "id": 1987,
                        "nodeType": "Return",
                        "src": "8761:11:3"
                      }
                    ]
                  }
                },
                {
                  "expression": {
                    "hexValue": "66616c7365",
                    "id": 1990,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "bool",
                    "lValueRequested": false,
                    "nodeType": "Literal",
                    "src": "8793:5:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    },
                    "value": "false"
                  },
                  "functionReturnParameters": 1976,
                  "id": 1991,
                  "nodeType": "Return",
                  "src": "8786:12:3"
                }
              ]
            },
            "functionSelector": "8beeef2b",
            "id": 1993,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "didUserTakeSurvey",
            "nameLocation": "8632:17:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1973,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1972,
                  "mutability": "mutable",
                  "name": "_addr",
                  "nameLocation": "8658:5:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1993,
                  "src": "8650:13:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 1971,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "8650:7:3",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "8649:15:3"
            },
            "returnParameters": {
              "id": 1976,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1975,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1993,
                  "src": "8686:4:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bool",
                    "typeString": "bool"
                  },
                  "typeName": {
                    "id": 1974,
                    "name": "bool",
                    "nodeType": "ElementaryTypeName",
                    "src": "8686:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "8685:6:3"
            },
            "scope": 1994,
            "src": "8623:181:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "public"
          }
        ],
        "scope": 1995,
        "src": "154:8653:3",
        "usedErrors": []
      }
    ],
    "src": "33:8776:3"
  },
  "legacyAST": {
    "absolutePath": "project:/contracts/Survey.sol",
    "exportedSymbols": {
      "Survey": [
        1994
      ],
      "SurveyInterface": [
        2075
      ],
      "Token": [
        2124
      ]
    },
    "id": 1995,
    "license": "MIT",
    "nodeType": "SourceUnit",
    "nodes": [
      {
        "id": 1073,
        "literals": [
          "experimental",
          "ABIEncoderV2"
        ],
        "nodeType": "PragmaDirective",
        "src": "33:33:3"
      },
      {
        "id": 1074,
        "literals": [
          "solidity",
          ">=",
          "0.6",
          ".0"
        ],
        "nodeType": "PragmaDirective",
        "src": "68:24:3"
      },
      {
        "absolutePath": "project:/contracts/SurveyInterface.sol",
        "file": "./SurveyInterface.sol",
        "id": 1075,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 1995,
        "sourceUnit": 2076,
        "src": "96:31:3",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "project:/contracts/Token.sol",
        "file": "./Token.sol",
        "id": 1076,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 1995,
        "sourceUnit": 2125,
        "src": "129:21:3",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "abstract": false,
        "baseContracts": [
          {
            "baseName": {
              "id": 1077,
              "name": "SurveyInterface",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 2075,
              "src": "173:15:3"
            },
            "id": 1078,
            "nodeType": "InheritanceSpecifier",
            "src": "173:15:3"
          }
        ],
        "contractDependencies": [],
        "contractKind": "contract",
        "fullyImplemented": true,
        "id": 1994,
        "linearizedBaseContracts": [
          1994,
          2075
        ],
        "name": "Survey",
        "nameLocation": "163:6:3",
        "nodeType": "ContractDefinition",
        "nodes": [
          {
            "constant": false,
            "functionSelector": "31b1b978",
            "id": 1083,
            "mutability": "mutable",
            "name": "questions",
            "nameLocation": "343:9:3",
            "nodeType": "VariableDeclaration",
            "scope": 1994,
            "src": "310:42:3",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_uint256_$_t_struct$_Question_$2020_storage_$",
              "typeString": "mapping(uint256 => struct SurveyInterface.Question)"
            },
            "typeName": {
              "id": 1082,
              "keyType": {
                "id": 1079,
                "name": "uint",
                "nodeType": "ElementaryTypeName",
                "src": "318:4:3",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "nodeType": "Mapping",
              "src": "310:25:3",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_uint256_$_t_struct$_Question_$2020_storage_$",
                "typeString": "mapping(uint256 => struct SurveyInterface.Question)"
              },
              "valueType": {
                "id": 1081,
                "nodeType": "UserDefinedTypeName",
                "pathNode": {
                  "id": 1080,
                  "name": "Question",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 2020,
                  "src": "326:8:3"
                },
                "referencedDeclaration": 2020,
                "src": "326:8:3",
                "typeDescriptions": {
                  "typeIdentifier": "t_struct$_Question_$2020_storage_ptr",
                  "typeString": "struct SurveyInterface.Question"
                }
              }
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "1468aa2c",
            "id": 1086,
            "mutability": "mutable",
            "name": "questionCount",
            "nameLocation": "369:13:3",
            "nodeType": "VariableDeclaration",
            "scope": 1994,
            "src": "357:29:3",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 1084,
              "name": "uint",
              "nodeType": "ElementaryTypeName",
              "src": "357:4:3",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": {
              "hexValue": "30",
              "id": 1085,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "385:1:3",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_0_by_1",
                "typeString": "int_const 0"
              },
              "value": "0"
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "2401519c",
            "id": 1091,
            "mutability": "mutable",
            "name": "answers",
            "nameLocation": "427:7:3",
            "nodeType": "VariableDeclaration",
            "scope": 1994,
            "src": "393:41:3",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_uint256_$_t_array$_t_string_storage_$dyn_storage_$",
              "typeString": "mapping(uint256 => string[])"
            },
            "typeName": {
              "id": 1090,
              "keyType": {
                "id": 1087,
                "name": "uint",
                "nodeType": "ElementaryTypeName",
                "src": "402:4:3",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "nodeType": "Mapping",
              "src": "393:26:3",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_uint256_$_t_array$_t_string_storage_$dyn_storage_$",
                "typeString": "mapping(uint256 => string[])"
              },
              "valueType": {
                "baseType": {
                  "id": 1088,
                  "name": "string",
                  "nodeType": "ElementaryTypeName",
                  "src": "410:6:3",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_storage_ptr",
                    "typeString": "string"
                  }
                },
                "id": 1089,
                "nodeType": "ArrayTypeName",
                "src": "410:8:3",
                "typeDescriptions": {
                  "typeIdentifier": "t_array$_t_string_storage_$dyn_storage_ptr",
                  "typeString": "string[]"
                }
              }
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "id": 1095,
            "mutability": "mutable",
            "name": "userAnswers",
            "nameLocation": "473:11:3",
            "nodeType": "VariableDeclaration",
            "scope": 1994,
            "src": "439:45:3",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
              "typeString": "mapping(address => uint256)"
            },
            "typeName": {
              "id": 1094,
              "keyType": {
                "id": 1092,
                "name": "address",
                "nodeType": "ElementaryTypeName",
                "src": "448:7:3",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              },
              "nodeType": "Mapping",
              "src": "439:25:3",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
                "typeString": "mapping(address => uint256)"
              },
              "valueType": {
                "id": 1093,
                "name": "uint",
                "nodeType": "ElementaryTypeName",
                "src": "459:4:3",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              }
            },
            "visibility": "private"
          },
          {
            "constant": false,
            "functionSelector": "8e1a55fc",
            "id": 1098,
            "mutability": "mutable",
            "name": "build",
            "nameLocation": "510:5:3",
            "nodeType": "VariableDeclaration",
            "scope": 1994,
            "src": "491:24:3",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
              "typeString": "struct SurveyInterface.SurveyBuild"
            },
            "typeName": {
              "id": 1097,
              "nodeType": "UserDefinedTypeName",
              "pathNode": {
                "id": 1096,
                "name": "SurveyBuild",
                "nodeType": "IdentifierPath",
                "referencedDeclaration": 2050,
                "src": "491:11:3"
              },
              "referencedDeclaration": 2050,
              "src": "491:11:3",
              "typeDescriptions": {
                "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage_ptr",
                "typeString": "struct SurveyInterface.SurveyBuild"
              }
            },
            "visibility": "public"
          },
          {
            "anonymous": false,
            "id": 1103,
            "name": "SurveyStatusChanged",
            "nameLocation": "528:19:3",
            "nodeType": "EventDefinition",
            "parameters": {
              "id": 1102,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1101,
                  "indexed": false,
                  "mutability": "mutable",
                  "name": "_status",
                  "nameLocation": "561:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1103,
                  "src": "554:14:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_enum$_Status_$2001",
                    "typeString": "enum SurveyInterface.Status"
                  },
                  "typeName": {
                    "id": 1100,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1099,
                      "name": "Status",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2001,
                      "src": "554:6:3"
                    },
                    "referencedDeclaration": 2001,
                    "src": "554:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_Status_$2001",
                      "typeString": "enum SurveyInterface.Status"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "547:26:3"
            },
            "src": "522:52:3"
          },
          {
            "body": {
              "id": 1144,
              "nodeType": "Block",
              "src": "680:157:3",
              "statements": [
                {
                  "expression": {
                    "id": 1120,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1114,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "689:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1117,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "info",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2039,
                        "src": "689:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                          "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                        }
                      },
                      "id": 1118,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "name",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2031,
                      "src": "689:15:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage",
                        "typeString": "string storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1119,
                      "name": "_name",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1107,
                      "src": "707:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_memory_ptr",
                        "typeString": "string memory"
                      }
                    },
                    "src": "689:23:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "id": 1121,
                  "nodeType": "ExpressionStatement",
                  "src": "689:23:3"
                },
                {
                  "expression": {
                    "id": 1128,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1122,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "719:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1125,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "info",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2039,
                        "src": "719:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                          "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                        }
                      },
                      "id": 1126,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "description",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2033,
                      "src": "719:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage",
                        "typeString": "string storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1127,
                      "name": "_description",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1109,
                      "src": "744:12:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_memory_ptr",
                        "typeString": "string memory"
                      }
                    },
                    "src": "719:37:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "id": 1129,
                  "nodeType": "ExpressionStatement",
                  "src": "719:37:3"
                },
                {
                  "expression": {
                    "id": 1136,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1130,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "763:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1133,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "info",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2039,
                        "src": "763:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                          "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                        }
                      },
                      "id": 1134,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "bonusAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2035,
                      "src": "763:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1135,
                      "name": "_bonusAmount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1111,
                      "src": "788:12:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "763:37:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1137,
                  "nodeType": "ExpressionStatement",
                  "src": "763:37:3"
                },
                {
                  "expression": {
                    "id": 1142,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "id": 1138,
                        "name": "build",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1098,
                        "src": "807:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                          "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                        }
                      },
                      "id": 1140,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "creator",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2049,
                      "src": "807:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1141,
                      "name": "_creator",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1105,
                      "src": "823:8:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "src": "807:24:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "id": 1143,
                  "nodeType": "ExpressionStatement",
                  "src": "807:24:3"
                }
              ]
            },
            "id": 1145,
            "implemented": true,
            "kind": "constructor",
            "modifiers": [],
            "name": "",
            "nameLocation": "-1:-1:-1",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1112,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1105,
                  "mutability": "mutable",
                  "name": "_creator",
                  "nameLocation": "602:8:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1145,
                  "src": "594:16:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 1104,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "594:7:3",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1107,
                  "mutability": "mutable",
                  "name": "_name",
                  "nameLocation": "626:5:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1145,
                  "src": "612:19:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1106,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "612:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1109,
                  "mutability": "mutable",
                  "name": "_description",
                  "nameLocation": "647:12:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1145,
                  "src": "633:26:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1108,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "633:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1111,
                  "mutability": "mutable",
                  "name": "_bonusAmount",
                  "nameLocation": "666:12:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1145,
                  "src": "661:17:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1110,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "661:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "593:86:3"
            },
            "returnParameters": {
              "id": 1113,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "680:0:3"
            },
            "scope": 1994,
            "src": "582:255:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 1157,
              "nodeType": "Block",
              "src": "862:198:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        "id": 1152,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1148,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "971:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1149,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "creator",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2049,
                          "src": "971:13:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "expression": {
                            "id": 1150,
                            "name": "tx",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967270,
                            "src": "988:2:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_magic_transaction",
                              "typeString": "tx"
                            }
                          },
                          "id": 1151,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "origin",
                          "nodeType": "MemberAccess",
                          "src": "988:9:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "src": "971:26:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4d757374206265207468652063726561746f7220746f2061636365737320746869732066756e6374696f6e",
                        "id": 1153,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "999:45:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_879c16fa9785c28093236dad4c926abbcc4ddd1e24d5a113771878e901c54b25",
                          "typeString": "literal_string \"Must be the creator to access this function\""
                        },
                        "value": "Must be the creator to access this function"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_879c16fa9785c28093236dad4c926abbcc4ddd1e24d5a113771878e901c54b25",
                          "typeString": "literal_string \"Must be the creator to access this function\""
                        }
                      ],
                      "id": 1147,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "963:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1154,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "963:82:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1155,
                  "nodeType": "ExpressionStatement",
                  "src": "963:82:3"
                },
                {
                  "id": 1156,
                  "nodeType": "PlaceholderStatement",
                  "src": "1053:1:3"
                }
              ]
            },
            "id": 1158,
            "name": "isCreator",
            "nameLocation": "852:9:3",
            "nodeType": "ModifierDefinition",
            "parameters": {
              "id": 1146,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "862:0:3"
            },
            "src": "843:217:3",
            "virtual": false,
            "visibility": "internal"
          },
          {
            "body": {
              "id": 1172,
              "nodeType": "Block",
              "src": "1126:35:3",
              "statements": [
                {
                  "expression": {
                    "id": 1170,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "id": 1166,
                        "name": "build",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1098,
                        "src": "1133:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                          "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                        }
                      },
                      "id": 1168,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "status",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2047,
                      "src": "1133:12:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_enum$_Status_$2001",
                        "typeString": "enum SurveyInterface.Status"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1169,
                      "name": "_status",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1161,
                      "src": "1148:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_enum$_Status_$2001",
                        "typeString": "enum SurveyInterface.Status"
                      }
                    },
                    "src": "1133:22:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_Status_$2001",
                      "typeString": "enum SurveyInterface.Status"
                    }
                  },
                  "id": 1171,
                  "nodeType": "ExpressionStatement",
                  "src": "1133:22:3"
                }
              ]
            },
            "functionSelector": "f93bbb87",
            "id": 1173,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1164,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1163,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "1116:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "1116:9:3"
              }
            ],
            "name": "setSurveyStatus",
            "nameLocation": "1075:15:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1162,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1161,
                  "mutability": "mutable",
                  "name": "_status",
                  "nameLocation": "1098:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1173,
                  "src": "1091:14:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_enum$_Status_$2001",
                    "typeString": "enum SurveyInterface.Status"
                  },
                  "typeName": {
                    "id": 1160,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1159,
                      "name": "Status",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2001,
                      "src": "1091:6:3"
                    },
                    "referencedDeclaration": 2001,
                    "src": "1091:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_Status_$2001",
                      "typeString": "enum SurveyInterface.Status"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1090:16:3"
            },
            "returnParameters": {
              "id": 1165,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "1126:0:3"
            },
            "scope": 1994,
            "src": "1066:95:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "external"
          },
          {
            "anonymous": false,
            "id": 1177,
            "name": "Log",
            "nameLocation": "1173:3:3",
            "nodeType": "EventDefinition",
            "parameters": {
              "id": 1176,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1175,
                  "indexed": false,
                  "mutability": "mutable",
                  "name": "s",
                  "nameLocation": "1184:1:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1177,
                  "src": "1177:8:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1174,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "1177:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1176:10:3"
            },
            "src": "1167:20:3"
          },
          {
            "body": {
              "id": 1468,
              "nodeType": "Block",
              "src": "1312:2426:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1194,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1191,
                            "name": "_answers",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1185,
                            "src": "1327:8:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_array$_t_string_calldata_ptr_$dyn_calldata_ptr",
                              "typeString": "string calldata[] calldata"
                            }
                          },
                          "id": 1192,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "length",
                          "nodeType": "MemberAccess",
                          "src": "1327:15:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "id": 1193,
                          "name": "questionCount",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1086,
                          "src": "1346:13:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "src": "1327:32:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "416e7377657220737472696e6720617272617920646f6573206e6f74206d6174636820746865206c656e677468206f66207175657374696f6e73",
                        "id": 1195,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "1361:60:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_0cea1408d7a63a11331c6748505bc80cd60b8480f58c4c2651963f54f0b97c32",
                          "typeString": "literal_string \"Answer string array does not match the length of questions\""
                        },
                        "value": "Answer string array does not match the length of questions"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_0cea1408d7a63a11331c6748505bc80cd60b8480f58c4c2651963f54f0b97c32",
                          "typeString": "literal_string \"Answer string array does not match the length of questions\""
                        }
                      ],
                      "id": 1190,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "1319:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1196,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1319:103:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1197,
                  "nodeType": "ExpressionStatement",
                  "src": "1319:103:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 1203,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "nodeType": "UnaryOperation",
                        "operator": "!",
                        "prefix": true,
                        "src": "1489:29:3",
                        "subExpression": {
                          "arguments": [
                            {
                              "expression": {
                                "id": 1200,
                                "name": "tx",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 4294967270,
                                "src": "1508:2:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_magic_transaction",
                                  "typeString": "tx"
                                }
                              },
                              "id": 1201,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": false,
                              "lValueRequested": false,
                              "memberName": "origin",
                              "nodeType": "MemberAccess",
                              "src": "1508:9:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            ],
                            "id": 1199,
                            "name": "didUserTakeSurvey",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1993,
                            "src": "1490:17:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_internal_view$_t_address_$returns$_t_bool_$",
                              "typeString": "function (address) view returns (bool)"
                            }
                          },
                          "id": 1202,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "1490:28:3",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "416c726561647920746f6f6b2074686520737572766579",
                        "id": 1204,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "1520:25:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_6ea6531dad0de6919871ea7d20ff474e1ecd8be9b63504d49bb651d3d627d724",
                          "typeString": "literal_string \"Already took the survey\""
                        },
                        "value": "Already took the survey"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_6ea6531dad0de6919871ea7d20ff474e1ecd8be9b63504d49bb651d3d627d724",
                          "typeString": "literal_string \"Already took the survey\""
                        }
                      ],
                      "id": 1198,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "1481:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1205,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1481:65:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1206,
                  "nodeType": "ExpressionStatement",
                  "src": "1481:65:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        "id": 1212,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1208,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "1623:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1209,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "creator",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2049,
                          "src": "1623:13:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "!=",
                        "rightExpression": {
                          "expression": {
                            "id": 1210,
                            "name": "tx",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967270,
                            "src": "1640:2:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_magic_transaction",
                              "typeString": "tx"
                            }
                          },
                          "id": 1211,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "origin",
                          "nodeType": "MemberAccess",
                          "src": "1640:9:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "src": "1623:26:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "43726561746f722063616e6e6f742074616b652074686520737572766579",
                        "id": 1213,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "1651:32:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_f1c7bbfa2aef84eacd6e1bcb3c18e7590c1327e2ba069b2e3ddeb1a8f62ded03",
                          "typeString": "literal_string \"Creator cannot take the survey\""
                        },
                        "value": "Creator cannot take the survey"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_f1c7bbfa2aef84eacd6e1bcb3c18e7590c1327e2ba069b2e3ddeb1a8f62ded03",
                          "typeString": "literal_string \"Creator cannot take the survey\""
                        }
                      ],
                      "id": 1207,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "1615:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1214,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1615:69:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1215,
                  "nodeType": "ExpressionStatement",
                  "src": "1615:69:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_enum$_Status_$2001",
                          "typeString": "enum SurveyInterface.Status"
                        },
                        "id": 1221,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1217,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "1733:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1218,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "status",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2047,
                          "src": "1733:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "expression": {
                            "id": 1219,
                            "name": "Status",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2001,
                            "src": "1749:6:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_enum$_Status_$2001_$",
                              "typeString": "type(enum SurveyInterface.Status)"
                            }
                          },
                          "id": 1220,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "memberName": "OPEN",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 1999,
                          "src": "1749:11:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "src": "1733:27:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "537572766579206973206e6f74206f70656e",
                        "id": 1222,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "1762:20:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_f0fab26ac02ca5c681c22c19f8d96f059af3b7216c3818e8ee0f9360e4cf614b",
                          "typeString": "literal_string \"Survey is not open\""
                        },
                        "value": "Survey is not open"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_f0fab26ac02ca5c681c22c19f8d96f059af3b7216c3818e8ee0f9360e4cf614b",
                          "typeString": "literal_string \"Survey is not open\""
                        }
                      ],
                      "id": 1216,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "1725:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1223,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1725:58:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1224,
                  "nodeType": "ExpressionStatement",
                  "src": "1725:58:3"
                },
                {
                  "assignments": [
                    1226
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1226,
                      "mutability": "mutable",
                      "name": "reward",
                      "nameLocation": "1843:6:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1468,
                      "src": "1838:11:3",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 1225,
                        "name": "uint",
                        "nodeType": "ElementaryTypeName",
                        "src": "1838:4:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1228,
                  "initialValue": {
                    "hexValue": "30",
                    "id": 1227,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "number",
                    "lValueRequested": false,
                    "nodeType": "Literal",
                    "src": "1852:1:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_rational_0_by_1",
                      "typeString": "int_const 0"
                    },
                    "value": "0"
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1838:15:3"
                },
                {
                  "assignments": [
                    1230
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1230,
                      "mutability": "mutable",
                      "name": "filled",
                      "nameLocation": "1866:6:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1468,
                      "src": "1860:12:3",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint8",
                        "typeString": "uint8"
                      },
                      "typeName": {
                        "id": 1229,
                        "name": "uint8",
                        "nodeType": "ElementaryTypeName",
                        "src": "1860:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint8",
                          "typeString": "uint8"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1232,
                  "initialValue": {
                    "hexValue": "30",
                    "id": 1231,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "number",
                    "lValueRequested": false,
                    "nodeType": "Literal",
                    "src": "1875:1:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_rational_0_by_1",
                      "typeString": "int_const 0"
                    },
                    "value": "0"
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1860:16:3"
                },
                {
                  "body": {
                    "id": 1281,
                    "nodeType": "Block",
                    "src": "1924:262:3",
                    "statements": [
                      {
                        "assignments": [
                          1245
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 1245,
                            "mutability": "mutable",
                            "name": "q",
                            "nameLocation": "1949:1:3",
                            "nodeType": "VariableDeclaration",
                            "scope": 1281,
                            "src": "1933:17:3",
                            "stateVariable": false,
                            "storageLocation": "memory",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                              "typeString": "struct SurveyInterface.Question"
                            },
                            "typeName": {
                              "id": 1244,
                              "nodeType": "UserDefinedTypeName",
                              "pathNode": {
                                "id": 1243,
                                "name": "Question",
                                "nodeType": "IdentifierPath",
                                "referencedDeclaration": 2020,
                                "src": "1933:8:3"
                              },
                              "referencedDeclaration": 2020,
                              "src": "1933:8:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_Question_$2020_storage_ptr",
                                "typeString": "struct SurveyInterface.Question"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 1249,
                        "initialValue": {
                          "baseExpression": {
                            "id": 1246,
                            "name": "questions",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1083,
                            "src": "1953:9:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_mapping$_t_uint256_$_t_struct$_Question_$2020_storage_$",
                              "typeString": "mapping(uint256 => struct SurveyInterface.Question storage ref)"
                            }
                          },
                          "id": 1248,
                          "indexExpression": {
                            "id": 1247,
                            "name": "i",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1234,
                            "src": "1963:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "nodeType": "IndexAccess",
                          "src": "1953:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Question_$2020_storage",
                            "typeString": "struct SurveyInterface.Question storage ref"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "1933:32:3"
                      },
                      {
                        "assignments": [
                          1251
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 1251,
                            "mutability": "mutable",
                            "name": "a",
                            "nameLocation": "1988:1:3",
                            "nodeType": "VariableDeclaration",
                            "scope": 1281,
                            "src": "1974:15:3",
                            "stateVariable": false,
                            "storageLocation": "memory",
                            "typeDescriptions": {
                              "typeIdentifier": "t_string_memory_ptr",
                              "typeString": "string"
                            },
                            "typeName": {
                              "id": 1250,
                              "name": "string",
                              "nodeType": "ElementaryTypeName",
                              "src": "1974:6:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_string_storage_ptr",
                                "typeString": "string"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 1255,
                        "initialValue": {
                          "baseExpression": {
                            "id": 1252,
                            "name": "_answers",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1185,
                            "src": "1992:8:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_array$_t_string_calldata_ptr_$dyn_calldata_ptr",
                              "typeString": "string calldata[] calldata"
                            }
                          },
                          "id": 1254,
                          "indexExpression": {
                            "id": 1253,
                            "name": "i",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1234,
                            "src": "2001:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "nodeType": "IndexAccess",
                          "src": "1992:11:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_string_calldata_ptr",
                            "typeString": "string calldata"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "1974:29:3"
                      },
                      {
                        "condition": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 1262,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "expression": {
                              "arguments": [
                                {
                                  "id": 1258,
                                  "name": "a",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1251,
                                  "src": "2022:1:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_string_memory_ptr",
                                    "typeString": "string memory"
                                  }
                                }
                              ],
                              "expression": {
                                "argumentTypes": [
                                  {
                                    "typeIdentifier": "t_string_memory_ptr",
                                    "typeString": "string memory"
                                  }
                                ],
                                "id": 1257,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": true,
                                "lValueRequested": false,
                                "nodeType": "ElementaryTypeNameExpression",
                                "src": "2016:5:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
                                  "typeString": "type(bytes storage pointer)"
                                },
                                "typeName": {
                                  "id": 1256,
                                  "name": "bytes",
                                  "nodeType": "ElementaryTypeName",
                                  "src": "2016:5:3",
                                  "typeDescriptions": {}
                                }
                              },
                              "id": 1259,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": false,
                              "kind": "typeConversion",
                              "lValueRequested": false,
                              "names": [],
                              "nodeType": "FunctionCall",
                              "src": "2016:8:3",
                              "tryCall": false,
                              "typeDescriptions": {
                                "typeIdentifier": "t_bytes_memory_ptr",
                                "typeString": "bytes memory"
                              }
                            },
                            "id": 1260,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "length",
                            "nodeType": "MemberAccess",
                            "src": "2016:15:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": ">",
                          "rightExpression": {
                            "hexValue": "30",
                            "id": 1261,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "kind": "number",
                            "lValueRequested": false,
                            "nodeType": "Literal",
                            "src": "2034:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_rational_0_by_1",
                              "typeString": "int_const 0"
                            },
                            "value": "0"
                          },
                          "src": "2016:19:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "falseBody": {
                          "condition": {
                            "expression": {
                              "id": 1272,
                              "name": "q",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1245,
                              "src": "2104:1:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                                "typeString": "struct SurveyInterface.Question memory"
                              }
                            },
                            "id": 1273,
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "required",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2012,
                            "src": "2104:10:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_bool",
                              "typeString": "bool"
                            }
                          },
                          "id": 1279,
                          "nodeType": "IfStatement",
                          "src": "2100:79:3",
                          "trueBody": {
                            "id": 1278,
                            "nodeType": "Block",
                            "src": "2116:63:3",
                            "statements": [
                              {
                                "expression": {
                                  "arguments": [
                                    {
                                      "hexValue": "5265717569726564207175657374696f6e206e6f742066696c6c6564206f7574",
                                      "id": 1275,
                                      "isConstant": false,
                                      "isLValue": false,
                                      "isPure": true,
                                      "kind": "string",
                                      "lValueRequested": false,
                                      "nodeType": "Literal",
                                      "src": "2134:34:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_stringliteral_04037c1c73b6df0138c0effd84a095632c6f0e3142cefd7669cea1e916bce893",
                                        "typeString": "literal_string \"Required question not filled out\""
                                      },
                                      "value": "Required question not filled out"
                                    }
                                  ],
                                  "expression": {
                                    "argumentTypes": [
                                      {
                                        "typeIdentifier": "t_stringliteral_04037c1c73b6df0138c0effd84a095632c6f0e3142cefd7669cea1e916bce893",
                                        "typeString": "literal_string \"Required question not filled out\""
                                      }
                                    ],
                                    "id": 1274,
                                    "name": "revert",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [
                                      4294967277,
                                      4294967277
                                    ],
                                    "referencedDeclaration": 4294967277,
                                    "src": "2127:6:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_function_revert_pure$_t_string_memory_ptr_$returns$__$",
                                      "typeString": "function (string memory) pure"
                                    }
                                  },
                                  "id": 1276,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "kind": "functionCall",
                                  "lValueRequested": false,
                                  "names": [],
                                  "nodeType": "FunctionCall",
                                  "src": "2127:42:3",
                                  "tryCall": false,
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_tuple$__$",
                                    "typeString": "tuple()"
                                  }
                                },
                                "id": 1277,
                                "nodeType": "ExpressionStatement",
                                "src": "2127:42:3"
                              }
                            ]
                          }
                        },
                        "id": 1280,
                        "nodeType": "IfStatement",
                        "src": "2012:167:3",
                        "trueBody": {
                          "id": 1271,
                          "nodeType": "Block",
                          "src": "2037:57:3",
                          "statements": [
                            {
                              "expression": {
                                "id": 1266,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "lValueRequested": false,
                                "leftHandSide": {
                                  "id": 1263,
                                  "name": "reward",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1226,
                                  "src": "2048:6:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "nodeType": "Assignment",
                                "operator": "+=",
                                "rightHandSide": {
                                  "expression": {
                                    "id": 1264,
                                    "name": "q",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 1245,
                                    "src": "2058:1:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                                      "typeString": "struct SurveyInterface.Question memory"
                                    }
                                  },
                                  "id": 1265,
                                  "isConstant": false,
                                  "isLValue": true,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "worth",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 2010,
                                  "src": "2058:7:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "src": "2048:17:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              "id": 1267,
                              "nodeType": "ExpressionStatement",
                              "src": "2048:17:3"
                            },
                            {
                              "expression": {
                                "id": 1269,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "lValueRequested": false,
                                "nodeType": "UnaryOperation",
                                "operator": "++",
                                "prefix": false,
                                "src": "2076:8:3",
                                "subExpression": {
                                  "id": 1268,
                                  "name": "filled",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1230,
                                  "src": "2076:6:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint8",
                                    "typeString": "uint8"
                                  }
                                },
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint8",
                                  "typeString": "uint8"
                                }
                              },
                              "id": 1270,
                              "nodeType": "ExpressionStatement",
                              "src": "2076:8:3"
                            }
                          ]
                        }
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1239,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1237,
                      "name": "i",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1234,
                      "src": "1900:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "id": 1238,
                      "name": "questionCount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1086,
                      "src": "1904:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1900:17:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1282,
                  "initializationExpression": {
                    "assignments": [
                      1234
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 1234,
                        "mutability": "mutable",
                        "name": "i",
                        "nameLocation": "1893:1:3",
                        "nodeType": "VariableDeclaration",
                        "scope": 1282,
                        "src": "1888:6:3",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 1233,
                          "name": "uint",
                          "nodeType": "ElementaryTypeName",
                          "src": "1888:4:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 1236,
                    "initialValue": {
                      "hexValue": "30",
                      "id": 1235,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "1897:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "nodeType": "VariableDeclarationStatement",
                    "src": "1888:10:3"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 1241,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "1919:3:3",
                      "subExpression": {
                        "id": 1240,
                        "name": "i",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1234,
                        "src": "1919:1:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 1242,
                    "nodeType": "ExpressionStatement",
                    "src": "1919:3:3"
                  },
                  "nodeType": "ForStatement",
                  "src": "1883:303:3"
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1285,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1283,
                      "name": "filled",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1230,
                      "src": "2196:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint8",
                        "typeString": "uint8"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 1284,
                      "name": "questionCount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1086,
                      "src": "2206:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2196:23:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1293,
                  "nodeType": "IfStatement",
                  "src": "2192:78:3",
                  "trueBody": {
                    "id": 1292,
                    "nodeType": "Block",
                    "src": "2221:49:3",
                    "statements": [
                      {
                        "expression": {
                          "id": 1290,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "id": 1286,
                            "name": "reward",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1226,
                            "src": "2230:6:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "+=",
                          "rightHandSide": {
                            "expression": {
                              "expression": {
                                "id": 1287,
                                "name": "build",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 1098,
                                "src": "2240:5:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                  "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                                }
                              },
                              "id": 1288,
                              "isConstant": false,
                              "isLValue": true,
                              "isPure": false,
                              "lValueRequested": false,
                              "memberName": "info",
                              "nodeType": "MemberAccess",
                              "referencedDeclaration": 2039,
                              "src": "2240:10:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                                "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                              }
                            },
                            "id": 1289,
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "bonusAmount",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2035,
                            "src": "2240:22:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "src": "2230:32:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "id": 1291,
                        "nodeType": "ExpressionStatement",
                        "src": "2230:32:3"
                      }
                    ]
                  }
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1299,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "id": 1295,
                          "name": "reward",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1226,
                          "src": "2355:6:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "<=",
                        "rightExpression": {
                          "expression": {
                            "expression": {
                              "id": 1296,
                              "name": "build",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1098,
                              "src": "2365:5:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                              }
                            },
                            "id": 1297,
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "pool",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2042,
                            "src": "2365:10:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                              "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                            }
                          },
                          "id": 1298,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "tokenAmount",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2022,
                          "src": "2365:22:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "src": "2355:32:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "4e6f7420656e6f7567682072657761726420746f20676976652c2063616e63656c6c696e67207375626d697373696f6e2e",
                        "id": 1300,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2389:51:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_011cc548aef422f49ec5b449d0fed3dafc46f94a16900943c531cd7c2a55cecb",
                          "typeString": "literal_string \"Not enough reward to give, cancelling submission.\""
                        },
                        "value": "Not enough reward to give, cancelling submission."
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_011cc548aef422f49ec5b449d0fed3dafc46f94a16900943c531cd7c2a55cecb",
                          "typeString": "literal_string \"Not enough reward to give, cancelling submission.\""
                        }
                      ],
                      "id": 1294,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "2347:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1301,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2347:94:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1302,
                  "nodeType": "ExpressionStatement",
                  "src": "2347:94:3"
                },
                {
                  "expression": {
                    "id": 1311,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "baseExpression": {
                        "id": 1303,
                        "name": "userAnswers",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1095,
                        "src": "2450:11:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
                          "typeString": "mapping(address => uint256)"
                        }
                      },
                      "id": 1306,
                      "indexExpression": {
                        "expression": {
                          "id": 1304,
                          "name": "tx",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967270,
                          "src": "2462:2:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_transaction",
                            "typeString": "tx"
                          }
                        },
                        "id": 1305,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "origin",
                        "nodeType": "MemberAccess",
                        "src": "2462:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "nodeType": "IndexAccess",
                      "src": "2450:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "commonType": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "id": 1310,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "leftExpression": {
                        "expression": {
                          "id": 1307,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "2475:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1308,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "surveysTaken",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2044,
                        "src": "2475:18:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "nodeType": "BinaryOperation",
                      "operator": "+",
                      "rightExpression": {
                        "hexValue": "31",
                        "id": 1309,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "number",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2496:1:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_rational_1_by_1",
                          "typeString": "int_const 1"
                        },
                        "value": "1"
                      },
                      "src": "2475:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2450:47:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1312,
                  "nodeType": "ExpressionStatement",
                  "src": "2450:47:3"
                },
                {
                  "body": {
                    "id": 1346,
                    "nodeType": "Block",
                    "src": "2635:119:3",
                    "statements": [
                      {
                        "assignments": [
                          1325
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 1325,
                            "mutability": "mutable",
                            "name": "a",
                            "nameLocation": "2658:1:3",
                            "nodeType": "VariableDeclaration",
                            "scope": 1346,
                            "src": "2644:15:3",
                            "stateVariable": false,
                            "storageLocation": "memory",
                            "typeDescriptions": {
                              "typeIdentifier": "t_string_memory_ptr",
                              "typeString": "string"
                            },
                            "typeName": {
                              "id": 1324,
                              "name": "string",
                              "nodeType": "ElementaryTypeName",
                              "src": "2644:6:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_string_storage_ptr",
                                "typeString": "string"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 1329,
                        "initialValue": {
                          "baseExpression": {
                            "id": 1326,
                            "name": "_answers",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1185,
                            "src": "2662:8:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_array$_t_string_calldata_ptr_$dyn_calldata_ptr",
                              "typeString": "string calldata[] calldata"
                            }
                          },
                          "id": 1328,
                          "indexExpression": {
                            "id": 1327,
                            "name": "i",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1314,
                            "src": "2671:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "nodeType": "IndexAccess",
                          "src": "2662:11:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_string_calldata_ptr",
                            "typeString": "string calldata"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "2644:29:3"
                      },
                      {
                        "condition": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 1336,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "expression": {
                              "arguments": [
                                {
                                  "id": 1332,
                                  "name": "a",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1325,
                                  "src": "2692:1:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_string_memory_ptr",
                                    "typeString": "string memory"
                                  }
                                }
                              ],
                              "expression": {
                                "argumentTypes": [
                                  {
                                    "typeIdentifier": "t_string_memory_ptr",
                                    "typeString": "string memory"
                                  }
                                ],
                                "id": 1331,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": true,
                                "lValueRequested": false,
                                "nodeType": "ElementaryTypeNameExpression",
                                "src": "2686:5:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
                                  "typeString": "type(bytes storage pointer)"
                                },
                                "typeName": {
                                  "id": 1330,
                                  "name": "bytes",
                                  "nodeType": "ElementaryTypeName",
                                  "src": "2686:5:3",
                                  "typeDescriptions": {}
                                }
                              },
                              "id": 1333,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": false,
                              "kind": "typeConversion",
                              "lValueRequested": false,
                              "names": [],
                              "nodeType": "FunctionCall",
                              "src": "2686:8:3",
                              "tryCall": false,
                              "typeDescriptions": {
                                "typeIdentifier": "t_bytes_memory_ptr",
                                "typeString": "bytes memory"
                              }
                            },
                            "id": 1334,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "length",
                            "nodeType": "MemberAccess",
                            "src": "2686:15:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": ">",
                          "rightExpression": {
                            "hexValue": "30",
                            "id": 1335,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "kind": "number",
                            "lValueRequested": false,
                            "nodeType": "Literal",
                            "src": "2704:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_rational_0_by_1",
                              "typeString": "int_const 0"
                            },
                            "value": "0"
                          },
                          "src": "2686:19:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "id": 1345,
                        "nodeType": "IfStatement",
                        "src": "2682:65:3",
                        "trueBody": {
                          "id": 1344,
                          "nodeType": "Block",
                          "src": "2707:40:3",
                          "statements": [
                            {
                              "expression": {
                                "arguments": [
                                  {
                                    "id": 1341,
                                    "name": "a",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 1325,
                                    "src": "2734:1:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_string_memory_ptr",
                                      "typeString": "string memory"
                                    }
                                  }
                                ],
                                "expression": {
                                  "argumentTypes": [
                                    {
                                      "typeIdentifier": "t_string_memory_ptr",
                                      "typeString": "string memory"
                                    }
                                  ],
                                  "expression": {
                                    "baseExpression": {
                                      "id": 1337,
                                      "name": "answers",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 1091,
                                      "src": "2718:7:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_mapping$_t_uint256_$_t_array$_t_string_storage_$dyn_storage_$",
                                        "typeString": "mapping(uint256 => string storage ref[] storage ref)"
                                      }
                                    },
                                    "id": 1339,
                                    "indexExpression": {
                                      "id": 1338,
                                      "name": "i",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 1314,
                                      "src": "2726:1:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_uint256",
                                        "typeString": "uint256"
                                      }
                                    },
                                    "isConstant": false,
                                    "isLValue": true,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "nodeType": "IndexAccess",
                                    "src": "2718:10:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_array$_t_string_storage_$dyn_storage",
                                      "typeString": "string storage ref[] storage ref"
                                    }
                                  },
                                  "id": 1340,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "push",
                                  "nodeType": "MemberAccess",
                                  "src": "2718:15:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_arraypush_nonpayable$_t_array$_t_string_storage_$dyn_storage_ptr_$_t_string_storage_$returns$__$bound_to$_t_array$_t_string_storage_$dyn_storage_ptr_$",
                                    "typeString": "function (string storage ref[] storage pointer,string storage ref)"
                                  }
                                },
                                "id": 1342,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "2718:18:3",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_tuple$__$",
                                  "typeString": "tuple()"
                                }
                              },
                              "id": 1343,
                              "nodeType": "ExpressionStatement",
                              "src": "2718:18:3"
                            }
                          ]
                        }
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1320,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1317,
                      "name": "i",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1314,
                      "src": "2609:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "expression": {
                        "id": 1318,
                        "name": "_answers",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1185,
                        "src": "2613:8:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_string_calldata_ptr_$dyn_calldata_ptr",
                          "typeString": "string calldata[] calldata"
                        }
                      },
                      "id": 1319,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "length",
                      "nodeType": "MemberAccess",
                      "src": "2613:15:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2609:19:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1347,
                  "initializationExpression": {
                    "assignments": [
                      1314
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 1314,
                        "mutability": "mutable",
                        "name": "i",
                        "nameLocation": "2602:1:3",
                        "nodeType": "VariableDeclaration",
                        "scope": 1347,
                        "src": "2597:6:3",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 1313,
                          "name": "uint",
                          "nodeType": "ElementaryTypeName",
                          "src": "2597:4:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 1316,
                    "initialValue": {
                      "hexValue": "30",
                      "id": 1315,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "2606:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "nodeType": "VariableDeclarationStatement",
                    "src": "2597:10:3"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 1322,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "2630:3:3",
                      "subExpression": {
                        "id": 1321,
                        "name": "i",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1314,
                        "src": "2630:1:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 1323,
                    "nodeType": "ExpressionStatement",
                    "src": "2630:3:3"
                  },
                  "nodeType": "ForStatement",
                  "src": "2593:161:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "expression": {
                          "id": 1351,
                          "name": "tx",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967270,
                          "src": "2852:2:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_transaction",
                            "typeString": "tx"
                          }
                        },
                        "id": 1352,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "origin",
                        "nodeType": "MemberAccess",
                        "src": "2852:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 1353,
                        "name": "reward",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1226,
                        "src": "2863:6:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "expression": {
                        "id": 1348,
                        "name": "_token",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1182,
                        "src": "2836:6:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_Token_$2124",
                          "typeString": "contract Token"
                        }
                      },
                      "id": 1350,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "transfer",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2103,
                      "src": "2836:15:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
                        "typeString": "function (address,uint256) external returns (bool)"
                      }
                    },
                    "id": 1354,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2836:34:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1355,
                  "nodeType": "ExpressionStatement",
                  "src": "2836:34:3"
                },
                {
                  "expression": {
                    "id": 1362,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1356,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "2877:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1359,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "2877:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1360,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "tokenAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2022,
                      "src": "2877:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "-=",
                    "rightHandSide": {
                      "id": 1361,
                      "name": "reward",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1226,
                      "src": "2903:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2877:32:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1363,
                  "nodeType": "ExpressionStatement",
                  "src": "2877:32:3"
                },
                {
                  "expression": {
                    "id": 1370,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1364,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "2916:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1367,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "2916:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1368,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "totalTokensSent",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2028,
                      "src": "2916:26:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "+=",
                    "rightHandSide": {
                      "id": 1369,
                      "name": "reward",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1226,
                      "src": "2946:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2916:36:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1371,
                  "nodeType": "ExpressionStatement",
                  "src": "2916:36:3"
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1376,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "expression": {
                        "expression": {
                          "id": 1372,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "3008:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1373,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "3008:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1374,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "gasAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2024,
                      "src": "3008:20:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": ">",
                    "rightExpression": {
                      "hexValue": "30",
                      "id": 1375,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "3031:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "src": "3008:24:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1440,
                  "nodeType": "IfStatement",
                  "src": "3004:394:3",
                  "trueBody": {
                    "id": 1439,
                    "nodeType": "Block",
                    "src": "3034:364:3",
                    "statements": [
                      {
                        "assignments": [
                          1378
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 1378,
                            "mutability": "mutable",
                            "name": "diff",
                            "nameLocation": "3048:4:3",
                            "nodeType": "VariableDeclaration",
                            "scope": 1439,
                            "src": "3043:9:3",
                            "stateVariable": false,
                            "storageLocation": "default",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            },
                            "typeName": {
                              "id": 1377,
                              "name": "uint",
                              "nodeType": "ElementaryTypeName",
                              "src": "3043:4:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 1384,
                        "initialValue": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 1383,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "expression": {
                              "expression": {
                                "id": 1379,
                                "name": "build",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 1098,
                                "src": "3055:5:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                  "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                                }
                              },
                              "id": 1380,
                              "isConstant": false,
                              "isLValue": true,
                              "isPure": false,
                              "lValueRequested": false,
                              "memberName": "pool",
                              "nodeType": "MemberAccess",
                              "referencedDeclaration": 2042,
                              "src": "3055:10:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                                "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                              }
                            },
                            "id": 1381,
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "gasAmount",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2024,
                            "src": "3055:20:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": "-",
                          "rightExpression": {
                            "id": 1382,
                            "name": "_gas",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1179,
                            "src": "3078:4:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "src": "3055:27:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "3043:39:3"
                      },
                      {
                        "assignments": [
                          1386
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 1386,
                            "mutability": "mutable",
                            "name": "send",
                            "nameLocation": "3096:4:3",
                            "nodeType": "VariableDeclaration",
                            "scope": 1439,
                            "src": "3091:9:3",
                            "stateVariable": false,
                            "storageLocation": "default",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            },
                            "typeName": {
                              "id": 1385,
                              "name": "uint",
                              "nodeType": "ElementaryTypeName",
                              "src": "3091:4:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 1388,
                        "initialValue": {
                          "id": 1387,
                          "name": "_gas",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1179,
                          "src": "3103:4:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "3091:16:3"
                      },
                      {
                        "condition": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 1391,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "id": 1389,
                            "name": "diff",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1378,
                            "src": "3120:4:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": "<=",
                          "rightExpression": {
                            "hexValue": "30",
                            "id": 1390,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "kind": "number",
                            "lValueRequested": false,
                            "nodeType": "Literal",
                            "src": "3128:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_rational_0_by_1",
                              "typeString": "int_const 0"
                            },
                            "value": "0"
                          },
                          "src": "3120:9:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "id": 1399,
                        "nodeType": "IfStatement",
                        "src": "3116:63:3",
                        "trueBody": {
                          "id": 1398,
                          "nodeType": "Block",
                          "src": "3131:48:3",
                          "statements": [
                            {
                              "expression": {
                                "id": 1396,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "lValueRequested": false,
                                "leftHandSide": {
                                  "id": 1392,
                                  "name": "send",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1386,
                                  "src": "3142:4:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "nodeType": "Assignment",
                                "operator": "=",
                                "rightHandSide": {
                                  "expression": {
                                    "expression": {
                                      "id": 1393,
                                      "name": "build",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 1098,
                                      "src": "3149:5:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                                      }
                                    },
                                    "id": 1394,
                                    "isConstant": false,
                                    "isLValue": true,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "memberName": "pool",
                                    "nodeType": "MemberAccess",
                                    "referencedDeclaration": 2042,
                                    "src": "3149:10:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                                      "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                                    }
                                  },
                                  "id": 1395,
                                  "isConstant": false,
                                  "isLValue": true,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "gasAmount",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 2024,
                                  "src": "3149:20:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "src": "3142:27:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              "id": 1397,
                              "nodeType": "ExpressionStatement",
                              "src": "3142:27:3"
                            }
                          ]
                        }
                      },
                      {
                        "condition": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 1406,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "expression": {
                              "arguments": [
                                {
                                  "id": 1402,
                                  "name": "this",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 4294967268,
                                  "src": "3199:4:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_contract$_Survey_$1994",
                                    "typeString": "contract Survey"
                                  }
                                }
                              ],
                              "expression": {
                                "argumentTypes": [
                                  {
                                    "typeIdentifier": "t_contract$_Survey_$1994",
                                    "typeString": "contract Survey"
                                  }
                                ],
                                "id": 1401,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": true,
                                "lValueRequested": false,
                                "nodeType": "ElementaryTypeNameExpression",
                                "src": "3191:7:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_type$_t_address_$",
                                  "typeString": "type(address)"
                                },
                                "typeName": {
                                  "id": 1400,
                                  "name": "address",
                                  "nodeType": "ElementaryTypeName",
                                  "src": "3191:7:3",
                                  "typeDescriptions": {}
                                }
                              },
                              "id": 1403,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": false,
                              "kind": "typeConversion",
                              "lValueRequested": false,
                              "names": [],
                              "nodeType": "FunctionCall",
                              "src": "3191:13:3",
                              "tryCall": false,
                              "typeDescriptions": {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            },
                            "id": 1404,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "balance",
                            "nodeType": "MemberAccess",
                            "src": "3191:21:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": ">=",
                          "rightExpression": {
                            "id": 1405,
                            "name": "send",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1386,
                            "src": "3216:4:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "src": "3191:29:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "id": 1438,
                        "nodeType": "IfStatement",
                        "src": "3187:204:3",
                        "trueBody": {
                          "id": 1437,
                          "nodeType": "Block",
                          "src": "3222:169:3",
                          "statements": [
                            {
                              "assignments": [
                                1408
                              ],
                              "declarations": [
                                {
                                  "constant": false,
                                  "id": 1408,
                                  "mutability": "mutable",
                                  "name": "pa",
                                  "nameLocation": "3249:2:3",
                                  "nodeType": "VariableDeclaration",
                                  "scope": 1437,
                                  "src": "3233:18:3",
                                  "stateVariable": false,
                                  "storageLocation": "default",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_address_payable",
                                    "typeString": "address payable"
                                  },
                                  "typeName": {
                                    "id": 1407,
                                    "name": "address",
                                    "nodeType": "ElementaryTypeName",
                                    "src": "3233:15:3",
                                    "stateMutability": "payable",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_address_payable",
                                      "typeString": "address payable"
                                    }
                                  },
                                  "visibility": "internal"
                                }
                              ],
                              "id": 1414,
                              "initialValue": {
                                "arguments": [
                                  {
                                    "expression": {
                                      "id": 1411,
                                      "name": "tx",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 4294967270,
                                      "src": "3262:2:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_magic_transaction",
                                        "typeString": "tx"
                                      }
                                    },
                                    "id": 1412,
                                    "isConstant": false,
                                    "isLValue": false,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "memberName": "origin",
                                    "nodeType": "MemberAccess",
                                    "src": "3262:9:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_address",
                                      "typeString": "address"
                                    }
                                  }
                                ],
                                "expression": {
                                  "argumentTypes": [
                                    {
                                      "typeIdentifier": "t_address",
                                      "typeString": "address"
                                    }
                                  ],
                                  "id": 1410,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": true,
                                  "lValueRequested": false,
                                  "nodeType": "ElementaryTypeNameExpression",
                                  "src": "3254:8:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_type$_t_address_payable_$",
                                    "typeString": "type(address payable)"
                                  },
                                  "typeName": {
                                    "id": 1409,
                                    "name": "address",
                                    "nodeType": "ElementaryTypeName",
                                    "src": "3254:8:3",
                                    "stateMutability": "payable",
                                    "typeDescriptions": {}
                                  }
                                },
                                "id": 1413,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "typeConversion",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "3254:18:3",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_address_payable",
                                  "typeString": "address payable"
                                }
                              },
                              "nodeType": "VariableDeclarationStatement",
                              "src": "3233:39:3"
                            },
                            {
                              "expression": {
                                "arguments": [
                                  {
                                    "id": 1418,
                                    "name": "send",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 1386,
                                    "src": "3295:4:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_uint256",
                                      "typeString": "uint256"
                                    }
                                  }
                                ],
                                "expression": {
                                  "argumentTypes": [
                                    {
                                      "typeIdentifier": "t_uint256",
                                      "typeString": "uint256"
                                    }
                                  ],
                                  "expression": {
                                    "id": 1415,
                                    "name": "pa",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 1408,
                                    "src": "3283:2:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_address_payable",
                                      "typeString": "address payable"
                                    }
                                  },
                                  "id": 1417,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "transfer",
                                  "nodeType": "MemberAccess",
                                  "src": "3283:11:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
                                    "typeString": "function (uint256)"
                                  }
                                },
                                "id": 1419,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "3283:17:3",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_tuple$__$",
                                  "typeString": "tuple()"
                                }
                              },
                              "id": 1420,
                              "nodeType": "ExpressionStatement",
                              "src": "3283:17:3"
                            },
                            {
                              "expression": {
                                "id": 1427,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "lValueRequested": false,
                                "leftHandSide": {
                                  "expression": {
                                    "expression": {
                                      "id": 1421,
                                      "name": "build",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 1098,
                                      "src": "3311:5:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                                      }
                                    },
                                    "id": 1424,
                                    "isConstant": false,
                                    "isLValue": true,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "memberName": "pool",
                                    "nodeType": "MemberAccess",
                                    "referencedDeclaration": 2042,
                                    "src": "3311:10:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                                      "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                                    }
                                  },
                                  "id": 1425,
                                  "isConstant": false,
                                  "isLValue": true,
                                  "isPure": false,
                                  "lValueRequested": true,
                                  "memberName": "gasAmount",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 2024,
                                  "src": "3311:20:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "nodeType": "Assignment",
                                "operator": "-=",
                                "rightHandSide": {
                                  "id": 1426,
                                  "name": "send",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1386,
                                  "src": "3335:4:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "src": "3311:28:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              "id": 1428,
                              "nodeType": "ExpressionStatement",
                              "src": "3311:28:3"
                            },
                            {
                              "expression": {
                                "id": 1435,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "lValueRequested": false,
                                "leftHandSide": {
                                  "expression": {
                                    "expression": {
                                      "id": 1429,
                                      "name": "build",
                                      "nodeType": "Identifier",
                                      "overloadedDeclarations": [],
                                      "referencedDeclaration": 1098,
                                      "src": "3350:5:3",
                                      "typeDescriptions": {
                                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                                      }
                                    },
                                    "id": 1432,
                                    "isConstant": false,
                                    "isLValue": true,
                                    "isPure": false,
                                    "lValueRequested": false,
                                    "memberName": "pool",
                                    "nodeType": "MemberAccess",
                                    "referencedDeclaration": 2042,
                                    "src": "3350:10:3",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                                      "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                                    }
                                  },
                                  "id": 1433,
                                  "isConstant": false,
                                  "isLValue": true,
                                  "isPure": false,
                                  "lValueRequested": true,
                                  "memberName": "totalGasSent",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 2026,
                                  "src": "3350:23:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "nodeType": "Assignment",
                                "operator": "+=",
                                "rightHandSide": {
                                  "id": 1434,
                                  "name": "send",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 1386,
                                  "src": "3377:4:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "src": "3350:31:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              "id": 1436,
                              "nodeType": "ExpressionStatement",
                              "src": "3350:31:3"
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  "expression": {
                    "id": 1444,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "nodeType": "UnaryOperation",
                    "operator": "++",
                    "prefix": false,
                    "src": "3437:20:3",
                    "subExpression": {
                      "expression": {
                        "id": 1441,
                        "name": "build",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1098,
                        "src": "3437:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                          "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                        }
                      },
                      "id": 1443,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "surveysTaken",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2044,
                      "src": "3437:18:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1445,
                  "nodeType": "ExpressionStatement",
                  "src": "3437:20:3"
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1451,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "expression": {
                        "expression": {
                          "id": 1446,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "3585:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1447,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "3585:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1448,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "tokenAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2022,
                      "src": "3585:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "arguments": [],
                      "expression": {
                        "argumentTypes": [],
                        "id": 1449,
                        "name": "worth",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1613,
                        "src": "3610:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_internal_view$__$returns$_t_uint256_$",
                          "typeString": "function () view returns (uint256)"
                        }
                      },
                      "id": 1450,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "3610:7:3",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "3585:32:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1465,
                  "nodeType": "IfStatement",
                  "src": "3581:132:3",
                  "trueBody": {
                    "id": 1464,
                    "nodeType": "Block",
                    "src": "3619:94:3",
                    "statements": [
                      {
                        "expression": {
                          "id": 1457,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "expression": {
                              "id": 1452,
                              "name": "build",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1098,
                              "src": "3628:5:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                              }
                            },
                            "id": 1454,
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": true,
                            "memberName": "status",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2047,
                            "src": "3628:12:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_enum$_Status_$2001",
                              "typeString": "enum SurveyInterface.Status"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "=",
                          "rightHandSide": {
                            "expression": {
                              "id": 1455,
                              "name": "Status",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2001,
                              "src": "3643:6:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_type$_t_enum$_Status_$2001_$",
                                "typeString": "type(enum SurveyInterface.Status)"
                              }
                            },
                            "id": 1456,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "lValueRequested": false,
                            "memberName": "FINISHED",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2000,
                            "src": "3643:15:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_enum$_Status_$2001",
                              "typeString": "enum SurveyInterface.Status"
                            }
                          },
                          "src": "3628:30:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "id": 1458,
                        "nodeType": "ExpressionStatement",
                        "src": "3628:30:3"
                      },
                      {
                        "eventCall": {
                          "arguments": [
                            {
                              "expression": {
                                "id": 1460,
                                "name": "build",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 1098,
                                "src": "3692:5:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                                  "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                                }
                              },
                              "id": 1461,
                              "isConstant": false,
                              "isLValue": true,
                              "isPure": false,
                              "lValueRequested": false,
                              "memberName": "status",
                              "nodeType": "MemberAccess",
                              "referencedDeclaration": 2047,
                              "src": "3692:12:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_enum$_Status_$2001",
                                "typeString": "enum SurveyInterface.Status"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_enum$_Status_$2001",
                                "typeString": "enum SurveyInterface.Status"
                              }
                            ],
                            "id": 1459,
                            "name": "SurveyStatusChanged",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1103,
                            "src": "3672:19:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_event_nonpayable$_t_enum$_Status_$2001_$returns$__$",
                              "typeString": "function (enum SurveyInterface.Status)"
                            }
                          },
                          "id": 1462,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "3672:33:3",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_tuple$__$",
                            "typeString": "tuple()"
                          }
                        },
                        "id": 1463,
                        "nodeType": "EmitStatement",
                        "src": "3667:38:3"
                      }
                    ]
                  }
                },
                {
                  "expression": {
                    "id": 1466,
                    "name": "reward",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1226,
                    "src": "3726:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 1189,
                  "id": 1467,
                  "nodeType": "Return",
                  "src": "3719:13:3"
                }
              ]
            },
            "functionSelector": "d6da669e",
            "id": 1469,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "submitSurvey",
            "nameLocation": "1202:12:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1186,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1179,
                  "mutability": "mutable",
                  "name": "_gas",
                  "nameLocation": "1226:4:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1469,
                  "src": "1221:9:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1178,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "1221:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1182,
                  "mutability": "mutable",
                  "name": "_token",
                  "nameLocation": "1243:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1469,
                  "src": "1237:12:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_contract$_Token_$2124",
                    "typeString": "contract Token"
                  },
                  "typeName": {
                    "id": 1181,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1180,
                      "name": "Token",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2124,
                      "src": "1237:5:3"
                    },
                    "referencedDeclaration": 2124,
                    "src": "1237:5:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_Token_$2124",
                      "typeString": "contract Token"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1185,
                  "mutability": "mutable",
                  "name": "_answers",
                  "nameLocation": "1274:8:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1469,
                  "src": "1256:26:3",
                  "stateVariable": false,
                  "storageLocation": "calldata",
                  "typeDescriptions": {
                    "typeIdentifier": "t_array$_t_string_calldata_ptr_$dyn_calldata_ptr",
                    "typeString": "string[]"
                  },
                  "typeName": {
                    "baseType": {
                      "id": 1183,
                      "name": "string",
                      "nodeType": "ElementaryTypeName",
                      "src": "1256:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage_ptr",
                        "typeString": "string"
                      }
                    },
                    "id": 1184,
                    "nodeType": "ArrayTypeName",
                    "src": "1256:8:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_string_storage_$dyn_storage_ptr",
                      "typeString": "string[]"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1214:73:3"
            },
            "returnParameters": {
              "id": 1189,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1188,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1469,
                  "src": "1306:4:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1187,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "1306:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1305:6:3"
            },
            "scope": 1994,
            "src": "1193:2545:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1478,
              "nodeType": "Block",
              "src": "3911:35:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "expression": {
                        "id": 1474,
                        "name": "build",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1098,
                        "src": "3925:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                          "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                        }
                      },
                      "id": 1475,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "info",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2039,
                      "src": "3925:10:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                        "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                      }
                    },
                    "id": 1476,
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "name",
                    "nodeType": "MemberAccess",
                    "referencedDeclaration": 2031,
                    "src": "3925:15:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "functionReturnParameters": 1473,
                  "id": 1477,
                  "nodeType": "Return",
                  "src": "3918:22:3"
                }
              ]
            },
            "functionSelector": "06fdde03",
            "id": 1479,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "name",
            "nameLocation": "3866:4:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1470,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "3870:2:3"
            },
            "returnParameters": {
              "id": 1473,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1472,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1479,
                  "src": "3896:13:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1471,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "3896:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "3895:15:3"
            },
            "scope": 1994,
            "src": "3857:89:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1488,
              "nodeType": "Block",
              "src": "4122:42:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "expression": {
                        "id": 1484,
                        "name": "build",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1098,
                        "src": "4136:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                          "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                        }
                      },
                      "id": 1485,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "info",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2039,
                      "src": "4136:10:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                        "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                      }
                    },
                    "id": 1486,
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "bonusAmount",
                    "nodeType": "MemberAccess",
                    "referencedDeclaration": 2035,
                    "src": "4136:22:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 1483,
                  "id": 1487,
                  "nodeType": "Return",
                  "src": "4129:29:3"
                }
              ]
            },
            "functionSelector": "abadaf9a",
            "id": 1489,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "bonusAmount",
            "nameLocation": "4079:11:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1480,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4090:2:3"
            },
            "returnParameters": {
              "id": 1483,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1482,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1489,
                  "src": "4116:4:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1481,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "4116:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4115:6:3"
            },
            "scope": 1994,
            "src": "4070:94:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1497,
              "nodeType": "Block",
              "src": "4221:33:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "id": 1494,
                      "name": "build",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1098,
                      "src": "4235:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                      }
                    },
                    "id": 1495,
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "creator",
                    "nodeType": "MemberAccess",
                    "referencedDeclaration": 2049,
                    "src": "4235:13:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "functionReturnParameters": 1493,
                  "id": 1496,
                  "nodeType": "Return",
                  "src": "4228:20:3"
                }
              ]
            },
            "functionSelector": "02d05d3f",
            "id": 1498,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "creator",
            "nameLocation": "4179:7:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1490,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4186:2:3"
            },
            "returnParameters": {
              "id": 1493,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1492,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1498,
                  "src": "4212:7:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 1491,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "4212:7:3",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4211:9:3"
            },
            "scope": 1994,
            "src": "4170:84:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1507,
              "nodeType": "Block",
              "src": "4309:32:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "id": 1504,
                      "name": "build",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1098,
                      "src": "4323:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                      }
                    },
                    "id": 1505,
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "status",
                    "nodeType": "MemberAccess",
                    "referencedDeclaration": 2047,
                    "src": "4323:12:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_Status_$2001",
                      "typeString": "enum SurveyInterface.Status"
                    }
                  },
                  "functionReturnParameters": 1503,
                  "id": 1506,
                  "nodeType": "Return",
                  "src": "4316:19:3"
                }
              ]
            },
            "functionSelector": "200d2ed2",
            "id": 1508,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "status",
            "nameLocation": "4269:6:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1499,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4275:2:3"
            },
            "returnParameters": {
              "id": 1503,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1502,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1508,
                  "src": "4301:6:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_enum$_Status_$2001",
                    "typeString": "enum SurveyInterface.Status"
                  },
                  "typeName": {
                    "id": 1501,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1500,
                      "name": "Status",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2001,
                      "src": "4301:6:3"
                    },
                    "referencedDeclaration": 2001,
                    "src": "4301:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_Status_$2001",
                      "typeString": "enum SurveyInterface.Status"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4300:8:3"
            },
            "scope": 1994,
            "src": "4260:81:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1517,
              "nodeType": "Block",
              "src": "4406:30:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "id": 1514,
                      "name": "build",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1098,
                      "src": "4420:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                      }
                    },
                    "id": 1515,
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "info",
                    "nodeType": "MemberAccess",
                    "referencedDeclaration": 2039,
                    "src": "4420:10:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                      "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                    }
                  },
                  "functionReturnParameters": 1513,
                  "id": 1516,
                  "nodeType": "Return",
                  "src": "4413:17:3"
                }
              ]
            },
            "functionSelector": "370158ea",
            "id": 1518,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "info",
            "nameLocation": "4356:4:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1509,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4360:2:3"
            },
            "returnParameters": {
              "id": 1513,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1512,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1518,
                  "src": "4386:18:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_SurveyBasic_$2036_memory_ptr",
                    "typeString": "struct SurveyInterface.SurveyBasic"
                  },
                  "typeName": {
                    "id": 1511,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1510,
                      "name": "SurveyBasic",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2036,
                      "src": "4386:11:3"
                    },
                    "referencedDeclaration": 2036,
                    "src": "4386:11:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage_ptr",
                      "typeString": "struct SurveyInterface.SurveyBasic"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4385:20:3"
            },
            "scope": 1994,
            "src": "4347:89:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1527,
              "nodeType": "Block",
              "src": "4503:30:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "id": 1524,
                      "name": "build",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1098,
                      "src": "4517:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                        "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                      }
                    },
                    "id": 1525,
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "pool",
                    "nodeType": "MemberAccess",
                    "referencedDeclaration": 2042,
                    "src": "4517:10:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                      "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                    }
                  },
                  "functionReturnParameters": 1523,
                  "id": 1526,
                  "nodeType": "Return",
                  "src": "4510:17:3"
                }
              ]
            },
            "functionSelector": "16f0115b",
            "id": 1528,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "pool",
            "nameLocation": "4451:4:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1519,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4455:2:3"
            },
            "returnParameters": {
              "id": 1523,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1522,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1528,
                  "src": "4481:20:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_LiquidityPool_$2029_memory_ptr",
                    "typeString": "struct SurveyInterface.LiquidityPool"
                  },
                  "typeName": {
                    "id": 1521,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1520,
                      "name": "LiquidityPool",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2029,
                      "src": "4481:13:3"
                    },
                    "referencedDeclaration": 2029,
                    "src": "4481:13:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage_ptr",
                      "typeString": "struct SurveyInterface.LiquidityPool"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4480:22:3"
            },
            "scope": 1994,
            "src": "4442:91:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1539,
              "nodeType": "Block",
              "src": "4658:41:3",
              "statements": [
                {
                  "expression": {
                    "expression": {
                      "arguments": [
                        {
                          "id": 1535,
                          "name": "this",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967268,
                          "src": "4680:4:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_contract$_Survey_$1994",
                            "typeString": "contract Survey"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_contract$_Survey_$1994",
                            "typeString": "contract Survey"
                          }
                        ],
                        "id": 1534,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "nodeType": "ElementaryTypeNameExpression",
                        "src": "4672:7:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_address_$",
                          "typeString": "type(address)"
                        },
                        "typeName": {
                          "id": 1533,
                          "name": "address",
                          "nodeType": "ElementaryTypeName",
                          "src": "4672:7:3",
                          "typeDescriptions": {}
                        }
                      },
                      "id": 1536,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "typeConversion",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "4672:13:3",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "id": 1537,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "memberName": "balance",
                    "nodeType": "MemberAccess",
                    "src": "4672:21:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 1532,
                  "id": 1538,
                  "nodeType": "Return",
                  "src": "4665:28:3"
                }
              ]
            },
            "functionSelector": "12065fe0",
            "id": 1540,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "getBalance",
            "nameLocation": "4616:10:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1529,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4626:2:3"
            },
            "returnParameters": {
              "id": 1532,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1531,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1540,
                  "src": "4652:4:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1530,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "4652:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4651:6:3"
            },
            "scope": 1994,
            "src": "4607:92:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1576,
              "nodeType": "Block",
              "src": "4774:407:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "hexValue": "30",
                        "id": 1547,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "number",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "4816:1:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_rational_0_by_1",
                          "typeString": "int_const 0"
                        },
                        "value": "0"
                      },
                      {
                        "arguments": [
                          {
                            "id": 1550,
                            "name": "this",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967268,
                            "src": "4840:4:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_contract$_Survey_$1994",
                              "typeString": "contract Survey"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_contract$_Survey_$1994",
                              "typeString": "contract Survey"
                            }
                          ],
                          "id": 1549,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "nodeType": "ElementaryTypeNameExpression",
                          "src": "4832:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_type$_t_address_$",
                            "typeString": "type(address)"
                          },
                          "typeName": {
                            "id": 1548,
                            "name": "address",
                            "nodeType": "ElementaryTypeName",
                            "src": "4832:7:3",
                            "typeDescriptions": {}
                          }
                        },
                        "id": 1551,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "typeConversion",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "4832:13:3",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "arguments": [],
                        "expression": {
                          "argumentTypes": [],
                          "id": 1552,
                          "name": "worth",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1613,
                          "src": "4861:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_function_internal_view$__$returns$_t_uint256_$",
                            "typeString": "function () view returns (uint256)"
                          }
                        },
                        "id": 1553,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "functionCall",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "4861:7:3",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "expression": {
                          "expression": {
                            "id": 1554,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "4890:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1555,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "info",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2039,
                          "src": "4890:10:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                            "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                          }
                        },
                        "id": 1556,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "bonusAmount",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2035,
                        "src": "4890:22:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "expression": {
                          "expression": {
                            "id": 1557,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "4927:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1558,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "info",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2039,
                          "src": "4927:10:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                            "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                          }
                        },
                        "id": 1559,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "name",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2031,
                        "src": "4927:15:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_storage",
                          "typeString": "string storage ref"
                        }
                      },
                      {
                        "expression": {
                          "expression": {
                            "id": 1560,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "4964:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1561,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "info",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2039,
                          "src": "4964:10:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                            "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                          }
                        },
                        "id": 1562,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "description",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2033,
                        "src": "4964:22:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_storage",
                          "typeString": "string storage ref"
                        }
                      },
                      {
                        "expression": {
                          "id": 1563,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "5003:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1564,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "status",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2047,
                        "src": "5003:12:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_enum$_Status_$2001",
                          "typeString": "enum SurveyInterface.Status"
                        }
                      },
                      {
                        "expression": {
                          "id": 1565,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "5031:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1566,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "surveysTaken",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2044,
                        "src": "5031:18:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "expression": {
                          "expression": {
                            "id": 1567,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "5067:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1568,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "pool",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2042,
                          "src": "5067:10:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                            "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                          }
                        },
                        "id": 1569,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "gasAmount",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2024,
                        "src": "5067:20:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "expression": {
                          "expression": {
                            "id": 1570,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "5108:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1571,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "pool",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2042,
                          "src": "5108:10:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                            "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                          }
                        },
                        "id": 1572,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "tokenAmount",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2022,
                        "src": "5108:22:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "id": 1573,
                        "name": "questionCount",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1086,
                        "src": "5154:13:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_rational_0_by_1",
                          "typeString": "int_const 0"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_string_storage",
                          "typeString": "string storage ref"
                        },
                        {
                          "typeIdentifier": "t_string_storage",
                          "typeString": "string storage ref"
                        },
                        {
                          "typeIdentifier": "t_enum$_Status_$2001",
                          "typeString": "enum SurveyInterface.Status"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "id": 1546,
                      "name": "SurveyOverview",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2074,
                      "src": "4788:14:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_type$_t_struct$_SurveyOverview_$2074_storage_ptr_$",
                        "typeString": "type(struct SurveyInterface.SurveyOverview storage pointer)"
                      }
                    },
                    "id": 1574,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "structConstructorCall",
                    "lValueRequested": false,
                    "names": [
                      "id",
                      "addr",
                      "worth",
                      "bonusAmount",
                      "name",
                      "description",
                      "status",
                      "taken",
                      "gasLeft",
                      "tokensLeft",
                      "questionCount"
                    ],
                    "nodeType": "FunctionCall",
                    "src": "4788:387:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_SurveyOverview_$2074_memory_ptr",
                      "typeString": "struct SurveyInterface.SurveyOverview memory"
                    }
                  },
                  "functionReturnParameters": 1545,
                  "id": 1575,
                  "nodeType": "Return",
                  "src": "4781:394:3"
                }
              ]
            },
            "functionSelector": "20443e8d",
            "id": 1577,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "getOverview",
            "nameLocation": "4714:11:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1541,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "4725:2:3"
            },
            "returnParameters": {
              "id": 1545,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1544,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1577,
                  "src": "4751:21:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_struct$_SurveyOverview_$2074_memory_ptr",
                    "typeString": "struct SurveyInterface.SurveyOverview"
                  },
                  "typeName": {
                    "id": 1543,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1542,
                      "name": "SurveyOverview",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2074,
                      "src": "4751:14:3"
                    },
                    "referencedDeclaration": 2074,
                    "src": "4751:14:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_SurveyOverview_$2074_storage_ptr",
                      "typeString": "struct SurveyInterface.SurveyOverview"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "4750:23:3"
            },
            "scope": 1994,
            "src": "4705:476:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1612,
              "nodeType": "Block",
              "src": "5231:155:3",
              "statements": [
                {
                  "assignments": [
                    1583
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1583,
                      "mutability": "mutable",
                      "name": "w",
                      "nameLocation": "5243:1:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1612,
                      "src": "5238:6:3",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 1582,
                        "name": "uint",
                        "nodeType": "ElementaryTypeName",
                        "src": "5238:4:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1585,
                  "initialValue": {
                    "hexValue": "30",
                    "id": 1584,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "number",
                    "lValueRequested": false,
                    "nodeType": "Literal",
                    "src": "5247:1:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_rational_0_by_1",
                      "typeString": "int_const 0"
                    },
                    "value": "0"
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "5238:10:3"
                },
                {
                  "body": {
                    "id": 1608,
                    "nodeType": "Block",
                    "src": "5296:70:3",
                    "statements": [
                      {
                        "assignments": [
                          1598
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 1598,
                            "mutability": "mutable",
                            "name": "q",
                            "nameLocation": "5321:1:3",
                            "nodeType": "VariableDeclaration",
                            "scope": 1608,
                            "src": "5305:17:3",
                            "stateVariable": false,
                            "storageLocation": "memory",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                              "typeString": "struct SurveyInterface.Question"
                            },
                            "typeName": {
                              "id": 1597,
                              "nodeType": "UserDefinedTypeName",
                              "pathNode": {
                                "id": 1596,
                                "name": "Question",
                                "nodeType": "IdentifierPath",
                                "referencedDeclaration": 2020,
                                "src": "5305:8:3"
                              },
                              "referencedDeclaration": 2020,
                              "src": "5305:8:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_Question_$2020_storage_ptr",
                                "typeString": "struct SurveyInterface.Question"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 1602,
                        "initialValue": {
                          "baseExpression": {
                            "id": 1599,
                            "name": "questions",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1083,
                            "src": "5325:9:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_mapping$_t_uint256_$_t_struct$_Question_$2020_storage_$",
                              "typeString": "mapping(uint256 => struct SurveyInterface.Question storage ref)"
                            }
                          },
                          "id": 1601,
                          "indexExpression": {
                            "id": 1600,
                            "name": "i",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1587,
                            "src": "5335:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "nodeType": "IndexAccess",
                          "src": "5325:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Question_$2020_storage",
                            "typeString": "struct SurveyInterface.Question storage ref"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "5305:32:3"
                      },
                      {
                        "expression": {
                          "id": 1606,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "id": 1603,
                            "name": "w",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1583,
                            "src": "5346:1:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "+=",
                          "rightHandSide": {
                            "expression": {
                              "id": 1604,
                              "name": "q",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1598,
                              "src": "5351:1:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                                "typeString": "struct SurveyInterface.Question memory"
                              }
                            },
                            "id": 1605,
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "worth",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2010,
                            "src": "5351:7:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "src": "5346:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "id": 1607,
                        "nodeType": "ExpressionStatement",
                        "src": "5346:12:3"
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1592,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1590,
                      "name": "i",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1587,
                      "src": "5272:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "id": 1591,
                      "name": "questionCount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1086,
                      "src": "5276:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "5272:17:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1609,
                  "initializationExpression": {
                    "assignments": [
                      1587
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 1587,
                        "mutability": "mutable",
                        "name": "i",
                        "nameLocation": "5265:1:3",
                        "nodeType": "VariableDeclaration",
                        "scope": 1609,
                        "src": "5260:6:3",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 1586,
                          "name": "uint",
                          "nodeType": "ElementaryTypeName",
                          "src": "5260:4:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 1589,
                    "initialValue": {
                      "hexValue": "30",
                      "id": 1588,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "5269:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "nodeType": "VariableDeclarationStatement",
                    "src": "5260:10:3"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 1594,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "5291:3:3",
                      "subExpression": {
                        "id": 1593,
                        "name": "i",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1587,
                        "src": "5291:1:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 1595,
                    "nodeType": "ExpressionStatement",
                    "src": "5291:3:3"
                  },
                  "nodeType": "ForStatement",
                  "src": "5255:111:3"
                },
                {
                  "expression": {
                    "id": 1610,
                    "name": "w",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1583,
                    "src": "5379:1:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 1581,
                  "id": 1611,
                  "nodeType": "Return",
                  "src": "5372:8:3"
                }
              ]
            },
            "functionSelector": "ad11c131",
            "id": 1613,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "worth",
            "nameLocation": "5196:5:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1578,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "5201:2:3"
            },
            "returnParameters": {
              "id": 1581,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1580,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1613,
                  "src": "5225:4:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1579,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "5225:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5224:6:3"
            },
            "scope": 1994,
            "src": "5187:199:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 1654,
              "nodeType": "Block",
              "src": "5458:185:3",
              "statements": [
                {
                  "assignments": [
                    1624
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1624,
                      "mutability": "mutable",
                      "name": "q",
                      "nameLocation": "5483:1:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1654,
                      "src": "5465:19:3",
                      "stateVariable": false,
                      "storageLocation": "memory",
                      "typeDescriptions": {
                        "typeIdentifier": "t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr",
                        "typeString": "struct SurveyInterface.Question[]"
                      },
                      "typeName": {
                        "baseType": {
                          "id": 1622,
                          "nodeType": "UserDefinedTypeName",
                          "pathNode": {
                            "id": 1621,
                            "name": "Question",
                            "nodeType": "IdentifierPath",
                            "referencedDeclaration": 2020,
                            "src": "5465:8:3"
                          },
                          "referencedDeclaration": 2020,
                          "src": "5465:8:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Question_$2020_storage_ptr",
                            "typeString": "struct SurveyInterface.Question"
                          }
                        },
                        "id": 1623,
                        "nodeType": "ArrayTypeName",
                        "src": "5465:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_struct$_Question_$2020_storage_$dyn_storage_ptr",
                          "typeString": "struct SurveyInterface.Question[]"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1631,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 1629,
                        "name": "questionCount",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1086,
                        "src": "5502:13:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "id": 1628,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "lValueRequested": false,
                      "nodeType": "NewExpression",
                      "src": "5487:14:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr_$",
                        "typeString": "function (uint256) pure returns (struct SurveyInterface.Question memory[] memory)"
                      },
                      "typeName": {
                        "baseType": {
                          "id": 1626,
                          "nodeType": "UserDefinedTypeName",
                          "pathNode": {
                            "id": 1625,
                            "name": "Question",
                            "nodeType": "IdentifierPath",
                            "referencedDeclaration": 2020,
                            "src": "5491:8:3"
                          },
                          "referencedDeclaration": 2020,
                          "src": "5491:8:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Question_$2020_storage_ptr",
                            "typeString": "struct SurveyInterface.Question"
                          }
                        },
                        "id": 1627,
                        "nodeType": "ArrayTypeName",
                        "src": "5491:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_struct$_Question_$2020_storage_$dyn_storage_ptr",
                          "typeString": "struct SurveyInterface.Question[]"
                        }
                      }
                    },
                    "id": 1630,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "5487:29:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr",
                      "typeString": "struct SurveyInterface.Question memory[] memory"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "5465:51:3"
                },
                {
                  "body": {
                    "id": 1650,
                    "nodeType": "Block",
                    "src": "5579:44:3",
                    "statements": [
                      {
                        "expression": {
                          "id": 1648,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "baseExpression": {
                              "id": 1642,
                              "name": "q",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1624,
                              "src": "5588:1:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr",
                                "typeString": "struct SurveyInterface.Question memory[] memory"
                              }
                            },
                            "id": 1644,
                            "indexExpression": {
                              "id": 1643,
                              "name": "index",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1633,
                              "src": "5590:5:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": true,
                            "nodeType": "IndexAccess",
                            "src": "5588:8:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                              "typeString": "struct SurveyInterface.Question memory"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "=",
                          "rightHandSide": {
                            "baseExpression": {
                              "id": 1645,
                              "name": "questions",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1083,
                              "src": "5599:9:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_mapping$_t_uint256_$_t_struct$_Question_$2020_storage_$",
                                "typeString": "mapping(uint256 => struct SurveyInterface.Question storage ref)"
                              }
                            },
                            "id": 1647,
                            "indexExpression": {
                              "id": 1646,
                              "name": "index",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1633,
                              "src": "5609:5:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": false,
                            "nodeType": "IndexAccess",
                            "src": "5599:16:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_Question_$2020_storage",
                              "typeString": "struct SurveyInterface.Question storage ref"
                            }
                          },
                          "src": "5588:27:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                            "typeString": "struct SurveyInterface.Question memory"
                          }
                        },
                        "id": 1649,
                        "nodeType": "ExpressionStatement",
                        "src": "5588:27:3"
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1638,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1636,
                      "name": "index",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1633,
                      "src": "5547:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "id": 1637,
                      "name": "questionCount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1086,
                      "src": "5555:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "5547:21:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1651,
                  "initializationExpression": {
                    "assignments": [
                      1633
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 1633,
                        "mutability": "mutable",
                        "name": "index",
                        "nameLocation": "5536:5:3",
                        "nodeType": "VariableDeclaration",
                        "scope": 1651,
                        "src": "5528:13:3",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 1632,
                          "name": "uint256",
                          "nodeType": "ElementaryTypeName",
                          "src": "5528:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 1635,
                    "initialValue": {
                      "hexValue": "30",
                      "id": 1634,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "5544:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "nodeType": "VariableDeclarationStatement",
                    "src": "5528:17:3"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 1640,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "5570:7:3",
                      "subExpression": {
                        "id": 1639,
                        "name": "index",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1633,
                        "src": "5570:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 1641,
                    "nodeType": "ExpressionStatement",
                    "src": "5570:7:3"
                  },
                  "nodeType": "ForStatement",
                  "src": "5523:100:3"
                },
                {
                  "expression": {
                    "id": 1652,
                    "name": "q",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1624,
                    "src": "5636:1:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr",
                      "typeString": "struct SurveyInterface.Question memory[] memory"
                    }
                  },
                  "functionReturnParameters": 1619,
                  "id": 1653,
                  "nodeType": "Return",
                  "src": "5629:8:3"
                }
              ]
            },
            "functionSelector": "97221ab7",
            "id": 1655,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "getQuestions",
            "nameLocation": "5401:12:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1614,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "5413:2:3"
            },
            "returnParameters": {
              "id": 1619,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1618,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1655,
                  "src": "5439:17:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_array$_t_struct$_Question_$2020_memory_ptr_$dyn_memory_ptr",
                    "typeString": "struct SurveyInterface.Question[]"
                  },
                  "typeName": {
                    "baseType": {
                      "id": 1616,
                      "nodeType": "UserDefinedTypeName",
                      "pathNode": {
                        "id": 1615,
                        "name": "Question",
                        "nodeType": "IdentifierPath",
                        "referencedDeclaration": 2020,
                        "src": "5439:8:3"
                      },
                      "referencedDeclaration": 2020,
                      "src": "5439:8:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_Question_$2020_storage_ptr",
                        "typeString": "struct SurveyInterface.Question"
                      }
                    },
                    "id": 1617,
                    "nodeType": "ArrayTypeName",
                    "src": "5439:10:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_struct$_Question_$2020_storage_$dyn_storage_ptr",
                      "typeString": "struct SurveyInterface.Question[]"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5438:19:3"
            },
            "scope": 1994,
            "src": "5392:251:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1676,
              "nodeType": "Block",
              "src": "5729:64:3",
              "statements": [
                {
                  "assignments": [
                    1669
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1669,
                      "mutability": "mutable",
                      "name": "ret",
                      "nameLocation": "5752:3:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1676,
                      "src": "5736:19:3",
                      "stateVariable": false,
                      "storageLocation": "memory",
                      "typeDescriptions": {
                        "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                        "typeString": "string[]"
                      },
                      "typeName": {
                        "baseType": {
                          "id": 1667,
                          "name": "string",
                          "nodeType": "ElementaryTypeName",
                          "src": "5736:6:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_string_storage_ptr",
                            "typeString": "string"
                          }
                        },
                        "id": 1668,
                        "nodeType": "ArrayTypeName",
                        "src": "5736:8:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_string_storage_$dyn_storage_ptr",
                          "typeString": "string[]"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1673,
                  "initialValue": {
                    "baseExpression": {
                      "id": 1670,
                      "name": "answers",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1091,
                      "src": "5758:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_mapping$_t_uint256_$_t_array$_t_string_storage_$dyn_storage_$",
                        "typeString": "mapping(uint256 => string storage ref[] storage ref)"
                      }
                    },
                    "id": 1672,
                    "indexExpression": {
                      "id": 1671,
                      "name": "qid",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1657,
                      "src": "5766:3:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "nodeType": "IndexAccess",
                    "src": "5758:12:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_string_storage_$dyn_storage",
                      "typeString": "string storage ref[] storage ref"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "5736:34:3"
                },
                {
                  "expression": {
                    "id": 1674,
                    "name": "ret",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 1669,
                    "src": "5784:3:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                      "typeString": "string memory[] memory"
                    }
                  },
                  "functionReturnParameters": 1664,
                  "id": 1675,
                  "nodeType": "Return",
                  "src": "5777:10:3"
                }
              ]
            },
            "functionSelector": "1e59e02a",
            "id": 1677,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1660,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1659,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "5693:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "5693:9:3"
              }
            ],
            "name": "getAnswers",
            "nameLocation": "5658:10:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1658,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1657,
                  "mutability": "mutable",
                  "name": "qid",
                  "nameLocation": "5674:3:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1677,
                  "src": "5669:8:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1656,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "5669:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5668:10:3"
            },
            "returnParameters": {
              "id": 1664,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1663,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1677,
                  "src": "5712:15:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                    "typeString": "string[]"
                  },
                  "typeName": {
                    "baseType": {
                      "id": 1661,
                      "name": "string",
                      "nodeType": "ElementaryTypeName",
                      "src": "5712:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage_ptr",
                        "typeString": "string"
                      }
                    },
                    "id": 1662,
                    "nodeType": "ArrayTypeName",
                    "src": "5712:8:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_string_storage_$dyn_storage_ptr",
                      "typeString": "string[]"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "5711:17:3"
            },
            "scope": 1994,
            "src": "5649:144:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1721,
              "nodeType": "Block",
              "src": "6289:208:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_enum$_Status_$2001",
                          "typeString": "enum SurveyInterface.Status"
                        },
                        "id": 1693,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1689,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "6304:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1690,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "status",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2047,
                          "src": "6304:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "expression": {
                            "id": 1691,
                            "name": "Status",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2001,
                            "src": "6320:6:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_enum$_Status_$2001_$",
                              "typeString": "type(enum SurveyInterface.Status)"
                            }
                          },
                          "id": 1692,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "memberName": "NOT_OPENED",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 1998,
                          "src": "6320:17:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "src": "6304:33:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "537572766579206d75737420626520696e2065646974696e67207374616765",
                        "id": 1694,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "6339:33:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3",
                          "typeString": "literal_string \"Survey must be in editing stage\""
                        },
                        "value": "Survey must be in editing stage"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3",
                          "typeString": "literal_string \"Survey must be in editing stage\""
                        }
                      ],
                      "id": 1688,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "6296:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1695,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6296:77:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1696,
                  "nodeType": "ExpressionStatement",
                  "src": "6296:77:3"
                },
                {
                  "expression": {
                    "id": 1703,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1697,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "6380:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1700,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "info",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2039,
                        "src": "6380:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                          "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                        }
                      },
                      "id": 1701,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "name",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2031,
                      "src": "6380:15:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage",
                        "typeString": "string storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1702,
                      "name": "_name",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1679,
                      "src": "6398:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_memory_ptr",
                        "typeString": "string memory"
                      }
                    },
                    "src": "6380:23:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "id": 1704,
                  "nodeType": "ExpressionStatement",
                  "src": "6380:23:3"
                },
                {
                  "expression": {
                    "id": 1711,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1705,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "6410:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1708,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "info",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2039,
                        "src": "6410:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                          "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                        }
                      },
                      "id": 1709,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "description",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2033,
                      "src": "6410:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage",
                        "typeString": "string storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1710,
                      "name": "_description",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1681,
                      "src": "6435:12:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_memory_ptr",
                        "typeString": "string memory"
                      }
                    },
                    "src": "6410:37:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage",
                      "typeString": "string storage ref"
                    }
                  },
                  "id": 1712,
                  "nodeType": "ExpressionStatement",
                  "src": "6410:37:3"
                },
                {
                  "expression": {
                    "id": 1719,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1713,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "6454:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1716,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "info",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2039,
                        "src": "6454:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_SurveyBasic_$2036_storage",
                          "typeString": "struct SurveyInterface.SurveyBasic storage ref"
                        }
                      },
                      "id": 1717,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "bonusAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2035,
                      "src": "6454:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 1718,
                      "name": "_bonusAmount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1683,
                      "src": "6479:12:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "6454:37:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1720,
                  "nodeType": "ExpressionStatement",
                  "src": "6454:37:3"
                }
              ]
            },
            "functionSelector": "1eea56a3",
            "id": 1722,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1686,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1685,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "6279:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "6279:9:3"
              }
            ],
            "name": "updateSurvey",
            "nameLocation": "6171:12:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1684,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1679,
                  "mutability": "mutable",
                  "name": "_name",
                  "nameLocation": "6204:5:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1722,
                  "src": "6190:19:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1678,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "6190:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1681,
                  "mutability": "mutable",
                  "name": "_description",
                  "nameLocation": "6230:12:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1722,
                  "src": "6216:26:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1680,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "6216:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1683,
                  "mutability": "mutable",
                  "name": "_bonusAmount",
                  "nameLocation": "6254:12:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1722,
                  "src": "6249:17:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1682,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "6249:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6183:88:3"
            },
            "returnParameters": {
              "id": 1687,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "6289:0:3"
            },
            "scope": 1994,
            "src": "6162:335:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 1769,
              "nodeType": "Block",
              "src": "6720:298:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_enum$_Status_$2001",
                          "typeString": "enum SurveyInterface.Status"
                        },
                        "id": 1748,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1744,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "6735:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1745,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "status",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2047,
                          "src": "6735:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "expression": {
                            "id": 1746,
                            "name": "Status",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2001,
                            "src": "6751:6:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_enum$_Status_$2001_$",
                              "typeString": "type(enum SurveyInterface.Status)"
                            }
                          },
                          "id": 1747,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "memberName": "NOT_OPENED",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 1998,
                          "src": "6751:17:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "src": "6735:33:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "537572766579206d75737420626520696e2065646974696e67207374616765",
                        "id": 1749,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "6770:33:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3",
                          "typeString": "literal_string \"Survey must be in editing stage\""
                        },
                        "value": "Survey must be in editing stage"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3",
                          "typeString": "literal_string \"Survey must be in editing stage\""
                        }
                      ],
                      "id": 1743,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "6727:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1750,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6727:77:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1751,
                  "nodeType": "ExpressionStatement",
                  "src": "6727:77:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 1753,
                        "name": "questionCount",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1086,
                        "src": "6834:13:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "id": 1754,
                        "name": "_qtypes",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1725,
                        "src": "6856:7:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_enum$_QuestionType_$2005",
                          "typeString": "enum SurveyInterface.QuestionType"
                        }
                      },
                      {
                        "id": 1755,
                        "name": "_worth",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1727,
                        "src": "6872:6:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "id": 1756,
                        "name": "_required",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1729,
                        "src": "6887:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "id": 1757,
                        "name": "_title",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1731,
                        "src": "6905:6:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      },
                      {
                        "id": 1758,
                        "name": "_qdescription",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1733,
                        "src": "6920:13:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        }
                      },
                      {
                        "id": 1759,
                        "name": "_choices",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1736,
                        "src": "6942:8:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                          "typeString": "string memory[] memory"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_enum$_QuestionType_$2005",
                          "typeString": "enum SurveyInterface.QuestionType"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        },
                        {
                          "typeIdentifier": "t_string_memory_ptr",
                          "typeString": "string memory"
                        },
                        {
                          "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                          "typeString": "string memory[] memory"
                        }
                      ],
                      "id": 1752,
                      "name": "updateQuestion",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1814,
                      "src": "6811:14:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_nonpayable$_t_uint256_$_t_enum$_QuestionType_$2005_$_t_uint256_$_t_bool_$_t_string_memory_ptr_$_t_string_memory_ptr_$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$returns$__$",
                        "typeString": "function (uint256,enum SurveyInterface.QuestionType,uint256,bool,string memory,string memory,string memory[] memory)"
                      }
                    },
                    "id": 1760,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "6811:146:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1761,
                  "nodeType": "ExpressionStatement",
                  "src": "6811:146:3"
                },
                {
                  "expression": {
                    "id": 1763,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "nodeType": "UnaryOperation",
                    "operator": "++",
                    "prefix": false,
                    "src": "6964:15:3",
                    "subExpression": {
                      "id": 1762,
                      "name": "questionCount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1086,
                      "src": "6964:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1764,
                  "nodeType": "ExpressionStatement",
                  "src": "6964:15:3"
                },
                {
                  "expression": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1767,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1765,
                      "name": "questionCount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1086,
                      "src": "6995:13:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "-",
                    "rightExpression": {
                      "hexValue": "31",
                      "id": 1766,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "7011:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_1_by_1",
                        "typeString": "int_const 1"
                      },
                      "value": "1"
                    },
                    "src": "6995:17:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "functionReturnParameters": 1742,
                  "id": 1768,
                  "nodeType": "Return",
                  "src": "6988:24:3"
                }
              ]
            },
            "functionSelector": "482ff513",
            "id": 1770,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1739,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1738,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "6695:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "6695:9:3"
              }
            ],
            "name": "addQuestion",
            "nameLocation": "6512:11:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1737,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1725,
                  "mutability": "mutable",
                  "name": "_qtypes",
                  "nameLocation": "6543:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6530:20:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_enum$_QuestionType_$2005",
                    "typeString": "enum SurveyInterface.QuestionType"
                  },
                  "typeName": {
                    "id": 1724,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1723,
                      "name": "QuestionType",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2005,
                      "src": "6530:12:3"
                    },
                    "referencedDeclaration": 2005,
                    "src": "6530:12:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_QuestionType_$2005",
                      "typeString": "enum SurveyInterface.QuestionType"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1727,
                  "mutability": "mutable",
                  "name": "_worth",
                  "nameLocation": "6562:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6557:11:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1726,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "6557:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1729,
                  "mutability": "mutable",
                  "name": "_required",
                  "nameLocation": "6580:9:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6575:14:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bool",
                    "typeString": "bool"
                  },
                  "typeName": {
                    "id": 1728,
                    "name": "bool",
                    "nodeType": "ElementaryTypeName",
                    "src": "6575:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1731,
                  "mutability": "mutable",
                  "name": "_title",
                  "nameLocation": "6610:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6596:20:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1730,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "6596:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1733,
                  "mutability": "mutable",
                  "name": "_qdescription",
                  "nameLocation": "6637:13:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6623:27:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1732,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "6623:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1736,
                  "mutability": "mutable",
                  "name": "_choices",
                  "nameLocation": "6673:8:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6657:24:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                    "typeString": "string[]"
                  },
                  "typeName": {
                    "baseType": {
                      "id": 1734,
                      "name": "string",
                      "nodeType": "ElementaryTypeName",
                      "src": "6657:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage_ptr",
                        "typeString": "string"
                      }
                    },
                    "id": 1735,
                    "nodeType": "ArrayTypeName",
                    "src": "6657:8:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_string_storage_$dyn_storage_ptr",
                      "typeString": "string[]"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6523:163:3"
            },
            "returnParameters": {
              "id": 1742,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1741,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1770,
                  "src": "6714:4:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1740,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "6714:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "6713:6:3"
            },
            "scope": 1994,
            "src": "6503:515:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 1813,
              "nodeType": "Block",
              "src": "7243:232:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_enum$_Status_$2001",
                          "typeString": "enum SurveyInterface.Status"
                        },
                        "id": 1796,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1792,
                            "name": "build",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 1098,
                            "src": "7258:5:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                              "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                            }
                          },
                          "id": 1793,
                          "isConstant": false,
                          "isLValue": true,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "status",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 2047,
                          "src": "7258:12:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "expression": {
                            "id": 1794,
                            "name": "Status",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2001,
                            "src": "7274:6:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_enum$_Status_$2001_$",
                              "typeString": "type(enum SurveyInterface.Status)"
                            }
                          },
                          "id": 1795,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "memberName": "NOT_OPENED",
                          "nodeType": "MemberAccess",
                          "referencedDeclaration": 1998,
                          "src": "7274:17:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_Status_$2001",
                            "typeString": "enum SurveyInterface.Status"
                          }
                        },
                        "src": "7258:33:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "537572766579206d75737420626520696e2065646974696e67207374616765",
                        "id": 1797,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "7293:33:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3",
                          "typeString": "literal_string \"Survey must be in editing stage\""
                        },
                        "value": "Survey must be in editing stage"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_4904aa88ff370ef9a966eb530159721289370ce5da29b6bfcde2e70529fae2e3",
                          "typeString": "literal_string \"Survey must be in editing stage\""
                        }
                      ],
                      "id": 1791,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "7250:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1798,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "7250:77:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1799,
                  "nodeType": "ExpressionStatement",
                  "src": "7250:77:3"
                },
                {
                  "expression": {
                    "id": 1811,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "baseExpression": {
                        "id": 1800,
                        "name": "questions",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1083,
                        "src": "7334:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_mapping$_t_uint256_$_t_struct$_Question_$2020_storage_$",
                          "typeString": "mapping(uint256 => struct SurveyInterface.Question storage ref)"
                        }
                      },
                      "id": 1802,
                      "indexExpression": {
                        "id": 1801,
                        "name": "_id",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1772,
                        "src": "7344:3:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "nodeType": "IndexAccess",
                      "src": "7334:14:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_Question_$2020_storage",
                        "typeString": "struct SurveyInterface.Question storage ref"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "arguments": [
                        {
                          "id": 1804,
                          "name": "_qtypes",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1775,
                          "src": "7368:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_enum$_QuestionType_$2005",
                            "typeString": "enum SurveyInterface.QuestionType"
                          }
                        },
                        {
                          "id": 1805,
                          "name": "_worth",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1777,
                          "src": "7384:6:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        {
                          "id": 1806,
                          "name": "_required",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1779,
                          "src": "7399:9:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        {
                          "id": 1807,
                          "name": "_title",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1781,
                          "src": "7417:6:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_string_memory_ptr",
                            "typeString": "string memory"
                          }
                        },
                        {
                          "id": 1808,
                          "name": "_qdescription",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1783,
                          "src": "7432:13:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_string_memory_ptr",
                            "typeString": "string memory"
                          }
                        },
                        {
                          "id": 1809,
                          "name": "_choices",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1786,
                          "src": "7454:8:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                            "typeString": "string memory[] memory"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_enum$_QuestionType_$2005",
                            "typeString": "enum SurveyInterface.QuestionType"
                          },
                          {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          },
                          {
                            "typeIdentifier": "t_string_memory_ptr",
                            "typeString": "string memory"
                          },
                          {
                            "typeIdentifier": "t_string_memory_ptr",
                            "typeString": "string memory"
                          },
                          {
                            "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                            "typeString": "string memory[] memory"
                          }
                        ],
                        "id": 1803,
                        "name": "Question",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2020,
                        "src": "7351:8:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_struct$_Question_$2020_storage_ptr_$",
                          "typeString": "type(struct SurveyInterface.Question storage pointer)"
                        }
                      },
                      "id": 1810,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "structConstructorCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "7351:118:3",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_Question_$2020_memory_ptr",
                        "typeString": "struct SurveyInterface.Question memory"
                      }
                    },
                    "src": "7334:135:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_struct$_Question_$2020_storage",
                      "typeString": "struct SurveyInterface.Question storage ref"
                    }
                  },
                  "id": 1812,
                  "nodeType": "ExpressionStatement",
                  "src": "7334:135:3"
                }
              ]
            },
            "functionSelector": "4a4cd405",
            "id": 1814,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1789,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1788,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "7233:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "7233:9:3"
              }
            ],
            "name": "updateQuestion",
            "nameLocation": "7033:14:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1787,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1772,
                  "mutability": "mutable",
                  "name": "_id",
                  "nameLocation": "7059:3:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7054:8:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1771,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "7054:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1775,
                  "mutability": "mutable",
                  "name": "_qtypes",
                  "nameLocation": "7082:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7069:20:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_enum$_QuestionType_$2005",
                    "typeString": "enum SurveyInterface.QuestionType"
                  },
                  "typeName": {
                    "id": 1774,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1773,
                      "name": "QuestionType",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2005,
                      "src": "7069:12:3"
                    },
                    "referencedDeclaration": 2005,
                    "src": "7069:12:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_enum$_QuestionType_$2005",
                      "typeString": "enum SurveyInterface.QuestionType"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1777,
                  "mutability": "mutable",
                  "name": "_worth",
                  "nameLocation": "7101:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7096:11:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1776,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "7096:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1779,
                  "mutability": "mutable",
                  "name": "_required",
                  "nameLocation": "7119:9:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7114:14:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bool",
                    "typeString": "bool"
                  },
                  "typeName": {
                    "id": 1778,
                    "name": "bool",
                    "nodeType": "ElementaryTypeName",
                    "src": "7114:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1781,
                  "mutability": "mutable",
                  "name": "_title",
                  "nameLocation": "7149:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7135:20:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1780,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "7135:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1783,
                  "mutability": "mutable",
                  "name": "_qdescription",
                  "nameLocation": "7176:13:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7162:27:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_string_memory_ptr",
                    "typeString": "string"
                  },
                  "typeName": {
                    "id": 1782,
                    "name": "string",
                    "nodeType": "ElementaryTypeName",
                    "src": "7162:6:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_string_storage_ptr",
                      "typeString": "string"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1786,
                  "mutability": "mutable",
                  "name": "_choices",
                  "nameLocation": "7212:8:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1814,
                  "src": "7196:24:3",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_array$_t_string_memory_ptr_$dyn_memory_ptr",
                    "typeString": "string[]"
                  },
                  "typeName": {
                    "baseType": {
                      "id": 1784,
                      "name": "string",
                      "nodeType": "ElementaryTypeName",
                      "src": "7196:6:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_string_storage_ptr",
                        "typeString": "string"
                      }
                    },
                    "id": 1785,
                    "nodeType": "ArrayTypeName",
                    "src": "7196:8:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_string_storage_$dyn_storage_ptr",
                      "typeString": "string[]"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "7047:178:3"
            },
            "returnParameters": {
              "id": 1790,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "7243:0:3"
            },
            "scope": 1994,
            "src": "7024:451:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 1851,
              "nodeType": "Block",
              "src": "7562:172:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1827,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "id": 1825,
                          "name": "_amount",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1819,
                          "src": "7577:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">",
                        "rightExpression": {
                          "hexValue": "30",
                          "id": 1826,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "number",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "7587:1:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_rational_0_by_1",
                            "typeString": "int_const 0"
                          },
                          "value": "0"
                        },
                        "src": "7577:11:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "616d6f756e742068617320746f2062652067726561746572207468616e207a65726f",
                        "id": 1828,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "7590:36:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        },
                        "value": "amount has to be greater than zero"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        }
                      ],
                      "id": 1824,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "7569:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1829,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "7569:58:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1830,
                  "nodeType": "ExpressionStatement",
                  "src": "7569:58:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "expression": {
                          "id": 1834,
                          "name": "tx",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967270,
                          "src": "7654:2:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_transaction",
                            "typeString": "tx"
                          }
                        },
                        "id": 1835,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "origin",
                        "nodeType": "MemberAccess",
                        "src": "7654:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "arguments": [
                          {
                            "id": 1838,
                            "name": "this",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967268,
                            "src": "7673:4:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_contract$_Survey_$1994",
                              "typeString": "contract Survey"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_contract$_Survey_$1994",
                              "typeString": "contract Survey"
                            }
                          ],
                          "id": 1837,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "nodeType": "ElementaryTypeNameExpression",
                          "src": "7665:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_type$_t_address_$",
                            "typeString": "type(address)"
                          },
                          "typeName": {
                            "id": 1836,
                            "name": "address",
                            "nodeType": "ElementaryTypeName",
                            "src": "7665:7:3",
                            "typeDescriptions": {}
                          }
                        },
                        "id": 1839,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "typeConversion",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "7665:13:3",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 1840,
                        "name": "_amount",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1819,
                        "src": "7680:7:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "expression": {
                        "id": 1831,
                        "name": "_token",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1817,
                        "src": "7634:6:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_Token_$2124",
                          "typeString": "contract Token"
                        }
                      },
                      "id": 1833,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "transferFrom",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2114,
                      "src": "7634:19:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_bool_$",
                        "typeString": "function (address,address,uint256) external returns (bool)"
                      }
                    },
                    "id": 1841,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "7634:54:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1842,
                  "nodeType": "ExpressionStatement",
                  "src": "7634:54:3"
                },
                {
                  "expression": {
                    "id": 1849,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1843,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "7695:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1846,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "7695:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1847,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "tokenAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2022,
                      "src": "7695:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "+=",
                    "rightHandSide": {
                      "id": 1848,
                      "name": "_amount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1819,
                      "src": "7721:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "7695:33:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1850,
                  "nodeType": "ExpressionStatement",
                  "src": "7695:33:3"
                }
              ]
            },
            "functionSelector": "38745a1c",
            "id": 1852,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1822,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1821,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "7552:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "7552:9:3"
              }
            ],
            "name": "depositToSurveyTokenPool",
            "nameLocation": "7490:24:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1820,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1817,
                  "mutability": "mutable",
                  "name": "_token",
                  "nameLocation": "7521:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1852,
                  "src": "7515:12:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_contract$_Token_$2124",
                    "typeString": "contract Token"
                  },
                  "typeName": {
                    "id": 1816,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1815,
                      "name": "Token",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2124,
                      "src": "7515:5:3"
                    },
                    "referencedDeclaration": 2124,
                    "src": "7515:5:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_Token_$2124",
                      "typeString": "contract Token"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1819,
                  "mutability": "mutable",
                  "name": "_amount",
                  "nameLocation": "7534:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1852,
                  "src": "7529:12:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1818,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "7529:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "7514:28:3"
            },
            "returnParameters": {
              "id": 1823,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "7562:0:3"
            },
            "scope": 1994,
            "src": "7481:253:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1874,
              "nodeType": "Block",
              "src": "7801:113:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1861,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "id": 1858,
                            "name": "msg",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 4294967281,
                            "src": "7816:3:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_magic_message",
                              "typeString": "msg"
                            }
                          },
                          "id": 1859,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "value",
                          "nodeType": "MemberAccess",
                          "src": "7816:9:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">",
                        "rightExpression": {
                          "hexValue": "30",
                          "id": 1860,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "number",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "7828:1:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_rational_0_by_1",
                            "typeString": "int_const 0"
                          },
                          "value": "0"
                        },
                        "src": "7816:13:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "616d6f756e742068617320746f2062652067726561746572207468616e207a65726f",
                        "id": 1862,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "7831:36:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        },
                        "value": "amount has to be greater than zero"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        }
                      ],
                      "id": 1857,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "7808:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1863,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "7808:60:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1864,
                  "nodeType": "ExpressionStatement",
                  "src": "7808:60:3"
                },
                {
                  "expression": {
                    "id": 1872,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1865,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "7875:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1868,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "7875:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1869,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "gasAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2024,
                      "src": "7875:20:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "+=",
                    "rightHandSide": {
                      "expression": {
                        "id": 1870,
                        "name": "msg",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 4294967281,
                        "src": "7899:3:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_magic_message",
                          "typeString": "msg"
                        }
                      },
                      "id": 1871,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "value",
                      "nodeType": "MemberAccess",
                      "src": "7899:9:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "7875:33:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1873,
                  "nodeType": "ExpressionStatement",
                  "src": "7875:33:3"
                }
              ]
            },
            "functionSelector": "31767ffd",
            "id": 1875,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1855,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1854,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "7791:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "7791:9:3"
              }
            ],
            "name": "depositToSurveyGasPool",
            "nameLocation": "7749:22:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1853,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "7771:2:3"
            },
            "returnParameters": {
              "id": 1856,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "7801:0:3"
            },
            "scope": 1994,
            "src": "7740:174:3",
            "stateMutability": "payable",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1921,
              "nodeType": "Block",
              "src": "7998:263:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1888,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "id": 1886,
                          "name": "_amount",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1880,
                          "src": "8013:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">",
                        "rightExpression": {
                          "hexValue": "30",
                          "id": 1887,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "number",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "8023:1:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_rational_0_by_1",
                            "typeString": "int_const 0"
                          },
                          "value": "0"
                        },
                        "src": "8013:11:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "616d6f756e742068617320746f2062652067726561746572207468616e207a65726f",
                        "id": 1889,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "8026:36:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        },
                        "value": "amount has to be greater than zero"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        }
                      ],
                      "id": 1885,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "8005:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1890,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8005:58:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1891,
                  "nodeType": "ExpressionStatement",
                  "src": "8005:58:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1901,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "arguments": [
                            {
                              "arguments": [
                                {
                                  "id": 1897,
                                  "name": "this",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 4294967268,
                                  "src": "8103:4:3",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_contract$_Survey_$1994",
                                    "typeString": "contract Survey"
                                  }
                                }
                              ],
                              "expression": {
                                "argumentTypes": [
                                  {
                                    "typeIdentifier": "t_contract$_Survey_$1994",
                                    "typeString": "contract Survey"
                                  }
                                ],
                                "id": 1896,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": true,
                                "lValueRequested": false,
                                "nodeType": "ElementaryTypeNameExpression",
                                "src": "8095:7:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_type$_t_address_$",
                                  "typeString": "type(address)"
                                },
                                "typeName": {
                                  "id": 1895,
                                  "name": "address",
                                  "nodeType": "ElementaryTypeName",
                                  "src": "8095:7:3",
                                  "typeDescriptions": {}
                                }
                              },
                              "id": 1898,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": false,
                              "kind": "typeConversion",
                              "lValueRequested": false,
                              "names": [],
                              "nodeType": "FunctionCall",
                              "src": "8095:13:3",
                              "tryCall": false,
                              "typeDescriptions": {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            ],
                            "expression": {
                              "id": 1893,
                              "name": "_token",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 1878,
                              "src": "8078:6:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_contract$_Token_$2124",
                                "typeString": "contract Token"
                              }
                            },
                            "id": 1894,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "balanceOf",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 2085,
                            "src": "8078:16:3",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_external_view$_t_address_$returns$_t_uint256_$",
                              "typeString": "function (address) view external returns (uint256)"
                            }
                          },
                          "id": 1899,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "8078:31:3",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">=",
                        "rightExpression": {
                          "id": 1900,
                          "name": "_amount",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1880,
                          "src": "8113:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "src": "8078:42:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "42616c616e63652068617320746f206265203e3d207468616e2074686520616d6f756e7420746f207769746864726177",
                        "id": 1902,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "8122:50:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_951ece5d5af66174f14cd35238da3522fbecff682f2440d776cb968d376dbcbf",
                          "typeString": "literal_string \"Balance has to be >= than the amount to withdraw\""
                        },
                        "value": "Balance has to be >= than the amount to withdraw"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_951ece5d5af66174f14cd35238da3522fbecff682f2440d776cb968d376dbcbf",
                          "typeString": "literal_string \"Balance has to be >= than the amount to withdraw\""
                        }
                      ],
                      "id": 1892,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "8070:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1903,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8070:103:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1904,
                  "nodeType": "ExpressionStatement",
                  "src": "8070:103:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "expression": {
                          "id": 1908,
                          "name": "tx",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967270,
                          "src": "8196:2:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_transaction",
                            "typeString": "tx"
                          }
                        },
                        "id": 1909,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "origin",
                        "nodeType": "MemberAccess",
                        "src": "8196:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 1910,
                        "name": "_amount",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1880,
                        "src": "8207:7:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "expression": {
                        "id": 1905,
                        "name": "_token",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1878,
                        "src": "8180:6:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_Token_$2124",
                          "typeString": "contract Token"
                        }
                      },
                      "id": 1907,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "transfer",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2103,
                      "src": "8180:15:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
                        "typeString": "function (address,uint256) external returns (bool)"
                      }
                    },
                    "id": 1911,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8180:35:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1912,
                  "nodeType": "ExpressionStatement",
                  "src": "8180:35:3"
                },
                {
                  "expression": {
                    "id": 1919,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1913,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "8222:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1916,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "8222:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1917,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "tokenAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2022,
                      "src": "8222:22:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "-=",
                    "rightHandSide": {
                      "id": 1918,
                      "name": "_amount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1880,
                      "src": "8248:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "8222:33:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1920,
                  "nodeType": "ExpressionStatement",
                  "src": "8222:33:3"
                }
              ]
            },
            "functionSelector": "1275b3bb",
            "id": 1922,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1883,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1882,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "7988:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "7988:9:3"
              }
            ],
            "name": "withdrawFromTokenPool",
            "nameLocation": "7929:21:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1881,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1878,
                  "mutability": "mutable",
                  "name": "_token",
                  "nameLocation": "7957:6:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1922,
                  "src": "7951:12:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_contract$_Token_$2124",
                    "typeString": "contract Token"
                  },
                  "typeName": {
                    "id": 1877,
                    "nodeType": "UserDefinedTypeName",
                    "pathNode": {
                      "id": 1876,
                      "name": "Token",
                      "nodeType": "IdentifierPath",
                      "referencedDeclaration": 2124,
                      "src": "7951:5:3"
                    },
                    "referencedDeclaration": 2124,
                    "src": "7951:5:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_Token_$2124",
                      "typeString": "contract Token"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 1880,
                  "mutability": "mutable",
                  "name": "_amount",
                  "nameLocation": "7970:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1922,
                  "src": "7965:12:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1879,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "7965:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "7950:28:3"
            },
            "returnParameters": {
              "id": 1884,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "7998:0:3"
            },
            "scope": 1994,
            "src": "7920:341:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1969,
              "nodeType": "Block",
              "src": "8329:288:3",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1932,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "id": 1930,
                          "name": "_amount",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1924,
                          "src": "8344:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">",
                        "rightExpression": {
                          "hexValue": "30",
                          "id": 1931,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "number",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "8354:1:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_rational_0_by_1",
                            "typeString": "int_const 0"
                          },
                          "value": "0"
                        },
                        "src": "8344:11:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "616d6f756e742068617320746f2062652067726561746572207468616e207a65726f",
                        "id": 1933,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "8357:36:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        },
                        "value": "amount has to be greater than zero"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_f64017aa436f5238e8bf46c35d1f20839f37a2faa734a0500e0fe00b867e66ef",
                          "typeString": "literal_string \"amount has to be greater than zero\""
                        }
                      ],
                      "id": 1929,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "8336:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1934,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8336:58:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1935,
                  "nodeType": "ExpressionStatement",
                  "src": "8336:58:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "id": 1943,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "expression": {
                            "arguments": [
                              {
                                "id": 1939,
                                "name": "this",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 4294967268,
                                "src": "8417:4:3",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_contract$_Survey_$1994",
                                  "typeString": "contract Survey"
                                }
                              }
                            ],
                            "expression": {
                              "argumentTypes": [
                                {
                                  "typeIdentifier": "t_contract$_Survey_$1994",
                                  "typeString": "contract Survey"
                                }
                              ],
                              "id": 1938,
                              "isConstant": false,
                              "isLValue": false,
                              "isPure": true,
                              "lValueRequested": false,
                              "nodeType": "ElementaryTypeNameExpression",
                              "src": "8409:7:3",
                              "typeDescriptions": {
                                "typeIdentifier": "t_type$_t_address_$",
                                "typeString": "type(address)"
                              },
                              "typeName": {
                                "id": 1937,
                                "name": "address",
                                "nodeType": "ElementaryTypeName",
                                "src": "8409:7:3",
                                "typeDescriptions": {}
                              }
                            },
                            "id": 1940,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "kind": "typeConversion",
                            "lValueRequested": false,
                            "names": [],
                            "nodeType": "FunctionCall",
                            "src": "8409:13:3",
                            "tryCall": false,
                            "typeDescriptions": {
                              "typeIdentifier": "t_address",
                              "typeString": "address"
                            }
                          },
                          "id": 1941,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "memberName": "balance",
                          "nodeType": "MemberAccess",
                          "src": "8409:21:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": ">=",
                        "rightExpression": {
                          "id": 1942,
                          "name": "_amount",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1924,
                          "src": "8434:7:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "src": "8409:32:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "42616c616e63652068617320746f206265203e3d207468616e2074686520616d6f756e7420746f207769746864726177",
                        "id": 1944,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "8443:50:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_951ece5d5af66174f14cd35238da3522fbecff682f2440d776cb968d376dbcbf",
                          "typeString": "literal_string \"Balance has to be >= than the amount to withdraw\""
                        },
                        "value": "Balance has to be >= than the amount to withdraw"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_951ece5d5af66174f14cd35238da3522fbecff682f2440d776cb968d376dbcbf",
                          "typeString": "literal_string \"Balance has to be >= than the amount to withdraw\""
                        }
                      ],
                      "id": 1936,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "8401:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 1945,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8401:93:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1946,
                  "nodeType": "ExpressionStatement",
                  "src": "8401:93:3"
                },
                {
                  "assignments": [
                    1948
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1948,
                      "mutability": "mutable",
                      "name": "_addr",
                      "nameLocation": "8517:5:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1969,
                      "src": "8501:21:3",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address_payable",
                        "typeString": "address payable"
                      },
                      "typeName": {
                        "id": 1947,
                        "name": "address",
                        "nodeType": "ElementaryTypeName",
                        "src": "8501:15:3",
                        "stateMutability": "payable",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address_payable",
                          "typeString": "address payable"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1954,
                  "initialValue": {
                    "arguments": [
                      {
                        "expression": {
                          "id": 1951,
                          "name": "tx",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 4294967270,
                          "src": "8533:2:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_magic_transaction",
                            "typeString": "tx"
                          }
                        },
                        "id": 1952,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "origin",
                        "nodeType": "MemberAccess",
                        "src": "8533:9:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 1950,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "lValueRequested": false,
                      "nodeType": "ElementaryTypeNameExpression",
                      "src": "8525:8:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_type$_t_address_payable_$",
                        "typeString": "type(address payable)"
                      },
                      "typeName": {
                        "id": 1949,
                        "name": "address",
                        "nodeType": "ElementaryTypeName",
                        "src": "8525:8:3",
                        "stateMutability": "payable",
                        "typeDescriptions": {}
                      }
                    },
                    "id": 1953,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "typeConversion",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8525:18:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_address_payable",
                      "typeString": "address payable"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "8501:42:3"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 1958,
                        "name": "_amount",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1924,
                        "src": "8565:7:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "expression": {
                        "id": 1955,
                        "name": "_addr",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 1948,
                        "src": "8550:5:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address_payable",
                          "typeString": "address payable"
                        }
                      },
                      "id": 1957,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "transfer",
                      "nodeType": "MemberAccess",
                      "src": "8550:14:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_transfer_nonpayable$_t_uint256_$returns$__$",
                        "typeString": "function (uint256)"
                      }
                    },
                    "id": 1959,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "8550:23:3",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 1960,
                  "nodeType": "ExpressionStatement",
                  "src": "8550:23:3"
                },
                {
                  "expression": {
                    "id": 1967,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "expression": {
                        "expression": {
                          "id": 1961,
                          "name": "build",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 1098,
                          "src": "8580:5:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_SurveyBuild_$2050_storage",
                            "typeString": "struct SurveyInterface.SurveyBuild storage ref"
                          }
                        },
                        "id": 1964,
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "pool",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 2042,
                        "src": "8580:10:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_struct$_LiquidityPool_$2029_storage",
                          "typeString": "struct SurveyInterface.LiquidityPool storage ref"
                        }
                      },
                      "id": 1965,
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "memberName": "gasAmount",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 2024,
                      "src": "8580:20:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "-=",
                    "rightHandSide": {
                      "id": 1966,
                      "name": "_amount",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1924,
                      "src": "8604:7:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "8580:31:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 1968,
                  "nodeType": "ExpressionStatement",
                  "src": "8580:31:3"
                }
              ]
            },
            "functionSelector": "8e6b582f",
            "id": 1970,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 1927,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 1926,
                  "name": "isCreator",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 1158,
                  "src": "8319:9:3"
                },
                "nodeType": "ModifierInvocation",
                "src": "8319:9:3"
              }
            ],
            "name": "withdrawFromGasPool",
            "nameLocation": "8276:19:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1925,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1924,
                  "mutability": "mutable",
                  "name": "_amount",
                  "nameLocation": "8301:7:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1970,
                  "src": "8296:12:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 1923,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "8296:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "8295:14:3"
            },
            "returnParameters": {
              "id": 1928,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "8329:0:3"
            },
            "scope": 1994,
            "src": "8267:350:3",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "external"
          },
          {
            "body": {
              "id": 1992,
              "nodeType": "Block",
              "src": "8692:112:3",
              "statements": [
                {
                  "assignments": [
                    1978
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 1978,
                      "mutability": "mutable",
                      "name": "index",
                      "nameLocation": "8704:5:3",
                      "nodeType": "VariableDeclaration",
                      "scope": 1992,
                      "src": "8699:10:3",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 1977,
                        "name": "uint",
                        "nodeType": "ElementaryTypeName",
                        "src": "8699:4:3",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 1982,
                  "initialValue": {
                    "baseExpression": {
                      "id": 1979,
                      "name": "userAnswers",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1095,
                      "src": "8712:11:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
                        "typeString": "mapping(address => uint256)"
                      }
                    },
                    "id": 1981,
                    "indexExpression": {
                      "id": 1980,
                      "name": "_addr",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1972,
                      "src": "8724:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "nodeType": "IndexAccess",
                    "src": "8712:18:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "8699:31:3"
                },
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 1985,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 1983,
                      "name": "index",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1978,
                      "src": "8741:5:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": ">",
                    "rightExpression": {
                      "hexValue": "30",
                      "id": 1984,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "8749:1:3",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "src": "8741:9:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 1989,
                  "nodeType": "IfStatement",
                  "src": "8737:43:3",
                  "trueBody": {
                    "id": 1988,
                    "nodeType": "Block",
                    "src": "8752:28:3",
                    "statements": [
                      {
                        "expression": {
                          "hexValue": "74727565",
                          "id": 1986,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "bool",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "8768:4:3",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          },
                          "value": "true"
                        },
                        "functionReturnParameters": 1976,
                        "id": 1987,
                        "nodeType": "Return",
                        "src": "8761:11:3"
                      }
                    ]
                  }
                },
                {
                  "expression": {
                    "hexValue": "66616c7365",
                    "id": 1990,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": true,
                    "kind": "bool",
                    "lValueRequested": false,
                    "nodeType": "Literal",
                    "src": "8793:5:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    },
                    "value": "false"
                  },
                  "functionReturnParameters": 1976,
                  "id": 1991,
                  "nodeType": "Return",
                  "src": "8786:12:3"
                }
              ]
            },
            "functionSelector": "8beeef2b",
            "id": 1993,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "didUserTakeSurvey",
            "nameLocation": "8632:17:3",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 1973,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1972,
                  "mutability": "mutable",
                  "name": "_addr",
                  "nameLocation": "8658:5:3",
                  "nodeType": "VariableDeclaration",
                  "scope": 1993,
                  "src": "8650:13:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 1971,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "8650:7:3",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "8649:15:3"
            },
            "returnParameters": {
              "id": 1976,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 1975,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 1993,
                  "src": "8686:4:3",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_bool",
                    "typeString": "bool"
                  },
                  "typeName": {
                    "id": 1974,
                    "name": "bool",
                    "nodeType": "ElementaryTypeName",
                    "src": "8686:4:3",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "8685:6:3"
            },
            "scope": 1994,
            "src": "8623:181:3",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "public"
          }
        ],
        "scope": 1995,
        "src": "154:8653:3",
        "usedErrors": []
      }
    ],
    "src": "33:8776:3"
  },
  "compiler": {
    "name": "solc",
    "version": "0.8.7+commit.e28d00a7.Emscripten.clang"
  },
  "networks": {},
  "schemaVersion": "3.4.3",
  "updatedAt": "2023-08-12T20:46:38.586Z",
  "devdoc": {
    "kind": "dev",
    "methods": {},
    "version": 1
  },
  "userdoc": {
    "kind": "user",
    "methods": {},
    "version": 1
  }
}